export default {
  portalFinancial: {
    refreshFailed:
      'Avbestillingen er registrert, men vi kunne ikke hente oppdatert refusjonsstatus. Prøv igjen eller åpne kundeportalen på nytt.',
    heading: 'Fakturaer, kvitteringer og refusjoner',
    explanation:
      'Dokumentene vises i nummerrekkefølge. En kreditnota korrigerer et dokument, men bekrefter ikke at pengene er tilbake på kontoen din.',
    refundWithoutDocument: 'Ingen dokumenter er utstedt for denne avtalen.',
    refundWithoutDocumentBody:
      'Statusen under er det vi vet om tilbakebetalingen. Kontakt tilbyderen hvis du trenger dokumentasjon.',
    reverses: 'Reverserer dokument {number}',
    download: 'Last ned PDF {number}',
    downloadFailed:
      'Kunne ikke hente dokumentet. Prøv igjen, eller åpne kundeportalen på nytt hvis innloggingen har gått ut.',
    durableAccess:
      'Du finner tilgjengelige fakturaer, kvitteringer, kreditnotaer og oppdatert refusjonsstatus i kundeportalen. Du kan bli bedt om å logge inn med e-post.',
    openPortal: 'Åpne kundeportalen',
    kind: {
      sale: 'Kvittering',
      invoice: 'Faktura',
      credit_note: 'Kreditnota',
      credit_note_reversal: 'Reversering av kreditnota',
    },
    refund: {
      pending: 'Tilbakebetalingen venter på behandling. Pengene er ikke bekreftet tilbake ennå.',
      succeeded:
        'Tilbakebetalingen er gjennomført. Banken kan bruke noen dager før beløpet vises på kontoen din.',
      failed: 'Tilbakebetalingen mislyktes. Kontakt tilbyderen for hjelp.',
      canceled: 'Tilbakebetalingen ble stoppet. Kontakt tilbyderen for hjelp.',
      unknown:
        'Vi har ikke bekreftet status for tilbakebetalingen. Kontakt tilbyderen hvis du trenger hjelp.',
    },
  },
  paymentDisputes: {
    title: 'Betalingssaker',
    subtitle: 'Tilbakeføringskrav fra Stripe, med frister og avsluttede saker.',
    caseTitle: 'Tilbakeføringskrav',
    bookingTitle: 'Betalingssaker for møtet',
    searchLabel: 'Finn en sak',
    searchPlaceholder: 'Kunde, e-post, møtetittel eller saksnummer',
    search: 'Søk',
    loading: 'Henter betalingssakene …',
    empty: 'Ingen betalingssaker ennå',
    emptyBody: 'Tilbakeføringskrav fra Stripe vises her når de blir registrert.',
    searchEmpty: 'Ingen saker funnet',
    searchEmptyBody: 'Ingen registrerte saker passer til dette søket.',
    notFound: 'Fant ikke saken',
    unknown: 'Ikke oppgitt av Stripe',
    back: 'Til betalingssakene',
    viewAll: 'Se alle sakene',
    pages: 'Sider med betalingssaker',
    previous: 'Forrige',
    next: 'Neste',
    caseId: 'Saksnummer i Stripe',
    reason: 'Begrunnelse fra Stripe',
    stripeStatus: 'Status i Stripe',
    deadline: 'Svarfrist',
    noDeadline: 'Banken tar ikke imot svar',
    opened: 'Åpnet',
    closed: 'Avsluttet',
    evidence: 'Dokumentasjon i Stripe',
    evidenceSaved: 'Dokumentasjon er lagret',
    evidenceNone: 'Ingen dokumentasjon er lagret',
    submissions: 'Antall innsendinger i Stripe',
    updated: 'Sist oppdatert fra Stripe',
    evidenceHelp:
      'Lagret dokumentasjon betyr ikke nødvendigvis at et svar er sendt. Innsending og vurdering skjer i Stripe.',
    deletedBooking: 'Møtet er slettet',
    deletedBookingHelp:
      'Møtet er slettet. Betalingssaken er bevart uten kundeopplysningene fra møtet.',
    openBooking: 'Åpne møtet',
    handoffTitle: 'Svar i Stripe',
    handoff:
      'Åpne Stripe og finn saken med saksnummeret over. Du svarer og sender dokumentasjon i Stripe. Stemne sender ikke inn dokumentasjon for deg.',
    followTitle: 'Se saken i Stripe',
    follow:
      'Åpne Stripe og finn saken med saksnummeret over. Se siste status og eventuelle muligheter i Stripe.',
    testMode: 'Denne saken tilhører testmodus i Stripe.',
    openStripe: 'Åpne Stripe',
    stripeLogin: 'Logg inn direkte i Stripe',
    reasonLabel: {
      fraudulent: 'Kunden kjenner ikke igjen belastningen',
      duplicate: 'Kunden mener de er belastet to ganger',
      product_not_received: 'Kunden sier de ikke fikk tjenesten',
      product_unacceptable: 'Kunden mener tjenesten ikke var som avtalt',
      subscription_canceled: 'Kunden mener avtalen var avbestilt',
      credit_not_processed: 'Kunden venter på en refusjon',
      unrecognized: 'Kunden kjenner ikke igjen belastningen',
      general: 'Ingen nærmere begrunnelse oppgitt',
      bank_cannot_process: 'Banken kan ikke behandle betalingen',
    },
    statusLabel: {
      won: 'Avgjort i din favør',
      lost: 'Avgjort i kundens favør',
      warning_closed: 'Forespørselen er avsluttet uten tilbakeføringskrav',
      prevented: 'Tilbakeføringskravet ble avverget',
      charge_refunded: 'Beløpet er refundert',
    },
    state: {
      response_required: 'Venter på svar fra deg',
      response_overdue: 'Svarfristen har gått ut',
      response_not_allowed: 'Banken tar ikke imot svar',
      under_review: 'Til vurdering',
      resolved: 'Avsluttet sak',
      unknown: 'Se status i Stripe',
    },
    guidance: {
      response_required: 'Se svarfristen og svar i Stripe.',
      response_overdue:
        'Den registrerte svarfristen har gått ut. Se siste status og eventuelle muligheter i Stripe.',
      response_not_allowed:
        'Stripe oppgir at banken til kunden ikke tar imot svar i denne saken. Du kan følge saken i Stripe, men du kan ikke sende dokumentasjon.',
      under_review: 'Stripe har saken til vurdering. Se status i Stripe for oppdateringer.',
      resolved: 'Saken er avsluttet. Utfallet fra Stripe står under.',
      unknown: 'Denne statusen er ikke kjent i Stemne ennå. Åpne Stripe for å se hva den betyr.',
    },
  },
  a11y: {
    carousel: 'karusell',
    carouselSlide: 'lysbilde',
    carouselSlideLabel: '{position} av {total}',
  },

  imageLightbox: {
    label: 'Forstørret bilde',
    previous: 'Forrige',
  },

  common: {
    back: 'Tilbake',
    continue: 'Fortsett',
    next: 'Neste',
    // Two different "cancel"s, cancelBooking is the domain action
    // (customer cancels the booking), abort dismisses a dialog/flow.
    // A generic `cancel` key held 'Avbestill' and any modal reaching
    // for it would have cancelled the wrong thing (UX review 2026-06).
    cancelBooking: 'Avbestill',
    abort: 'Avbryt',
    clear: 'Tøm',
    hours: 'Time',
    minutes: 'Min',
    now: 'Nå',
    save: 'Lagre',
    selectTime: 'Velg tid',
    copy: 'Kopier',
    copied: 'Kopiert',
    copyLink: 'Kopier lenke',
    copiedLink: '\u2713 Kopiert',
    loading: 'Laster...',
    loadingBooking: 'Henter møtet...',
    loadingSlots: 'Henter ledige tider...',
    loadingMeetings: 'Henter dine møter...',
    loadingServices: 'Laster tjenester',
    privacy: 'personvern',
    terms: 'vilkår',
    faq: 'spørsmål og svar',
    termsLink: 'vilkårene',
    privacyLink: 'personvernerklæringen',
    stemneUrl: 'stemne.no',
    copyright: '\u00A9 2026 Stemne AS. Alle rettigheter reservert.',
    // Under prisfeltet i tjenesteredigering og ny-tjeneste-modalen. Vises bare
    // når operatøren faktisk står i Merverdiavgiftsregisteret og betaling ved
    // booking er på — én nøkkel for begge flatene, så de aldri kan si ulikt om
    // det samme skattekravet.
    priceVatIncludedHint: 'Oppgi prisen inkludert mva.',
    noSlotsToday: 'Ingen ledige tider denne dagen.',
    min: '{mins} min',
    online: 'online',
    withHost: 'med {host}',
    inClinic: 'i klinikken',
    onlineOrInClinic: 'online eller i klinikken',
    howToJoin: 'Slik deltar du',
    joinLinkHint: 'Møtelenken dukker opp her og i e-posten før møtet starter.',
    remove: 'Fjern',
    edit: 'Endre',
    close: 'Lukk',
    chooseLanguage: 'Velg språk',
    language: 'Språk',
    login: 'Logg inn',
    goToDashboard: 'Gå til dashboard',
    backToHome: 'Tilbake til forsiden',
    bookingWith: 'du booker med',
    switchPerson: 'bytt person',
  },

  // Shared StemneLoadError copy — the failed-load sibling of the empty state.
  // Muted and factual, no apology theater; the retry is the point.
  relativeTime: {
    justNow: 'akkurat nå',
    minsAgo: '{n} min siden',
    hoursAgo: '{n} t siden',
    daysAgo: '{n} dag siden | {n} dager siden',
    inMins: 'om {n} min',
    inHours: 'om {n} t',
    inDays: 'om {n} dag | om {n} dager',
    countdownDays: '{count} dag | {count} dager',
    countdownHourUnit: 't',
    countdownMinuteUnit: 'm',
    countdownSecondUnit: 's',
  },
  loadError: {
    title: 'Kunne ikke laste innholdet',
    retry: 'Prøv igjen',
    // Whole-page variant: a lazy route chunk failed to load (#3874).
    pageTitle: 'Vi fikk ikke lastet siden',
    pageBody: 'Prøv å laste inn siden på nytt. Hjelper ikke det, vent litt og prøv igjen.',
  },

  // Localized messages for backend errors. Generic-by-status keys are the
  // floor; stable snake_case codes (from httputil.WriteErrorCode) get a
  // specific message keyed as errors.<code>. See utils/apiError.ts.
  errors: {
    generic: 'Noe gikk galt. Prøv igjen.',
    network: 'Nettverksfeil. Sjekk tilkoblingen og prøv igjen.',
    server: 'Noe gikk galt hos oss. Prøv igjen om litt.',
    badRequest: 'Noe i forespørselen var ugyldig. Sjekk feltene og prøv igjen.',
    validation: 'Sjekk feltene og prøv igjen.',
    unauthorized: 'Du må logge inn på nytt.',
    forbidden: 'Du har ikke tilgang til dette.',
    notFound: 'Vi fant ikke det du lette etter.',
    conflict: 'Dette er allerede i bruk eller ble nettopp endret.',
    video_start_too_early: 'Videomøtet kan startes fra 15 minutter før avtalt tid.',
    tooLarge: 'Filen er for stor.',
    rateLimited: 'For mange forsøk. Prøv igjen om litt.',
    // 410 covers every expired magic link in the product (booking,
    // invitee, betalingslenke, signup verify). Deliberately worded as
    // the byte-identical twin of the backend's own errMagicTokenExpired
    // so adding this entry costs the three useBookingInvitees call
    // sites nothing — they showed exactly this sentence via the raw
    // backend text — while an un-coded 410 stops leaking English
    // (e.g. "booking is no longer active") into a Norwegian surface.
    gone: 'Lenken er utløpt. Be om en ny.',
    // Group departures (stories/09).
    departure_full:
      'Det er ikke nok ledige plasser på denne avgangen. Velg en annen avgang eller færre plasser.',
    already_booked: 'Du har allerede en booking på dette tidspunktet.',
    departure_closed: 'Avgangen er avlyst eller har allerede startet. Velg en annen avgang.',
    invalid_seats: 'Velg mellom 1 og 20 plasser.',
    departure_payments_unsupported:
      'Denne tjenesten tar betalt ved booking. Det støttes ikke for faste avganger ennå.',
    departure_booking:
      'Dette er en booking på en fast avgang. Avbestill og book en annen avgang i stedet.',
    departure_required: 'Denne tjenesten bookes via faste avganger. Velg en avgang.',
    departure_service_mismatch: 'Avgangen hører til en annen tjeneste. Velg avgangen på nytt.',
    departure_exists: 'Det finnes allerede en avgang for denne tjenesten på dette tidspunktet.',
    departure_has_payments:
      'Avgangen har betalte bookinger. Refunder og avbestill dem enkeltvis før du avlyser avgangen.',
    departure_cancel_reason: 'Skriv en kort begrunnelse (maks 500 tegn).',
    departure_cancel_forbidden: 'Bare guiden på avgangen eller en administrator kan avlyse den.',
    guide_has_departures:
      'Rådgiveren leder kommende avganger. Avlys dem eller bytt guide før du deaktiverer eller fjerner rådgiveren.',
    departure_service_in_use:
      'Tjenesten har kommende avganger. Avlys dem før du skjuler eller sletter tjenesten.',
    booking_model_locked:
      'Tjenesten har aktive bookinger eller kommende avganger, så fast avgang kan ikke slås av eller på nå.',
    // Specific codes — added as backend sites adopt WriteErrorCode.
    email_required: 'Skriv inn en e-postadresse.',
    invalid_email: 'E-postadressen ser ikke riktig ut.',
    // Registreringskoden (#3316). signup_code_invalid sier bevisst ikke hvor
    // mange forsøk som er igjen — en nedtelling er en framdriftsindikator for
    // den som gjetter.
    // Ikke en feil: lenken og koden åpner den samme registreringen, og den
    // som brukes sist møter en registrering som allerede er fullført. Egen
    // kode, slik at teksten sier «du er ferdig» og ikke «lenken er ødelagt».
    signup_already_verified: 'E-posten er allerede bekreftet',
    signup_code_invalid: 'Koden stemmer ikke. Sjekk e-posten og prøv igjen.',
    signup_code_locked: 'For mange forsøk på denne koden. Be om en ny kode.',
    signup_code_unavailable:
      'Denne registreringen fikk ingen kode. Velg «Send på nytt» for å få en kode.',
    name_required: 'Skriv inn et navn.',
    slot_taken: 'Tidspunktet er dessverre ikke ledig lenger. Velg et annet.',
    series_slot_conflict: 'Tidspunktet er ikke ledig for alle møtene i serien. Velg en annen tid.',
    booking_not_found: 'Vi fant ikke dette møtet.',
    meeting_not_finished:
      'Møtet er ikke ferdig ennå. Du kan sende oppsummeringen når møtet er holdt.',
    invitee_is_primary: 'Denne personen er allerede deltaker i møtet.',
    invitee_exists: 'Denne personen er allerede invitert.',
    too_many_invitees: 'Møtet har for mange deltakere.',
    group_full: 'Møtet er fullt.',
    video_duration_limit_exceeded:
      'Videomøtet er lengre enn abonnementet ditt tillater. Velg en kortere varighet.',
    availability_invalid_time:
      'Klokkeslettet må skrives som timer og minutter, for eksempel 09:00.',
    availability_invalid_range: 'Sluttidspunktet må være etter starttidspunktet.',
    vat_status_unknown:
      'Vi vet ikke om virksomheten din er registrert i Merverdiavgiftsregisteret, og da kan vi ikke lage riktige kvitteringer. Legg inn organisasjonsnummeret under Selskap, så henter vi statusen fra Brønnøysundregisteret.',
    vat_status_unknown_not_owner:
      'Vi vet ikke om virksomheten din er registrert i Merverdiavgiftsregisteret, og da kan vi ikke lage riktige kvitteringer. Be en eier legge inn organisasjonsnummeret under Selskap.',
    vat_registry_unavailable:
      'Brønnøysundregisteret svarte ikke, så vi fikk ikke sjekket om du er mva-registrert. Prøv igjen om litt.',
    // Signup verify (#3313). Four distinct token states, four distinct
    // answers — collapsing them told an operator whose link had merely
    // opened in the wrong browser to resend, the one action that could
    // not help. signup_session_mismatch deliberately does NOT name a
    // cause: the backend sees "this browser can't prove it owns the
    // link" and cannot tell a second device from a dropped cookie.
    signup_token_not_found: 'Bekreftelsen er ugyldig eller utløpt. Be om en ny kode.',
    signup_token_used: 'Bekreftelsen er allerede brukt eller erstattet av en nyere.',
    signup_token_expired: 'Bekreftelsen har utløpt.',
    signup_session_mismatch: 'Vi fikk ikke bekreftet e-posten i denne nettleseren.',
    signup_provisioning_failed: 'Vi fikk ikke opprettet kontoen. Prøv å bekrefte på nytt om litt.',
  },

  // Illustrasjonstekst i mockup-vinduene i heroen. Navn, byer og kr-priser
  // ligger som literaler i landing-data.ts — bare rolle, tjenestenavn og
  // gratis-merkingen avhenger av språk.
  landingMockup: {
    roleCouplesTherapist: 'Parterapeut',
    roleNaprapath: 'Naprapat',
    roleLeadershipCoach: 'Lederveileder',
    rolePhysiotherapist: 'Fysioterapeut',
    rolePersonalTrainer: 'Personlig trener',
    serviceIntroCall: 'Introsamtale',
    serviceCouplesFirst: 'Parterapi, første møte',
    serviceFollowUp: 'Oppfølging',
    serviceFirstSession: 'Førstegangstime',
    serviceFirstConsultation: 'Førstegangskonsultasjon',
    serviceTreatment: 'Behandling',
    serviceStrategySession: 'Strategisamtale',
    serviceSparring: 'Sparring',
    serviceIntroSession: 'Introøkt',
    serviceStrengthSession: 'Styrkeøkt',
    priceFree: 'gratis',
  },
  landing: {
    hero: {
      eyebrow: 'For deg som jobber med mennesker',
      headingFirst: 'Mer tid til',
      headingSecond: 'dem du møter.',
      intro: 'Booking, notater og oppfølging på ett sted. Fra første avtale til neste møte.',
      secondary: 'Se hvordan det fungerer',
      trust: 'Ingen bindingstid. Norsk kundestøtte.',
      detailFirst: 'Kunden finner en tid.',
      detailSecond: 'Du møter forberedt.',
      carouselLabel: 'Hvem bruker Stemne?',
      audienceLink: 'Stemne for {audience}',
      seeAll: 'Se alle',
      ptDescription: 'Fra første PT-time til neste mål. Hold oversikt over timer og oppfølging.',
      practitionerDescription:
        'Gi neste behandling din fulle oppmerksomhet. Avtalene har du samlet her.',
      advisorDescription:
        'Gode samtaler fortjener god oppfølging. Samle møter, notater og neste steg.',
      ptAlt: 'Personlig trener veileder en kunde på treningssenteret',
      practitionerAlt: 'Behandler og kunde i et lyst behandlingsrom',
      advisorAlt: 'Rådgiver og kunde i samtale rundt et bord',
    },
    audiences: {
      heading: 'Finn Stemne for ditt fag',
      ptTitle: 'Personlige trenere',
      practitionerTitle: 'Behandlere',
      advisorTitle: 'Rådgivere',
      ptDescription: 'Samle timer, øktnotater og oppfølging på kunden.',
      practitionerDescription: 'La kundene bestille selv, og finn fram til det dere avtalte sist.',
      advisorDescription: 'Ha møter, notater og neste steg samlet før neste samtale.',
    },
    nav: {
      features: 'Funksjoner',
      pricing: 'Priser',
      advisors: 'Rådgivere',
      login: 'Logg inn',
      getStarted: 'Kom i gang',
    },
    meta: 'm\u00F8ter \u00B7 for folk som tar imot andre',
    heading: 'En stille, ',
    headingItalic: 'vakker',
    headingEnd: ' m\u00E5te \u00E5 ta imot dem du m\u00F8ter.',
    // Stor S i brødtekst. Ordmerket er skrevet med liten s, men det er en
    // logo — i setninger er Stemne et egennavn, og samme side skriver ellers
    // "Stemne holder regnskapet" og "Stemne AS".
    body: 'Stemne er en bookingside for terapeuter, naprapater, fysioterapeuter, coacher, rådgivere og andre som har planlagte samtaler eller behandlinger. På video eller i klinikken. Du får din egen adresse på {subdomain}, og folk booker, møter og følger opp på ett sted.',
    heroCallout: 'Booking, video og oppfølging på ett sted.',
    subdomain: 'dittnavn.stemne.no',
    ctaPrimary: 'Lag din side, gratis i 3 måneder',
    ctaSecondary: 'Se hvordan det fungerer \u2192',
    trustMeta: 'ingen bindingstid \u00B7 norsk kundest\u00F8tte \u00B7 hostet i eu',
    featuresHeading: 'F\u00E6rre e-poster. Bedre samtaler.',
    feature1Title: 'Din egen adresse',
    feature1Body:
      'Hver side bor p\u00E5 et stille, stabilt domene. dittnavn.stemne.no er enkelt \u00E5 huske og deling er naturlig.',
    feature2Title: 'Forbered, m\u00F8t, f\u00F8lg opp',
    feature2Body:
      'Sp\u00F8r kunden om hva de vil snakke om f\u00F8r m\u00F8tet, ha prep-notater \u00E5pne mens dere m\u00F8tes, send en kryptert oppsummering etterp\u00E5. Alt p\u00E5 samme skjerm.',
    feature3Title: 'Video, kalender, varsler',
    feature3Body:
      'Videorom innebygget, ingen nedlasting for kunden. Koble til Google Calendar. Stille timer og per-kind varslinger s\u00E5 innboksen ikke sv\u00F8mmer over.',
    feature4Title: 'Krypterte notater du eier',
    feature4Body:
      'M\u00F8tenotater, oppsummeringer og kalenderkoblinger er krypterte n\u00E5r de ligger lagret. Du best\u00E5r personverntesten n\u00E5r kunden sp\u00F8r.',
    feature5Title: 'Husk hver utøver mellom øktene',
    feature5Body:
      'Stemne samler notater og økthistorikk på utøveren. Du eller en kollega åpner historikken når dere trenger å se hva dere jobbet med sist.',
    feature6Title: 'Laget i Norge, hostet i EU',
    feature6Body:
      'Data bor hos Hetzner i Tyskland, innenfor EU og underlagt GDPR, og forlater aldri E\u00D8S uten gyldig overf\u00F8ringsgrunnlag. N\u00E5r kunden sp\u00F8r hvor det ligger, har du svaret klart.',
    continuityMeta: 'kontinuitet',
    continuityHeading: 'Samme rådgiver hver gang',
    continuityLede:
      'Kunden trenger ikke å velge. Når noen kommer tilbake, havner de automatisk hos rådgiveren de møtte sist.',
    continuity1Title: 'Relasjonen følger kunden.',
    continuity1Body:
      'Booker en kunde på nytt, settes de opp med samme rådgiver som sist. Uten at noen må huske å fikse det.',
    continuity2Title: 'Teamet deler kundene.',
    continuity2Body:
      'Flere rådgivere på samme side, men hver kunde beholder sin. Er rådgiveren opptatt, tar en kollega timen, og historikken er allerede der.',
    continuity3Title: 'Kunden slipper å velge.',
    continuity3Body:
      'Kunden velger tjeneste og tid, ikke person. Dere styrer hvem som tar hva i bakgrunnen.',
    whoMeta: 'hvem bruker stemne',
    whoHeading: 'Et verkt\u00F8y. Mange m\u00E5ter \u00E5 m\u00F8tes p\u00E5.',
    whoTagPaid: 'med pris',
    whoTagFree: 'uten pris',
    whoTagOptional: 'valgfritt',
    who1Title: 'Terapeuter',
    who1Body:
      'Klienter booker selv. Du har kontroll p\u00E5 pauser, oppf\u00F8lging og fakturering (om du fakturerer).',
    who10Title: 'Personlige trenere & coacher',
    who10Body:
      'Utøvere booker økter selv. Du planlegger og logger økten, og finner notater og historikk når du eller en kollega trenger dem.',
    who2Title: 'Key account managers',
    who2Body:
      'Faste kvartalssamtaler og statusm\u00F8ter med kundene dine. En lenke \u00E5 dele, en kalender som stemmer.',
    who3Title: 'Kundesuksess & support',
    who3Body: 'Onboardingsamtaler, helsesjekker, eskaleringer. Kundene velger tid som passer dem.',
    who4Title: 'Mentorer & r\u00E5dgivere',
    who4Body:
      'Tilby et fast antall samtaler per m\u00E5ned, gratis eller mot honorar. Stemne holder regnskapet.',
    who5Title: 'Headhuntere & rekrutterere',
    who5Body:
      'F\u00F8rstegangs-screeninger uten tr\u00E5der fram og tilbake. Kalender alltid synlig, aldri overbooket.',
    who6Title: 'Frilansere & strateger',
    who6Body:
      'Pakker, oppdrag og oppf\u00F8lging. \u00C9n adresse, ett kontaktpunkt for alle henvendelser.',
    who7Title: 'Klinikere & behandlere',
    who7Body:
      'Naprapater, osteopater, fysioterapeuter, kiropraktorer. Klinikk-bookinger uten unødig friksjon, uten et videosystem du ikke trenger.',
    who8Title: 'Advokater & juridiske rådgivere',
    who8Body:
      'Klientmøter med diskret booking. Notater holdes på arbeidsplassen, ikke i innboksen. Krypterte kalenderkoblinger så historikken blir der den hører hjemme.',
    who9Title: 'Regnskapsførere & skatteforvaltere',
    who9Body:
      'Kvartalsmøter og årsoppgjør med klientene dine. Stemne husker fjorårets historikk når du sitter der i mars og prøver å huske hva dere ble enige om.',
    pricingMeta: 'pris',
    pricingHeading: 'Tre planer. Du velger størrelsen.',
    pricingLede: 'Start med det som passer i dag. Bytt plan når praksisen vokser. Alt flytter med.',
    tier: {
      solo: {
        name: 'Solo',
        price: '99 kr',
        period: 'per måned',
        seats: 'For deg alene.',
        body: 'Egen adresse, ubegrenset booking, krypterte notater, prep-visning, kryptert oppsummering. Gratis i 3 måneder.',
        cta: 'Start gratis',
      },
      team: {
        name: 'Team',
        price: '449 kr',
        period: 'per måned',
        seats: 'Inntil 5 brukere.',
        body: 'Inviter rådgivere, del krypterte notater, fordel «uten eier»-møter i to klikk. Egen e-post-avsender og felles kundekartotek inkludert.',
        cta: 'Start gratis',
      },
      vekst: {
        name: 'Vekst',
        price: '899 kr',
        period: 'per måned',
        seats: 'Inntil 15 brukere.',
        body: 'Audit-logg over administrator-handlinger, API-tilgang for integrasjoner, prioritert støtte. Trygt for etablerte praksiser.',
        cta: 'Start gratis',
      },
    },
    pricingExplainer: 'Ingen per-booking-kostnader. Ingen overraskelser. Skift plan når som helst.',
    pricingMva: 'Priser er uten mva.',
    pricingSecurity: 'Møtenotater og kalenderkoblinger er krypterte på alle planer.',
    pricingVideoCap:
      '* Videomøter varer i inntil 60 minutter. Trenger du lengre møter, kan du kjøpe utvidet varighet på inntil 120 minutter.',
    pricingEnterprise: 'Større team enn 15? Kontakt oss for skreddersydd avtale.',
    pricingFeatures: [
      'Din adresse på dittnavn.stemne.no',
      'Passordfri innlogging med passnøkler',
      'Ubegrenset møter og møtetyper',
      'Pris per møte er valgfritt, alltid',
      'Videorom innebygget, ingen nedlasting *',
      'Google Calendar-synk',
      'Prep-visning med «spør om dette» og kryptert oppsummering',
      'Stille timer og per-kind varslingskontroll',
      'E-postbekreftelser, påminnelser og automatisk ombooking',
      'Importer eksisterende kunder fra Excel eller CRM',
      'Kundeservice på norsk, hverdager',
      'Dataene dine, i EU',
    ],
    allFeaturesToggle: 'Se alt som er inkludert',
    finalHeading: 'Klar n\u00E5r du er det.',
    finalBody: 'Du kan v\u00E6re p\u00E5 lufta f\u00F8r kaffen er kald.',
    finalCta: 'Kom i gang',
    footerUrl: 'stemne.no',
  },

  signup: {
    back: '\u2190 Tilbake',
    heading: 'Lag din side.',
    body: 'Vi sender deg en lenke på e-post. Ingen passord å huske. Du kan være på lufta i løpet av fem minutter.',
    nameLabel: 'Navn',
    namePlaceholder: 'Fornavn Etternavn',
    emailLabel: 'E-post',
    submit: 'Send meg en lenke',
    termsPrefix: 'Ved å fortsette godtar du',
    termsAnd: 'og',
    termsSuffix: 'vår.',
  },

  verify: {
    meta: 'sjekk innboksen din',
    // Hedged, like resentHeading: /api/signup returns 200 on the
    // silently-throttled path too, so the SPA cannot truthfully assert a
    // send happened. Reads as "Se etter en kode til <adresse>".
    heading: 'Se etter en kode',
    body: 'Skriv inn den sekssifrede koden fra e-posten her for å fortsette. Den gjelder i 24 timer. Hører du ingenting i løpet av et par minutter, sjekk søppelpost og prøv å sende på nytt.',
    confirmed: 'Jeg har skrevet inn koden',
    resend: 'Send på nytt',
    resendAlert: 'Vi sender en ny kode straks.',
    helpPrefix: 'Finner du den ikke? Sjekk søppelpost, eller',
    helpLink: 'prøv en annen adresse',
  },

  subdomain: {
    back: '\u2190 Tilbake',
    heading: 'Velg din adresse.',
    body: 'Dette blir den offentlige siden din, der kundene finner og booker deg. Du kan endre den senere, men helst ikke.',
    placeholder: 'dittnavn',
    suffix: '.stemne.no',
    statusEmpty: 'begynn å skrive for å sjekke \u2026',
    statusShort: 'minst {min} tegn',
    statusLong: 'maks {max} tegn',
    statusChecking: 'sjekker ...',
    statusTaken: '{slug}{suffix} er opptatt, prøv noe annet',
    // Backend `midlertidig_utilgjengelig` = the CF subdomain cache
    // failed to hydrate. We don't know whether the slug is taken,
    // so phrase it as a transient check failure rather than blaming
    // the operator's pick.
    statusTransient: 'vi får ikke sjekket adressen akkurat nå, prøv igjen om litt',
    statusBlocked: 'denne adressen er ikke tillatt, velg noe annet',
    statusBadFormat: 'ugyldig adresse: bare sm\u00e5 bokstaver, tall og bindestreker',
    statusAvailable: 'ledig, {slug}{suffix} er din',
    tipLabel: 'Tips:',
    tipBody:
      'bruk fornavnet ditt eller firmanavnet ditt. Korte adresser er lettere å huske og dele.',
    submit: 'Fortsett \u2192',
  },

  login: {
    heading: 'Logg inn',
    emailLabel: 'E-post',
    submit: 'Fortsett',
    // Remembered-workspace hint: one-click retur til egen side for
    // nettlesere som har logget inn før (stemne_workspace-cookien).
    continueTo: 'Fortsett til {host}',
    pickWorkspace: 'Velg arbeidsområde',
    // Per-rad utlogging i arbeidsområde-velgeren. Samme streng er
    // aria-label på ikonknappen og tittel i bekreftelsesdialogen —
    // handlingen er den samme, og da skal ordlyden være det også.
    signOutOf: 'Logg ut av {host}',
    signOutBody:
      'Snarveien forsvinner fra denne enheten. Er du logget inn her nå, avslutter vi økten.',
    signOutConfirm: 'Logg ut',
    signOutError: 'Vi fikk ikke logget deg ut. Prøv igjen.',
    orUseEmail: 'eller få en innloggingslenke på e-post',
    emptyError: 'Skriv inn e-postadressen din.',
    sentHeading: 'Sjekk e-posten din',
    sentBody:
      'Hvis kontoen finnes, har vi sendt en innloggingslenke til {email}. Klikk på lenken for å logge inn på siden din.',
    sentHint: 'Finner du den ikke? Sjekk søppelpost.',
    // Apex /login post-submit actions (qa-bot #1461). Matches the
    // tenant /auth/login surface so a user landed here who never
    // gets the email isn't stranded with static text.
    sendAgain: 'Send på nytt',
    sendAgainCountdown: 'Send på nytt om {seconds}s',
    tryAnotherEmail: 'Prøv en annen adresse',
    rateLimited: 'For mange forsøk. Vent litt og prøv igjen.',
    submitError: 'Noe gikk galt. Prøv igjen.',
    noAccount: 'Ingen konto?',
    createAccount: 'Opprett en ny konto',
  },

  findBookings: {
    eyebrow: 'Finn m\u00f8tene dine',
    heading: 'Hvor har du m\u00f8ter?',
    body: 'Skriv inn e-postadressen din, s\u00e5 sender vi deg en oversikt over r\u00e5dgiverne du har m\u00f8ter hos.',
    emailLabel: 'E-post',
    emailPlaceholder: "din{'@'}epost.no",
    submit: 'Send meg oversikten',
    passwordless: 'Ingen passord. Du f\u00e5r en lenke p\u00e5 e-post.',
    sentEyebrow: 'Sjekk e-posten din',
    sentHeading: 'Oversikten er p\u00e5 vei.',
    sentBody:
      'Hvis du har m\u00f8ter hos en r\u00e5dgiver, har vi sendt en e-post til {email} med en lenke til hver av dem.',
    sentBack: 'Bruk en annen adresse',
    unavailable: 'Denne funksjonen er ikke tilgjengelig enn\u00e5.',
  },

  setup: {
    back: '\u2190 Tilbake',
    continue: 'Fortsett \u2192',
    profile: {
      heading: 'Fortell hvem du er.',
      body: 'Bare navnet ditt trengs nå. Du kan gjøre siden mer personlig senere.',
      optionalSummary: 'Fyll ut mer av profilen (valgfritt)',
      uploadPhoto: 'Last opp bilde',
      nameLabel: 'Navn',
      namePlaceholder: 'For- og etternavn',
      titleLabel: 'Tittel',
      titlePlaceholder: 'f.eks. Parterapeut',
      birthdayLabel: 'Fødselsdato',
      phoneLabel: 'Telefon',
      phonePlaceholder: '+47 999 99 999',
      bioLabel: 'Kort presentasjon',
      bioPlaceholder: 'Hva gjør du, og for hvem? To til fire setninger.',
      bioCount: '{count} tegn',
      bioShort: 'Anbefalt: minst 20 tegn',
      cityLabel: 'Sted',
      brandLabel: 'Arbeidsplassen',
      brandHint: 'Vises sammen med logoen i toppen av bookingsiden. La stå om det er deg selv.',
      logoLabel: 'Logo',
      logoHint: 'PNG, JPEG, WebP eller SVG. Gjennomsiktig bakgrunn anbefales. Maks 10 MB.',
      logoUpload: 'Last opp logo',
      logoChange: 'Bytt logo',
      logoRemove: 'Fjern',
      logoNone: 'Ingen logo lastet opp',
      logoTooBig: 'Filen er for stor. Maks 10 MB.',
      saveError: 'Kunne ikke lagre profilen. Prøv igjen.',
    },
    team: {
      heading: 'Hvem er med?',
      body: 'Legg til kollegaer som også tar imot kunder. Dette kan gjøres senere, du kan hoppe over.',
      addPerson: '+ Legg til person',
      namePlaceholder: 'f.eks. Maren Lien',
      rolePlaceholder: 'f.eks. Familieterapeut',
      colorLabel: 'Farge',
      you: 'deg',
      youUnnamed: 'Deg',
      titleField: 'Tittel (valgfritt)',
      titleHint: 'Klikk Rediger for å legge til tittel',
      titlePlaceholder: 'f.eks. Parterapeut',
      roleField: 'Rolle',
      roleLockedHint: 'Du er administrator i din egen organisasjon.',
      skip: 'Hopp over',
      empty: 'Ingen kollegaer enda, du er solo.',
      validation: 'Navn og rolle er påkrevd.',
    },
    company: {
      heading: 'Hvem fakturerer vi?',
      body: 'Skriv inn organisasjonsnummeret, så henter vi navn og adresse fra Brønnøysundregisteret. Du kan endre alt etterpå, eller hoppe over og fylle inn senere.',
      orgnrLabel: 'Organisasjonsnummer',
      orgnrPlaceholder: '987 654 321',
      orgnrHint: '9 sifre.',
      lookupBusy: 'henter fra Brønnøysundregisteret …',
      lookupError: 'fant ikke foretaket, sjekk nummeret eller fyll ut manuelt',
      lookupUpstream: 'Brønnøysundregisteret er utilgjengelig akkurat nå, du kan fylle ut manuelt',
      lookupInvalid: 'ugyldig organisasjonsnummer',
      foundLabel: 'fra Brønnøysundregisteret',
      nameLabel: 'Foretaksnavn',
      namePlaceholder: 'fylles ut fra Brønnøysundregisteret',
      nameHint: 'Hentet fra Brønnøysundregisteret, kan ikke endres her.',
      addressLabel: 'Forretningsadresse',
      addressPlaceholder: 'fylles ut fra Brønnøysundregisteret',
      addressHint: 'Hentet fra Brønnøysundregisteret, endre i Innstillinger ved behov.',
      industryLabel: 'Bransje',
      industryHint: 'NACE-kode fra Brønnøysundregisteret, vises ikke til kundene.',
      inactiveWarning:
        'Dette foretaket er ikke aktivt ({reason}). Du kan fortsatt fortsette, men dobbeltsjekk nummeret.',
      inactiveReasonKonkurs: 'konkurs',
      inactiveReasonAvvikling: 'under avvikling',
      inactiveReasonSlettet: 'slettet',
      skip: 'Hopp over',
    },
    services: {
      heading: 'Legg til tjenestene dine.',
      body: 'Dette er det folk booker. Tar du betalt? Legg til en pris. Hvis ikke, la feltet stå tomt, da viser vi det ikke. Du kan legge til flere senere.',
      defaults: 'Vi åpner mandag–fredag kl. 09–17 for deg. Du kan endre tidene senere.',
      nameLabel: 'Navn',
      namePlaceholder: 'f.eks. Strategisamtale',
      durationLabel: 'Varighet',
      priceLabel: 'Pris (valgfritt)',
      pricePlaceholder: '',
      addService: '+ Legg til tjeneste',
      remove: 'Fjern',
    },
    availability: {
      heading: 'Når er du ledig?',
      body: 'Kundene ser bare ledige tider innenfor disse rammene. Du kan alltid blokkere av eller åpne opp senere.',
      notAvailable: 'ikke tilgjengelig',
      timezoneHeading: 'Tidssone',
      timezoneBody: 'Brukes for å vise riktig tid til kunder i andre tidssoner.',
      days: {
        man: 'Mandag',
        tir: 'Tirsdag',
        ons: 'Onsdag',
        tor: 'Torsdag',
        fre: 'Fredag',
        lor: 'Lørdag',
        son: 'Søndag',
      },
    },
    calendar: {
      heading: 'Koble til kalenderen din.',
      body: 'Så ser vi automatisk når du er opptatt, og legger nye møter inn i kalenderen du allerede bruker. Du kan koble til flere senere.',
      google: 'Google Kalender',
      googleDesc: 'Den vanligste. Fungerer med Gmail og Workspace.',
      apple: 'Apple Kalender',
      appleDesc: 'For deg som lever i Apple-universet.',
      outlook: 'Microsoft 365',
      outlookDesc: 'Outlook, Exchange og Office-kontoer.',
      connecting: 'kobler til \u2026',
      connect: 'koble til \u2192',
      statusConnected: '✓ tilkoblet',
      statusFailed: 'mislyktes, prøv igjen',
      skip: 'Hopp over for nå \u2192',
      privacyNote: 'Vi leser bare opptatt/ledig, aldri innholdet i møter eller avtaler.',
    },
    done: {
      meta: 'du er på lufta',
      heading: 'Siden din er ',
      headingItalic: 'levende',
      headingEnd: '.',
      body: 'Del lenken med kundene dine, eller legg den i signaturen din. Første møte kommer snart.',
      viewSite: 'Se siden din \u2192',
      goToDashboard: 'Gå til dashboard',
      checkingMeta: 'sjekker avtale',
      checkingHeading: 'Vi sjekker det siste.',
      checkingBody: 'Vi bekrefter at alt er klart før siden kan deles.',
      checkFailedBody: 'Vi fikk ikke sjekket avtalen. Prøv igjen før du deler siden.',
      retry: 'Prøv igjen',
      outstandingMeta: 'før siden kan åpnes',
      outstandingHeading: 'Siden din er klar, men stengt for bestilling.',
      outstandingBody:
        'Opprett først en passnøkkel. Deretter finner du databehandleravtalen i dashbordet. Når avtalen er godtatt, kan kunder bestille.',
      outstandingAction: 'Fortsett med passnøkkel',
    },
    steps: {
      profile: 'Profil',
      company: 'Selskap',
      services: 'Tjenester',
      team: 'Team',
      availability: 'Tilgjengelighet',
      calendar: 'Kalender',
      done: 'Ferdig',
    },
    stepOf: 'steg {current} av {total}',
    progressLabel: 'Oppsettfremdrift',
  },

  dashboard: {
    greetingMorning: 'God morgen, {name}.',
    // "God dag" dekker hele 10–17 på norsk, så begge dagbøttene peker på den
    // samme frasen. Delingen finnes for engelsk, som ikke har et nøytralt ord.
    greetingLateMorning: 'God dag, {name}.',
    greetingAfternoon: 'God dag, {name}.',
    greetingEvening: 'God kveld, {name}.',
    // Ikke "God natt" — det er en avskjed, og dette er en hilsen til noen som
    // nettopp har åpnet dashbordet. Samme grunn som #2402 flyttet morgen til 04.
    greetingNight: 'Sent oppe, {name}?',
    todayMeetings: 'dagens møter',
    emptyTitle: 'Ingen møter i dag, ennå.',
    emptyBody: 'Det første møtet havner her. Del lenken din så kommer det fort.',
    shareLabel: 'del siden din',
    shareBody: 'Legg lenken i e-postsignaturen eller på profilen din i sosiale medier.',
    sharePreview: 'Forhåndsvis \u2192',
    progressLabel: 'kom enda videre',
    progressTitle: 'Gjør siden din din.',
    checkResume: 'Fullfør oppsettet. Neste: {step}',
    // #3551 — sjekklista tilbød fire kosmetiske oppgaver mens avtalen holdt
    // siden stengt. Den står nå først, og forsvinner idet den er godtatt.
    checkAcceptDpa: 'Godta databehandleravtalen og åpne for bestillinger',
    checkUploadPhoto: 'Last opp et profilbilde',
    checkAddServices: 'Legg til flere tjenester ({count} lagt til)',
    checkConnectCalendar: 'Koble til kalender',
    checkWriteAbout: 'Skriv et lengre \u00ABom meg\u00BB',
    siteLabel: 'din side',
    nav: {
      overview: 'Oversikt',
      meetings: 'Møter',
      notater: 'Notater',
      documents: 'Dokumenter',
      services: 'Tjenester',
      availability: 'Tilgjengelighet',
      calendar: 'Kalender',
      departures: 'Avganger',
      customers: 'Kunder',
      innsikt: 'Innsikt',
      rapporter: 'Fakturagrunnlag',
      disputes: 'Betalingssaker',
      account: 'Min konto',
      settings: 'Innstillinger',
      integrasjoner: 'Integrasjoner',
      help: 'Hjelp',
    },

    meetings: {
      title: 'Møter',
      kicker: 'møter',
      sub: 'En linje per møte, alltid med en ansvarlig. Klikk en konsulent i raden under for å filtrere, eller "uten ansvarlig" for møter som mangler en.',
      newCta: '+ Nytt møte',
      instantCta: 'Møt nå',
      filterUpcoming: 'Kommende',
      filterPending: 'Ubekreftet',
      filterPendingHint: 'Kunden har ikke bekreftet tidspunktet ennå.',
      filterUnpaid: 'Ubetalt',
      filterPast: 'Tidligere',
      filterCancelled: 'Avlyste',
      filterAll: 'Alle',
      teamStripAlle: 'alle',
      teamStripDeg: 'deg',
      teamStripIngenEier: 'uten ansvarlig',
      assignOwnerCta: 'velg ansvarlig',
      noCustomerYet: 'Ingen kunde ennå',
      sortCta: 'Sortér',
      searchPlaceholder: 'Søk',
      resetFilter: 'Nullstill filter ↺',
      footerShowing: 'Viser {n} av {total}',
      footerScopeAll: 'hele selskapet',
      footerScopeMine: 'dine',
      footerScopeNone: 'uten ansvarlig',
      headerTime: 'tid',
      headerMeeting: 'møte',
      headerCustomer: 'kunde',
      headerOwner: 'ansvarlig',
      headerStatus: 'status',
      statusSoon: 'snart',
      statusUpcoming: 'kommende',
      statusPrivate: 'privat',
      paymentRemainder: 'Delvis betalt',
      paymentAfter: 'Ikke betalt',
      paymentOutstandingAmount: '{amount} gjenstår',
      // Mobile titles + sub copy adapt to the active filter so the
      // viewport's limited real estate carries the same signal the
      // desktop sidebar + breadcrumb together would.
      mobileTitleAll: 'Hele selskapet',
      mobileTitleMine: 'Dine møter',
      mobileTitleNone: 'Uten ansvarlig',
      mobileTitleMember: '{name}s møter',
      mobileSubAll: 'Alt som er booket gjennom {host}.',
      mobileSubMine: 'Møter som er tildelt deg.',
      mobileSubNone: 'Disse mangler en konsulent. Tildel før de starter.',
      mobileSubMember: 'Møter som er tildelt {name}.',
      // Inline alert above the status tabs when there are
      // unassigned bookings and the operator isn't already viewing
      // them. One click → switches the team-strip filter to
      // "ingen eier" (mobile mirror of the desktop's banner).
      mobileUnassignedAlertSingular: 'møte uten ansvarlig',
      mobileUnassignedAlertPlural: 'møter uten ansvarlig',
      mobileUnassignedAlertSub: 'Booket da ingen var ledige. Ta det, eller fordel det.',
      // FAB labels. On mobile the FAB is a speed-dial that exposes
      // both "Møt nå" (instant) and "Nytt møte" (scheduled), the
      // two CTAs that live in the desktop header above 820px.
      fabNewMeeting: 'Nytt møte',
      fabInstant: 'Møt nå',
      fabSchedule: 'Nytt møte',
      // Empty-state copy per filter (mobile only). Voice mirrors
      // the slogan rhythm: short, calm, no exclamation marks.
      emptyUpcomingTitle: 'Ingen kommende møter.',
      emptyUpcomingBody: 'Når kunder booker eller du legger til møter manuelt, dukker de opp her.',
      emptyPendingTitle: 'Ingen ubekreftede møter.',
      emptyPendingBody: 'Møter som venter på bekreftelse vises her.',
      emptyUnpaidTitle: 'Ingen ubetalte møter.',
      emptyUnpaidBody: 'Møter med et utestående beløp vises her.',
      emptyPastTitle: 'Ingen tidligere møter.',
      emptyPastBody: 'Fullførte møter samles her etter hvert.',
      emptyCancelledTitle: 'Ingen avlyste møter.',
      emptyCancelledBody: 'Møter som blir avlyst havner her.',
      emptyUnassignedTitle: 'Alle møter har en ansvarlig.',
      emptyUnassignedBody: 'Ingen møter trenger tildeling akkurat nå.',
      emptyMineTitle: 'Ingen møter på deg.',
      emptyMineBody:
        'Møter du er ansvarlig for dukker opp her når du blir tildelt eller booker selv.',
      emptyAllTitle: 'Ingen møter ennå.',
      emptyAllBody: 'Når du har møter, ser du dem her. Trykk + for å legge til et møte manuelt.',
      groupToday: 'I dag',
      groupTomorrow: 'I morgen',
      groupWeek: 'Senere i uken',
      groupLater: 'Senere',
      countSingular: '{n} møte',
      countPlural: '{n} møter',
      upcoming: 'kommende',
      past: 'tidligere',
      emptyTitle: 'Ingen kommende møter.',
      emptyBody: 'Nye møter dukker opp her automatisk.',
      emptyGroupTitle: 'Ingen møter i denne perioden.',
      modeVideo: 'Videomøte',
      modeOffice: 'På kontoret',
      statusConfirmed: 'bekreftet',
      statusPending: 'venter',
      statusCancelled: 'avlyst',
      error: 'Kunne ikke laste møter.',
    },
    services: {
      title: 'Det du tilbyr',
      kicker: 'tjenester',
      // Failed load, NOT an empty list (#2663) — says the load broke and the
      // retry button says what to do. No blame, no error code in the operator's face.
      loadErrorTitle: 'Vi fikk ikke lastet tjenestene dine.',
      sub: 'Hver tjeneste blir en egen bookingknapp på siden din.',
      newCta: '+ Ny tjeneste',
      label: 'alle tjenester',
      sortManually: 'Sorter manuelt ↕',
      statActive: 'aktive',
      statActiveSub: 'av {total}',
      statBookings: 'møter i år',
      statBookingsSub: 'fordelt på alle tjenestene',
      statAvgDuration: 'snitt-varighet',
      statAvgDurationSub: 'på tvers av tjenestene',
      gratis: 'gratis',
      priceUnset: '·',
      modeVideo: '◉ video',
      modeOffice: '⌂ kontoret',
      modeBoth: '◉⌂ video + kontoret',
      bufferLabel: '+{n} min buffer',
      hidden: 'skjult',
      private: 'privat',
      bookingsLabel: 'møter',
      bookingsCount: '{n} møte | {n} møter',
      bookingsThisYear: 'i år',
      durationLabel: 'varighet',
      priceLabel: 'pris',
      colService: 'tjeneste',
      introTip:
        'Tips: la pris stå tomt for møter du ikke fakturerer. Da viser vi heller ikke en pris-kolonne på siden din.',
      emptyTitle: 'Ingen tjenester lagt til.',
      emptyBody: 'Legg til tjenester under oppsett for å komme i gang.',
      error: 'Kunne ikke laste tjenester.',
      // FAB label, accessible name only; the plus glyph is decorative.
      fabNewService: 'Ny tjeneste',
      // Free-text search above the table (extracted fuzzy utils).
      searchPlaceholder: 'Søk i tjenestene',
      noMatchTitle: 'Ingen treff for «{q}».',
      noMatchBody: 'Prøv et annet ord, eller tøm søket for å se alle.',
      // #3549: a new service is visible on arrival, so this state is no
      // longer part of getting started — it only means the operator has
      // archived every service. The copy says that, and states the DPA as
      // a standing requirement rather than a pending step (the conditional
      // "have you accepted it" signal is BookabilityBanner's job).
      readinessKicker: 'ingen synlige tjenester',
      readinessTitle: 'Alle tjenestene dine er skjult',
      readinessBody:
        'Skjulte tjenester vises ikke på bookingsiden din, og kan ikke bestilles. Gjør en tjeneste synlig igjen for å ta imot møter. Bookingsiden krever også at databehandleravtalen er godtatt.',
      readinessCta: 'Gjør en tjeneste synlig',
    },
    availability: {
      title: 'Når kan kundene booke deg',
      kicker: 'tilgjengelighet',
      sub: 'Sett ukentlige rammer, og overstyr enkeltdager når livet ikke følger malen. Krasj med tilkoblede kalendere fjernes automatisk.',
      weeklyLabel: 'ukentlig mønster',
      weeklyHelp:
        'Standard for hver ukedag. Bruk + blokk for å dele dagen, f.eks. lunsj eller en ettermiddagsøkt.',
      addBlock: '+ blokk',
      addBlockTitle: 'Legg til ny tidsblokk (f.eks. lunsj)',
      removeBlock: 'Fjern tidsblokk',
      copyPrefix: 'Kopier',
      copySuffix: 'til alle',
      copySourceLabel: 'Velg dag å kopiere fra',
      copyAction: 'Bruk valgt dag som mal for alle andre',
      noBookingsThisDay: 'Ingen møter denne dagen',
      timeOffLabel: 'perioder · ferie og lengre fri',
      addTimeOff: '+ Legg til periode',
      noTimeOff: 'Ingen blokkeringer er satt.',
      removeTimeOff: 'fjern',
      timeOffRemoved: 'Perioden er fjernet.',
      timeOffRemoveError: 'Kunne ikke fjerne perioden. Prøv igjen.',
      previewTitle: 'Bookbare tider',
      previewKicker: 'uka {range}',
      previewAction: 'Forhåndsvis',
      previewHint:
        'Basert på dine arbeidstider. Bekreftede møter og konflikter med tilkoblede kalendere skjules også.',
      previewServiceLabel: 'Vis for tjeneste',
      previewServiceHint:
        'Velg en tjeneste for å se buffer-tid mellom møter. Uten tjeneste vises rå ledige tider.',
      previewAnyService: 'alle tjenester',
      previewClosed: 'fri',
      previewLeadToday: 'for kort varsel for i dag',
      previewFullyBooked: 'ingen ledige timer',
      overridesLabel: 'enkeltdager · overstyringer',
      overrideAdd: '+ Overstyr en dag',
      overridesEmpty: 'Ingen enkeltdager satt.',
      overrideKindClosed: 'stengt',
      overrideKindReplace: 'annen tid',
      overrideSaved: 'Overstyringen er lagret',
      overrideSaveError: 'Kunne ikke lagre overstyringen. Prøv igjen.',
      overrideDeleteError: 'Kunne ikke slette overstyringen. Prøv igjen.',
      free: 'fri',
      hoursSuffix: 'timer',
      hoursShort: 't',
      dayMon: 'Mandag',
      dayTue: 'Tirsdag',
      dayWed: 'Onsdag',
      dayThu: 'Torsdag',
      dayFri: 'Fredag',
      daySat: 'Lørdag',
      daySun: 'Søndag',
      saved: 'Tilgjengelighet lagret.',
      error: 'Kunne ikke laste tilgjengelighet.',
      saveError: 'Kunne ikke lagre tilgjengelighet.',
      validationOverlap: 'Tidsblokker kan ikke overlappe på {day}.',
      validationOrder: 'Starttid må være før sluttid på {day}.',
      fab: 'Legg til',
      fabOverride: 'Overstyr dag',
      fabTimeOff: 'Sperret periode',
    },
    calendarManage: {
      kicker: 'kalender · administrer',
      title: 'Administrer kalender',
      sub: 'Se hvilken konto som er koblet til, og koble fra hvis du vil bytte bruker eller stoppe synkroniseringen.',
      back: 'Tilbake til kalender',
      loading: 'Henter status …',
      loadError: 'Klarte ikke å hente kalenderstatusen. Prøv å laste siden på nytt.',
      syncHeading: 'Synkroniser møter til Google',
      syncBody: 'Når dette er på, dukker nye Stemne-møter automatisk opp i Google-kalenderen din.',
      syncVideoLabel: 'Videomøte',
      syncVideoDesc:
        'Vi setter videolenken som møtested så du kan starte møtet rett fra kalenderen. Tjenesten, kunde og eventuell beskjed fra kunden står i beskrivelsen.',
      syncOfficeLabel: 'På kontoret',
      syncOfficeDesc:
        'Møtestedet settes til kontoradressen din, slik at Google viser kartlenke. Resten av detaljene står i beskrivelsen.',
      syncFineprint:
        'Kunden får fortsatt bekreftelse og påminnelser fra Stemne. Vi legger ikke til kunden som deltaker i Google. Når du slår av, blir møter som allerede er i Google værende.',
      syncOneWayHeading: 'Synkroniseringen går én vei',
      syncOneWayBody:
        'Endringer du gjør i Google-kalenderen sendes ikke tilbake til Stemne. Hvis du flytter eller avlyser et møte i Google, vet ikke Stemne om det, og kunden får ingen beskjed. Endre møter herfra hvis kunden skal varsles.',
      syncTwoWayHeading: 'Endringer i Google sendes tilbake',
      syncTwoWayBody:
        'Flytter eller sletter du et Stemne-møte i Google-kalenderen, oppdateres møtet i Stemne automatisk, og kunden får beskjed. Det kan ta noen minutter før endringen er på plass.',
      syncToggleLabel: 'Synkroniser nye møter',
      syncToggleOn: 'På · nye møter dukker opp i Google',
      syncToggleOff: 'Av · nye møter skrives ikke til Google',
      syncError: 'Klarte ikke å lagre innstillingen. Prøv igjen.',
      accountsHeading: 'Tilkoblede kontoer',
      connectAnother: 'Koble til en konto til',
      primaryBadge: 'Mottar nye møter',
      makePrimary: 'Bruk for nye møter',
      readOnlyHint: 'Leses for opptatt/ledig',
      primarySet: 'Nye møter legges nå i denne kontoen.',
      primaryError: 'Klarte ikke å endre hvilken konto som mottar møter. Prøv igjen.',
      disconnectHeading: 'Koble fra Google',
      disconnectBody:
        'Vi slutter å lese opptatt/ledig fra Google-kalenderen din, og nye Stemne-møter skrives ikke lenger inn der. Eksisterende kalenderoppføringer blir liggende. Du kan slette dem manuelt om du ønsker det.',
      disconnectCta: 'Koble fra',
      confirmTitle: 'Koble fra Google-kalender?',
      confirmBody:
        'Du kobler fra {email}. Du kan koble til igjen når som helst. Innstillingene dine huskes ikke.',
      confirmCancel: 'Avbryt',
      confirmConfirm: 'Koble fra',
      disconnectError: 'Klarte ikke å koble fra. Prøv igjen.',
    },
    calendarPicker: {
      heading: 'Velg kalendere',
      sub: 'Bestem hvilke kalendere du vil se i Stemne-kalenderen, hvilke som blokkerer ledig tid, og hvor nye møter skal legges. De to første er uavhengige av hverandre. Du kan skrive til bare én kalender.',
      loading: 'Henter kalendere …',
      loadError: 'Klarte ikke å hente kalenderne dine. Prøv å laste siden på nytt.',
      empty: 'Vi fant ingen kalendere på denne kontoen. Sjekk tilgangene i Google og prøv igjen.',
      primaryBadge: 'primær',
      orphanBadge: 'fjernet',
      showInCalendar: 'Vis i kalenderen',
      syncBusy: 'Blokkerer ledig tid',
      writeTo: 'Skriv nye møter hit',
      colorLabel: 'Farge for {calendar}',
      colorPanelTitle: 'Velg farge',
      colorOption: 'Farge {hex}',
      colorReset: 'Bruk Google-fargen',
      reset: 'Tilbakestill',
      save: 'Lagre valg',
      saveSuccess: 'Kalendervalg lagret',
      saveError: 'Klarte ikke å lagre valgene. Prøv igjen.',
      errorPickWriteTarget: 'Velg én kalender som nye møter skal skrives til.',
    },
    calendar: {
      title: 'Kalender',
      kicker: 'kalender',
      sub: 'Stemne-møter sammen med kalenderne du har koblet til. Vi leser opptatt/ledig. Innholdet i andre kalendere er privat.',
      todayCta: 'I dag',
      blockCta: '+ Blokker tid',
      manage: 'Administrer →',
      settingsCta: 'Kalenderinnstillinger',
      weekHeading: 'Uke {n} · {range}',
      weekPrev: 'Forrige uke',
      weekNext: 'Neste uke',
      dayPrev: 'Forrige dag',
      dayNext: 'Neste dag',
      monthPrev: 'Forrige måned',
      monthNext: 'Neste måned',
      readOnlyHint:
        'Klikk en blokk for å se eller endre detaljer. Bare stemne-møter kan endres herfra. Eksterne kalendere er kun synkronisering.',
      providerGoogle: 'Google',
      providerApple: 'Apple',
      providerOutlook: 'Outlook',
      statusActive: '· koblet',
      statusNotConnected: '· ikke koblet',
      statusComingSoon: '· kommer',
      connectCta: 'Koble til',
      lastSyncedPrefix: 'sist synk',
      connectError: 'Klarte ikke å koble til {provider}. Prøv igjen.',
      connectErrorMissingScope:
        'Google ga ikke Stemne tilgang til kalenderen din. Prøv på nytt og pass på at du huker av kalenderboksen på Googles samtykkeskjerm.',
      label: 'integrasjoner',
      notConnected: 'Ikke tilkoblet',
      comingSoon: 'Integrasjon med kalendertjenester kommer snart.',
    },
    documents: {
      title: 'Dokumenter',
      kicker: 'delte dokumenter',
      sub: 'Et delt rom for filer mellom deg og kunden. Privat, innlogget og kan trekkes tilbake, ikke som et e-postvedlegg.',
      shareCta: 'Del dokument',
      searchPlaceholder: 'Søk i filnavn eller kunder…',
      tabAll: 'Alle',
      tabActive: 'Aktive',
      tabExpired: 'Utløpt',
      tabRevoked: 'Tilbaketrukket',
      tabReceived: 'Mottatt fra kunde',
      colDocument: 'dokument',
      colCustomer: 'kunde',
      colShared: 'delt',
      colExpiry: 'utløp',
      colStatus: 'status',
      statusActive: 'aktiv',
      statusExpired: 'utløpt',
      statusRevoked: 'trukket tilbake',
      statusReceived: 'mottatt',
      policyView: 'kun visning',
      policyDownload: 'nedlastbar',
      noExpiry: 'ingen utløp',
      emptyTitle: 'Ingen delte dokumenter ennå',
      emptyBody: 'Når du deler en fil med en kunde, dukker den opp her sammen med status og utløp.',
      emptyFilteredTitle: 'Ingenting å vise',
      emptyFilteredBody: 'Ingen dokumenter matcher det du leter etter.',
      errorTitle: 'Kunne ikke laste dokumenter',
      search: {
        sectionTitle: 'Søk og kategori',
        makeSearchable: 'Gjør søkbar',
        makeSearchableDesc:
          'Gjør dokumentet søkbart i dokumentsøket. Av som standard, og kun synlig for deg.',
        category: 'Kategori',
        noCategory: 'Ingen kategori',
        newCategory: 'Ny kategori',
        newCategoryPlaceholder: 'f.eks. Faktura',
        addCategory: 'Legg til',
        manageCategories: 'Administrer kategorier',
        deleteCategory: 'Slett kategori',
        categoryDuplicate: 'Kategorien finnes allerede',
        errorGeneric: 'Noe gikk galt. Prøv igjen.',
        toastSearchableOn: 'Dokumentet er nå søkbart',
        toastSearchableOff: 'Dokumentet er ikke lenger søkbart',
        toastCategorySet: 'Kategori oppdatert',
        toastCategoryCreated: 'Kategori lagt til',
        toastCategoryDeleted: 'Kategori slettet',
        searchableTag: 'søkbar',
        searchableTitle: 'Dette dokumentet er søkbart i dokumentsøket',
        modeArchive: 'Arkiv',
        modeSearch: 'Søk i innhold',
        modeSwitchAria: 'Velg visning',
        contentPlaceholder: 'Søk i filnavn og innhold…',
        facetAll: 'Alle',
        prompt: 'Skriv for å søke i dokumentinnhold på tvers av kunder.',
        searching: 'Søker…',
        noResults: 'Ingen dokumenter matcher søket.',
        unavailable: 'Søk er ikke tilgjengelig akkurat nå.',
        directionOut: 'delt av deg',
        directionIn: 'mottatt',
        internal: 'internt',
        openAria: 'Åpne {name}',
      },
      manage: {
        title: 'Administrer deling',
        kicker: 'deling',
        sharedAt: 'delt',
        expiresAt: 'utløper',
        noExpiry: 'ingen utløp',
        recipient: 'mottaker',
        policy: 'tilgang',
        size: 'størrelse',
        message: 'melding',
        actionsHeader: 'Handlinger',
        activityHeader: 'Hendelser',
        activityLoading: 'Henter hendelser…',
        activityEmpty: 'Ingen hendelser registrert ennå.',
        preview: 'Åpne dokument',
        previewBusy: 'Henter lenke…',
        previewError: 'Kunne ikke åpne dokumentet.',
        previewBlocked: 'Nettleseren blokkerte en ny fane. Tillat popup-vinduer og prøv igjen.',
        revoke: 'Trekk tilbake',
        revokeBusy: 'Trekker tilbake…',
        revokeConfirmTitle: 'Trekke tilbake denne delingen?',
        revokeConfirmBody:
          'Lenken slutter å virke for kunden umiddelbart. Du kan dele dokumentet på nytt senere.',
        revokeConfirmCta: 'Ja, trekk tilbake',
        revokeConfirmCancel: 'Avbryt',
        extend: 'Forleng utløp',
        extend7: '+7 dager',
        extend30: '+30 dager',
        extend90: '+90 dager',
        extendNever: 'Ingen utløp',
        extendBusy: 'Oppdaterer…',
        policyView: 'Sett til kun visning',
        policyDownload: 'Tillat nedlasting',
        policyBusy: 'Oppdaterer…',
        toastRevoked: 'Tilgang trukket tilbake',
        toastExtended: 'Utløp oppdatert',
        toastPolicy: 'Tilgang oppdatert',
        notManageable:
          'Denne delingen kan ikke endres lenger. Du kan dele dokumentet på nytt fra arkivet.',
        reshare: 'Del på nytt',
        changeRecipient: 'Del med en annen kunde',
        encryption: 'Kryptering',
        encryptedBadge: 'Kryptert',
        encEnable: 'Krypter filen',
        encDisable: 'Skru av kryptering',
        encBusy: 'Oppdaterer…',
        encDisableTitle: 'Skru av kryptering',
        encDisableBody:
          'Filen lagres da ukryptert i skylagringen. Innholdet beskyttes bare av tilgangskontroll. Ikke skru av for dokumenter med helseopplysninger.',
        encDisableConfirm: 'Skru av kryptering',
        encToastEnabled: 'Filen er kryptert',
        encToastDisabled: 'Kryptering er skrudd av',
        encErrIndexable: 'Filen er søkbar. Skru av innholdssøk før du krypterer.',
        encErrDpaStale: 'Databehandleravtalen må godtas på nytt før du kan kryptere.',
        encErrInProgress: 'En annen endring pågår, prøv igjen.',
      },
    },
    customers: {
      title: 'Kundene dine',
      kicker: 'kunder',
      // "et møte", ikke "en time" — møte er det kanoniske ordet på operatør-
      // flatene, og engelsk sier "a meeting" i samme setning.
      sub: 'Alle som noen gang har booket et møte. Ingen ser dette utenom deg og dem du har gitt rådgiver-tilgang til.',
      newCta: '+ Legg til manuelt',
      label: 'alle kunder',
      searchPlaceholder: 'Søk i kunder…',
      tabAll: 'Alle',
      tabActive: 'Aktive',
      tabNew: 'Nye',
      tabPaused: 'Pause',
      colCustomer: 'kunde',
      colMeetings: 'bookinger',
      colLast: 'siste',
      colNext: 'neste',
      colValue: 'Pris',
      statTotal: 'totalt',
      statTotalSub: 'kunder',
      statNew: 'nye denne måneden',
      statNewSub: 'siste 30 dager',
      statRevenue: 'omsetning hittil',
      statRevenueSub: 'eks. mva',
      statMeetingsThisMonth: 'møter denne måneden',
      statMeetingsThisMonthSub: 'på tvers av kunder',
      noNext: '·',
      nextRequested: 'forespurt',
      emptyMatch: 'Ingen kunder matcher «{q}».',
      emptyMatchBody: 'Prøv et annet søkeord eller fjern filteret.',
      emptyFilterTitle: 'Ingen kunder i denne visningen.',
      emptyFilterBody: 'Bytt filter for å se andre kunder, eller fjern det helt.',
      emptyTitle: 'Ingen kunder ennå.',
      emptyBody: 'Kundene dine dukker opp her etter første møte.',
      tagPar: 'par',
      tagIndivid: 'individ',
      tagIntro: 'intro',
      tagNy: 'ny',
      tagFast: 'fast',
      tagPause: 'pause',
      name: 'Navn',
      email: 'E-post',
      bookings: 'Bookinger',
      lastBooking: 'Siste booking',
      error: 'Kunne ikke laste kunder.',
      // FAB label, accessible name only; the plus glyph is decorative.
      fabNewCustomer: 'Ny kunde',
    },
    customerDetail: {
      kicker: 'kunde',
      crumb: 'Kunder',
      since: 'kunde siden {when}',
      sinceActive: 'kunde · aktiv',
      writeNote: 'Skriv et notat',
      bookMeeting: 'Book et møte',
      historyKicker: 'historikk',
      historyTitle: 'Alt vi har om {name}.',
      historyOrder: 'nyeste først',
      filterAll: 'alle',
      filterMeetings: 'møter',
      filterNotes: 'notater',
      filterComments: 'samtaler',
      searchPlaceholder: 'søk i {name}s historikk …',
      personalKicker: 'personlige notater',
      personalAdd: '+ legg til',
      personalSub:
        'Det du har lagt merke til om {name} på tvers av møtene. Kunden ser dem ikke i portalen, men kan be om innsyn.',
      personalAuthorYou: 'merket av deg',
      personalAuthorOther: 'merket av {who}',
      personalEdit: 'Rediger',
      personalDelete: 'Slett',
      nextKicker: 'neste møte',
      nextJoin: 'Bli med i møtet',
      nextPrep: 'Åpne forberedelsene',
      contactKicker: 'kontakt',
      contactEmail: 'e-post',
      contactPhone: 'telefon',
      contactSince: 'siden',
      rowMeeting: 'møte',
      rowNote: 'notat',
      rowComment: 'kommenterte på',
      rowAuthorYou: 'skrevet av deg',
      rowAuthorOther: 'skrevet av {who}',
      rowOpenMeeting: 'Åpne møtet',
      rowReplies: '{n} svar',
      emptyTitle: 'Ingen historikk ennå.',
      emptyBody:
        'Møter, notater og samtaler om denne kunden vises her etter hvert som dere jobber sammen.',
      loadError: 'Kunne ikke laste historikken.',
      notFound: 'Fant ikke kunden.',
      // Used in inline copy ("Alt vi har om {name}", "{name}s historikk")
      // when no name is available yet. The hero title still shows the
      // raw email, this only swaps the embedded sentence usage.
      referenceFallback: 'denne kunden',
      notFoundBody: 'Sjekk URL-en, eller gå tilbake til kundelisten og finn riktig kunde der.',
      notFoundBack: 'Tilbake til kundelisten',
      noMatchTitle: 'Ingen treff i denne visningen.',
      noMatchBody: 'Prøv et annet søkeord eller bytt filter.',
      resetFilter: 'Nullstill filter',
    },
    settings: {
      title: 'Innstillinger',
      profileLabel: 'profil',
      profileName: 'Navn',
      profileEmail: 'E-post',
      profileSaved: 'Profil lagret.',
      profileError: 'Kunne ikke lagre profil.',
      accountLabel: 'konto',
      currentPassword: 'Nåværende passord',
      newPassword: 'Nytt passord',
      passwordChanged: 'Passord endret.',
      passwordError: 'Kunne ikke endre passord.',
    },
  },

  services: {
    heading: 'Book en time',
    headingNoPrice: 'Avtal et møte',
    subheading: 'Velg en tjeneste og finn en ledig tid',
    empty: 'Ingen tjenester er tilgjengelige.',
    loadFailed: 'Kunne ikke laste tjenestene. Last siden på nytt.',
    gratis: 'gratis',
    // Suffix on a price the operator charges mva on. Appended by
    // servicePriceLabel, never written into a template by hand — the four
    // booking surfaces have to say this the same way.
    inklMva: 'inkl. mva',
    privateTitle: 'Denne siden er privat.',
    privateBody:
      'Booking skjer etter avtale. Hvis du venter en lenke, sjekk e-posten, eller kontakt operatøren direkte.',
    unavailableTitle: 'Booking er ikke tilgjengelig.',
    unavailableBody:
      'Det er ikke mulig å booke nye møter her akkurat nå. Har du allerede et møte, gjelder det fortsatt, og lenken i e-posten din virker som før.',
  },

  booking: {
    // Deposit disclosure (#3080). Shared by the service listing, the person
    // listing and the confirm step — one string so the three surfaces cannot
    // describe the same money three ways, and so it stays in step with the
    // awaiting-payment email's booking_verification.awaiting.deposit* copy.
    //
    // Rendered only when the booking charge is genuinely SMALLER than the
    // price (see utils/deposit.ts). The remainder is stated as a plain fact,
    // never a due date or a payment link: it is settled outside Stemne, so
    // promising a mechanism here would be a promise the product cannot keep.
    depositNote: 'Du betaler {dueNow} nå · {remaining} gjenstår',
    afterNote: 'Betales etter timen',
    stepTime: 'tid',
    stepDetails: 'detaljer',
    stepConfirm: 'bekreft',
    stepPayment: 'betaling',
    stepperAriaLabel: 'Bookingfremdrift',

    pickTime: {
      backToProfile: 'Tilbake til profil',
      heading: 'Velg et tidspunkt',
      sub: 'Ledige tider vises i din tidssone. Møtet varer {duration} minutter.',
      sidebarLabel: 'du booker',
      morning: 'morgen',
      afternoon: 'ettermiddag',
      slotCount: '{count} ledig time | {count} ledige timer',
      slotCountEmpty: 'fullt',
      lastSeat: 'få plasser igjen',
      // Empty-day state under the month calendar (#1936).
      emptyDayHeading: 'Ingen ledige tider denne dagen.',
      emptyDayHint: 'velg en annen dato i kalenderen',
      nesteLedige: 'neste ledige: {date}',
    },

    bookCalendar: {
      heading: 'Velg dato',
      backToTime: 'Tilbake til tider',
      today: 'i dag',
      prevMonth: 'Forrige måned',
      nextMonth: 'Neste måned',
      gridAria: 'Kalender, {month} {year}',
      // #1416/#1418, pipe-form pluralisation so 1 → "1 ledig tid"
      // (entall) and 0/2+ → "N ledige tider" (flertall). Screen readers
      // on cells with exactly one slot were reading "1 ledige tider".
      cellAria: '{date}. {month}, {count} ledig tid | {date}. {month}, {count} ledige tider',
      legendAvailable: 'ledig',
      legendLow: 'få plasser',
      legendClosed: 'fullt eller stengt',
      blockedPast: 'Denne dagen har vært. Velg en dag fram i tid.',
      blockedLoading: 'Henter ledige tider. Prøv igjen om et øyeblikk.',
      blockedFull: '{date}. {month} er fullt eller stengt. Velg en annen dag.',
      retry: 'Prøv igjen',
    },

    details: {
      backToTime: 'Tilbake til tid',
      heading: 'Om deg',
      sub: 'Vi trenger navn og e-post så vi kan sende deg bekreftelsen.',
      nameLabel: 'Navn',
      namePlaceholder: 'Skriv inn navn',
      emailLabel: 'E-post',
      emailPlaceholder: "din{'@'}epost.no",
      emailHint: 'Vi sender bekreftelsen hit. Ingen markedsføring.',
      phoneLabel: 'Telefon (valgfritt)',
      // {role} is the definite role noun for the picked service's kind
      // (useRoleNoun, #2014) — "treneren din" for a PT, not "rådgiveren din".
      phoneHint:
        'Brukes kun til en SMS-påminnelse 24 timer før møtet, dersom {role} din har skrudd det på.',
      addressLabel: 'Adresse (valgfritt)',
      addressPlaceholder: 'Søk etter adresse',
      addressHint: 'Oppgi adressen hvis {role} skal komme til deg.',
      // The label communicates requiredness without native validation (#3503).
      billingAddressLabel: 'Fakturaadresse (påkrevd)',
      billingAddressReceiptHint: 'Trengs på kvitteringen.',
      billingAddressHint: 'Brukes på fakturaen etter at tjenesten er levert.',
      billingAddressRequired: 'Oppgi fakturaadressen.',
      subjectLabel: 'Emne',
      noteLabel: 'Hva vil du snakke om?',
      noteOptional: '(valgfritt)',
      notePlaceholder: 'Kort om konteksten. En-to setninger holder.',
      trainingNoteLabel: 'Litt om deg og målet ditt',
      trainingNotePlaceholder:
        'Mål, erfaring, skader eller plager treneren bør vite om. En-to setninger holder.',
      recurrenceLabel: 'Gjenta',
      recurrenceHint:
        'Book en serie. Hvert møte havner i kalenderen din, du kan avbestille hele serien eller ett og ett.',
      recurrenceCountLabel: 'Antall ganger',
      recurrenceNone: 'Bare denne ene',
      recurrenceWeekly: 'Ukentlig',
      recurrenceBiweekly: 'Annenhver uke',
      recurrenceMonthly: 'Månedlig',
      recurrenceCountOption: '{n} ganger',
      submit: 'Gå til bekreftelse',
      reviewPayment: 'Se over før betaling',
    },

    confirm: {
      backToDetails: 'Tilbake til detaljer',
      heading: 'Se over og bekreft',
      paymentHeading: 'Se over før betaling',
      paymentSub:
        'Vi holder av tiden mens du betaler. Møtet blir bekreftet når betalingen er gjennomført, og du får bekreftelsen på e-post.',
      paymentSubmit: 'Gå til betaling',
      sub: 'Alt ser riktig ut? Trykk bekreft, så sender vi bekreftelsen på e-post med en gang.',
      labelService: 'tjeneste',
      labelTime: 'tid',
      labelWith: 'med',
      labelYou: 'du',
      labelNote: 'notat',
      labelPrice: 'pris',
      timePrefix: 'kl',
      edit: 'Endre',
      submit: 'Bekreft møtet',
      submitting: 'Sender...',
      ackTitle: 'Les før du bekrefter',
      ackConfirm: 'Jeg har lest og forstått',
      // «Vilkår og angrerett» (#3043). Replaces the old flat disclaimer,
      // which promised "avbestill når som helst" and then threatened a
      // hardcoded 24-timers fakturering regardless of what the operator had
      // actually set. termsChangeLead now states the operator's real window.
      termsTitle: 'Vilkår og angrerett',
      termsChangeLead:
        'Du kan endre eller avbestille avtalen fram til {hours} timer før den starter.',
      termsChangeAnytime: 'Du kan endre eller avbestille avtalen når som helst.',
      angrerettSummary:
        'Du har 14 dagers angrerett fra du inngår avtalen. Angreretten faller bort når tjenesten er levert fullt ut.',
      // Named for what /angreskjema actually holds: the statutory form and
      // the § 8 information about the right of withdrawal. It carries no
      // "vilkår" — the operator's own change and cancellation terms are the
      // two lines directly above this link, inline, with no route of their
      // own. The old label sent the customer looking for a terms page that
      // has never existed.
      angrerettLink: 'Les om angreretten og hent angreskjemaet',
      // § 9 a (1) d: hvem som selger og hvem som bare leverer systemet. Vises
      // på hver bestilling, uavhengig av pris — hvem du har avtalen med er like
      // sant for en gratis time.
      sellerDisclosure:
        '{name} er selgeren og har avtalen med deg. Stemne leverer bookingsystemet og er ikke part i avtalen.',
      sellerFallback: 'Tjenesteyteren',
      // The § 12 request and the § 22 c acknowledgement in one sentence,
      // because they are one decision for the customer. The wording revision
      // is recorded on the booking as booking.AngrerettConsentVersion; bump
      // that constant if the substance here changes.
      angrerettConsentTitle: 'Før du bekrefter',
      angrerettConsent:
        'Dersom timen er før angrefristen på 14 dager er utløpt, ber jeg om at tjenesten likevel leveres, og er kjent med at angreretten faller bort når tjenesten er levert fullt ut.',
    },

    // Angrerett (#3043). rightBody and effectsBody below are the MODEL TEXT
    // from «Skjema for opplysninger om angrerett» and the angreskjema
    // Q-0319B (FOR-2014-06-20-777). They are reproduced verbatim, not
    // written: angrerettloven § 8 (2) treats giving the standardised
    // information as compliance, and § 21 extends the withdrawal window by
    // twelve months when it is not given. Do not edit them for tone.
    angreskjema: {
      title: 'Angreskjema',
      subtitle: 'ved kjøp av varer og tjenester som ikke er finansielle tjenester',
      print: 'Skriv ut',
      formIntro: 'Fyll ut og returner dette skjemaet bare dersom du ønsker å gå fra avtalen.',
      sendTo: 'Utfylt skjema sendes til:',
      declaration:
        'Jeg/vi underretter herved om at jeg/vi ønsker å gå fra min/vår avtale om kjøp av følgende:',
      optionGoods: 'varer',
      optionServices: 'tjenester (spesifiser på linjene nedenfor)',
      fieldSpecify: 'Spesifikasjon',
      fieldContractDate: 'Avtalen ble inngått den (dato)',
      fieldConsumerName: 'Forbrukerens/forbrukernes navn',
      fieldConsumerAddress: 'Forbrukerens/forbrukernes adresse',
      fieldDate: 'Dato',
      fieldSignature: 'Forbrukerens/forbrukernes underskrift (bare dersom papirskjema benyttes)',
      infoTitle: 'Opplysninger om angrerett',
      rightTitle: 'Angrerett.',
      rightBody:
        'Du har rett til å gå fra denne avtalen innen 14 dager uten å oppgi noen grunn for dette. Angrefristen utløper 14 dager etter inngåelsen av avtalen. For å kunne bruke angreretten må du underrette oss ({contact}) på en utvetydig måte om din beslutning om å gå fra avtalen (f.eks. i et brev sendt med post eller e-post). Du kan benytte det vedlagte angreskjemaet, men det er ikke obligatorisk. For å overholde angrefristen er det tilstrekkelig at du sender meldingen om at du vil bruke angreretten før angrefristen utløper.',
      rightBodyNoContact:
        'Du har rett til å gå fra denne avtalen innen 14 dager uten å oppgi noen grunn for dette. Angrefristen utløper 14 dager etter inngåelsen av avtalen. For å kunne bruke angreretten må du underrette den næringsdrivende på en utvetydig måte om din beslutning om å gå fra avtalen (f.eks. i et brev sendt med post eller e-post). Du kan benytte det vedlagte angreskjemaet, men det er ikke obligatorisk. For å overholde angrefristen er det tilstrekkelig at du sender meldingen om at du vil bruke angreretten før angrefristen utløper.',
      effectsTitle: 'Virkningene av at angreretten brukes.',
      effectsBody:
        'Dersom du går fra denne avtalen, skal vi tilbakebetale alle betalinger vi har mottatt fra deg, uten unødig opphold og i alle tilfeller senest 14 dager etter den dag vi mottar melding om din beslutning om å gå fra denne avtalen. Vi foretar tilbakebetalingen med samme betalingsmiddel som du benyttet ved den opprinnelige transaksjonen, med mindre du uttrykkelig har avtalt noe annet med oss. I alle tilfeller vil du ikke bli pålagt noe gebyr som følge av tilbakebetalingen. Dersom du har anmodet om at utførelsen av tjenestene skal påbegynnes før angrefristen utløper, skal du betale oss et beløp som står i forhold til det som er utført eller levert fram til du underrettet oss om at du ønsket å gå fra avtalen, sammenlignet med full oppfyllelse av avtalen.',
      orgnrLabel: 'Organisasjonsnummer',
    },

    // Pay-at-booking (#1191). The customer is handed to Stripe Checkout after
    // the booking is created; this covers the one way that can end badly HERE
    // — we could not start the session. Pressing "tilbake" på Stripe lands on
    // the manage page now (manage.payment.cancelledNotice), which owns the
    // booking and can reopen Checkout for it.
    payment: {
      startFailed: 'Vi fikk ikke startet betalingen. Prøv igjen om litt.',
    },

    confirmed: {
      meta: 'møtet er bekreftet',
      heading: 'Vi sees {day}.',
      sub: 'En bekreftelse er sendt til {email}. Du kan administrere møtet herfra når som helst.',
      meetingPlace: 'Møtested',
      manage: 'Administrer møtet',
      addToCalendar: 'Legg til i kalender',
      portalHintLede: 'Vil du se alle møtene dine, eller laste ned eller slette dine data?',
      portalHintLink: 'Åpne kundeportalen',
      portalHintTail: 'logg inn med e-posten din.',
    },
  },

  portal: {
    entry: {
      // Header link sits beside "Logg inn" on the tenant booking landing.
      // Bare noun: this is a destination label, not a verb-prompt.
      headerLink: 'Mine møter',
      // Footer link is lowercase to sit naturally between "personvern"
      // and "vilkår" in the small-print row.
      footerLink: 'mine møter',
    },
    eyebrow: 'mine møter',
    heading: 'Hva er e-postadressen din?',
    body: 'Vi sender deg en innloggingslenke. Bruk samme adresse som da du booket møtet, så finner vi møtene dine.',
    emailLabel: 'E-post',
    submit: 'Send meg lenken',
    // Microcopy below the email form. Reassures the customer that there
    // is no password to remember and pre-empts "is this lenke safe?".
    passwordless:
      'Vi bruker ikke passord. Lenken er gyldig i 15 minutter og kan bare brukes én gang.',
    sentEyebrow: 'sjekk innboksen din',
    sentHeading: 'Lenken er på vei.',
    // {email} is rendered as a mono pill in the template, so the rest
    // of the sentence reads around it. Keep the punctuation outside.
    sentBody:
      'Vi sendte en innloggingslenke til {email}. Klikk lenken i e-posten for å se møtene dine.',
    sentTipsTitle: 'finner du den ikke?',
    // No sender address here: it varies per environment and tenant
    // (BREVO_FROM_EMAIL / org_config.smtp_from). The previously
    // hardcoded no-reply address never existed in any config, so
    // customers searching spam for it found nothing (qa-bot
    // #1554/#1563). The copyGuards spec pins this.
    sentTipSpam: 'Sjekk mappa for søppelpost.',
    sentTipAddress: 'Kanskje brukte du en annen e-postadresse da du booket?',
    sentTipResend: 'Send på nytt etter 30 sekunder.',
    sentResendCountdown: 'send på nytt om {n}s',
    sentResendReady: 'Send lenken på nytt',
    sentBack: 'Bruk en annen adresse',
    authHeading: 'Velkommen tilbake, {name}.',
    authSummary:
      'Du har {upcoming} kommende møter og {past} tidligere. Klikk et møte for å se detaljer, avbestille eller flytte tiden.',
    authSummaryNoneUpcoming: 'Du har ingen kommende møter. {past} tidligere møter ligger her.',
    authSummaryNonePast: 'Du har {upcoming} kommende møter. Ingen tidligere møter enda.',
    authBookNew: 'Book ny samtale',
    upcoming: 'Kommende møter',
    past: 'Tidligere møter',
    upcomingCount: '{n} møte | {n} møter',
    pastCount: '{n} møter · siste 3 år',
    pastFootnote: 'møter eldre enn 3 år vises i dataeksporten · ikke i denne lista',
    emptyUpcoming: 'Ingen kommende møter. Book et nytt møte under.',
    emptyPast: 'Ingen tidligere møter.',
    // Stand-alone "no bookings at all" state. The portal user authed
    // but we found nothing; they may be on a different address than
    // the one they booked with.
    noneEyebrow: 'mine møter',
    noneHeading: 'Ingen møter enda.',
    noneBody:
      'Vi finner ingen møter knyttet til {email}. Møter eldre enn 3 år vises ikke her, men ligger i dataeksporten.',
    noneBookCta: 'Book ditt første møte',
    noneTryOther: 'Prøv en annen e-postadresse',
    expiredEyebrow: 'lenken er utløpt',
    expiredTitle: 'Denne lenken er brukt opp eller utløpt.',
    expiredBody: 'Du kan be om en ny lenke under.',
    expiredCta: 'Be om ny lenke',
    logout: 'Logg ut',
    account: {
      eyebrow: 'konto & personvern',
      exportTitle: 'Last ned dataene mine',
      exportBody:
        'En kopi av alt vi har om deg: kontaktinfo, alle møter, betalingshistorikk. Sendt som zip til e-posten din.',
      exportCta: 'Be om eksport',
      exportSent: 'Lenke sendt. Sjekk innboksen.',
      deleteTitle: 'Slett kontoen min',
      deleteBody:
        'Sletter alt vi har om deg hos {tenant}. Kommende møter blir avlyst. Kan ikke angres.',
      deleteCta: 'Slett kontoen',
      deleteSent: 'Bekreftelseslenke sendt.',
      // Fallback when we don't have the tenant's display name (rare,
      // but covers the bootstrapped pre-brand state).
      fallbackTenantName: 'oss',
      controllerNote:
        '{tenant} er behandlingsansvarlig for dine data. Spørsmål? Kontakt operatøren direkte.',
    },

    deleteModal: {
      eyebrow: 'slette kontoen',
      heading: 'Er du sikker?',
      lead: 'Dette sletter alt vi har om deg hos {tenant}. Det kan ikke angres.',
      listTitle: 'dette blir slettet',
      listAccountKey: 'Kontoen',
      listAccountValue: 'e-post, navn, telefon',
      listBookingsKey: 'Møter',
      listBookingsValue: '{upcoming} kommende avlyses · {past} tidligere fjernes',
      listNotesKey: 'Notater',
      listNotesValue: 'spørreskjema-svar og meldinger til {tenant}',
      listPaymentKey: 'Betaling',
      listPaymentValue: 'vi beholder anonymiserte kvitteringer i 5 år (regnskapsplikt)',
      typePrompt: 'skriv slett for å bekrefte',
      typePlaceholder: 'slett',
      cancel: 'Avbryt',
      confirm: 'Slett kontoen permanent',
    },
  },

  privacy: {
    myData: {
      loading: 'Henter dataene dine',
      eyebrow: 'dine data',
      heading: 'Her er alt vi har om deg',
      lede: 'Dette er det vi har lagret knyttet til {email}. Du kan laste det ned som en JSON-fil under.',
      download: 'Last ned som JSON',
      bookings: 'Møter ({n})',
      bookingsEmpty: 'Ingen møter registrert.',
      account: 'Kontoopplysninger',
      accountFields: {
        name: 'Navn',
        email: 'E-post',
        phone: 'Telefon',
        address: 'Adresse',
        postal: 'Postnummer og sted',
        locale: 'Språk',
        tags: 'Merkelapper',
        note: 'Notat rådgiveren har lagt på kortet ditt',
        created: 'Registrert',
      },
      personalNotes: 'Notater rådgiveren har skrevet om deg',
      personalNotesLede:
        'Notater rådgiveren har skrevet om deg er med her. Notater som er knyttet til behandling og helse er ikke med i denne eksporten. Be rådgiveren om dem direkte, det er rådgiveren som er behandlingsansvarlig for dem.',
      personalNotesEmpty: 'Ingen notater er skrevet om deg.',
      thirdParties: 'Hvem vi deler opplysninger med',
      thirdPartiesLede:
        'Disse leverandørene behandler deler av opplysningene dine på våre vegne, slik personvernforordningen artikkel 15 krever at vi opplyser om.',
      thirdPartiesShares: 'Mottar',
      status: {
        pending: 'venter på bekreftelse',
        confirmed: 'bekreftet',
        rescheduled: 'flyttet',
        cancelled: 'avlyst',
        completed: 'gjennomført',
        no_show: 'ikke møtt',
        expired: 'utløpt',
      },
      expiredEyebrow: 'lenken er utløpt',
      expiredTitle: 'Denne lenken er brukt opp eller utløpt.',
      expiredBody:
        'Lenker fra personvern-e-poster er gyldige i 24 timer og kan kun brukes én gang. Be om en ny under.',
      expiredCta: 'Til kundeportalen',
      errorEyebrow: 'noe gikk galt',
      errorTitle: 'Kunne ikke hente dataene dine.',
      errorBody:
        "Prøv å åpne lenken på nytt. Hvis problemet vedvarer, kontakt personvern{'@'}stemne.no.",
    },
    confirmDelete: {
      eyebrow: 'bekreft sletting',
      heading: 'Slette alle dataene dine?',
      body: 'Du er ett klikk unna å slette alt. Vi vil ikke kunne hente det tilbake etterpå.',
      bullet1: 'Alle møter, både kommende og tidligere, blir slettet',
      bullet2: 'Kontaktinformasjonen og notatene knyttet til e-posten din forsvinner',
      bullet3: 'Du blir logget ut av kundeportalen',
      cta: 'Slett alt om meg',
      cancel: 'Avbryt',
      doneEyebrow: 'ferdig',
      doneHeading: 'Dataene dine er slettet',
      doneBody:
        'Vi slettet {n} oppføring. Takk for at du brukte oss. Vi beklager at du forlater. | Vi slettet {n} oppføringer. Takk for at du brukte oss. Vi beklager at du forlater.',
      doneCta: 'Til forsiden',
      expiredEyebrow: 'lenken er utløpt',
      expiredTitle: 'Denne lenken er brukt opp eller utløpt.',
      expiredBody: 'Be om en ny slettelenke fra kundeportalen din.',
      expiredCta: 'Til kundeportalen',
      errorEyebrow: 'noe gikk galt',
      errorTitle: 'Sletting feilet.',
      errorBody:
        "Prøv å åpne lenken på nytt. Hvis problemet vedvarer, kontakt personvern{'@'}stemne.no.",
    },
  },

  manage: {
    eyebrow: 'ditt møte',
    heading: 'Møte med {name}',
    upcomingMeeting: 'kommende møte',
    joinMeeting: 'Bli med i møtet',
    opensIn: 'Møtet åpner om',
    addToCalendar: 'Legg til i kalender',
    remindersHeading: 'Påminnelser',
    remindersBody:
      'Vi sender en påminnelse før møtet begynner. Du kan velge tidspunkt eller slå av hvis du foretrekker det.',
    getReminder: 'Få påminnelse',
    reminder24h: '24 timer før',
    reminder1h: '1 time før',
    reminder15m: '15 minutter før',
    participantsHeading: 'Deltakere',
    participantsBody: 'Inviter flere inn i møtet.',
    inviteColleagues: 'Inviter kollegaer',
    seatsUsed: '{used}/{capacity} plasser brukt',
    addParticipant: 'Legg til',
    invite: {
      loading: 'Henter deltakere',
      empty: 'Ingen andre er invitert ennå.',
      nameLabel: 'Navn',
      emailLabel: 'E-post',
      remove: 'Fjern',
      statusPending: 'venter',
      statusConfirmed: 'bekreftet',
      full: 'Møtet er fullt. Fjern noen for å invitere flere.',
      loadFailed: 'Vi fikk ikke hentet deltakerne.',
      addFailed: 'Vi fikk ikke lagt til deltakeren. Prøv igjen.',
      removeFailed: 'Vi fikk ikke fjernet deltakeren. Prøv igjen.',
    },
    reschedule: 'Endre tidspunkt',
    // Shown when the meeting needs a proposal (group or approval-required) but
    // the propose flow is unavailable, so the customer can't change the time
    // themselves and is pointed to the operator.
    contactToReschedule: 'Ta kontakt med rådgiveren for å endre tidspunkt',
    // Group meeting: the customer proposes a time to the operator instead of
    // moving the meeting directly (booking.suggest-time).
    suggestTime: 'Foreslå nytt tidspunkt',
    suggestDate: 'Dato',
    suggestTimeLabel: 'Tidspunkt',
    suggestNote: 'Beskjed til rådgiveren (valgfritt)',
    suggestSubmit: 'Send forslag',
    suggestTimeSent: 'Forslaget er sendt. Rådgiveren svarer deg på e-post.',
    cancel: 'Avbestill',
    // Default late-change warning (#2290). Vises til kunden ved enhver
    // flytting/avbestilling under 24 timer når tjenesten ikke har en egen
    // operatør-forfattet tekst. Operatørens tekst vinner når den finnes.
    lateChange: {
      defaultWarning: 'Du endrer mindre enn 24 timer før møtet. Timen kan bli fakturert.',
    },
    cancelModal: {
      heading: 'Avbestille møtet?',
      body: 'Møtet med {name} ({slot}) blir slettet fra kalenderen. {name} får beskjed.',
      // Unassigned booking (admin_id NULL → "Tildeles" placeholder in
      // the consultant card). The placeholder is NOT a person's name;
      // interpolating it into `body` produced "Møtet med Tildeles …
      // Tildeles får beskjed." (qa-bot #1562). Credit the org instead,
      // matching the /booking/cancelled page ("{org} har fått beskjed").
      bodyUnassigned: 'Møtet ditt ({slot}) blir slettet fra kalenderen. {org} får beskjed.',
      hint: 'Du kan booke en ny tid når som helst.',
      keep: 'Behold møtet',
      confirm: 'Avbestill møtet',
    },
    meeting: 'Møte',
    consultant: 'Rådgiver',
    sharedSummary: 'Oppsummering fra rådgiveren',
    // Group & team meeting card (gruppesamtale / flere verter).
    youMeet: 'Du møter',
    alsoWith: 'Også med',
    participants: 'Deltakere',
    groupTag: 'Gruppe',
    messageFrom: 'Melding fra {name}',
    // Pay-at-booking status on the meeting card + the return-trip banner
    // (#1191). A charge that has not settled says "bekreftes nå" — never
    // "ubetalt", because the customer may have paid seconds ago.
    payment: {
      label: 'betaling',
      labelPaid: 'betalt',
      paidWithAmount: '{amount} er betalt.',
      paid: 'Betalingen er registrert.',
      pending: 'Vi bekrefter betalingen din nå. Det tar vanligvis noen sekunder.',
      failed: 'Betalingen ble ikke fullført. Ta kontakt med oss, så ordner vi det.',
      refunded: 'Beløpet er refundert.',
      // #3044 — `refunded` alene betyr bare at Stripe tok imot refusjonen.
      // På en direkte belastning kan den bli liggende som `pending` til
      // rådgiverens saldo dekker den, og en ventende refusjon kan feile.
      // Da er «Beløpet er refundert» feil, og det er kundens penger.
      refundPending:
        'Refusjonen er sendt til banken din og behandles. Pengene er tilbake på kortet innen 5–10 virkedager.',
      refundFailed:
        'Refusjonen kunne ikke gjennomføres av banken. {org} tar kontakt med deg for å ordne det.',
      // Samme situasjon, men uten navnet på tilbyderen (merkevaren er ikke
      // lastet ennå). En setning med hull i er verre enn en nøytral.
      refundFailedNoOrg:
        'Refusjonen kunne ikke gjennomføres av banken. Ta kontakt med tilbyderen om du ikke hører noe.',
      receivedBanner: 'Betalingen er mottatt.',
      receiptLabel: 'Kvittering',
      receiptDownload: 'Last ned kvittering',
      // Kreditnota (bokføringsforskriften § 5-2-7). Shown in addition to the
      // kvittering, never instead of it: the sale stays on file and the
      // reversal is a second document, not an edit to the first.
      creditNoteLabel: 'Kreditnota',
      creditNoteDownload: 'Last ned kreditnota {number}',
      creditNoteReverses: 'Krediterer kvittering {number}',
      // Innkreving ETTER møtet (#3063) — resten etter et depositum, eller
      // hele prisen på en tjeneste med «betaling etterpå». Egen kicker fordi
      // dette er det eneste stedet på siden som beskriver penger kunden
      // fortsatt skylder; «betalt» over kan stå i samme kort.
      outstandingLabel: 'å betale',
      // Ingen forfallsdato, ingen renter, ingen gebyrer — produktet har ikke
      // noe av det, og å antyde det ville vært et løfte ingen kan holde.
      // Lenken ligger i e-posten: råtokenet finnes bare der (serveren lagrer
      // en digest), så dette kan ikke være en knapp.
      outstandingRemainder:
        'Du har {amount} igjen å betale for dette møtet. Betalingslenken ligger i e-posten vi sendte deg.',
      outstandingAfter:
        'Du har {amount} å betale for dette møtet. Betalingslenken ligger i e-posten vi sendte deg.',
      outstandingRemainderPayable: 'Du har {amount} igjen å betale for dette møtet.',
      outstandingAfterPayable: 'Du har {amount} å betale for dette møtet.',
      outstandingExpired:
        'Betalingslenken på {amount} har gått ut. Ta kontakt med oss, så sender vi deg en ny.',
      // Betaling som gjenstår VED booking — kunden forlot Stripe uten å betale.
      // Her finnes lenken faktisk (bookingens magic-token er i adressen), så
      // dette er en knapp, i motsetning til innkrevingen etter møtet over.
      cancelledNotice:
        'Betalingen ble ikke fullført, så møtet er ikke bekreftet ennå. Du kan betale her.',
      dueLabel: 'å betale',
      // Tiden er reservert mens betalingen står åpen. Ingen frist på minuttet i
      // teksten: sesjonen varer 30 minutter, men klokka står ikke i kundens
      // skjerm, og et tall som ikke stemmer er verre enn ingen.
      dueLede: 'Møtet blir bekreftet så snart betalingen er gjennomført.',
      payNow: 'Betal nå',
      requestLede:
        'Du sendes til en sikker betalingsside. Status oppdateres når betalingen er bekreftet.',
      requestPayNow: 'Betal nå',
      requestRetry: 'Prøv betalingen igjen',
      requestRetryLede: 'Hvis du prøver igjen, lukker vi den gamle betalingssiden først.',
      requestConfirmationPending: 'Betalingen er registrert. Bekreftelsen kommer om et øyeblikk.',
      requestStartFailed: 'Kunne ikke starte betalingen. Oppdater siden og prøv igjen.',
      requestReturned:
        'Du er tilbake fra betalingen. Status oppdateres når betalingen er bekreftet.',
      requestCancelled: 'Betalingen ble ikke fullført. Du kan prøve igjen fra avtalen.',
      requestUnavailable:
        'Betalingen kan ikke startes nå. Vent til statusen er oppdatert før du prøver igjen.',
      // One per terminal refusal code from the checkout handler. Three of
      // these exist so a customer is never told to wait for a state that
      // cannot change; only refusedChargeInFlight invites a retry.
      outstandingNotCollectable:
        'Denne betalingen kan ikke gjøres opp her. Ta kontakt med tilbyderen.',
      refusedSettled: 'Denne betalingen er allerede gjort opp. Du skal ikke betale noe mer.',
      refusedSetupIncomplete:
        'Betaling er ikke klar hos denne tilbyderen ennå. Ta kontakt med dem for å gjøre opp.',
      refusedChargeInFlight:
        'Betalingen er allerede i gang. Fullfør den i vinduet du åpnet, eller vent noen minutter og prøv på nytt.',
    },
    agendaLabel: 'Hva vi skal snakke om',
    fromTeam: '{names} fra teamet',
    groupSeats: '{filled} av {total} plasser fylt',
    groupCaptionOne: 'Du og én annen er påmeldt',
    groupCaptionMany: 'Du og {count} andre er påmeldt',
    // Shown in the consultant card on /booking?token=... when the
    // backend returns no assigned_advisor_name (admin_id NULL, the
    // pooled / 'unassigned' service policy from #1312, or the
    // assigner fell through). Previously the UI fell back to the org
    // display name here, which read as "Møtet er med E2E Tenant"
    // when it should have been "Møtet er med en rådgiver som
    // tildeles". Fixes qa-bot #1463 / #1457.
    consultantTBA: 'Tildeles',
    atOffice: 'På kontoret',
    addressTBA: 'Adresse oppgis i innkallingen.',
    seriesLabel: 'hele serien',
    seriesCount: '{n} møte igjen | {n} møter igjen',
    seriesItemCurrent: 'denne',
    seriesItemCancelled: 'avlyst',
    seriesCancelAll: 'Avbestill hele serien',
    seriesCancelTitle: 'Avbestille hele serien?',
    seriesCancelBody:
      'Det gjenværende møtet blir avlyst. Du kan booke nye når som helst. | Alle {n} gjenværende møter blir avlyst. Du kan booke nye når som helst.',
    seriesCancelKeep: 'Behold serien',
    seriesCancelConfirm: 'Avbestill alle',
  },

  invitee: {
    eyebrow: 'din invitasjon',
    confirm: 'Bekreft at du deltar',
    decline: 'Takk nei',
    confirmed: 'Du er bekreftet',
    declined: 'Du har takket nei',
    declinedHint: 'Rådgiveren er varslet. Møtet står som før for de andre.',
    documents: 'Dokumenter til gjennomgang',
    portalLink: 'Se alle møtene dine',
    suggestTime: 'Foreslå nytt tidspunkt',
    suggestDate: 'Dato',
    suggestTimeLabel: 'Tidspunkt',
    suggestNote: 'Beskjed til rådgiveren (valgfritt)',
    suggestNoSlots: 'Ingen ledige tider denne dagen. Velg en annen dato.',
    suggestSubmit: 'Send forslag',
    suggestTimeSent: 'Forslaget er sendt. Rådgiveren svarer deg på e-post.',
  },

  proposal: {
    someone: 'En deltaker',
    proposed: 'har foreslått et nytt tidspunkt',
    accept: 'Godta',
    decline: 'Avslå',
    accepted: 'Møtet er flyttet til det nye tidspunktet.',
    declined: 'Forslaget er avslått. Møtet beholder tidspunktet.',
  },

  // Co-host (medvert) suggesting a new time on the operator meeting detail.
  // The suggestion goes to the møtets vert, who godtar (flytter møtet) or avslår.
  coHostSuggest: {
    cta: 'Foreslå nytt tidspunkt',
    title: 'Foreslå nytt tidspunkt',
    intro:
      'Verten får forslaget og velger å godta eller avslå. Møtet flyttes ikke før verten godtar.',
    date: 'Dato',
    time: 'Tidspunkt',
    note: 'Beskjed til verten (valgfritt)',
    noSlots: 'Ingen ledige tider denne dagen. Velg en annen dato.',
    submit: 'Send forslag',
    sent: 'Forslaget er sendt til verten.',
    error: 'Kunne ikke sende forslaget. Prøv igjen.',
    exists: 'Det finnes allerede et åpent forslag for dette møtet.',
    notNow: 'Møtet kan ikke endres nå.',
  },

  reschedule: {
    backToBooking: 'Tilbake til møtet',
    backToReschedule: 'Tilbake til tider',
    heading: 'Endre tidspunkt',
    currentTime: 'Nåværende tid:',
    pickNew: 'Velg en ny tid under.',
    autoNotify: '{name} får beskjed automatisk.',
    seriesNoticeLabel: 'del av en serie',
    seriesNoticeBody:
      'Dette endrer kun denne ene gangen. Resten av serien står som den er. Om du vil flytte alle, kontakt oss eller avbestill serien og book på nytt.',
    confirmTitle: 'Bytt til {time}?',
    confirmBody: 'Du får en oppdatert bekreftelse på e-post, og {name} får beskjed.',
    confirmKeep: 'Behold tiden',
    confirmSwitch: 'Bytt tidspunkt',
  },

  cancelled: {
    meta: 'møtet er avbestilt',
    heading: 'Avbestillingen er registrert.',
    body: '{name} har fått beskjed. Du kan booke en ny tid når du vil.',
    bookNew: 'Book et nytt møte',
  },

  rescheduled: {
    meta: 'tidspunktet er endret',
    heading: 'Du har fått en ny tid.',
    body: '{name} har fått beskjed. Vi har sendt deg en oppdatert bekreftelse på e-post.',
    // #1360, trailing colon so the line reads "ny tid: onsdag 10.
    // juni", not "ny tidonsdag". The space after the colon lives in
    // the template as an explicit {{ ' ' }} text node, CSS margins
    // alone don't reach textContent (qa-bot #1552).
    newTimeLabel: 'ny tid:',
    addToCalendar: 'Legg til i kalender',
    portal: 'Gå til kundeportalen',
    home: 'Tilbake til forsiden',
    manageHint:
      'Ny administrer-lenke ligger i e-posten. Du kan også finne møtet under «Mine møter» i kundeportalen.',
  },

  meeting: {
    lobby: {
      eyebrow: 'møtet starter snart',
      heading: 'Klar til å møte {name}?',
      cameraOnLabel: 'kamera på \u00B7 forhåndsvisning',
      cameraOff: 'kamera av',
      micOn: 'mikrofon på',
      micOff: 'mikrofon av',
      deviceCheck: 'sjekk utstyr',
      camera: 'Kamera',
      microphone: 'Mikrofon',
      deviceNote: 'du kan slå av og på i møtet.',
      join: 'Bli med nå',
      waiting: '{name} venter allerede.',
    },
    inMeeting: {
      you: 'Du',
      youLabel: 'du',
      speaker: 'taler',
      meetingLabel: 'møte',
      live: 'pågår',
      participants: '{count} deltakere',
      micOn: 'mic på',
      micOff: 'mic av',
      cameraOn: 'kamera på',
      cameraOff: 'kamera av',
      end: 'Avslutt',
    },
    after: {
      meta: 'møtet er over',
      heading: 'Takk for samtalen.',
      body: 'Vi håper du fikk svar på det du lurte på. Har du spørsmål etterpå, send en e-post.',
      followupEyebrow: 'ønsker du å møtes igjen?',
      followupBody: 'Book en oppfølging med ett trykk. Vi husker at vi har snakket sammen.',
      bookFollowup: 'Book en oppfølging',
    },
  },

  chat: {
    // Møtechat-panelets overskrift. Bytter til gruppevarianten når møtet
    // har mer enn én deltaker (flere enn kunden selv).
    title: 'Chat',
    titleGroup: 'Chat med deltakere',
    // Feilmeldinger når kunden laster opp et dokument i møtechatten.
    // Backend-feilen mater disse via useMeetingChatUpload.
    upload: {
      unsupportedType: 'Filtypen støttes ikke. Velg PDF, Word, regneark, presentasjon eller bilde.',
      empty: 'Filen er tom eller skadet.',
      tooLarge: 'Filen er for stor. Maks 25 MB.',
      expired: 'Lenken er utløpt.',
      notFound: 'Vi fant ikke møtet.',
      unavailable: 'Opplasting er midlertidig utilgjengelig. Prøv igjen.',
      generic: 'Noe gikk galt med opplastingen.',
    },
  },

  edges: {
    expired: {
      eyebrow: 'lenken er utløpt',
      heading: 'Vi finner ikke dette møtet.',
      body: 'Lenken fungerer ikke lenger. Møtet kan være avholdt eller avbestilt, eller så ble bekreftelses-e-posten sendt ut på nytt. Sjekk innboksen din, eller book en ny tid.',
      bookNew: 'Book et nytt møte',
      contact: 'Kontakt oss',
      // #1415/#1417/#1419/#1423, the secondary "Kontakt oss"
      // button fires a mailto: which headless browsers (and
      // operators without a mail client) cannot follow. The
      // visible mailto link below the actions gives a clickable,
      // copy-able fallback that never depends on a mail handler.
      contactHelperBefore: 'Eller skriv direkte til ',
      contactHelperAfter: ' så hjelper vi deg videre.',
      // Toast after the "Kontakt oss" button is tapped, confirms the
      // action even when the browser has no mail client registered
      // (qa-bot #1460/#1453: the mailto silently fails and the button
      // reads as inert without feedback). Also primes the clipboard
      // with the address.
      contactCopied: 'E-postadressen {email} er kopiert.',
    },
    offByConsultant: {
      eyebrow: 'møtet er avlyst av verten',
      heading: '{name} måtte dessverre avlyse.',
      body: 'Møtet er ikke lenger tilgjengelig. Du kan finne en ny tid i kalenderen.',
      findNew: 'Finn en ny tid',
      backToProfile: 'Tilbake til profil',
    },
    fullyBooked: {
      eyebrow: 'ingen ledige tider',
      heading: 'Fullt denne dagen.',
      body: '{name} har ingen ledige tider denne dagen. Prøv en annen dag.',
      pickAnother: 'Velg en annen dag',
      notify: 'Gi meg beskjed',
    },
    errorPages: {
      topbarLabel: 'support',
      footerUrlLabel: 'forespurt',
      footerTimeLabel: 'tidspunkt',
      footerSporIdLabel: 'spor-id',
      notFound: {
        eyebrowCode: 'feil 404',
        eyebrowText: 'side ikke funnet',
        documentTitle: 'Side ikke funnet, stemne',
        heading: 'Vi finner ikke siden du leter etter.',
        body: 'Siden kan ha flyttet på seg, eller adressen kan være feilstavet. Sjekk at adressen er riktig, eller gå tilbake til forsiden.',
        primary: 'Tilbake til forsiden',
        secondary: 'Skriv til support',
        helperBefore: 'Hvis du fortsatt sitter fast, send oss en linje på ',
        helperAfter: '. Vi svarer som regel innen en time på hverdager.',
      },
      forbidden: {
        eyebrowCode: 'feil 403',
        eyebrowText: 'ingen tilgang',
        documentTitle: 'Ingen tilgang, stemne',
        heading: 'Denne lenken er ikke for deg.',
        body: 'Lenken kan ha utløpt, eller den hører til et annet møte. Magiske lenker er knyttet til e-postadressen som ble brukt ved bestilling. Be om en ny på samme adresse.',
        primary: 'Be om ny lenke',
        secondary: 'Tilbake til forsiden',
        helperBefore: 'Bruker du riktig e-postadresse, men får fortsatt denne siden? Skriv til ',
        helperAfter: ' med lenken fra bekreftelsen, så hjelper vi deg videre.',
      },
      gone: {
        eyebrowCode: 'feil 410',
        eyebrowText: 'møtet er ferdig',
        documentTitle: 'Møtet er over, stemne',
        heading: 'Dette møtet er allerede over.',
        body: 'Lenken er ikke lenger aktiv, men du kan booke et nytt møte med samme rådgiver, eller se kvittering og notater fra det forrige.',
        primary: 'Book et nytt møte',
        secondary: 'Se kvittering',
        helperPlain:
          'Hadde du planlagt en oppfølging? Rådgiveren din får varsel hvis du booker innen syv dager, og slipper å spørre om kontekst på nytt.',
      },
      serverError: {
        eyebrowCode: 'feil 500',
        eyebrowText: 'noe gikk galt hos oss',
        documentTitle: 'Noe gikk galt, stemne',
        heading: 'Noe gikk galt på vår side.',
        body: 'Vi har fått beskjed og jobber med det. Møtet ditt er trygt. Møtetidspunkt og deltakere blir ikke endret av at denne siden ikke vil lastes. Prøv igjen om et minutt.',
        primary: 'Prøv igjen',
        secondary: 'Sjekk driftsstatus',
        helperPlain:
          'Skal du i et møte akkurat nå? Du finner lenken i bekreftelsen på e-post. Den fungerer uavhengig av denne siden.',
      },
    },
  },

  bookingCard: {
    confirmed: 'bekreftet',
    pending: 'venter',
    rescheduled: 'endret',
    cancelled: 'avlyst',
    expired: 'utløpt',
    completed: 'avholdt',
    noShow: 'ikke møtt',
    joinMeeting: 'Bli med i møtet',
    viewDetails: 'Se detaljer',
    reschedule: 'Endre tid',
    cancel: 'Avbestill',
    sharedSummary: 'Oppsummering fra rådgiveren',
    meetingPlace: 'Møtested',
  },

  footer: {
    siteName: 'stemne.no',
    // Operator-facing only, see StemneFooter.vue. End customers
    // contact the operator (their consultancy), not Stemne support.
    helpPrompt: 'Trenger du hjelp?',
    helpEmail: "support{'@'}stemne.no",
    copyright: '\u00A9 2026 Stemne AS. Alle rettigheter reservert.',
    privacy: 'personvern',
    terms: 'vilkår',
  },

  spinner: {
    loading: 'Laster...',
  },

  linkRow: {
    copy: 'Kopier',
    copied: 'Kopiert',
  },
  adminConfirmEmailView: {
    invalidLink: 'Bekreftelseslenken er ugyldig.',
    expiredLink: 'Lenken er ugyldig eller utløpt. Be om en ny fra konto-innstillingene.',
    genericError: 'Noe gikk galt. Prøv igjen senere.',
    confirming: 'Bekrefter...',
    errorKicker: 'lenken er ugyldig',
    errorTitle: 'Vi kunne ikke bekrefte e-posten',
    backToLogin: 'Tilbake til innlogging',
    successKicker: 'bekreftet',
    successTitle: 'E-posten er oppdatert',
    successBody: 'Bruk den nye adressen neste gang du logger inn. Den gamle fungerer ikke lenger.',
    toAccountSettings: 'Til konto-innstillinger',
  },
  ownershipDisclosure: {
    title: 'Dette skjer når du overtar',
    clearsTerms: 'Operatøravtalen som ble inngått under oppsettet, opphører',
    clearsTermsBy: 'Operatøravtalen som {who} inngikk, opphører',
    clearsDpa: 'Databehandleravtalen som ble inngått under oppsettet, opphører',
    clearsDpaBy: 'Databehandleravtalen som {who} inngikk, opphører',
    clearsSubscription: 'Abonnementet avsluttes',
    clearsCard: 'Betalingskortet fjernes: {card}',
    removesOwner: '{who} mister tilgangen til organisasjonen',
    newTrial:
      'Organisasjonen settes på ny prøveperiode i {days} dager, og du må velge plan og legge inn betaling før den løper ut',
    agreements:
      'Du inngår operatøravtalen (versjon {terms}) og databehandleravtalen (versjon {dpa}) i ditt eget navn når du fullfører overtakelsen.',
    consentLabel: 'Jeg har lest hva overtakelsen innebærer, og godtar avtalene over',
  },
  ownershipTransfer: {
    title: 'Overfør eierskap',
    body: 'Gi organisasjonen til en annen person. Du mister tilgangen når de har godtatt.',
    pending: 'En overtakelse er sendt til {email}. Den venter på svar.',
    cta: 'Overfør eierskap',
    modalTitle: 'Overfør eierskap',
    modalLede:
      'Vi sender en lenke til personen som skal overta. Ingenting skjer før de har lest gjennom og godtatt.',
    consequenceAgreements: 'Avtalene du har inngått, opphører. Den nye eieren inngår dem på nytt.',
    consequencePayment:
      'Abonnement og betalingsopplysninger fjernes, og organisasjonen får ny prøveperiode.',
    consequenceAccess: 'Du mister tilgangen til organisasjonen når overtakelsen er fullført.',
    emailLabel: 'E-post til ny eier',
    emailPlaceholder: "navn{'@'}firma.no",
    reasonLabel: 'Begrunnelse',
    reasonPlaceholder: 'Hvorfor overføres eierskapet?',
    cancel: 'Avbryt',
    confirm: 'Send overtakelse',
    errEmailRequired: 'E-post er påkrevd',
    errReasonRequired: 'Begrunnelse er påkrevd',
    errGeneric: 'Kunne ikke sende overtakelsen. Prøv igjen.',
  },
  adminInviteAcceptView: {
    handoverLandingTitle: 'Du kan overta {org}',
    handoverLandingBodyPre: 'Du er invitert til å overta',
    handoverLandingBodyOn: 'på',
    handoverLandingBodyPost: 'Les gjennom hva overtakelsen innebærer før du går videre.',
    handoverFinalTitle: 'Fullfør overtakelsen',
    handoverFinalBody: 'Skriv inn navnet ditt og bekreft. Da blir du eier av organisasjonen.',
    errDisclosureRequired: 'Du må bekrefte hva overtakelsen innebærer',
    roleAdmin: 'administrator',
    roleAdvisor: 'rådgiver',
    errInvalidLink: 'Ugyldig invitasjonslenke.',
    errInviteInvalidOrExpired: 'Invitasjonen er ugyldig eller utløpt. Be om en ny.',
    errLoadInvite: 'Kunne ikke laste invitasjonen. Prøv igjen.',
    errTooManyRequests: 'For mange forespørsler. Vent en stund og prøv igjen.',
    errInviteInvalidOrExpiredShort: 'Invitasjonen er ugyldig eller utløpt.',
    errSendCode: 'Kunne ikke sende koden. Prøv igjen.',
    errOtpFormat: 'Skriv inn de seks sifrene fra e-posten.',
    errOtpWrong: 'Feil kode. Sjekk e-posten og prøv igjen.',
    errOtpTooManyAttempts: 'For mange forsøk. Be om en ny kode.',
    errOtpExpired: 'Koden er utløpt. Be om en ny kode.',
    errOtpVerifyFailed: 'Kunne ikke bekrefte koden.',
    errGeneric: 'Noe gikk galt. Prøv igjen.',
    errNameRequired: 'Skriv inn navnet ditt.',
    errAcceptFailed: 'Kunne ikke akseptere invitasjonen.',
    loadingLabel: 'Henter invitasjon...',
    failedTitle: 'Invitasjonen er ikke lenger gyldig',
    backToLogin: 'Tilbake til innlogging',
    landingKicker: 'velkommen',
    landingTitle: 'Hei. {inviter} har invitert deg til {org}.',
    someone: 'Noen',
    landingBodyPre: 'Du blir lagt til som',
    landingBodyAt: 'hos',
    landingBodyOn: 'på',
    landingBodyPost: 'For å bekrefte at e-posten er din, sender vi en kode til denne adressen.',
    sendCodeCta: 'Send kode →',
    otpKicker: 'bekreft e-post',
    otpTitle: 'Skriv inn koden vi sendte deg.',
    otpBodyPre: 'Vi sendte en 6-sifret kode til',
    otpBodyPost: 'Koden gjelder i 10 minutter.',
    otpInputLabel: '6-sifret kode',
    verifyCodeCta: 'Bekreft kode →',
    finalKicker: 'siste steg',
    finalTitle: 'Hva heter du?',
    finalBody:
      'Vi bruker navnet ditt på profilkortet ditt. Når du er ferdig, lager vi en passnøkkel for deg.',
    nameInputLabel: 'Navnet ditt',
    namePlaceholder: 'Fornavn Etternavn',
    finishCta: 'Fullfør og opprett passnøkkel →',
  },
  authWrongWorkspaceView: {
    heading: 'Du er logget inn i en annen arbeidsflate',
    loadingBody: 'Et øyeblikk, vi sjekker økten din.',
    body: 'Økten din hører til {sessionHost}, men siden du prøvde å åpne ligger på {currentHost}.',
    hint: 'Du kan fortsette der du er logget inn, eller logge ut og logge inn her.',
    continueCta: 'Fortsett til {sessionHost}',
    logoutCta: 'Logg ut og logg inn her',
  },
  authAwaitingReviewView: {
    headingRejected: 'Søknaden din ble avvist',
    headingAwaiting: 'Søknaden din er under behandling',
    loadingBody: 'Et øyeblikk, vi sjekker statusen din.',
    rejectedBody:
      'Etter en gjennomgang har vi besluttet at vi ikke kan tilby underdomenet du valgte.',
    reasonLabel: 'Begrunnelse:',
    contactBefore: 'Hvis du tror dette er en feil, ta kontakt på',
    awaitingBody1:
      'Vi har mottatt søknaden din. Underdomenet du valgte ligner på et kjent merkenavn, så en av oss går gjennom registreringen før vi åpner kontoen.',
    awaitingBody2:
      'Du får en e-post så snart vi har et svar. Det tar vanligvis mindre enn én arbeidsdag.',
    logout: 'Logg ut',
    refreshStatus: 'Oppdater status',
  },
  subscriptionRequiredView: {
    loadingBody: 'Et øyeblikk, vi sjekker abonnementet ditt.',
    headingTrialExpired: 'Prøveperioden er over',
    headingPastDue: 'Betalingen gikk ikke gjennom',
    headingCanceled: 'Abonnementet er avsluttet',
    headingPaused: 'Abonnementet er satt på pause',
    headingDefault: 'Abonnementet er ikke aktivt',
    bodyTrialExpired: 'Prøveperioden din er over. Velg en plan for å ta i bruk kontoen igjen.',
    bodyPastDue:
      'Vi fikk ikke belastet betalingsmåten din. Oppdater betalingen for å låse opp kontoen igjen.',
    bodyCanceled:
      'Abonnementet er avsluttet. Start et nytt abonnement for å ta i bruk kontoen igjen.',
    bodyPaused: 'Abonnementet er satt på pause. Gjenoppta det for å ta i bruk kontoen igjen.',
    bodyDefault: 'Velg eller forny en plan for å ta i bruk kontoen igjen.',
    nonOwnerBody:
      'Kontakt eieren av kontoen for å ordne abonnementet. Du får tilgang så snart det er på plass.',
    goToBilling: 'Gå til abonnement',
    logout: 'Logg ut',
  },
  dataProcessingAgreementView: {
    // Vises bare på ikke-norske språk: avtaleteksten finnes kun på norsk, og
    // den norske versjonen er den bindende.
    authoritativeLanguageNote:
      'Databehandleravtalen finnes bare på norsk. Den norske teksten er den bindende versjonen.',
    // Dokumenthodet. Verdiene hentes ut av avtaleteksten, så etikettene her
    // er det eneste som oversettes.
    versionLabel: 'Versjon {version}',
    effectiveLabel: 'Gjeldende fra {date}',
    backToHome: 'Til forsiden',
  },
  agreementsAcceptView: {
    // Overskriften når begge avtalene står ute. Ordlyden må dekke to
    // dokumenter uten å love flere enn det som faktisk vises.
    heading: 'Gjør siden klar til å ta imot bookinger',
    headingTermsOnly: 'Operatøravtale',
    bothLede:
      'Før du publiserer siden, trenger vi to korte avtaler. Du kan lese hver avtale i sin helhet før du godtar.',
    partyDisclosure: 'Vis hvem avtalene gjelder',
    termsTitle: 'Operatøravtale',
    termsBody: 'Regler for bruk av Stemne, betalinger og ansvaret for egne priser og bokføring.',
    termsReadCta: 'Les hele operatøravtalen',
    termsConsentLabel: 'Jeg godtar operatøravtalen.',
    ownerOnly:
      'Bare eieren i virksomheten kan godta avtaler på vegne av virksomheten. Be eieren logge inn for å godta.',
  },
  operatorAgreementView: {
    // Vises bare på ikke-norske språk: avtaleteksten finnes kun på norsk, og
    // den norske versjonen er den bindende.
    authoritativeLanguageNote:
      'Operatøravtalen finnes bare på norsk. Den norske teksten er den bindende versjonen.',
    // Dokumenthodet. Verdien hentes ut av avtaleteksten, så etiketten her er
    // det eneste som oversettes.
    versionLabel: 'Versjon {version}',
    backToHome: 'Til forsiden',
  },
  dpaAcceptView: {
    heading: 'Databehandleravtale',
    loadingBody: 'Henter avtalen.',
    body: 'Hvordan Stemne behandler og sikrer kundedata på dine vegne.',
    // #3551 — skjermen forklarte bare hva avtalen er, aldri hva du får igjen
    // for å signere. Dette er den mest verdifulle handlingen en ny operatør
    // kan gjøre, så gevinsten står her, ikke bare plikten.
    unlockBody:
      'Bestillingssiden din er stengt til dette er på plass. Når avtalen er godtatt, kan kunder se tjenestene dine, finne ledige tider og bestille time.',
    readCta: 'Les hele avtalen',
    consentLabel: 'Jeg godtar databehandleravtalen.',
    acceptCta: 'Godta og fortsett',
    partyController: 'Behandlingsansvarlig',
    partyProcessor: 'Databehandler',
    partyProcessorValue: 'Stemne AS, org.nr. 937 952 732',
    partyNameOrgnr: '{name}, org.nr. {orgnr}',
    partyContact: 'Kontakt',
    ownerOnly:
      'Bare eieren i virksomheten kan godta databehandleravtalen. Be eieren logge inn for å godta.',
  },
  // Bekreftelsen foran avtale-bounce-en (#3287). Knappen tar deg TIL avtalen,
  // den godtar den ikke — derfor "Se avtalen og fortsett" og ikke "Godta".
  agreementGateModal: {
    dpaTitle: 'Du må godta databehandleravtalen først',
    dpaBody:
      'Denne handlingen krever at virksomheten har godtatt Stemnes databehandleravtale. Du kan lese avtalen og godta den nå, så kommer du tilbake hit etterpå.',
    termsTitle: 'Du må godta operatøravtalen først',
    termsBody:
      'Før du kan aktivere betaling må virksomheten godta Stemnes operatøravtale. Du kan lese den og godta den nå.',
    confirm: 'Se avtalen og fortsett',
  },
  dpaRequiredView: {
    kicker: 'ett siste steg',
    title: 'Før du kan tilby tjenester',
    lede: 'Du kan utforske dashboardet og gjøre siden klar. Når en tjeneste skal bli synlig for kunder, trenger vi at du godtar Stemnes databehandleravtale.',
    noteTitle: 'Hva betyr det?',
    noteBody:
      'Avtalen forklarer hvordan Stemne behandler og beskytter opplysninger kundene dine deler når de bestiller hos deg.',
    reassurance:
      'Du bestemmer selv når du vil gjøre tjenesten synlig. Det er ingen endring i tjenesten din nå.',
    cta: 'Se avtalen og fortsett',
    back: 'Tilbake til dashboardet',
  },
  dashboardBookabilityBanner: {
    kicker: 'siden din er ikke bookbar ennå',
    title: 'Du har ingen aktive tjenester akkurat nå',
    body: 'Du kan fortsatt utforske og gjøre siden klar. Når du er klar, hjelper vi deg med siste steg før kunder kan bestille.',
    cta: 'Se tjenestene dine',
    dpaKicker: 'bestillingssiden er stengt',
    dpaTitle: 'Databehandleravtalen må godtas',
    dpaBody:
      'Kunder kan ikke se tjenester eller ledige tider, og kan ikke bestille, før virksomheten har godtatt avtalen.',
    dpaCta: 'Se avtalen',
    dpaAcceptCta: 'Godta avtalen og åpne siden',
  },
  authLoginView: {
    checkingSession: 'Sjekker økten din',
    sentTitle: 'Sjekk e-posten din',
    sentBody:
      'Hvis kontoen finnes, har vi sendt en innloggingslenke til {email}. Klikk på lenken for å logge inn.',
    sentHint: 'Finner du den ikke? Sjekk spam-mappen.',
    resend: 'Send på nytt',
    resendCountdown: 'Send på nytt om {seconds}s',
    tryAnotherAddress: 'Prøv en annen adresse',
    welcomeBack: 'Velkommen tilbake.',
    welcomeSubtitle: 'Skriv inn e-posten din. Vi spør enheten om passnøkkelen din.',
    emailLabel: 'E-post',
    emailPlaceholder: "du{'@'}firma.no",
    emailRequired: 'Skriv inn e-posten din først.',
    loginWithPasskey: 'Logg inn med passnøkkel',
    sendMagicLink: 'Send meg en innloggingslenke',
    tryPasskeyAgain: 'Prøv passnøkkel igjen',
    fallbackPrompt: 'Mangler passnøkkel på denne enheten? {link}.',
    fallbackLink: 'Send meg en innloggingslenke',
    securitySummary:
      'Logg inn sikkert med Face ID, Touch ID, Windows Hello eller en sikkerhetsnøkkel.',
    originFallbackHint:
      "Logg inn fra din egen stemne-adresse ({'{'}ditt-navn{'}'}.stemne.no). Vi kan sende deg en innloggingslenke i stedet.",
    transferFailedWithReason: 'Kunne ikke videresende: {reason}',
    transferFailed: 'Kunne ikke videresende.',
    rateLimited: 'For mange forsøk. Vent litt og prøv igjen.',
    magicLinkError: 'Vi får ikke kontakt med innloggingen akkurat nå. Prøv igjen om et øyeblikk.',
    recoveryLink: 'Logg inn med gjenopprettingskode',
    recoveryBack: 'Tilbake til passnøkkel',
    recoveryCodeLabel: 'Gjenopprettingskode',
    recoverySubmit: 'Logg inn med kode',
    recoveryInvalid: 'Koden er ugyldig eller allerede brukt.',
    recoveryError: 'Vi får ikke kontakt med innloggingen akkurat nå.',
  },
  authPasskeyEnrollView: {
    recoveryTitle: 'Passnøkkelen er klar.',
    recoveryIntro:
      'Lagre disse gjenopprettingskodene på et trygt sted. Hver kode kan bare brukes én gang, og de vises ikke igjen.',
    recoveryCopy: 'Kopier kodene',
    recoveryDownload: 'Last ned som .txt',
    recoveryOptional:
      'Passnøkkelen er synkronisert. Du kan lagre kodene nå, eller fortsette uten å lagre dem.',
    recoverySaved: 'Jeg har lagret kodene',
    recoveryContinue: 'Fortsett',
    recoveryContinueWithoutSaving: 'Fortsett uten å lagre',
    headline: 'Opprett passnøkkel med {verb}.',
    ctaLabel: 'Opprett med {verb}',
    verb: {
      faceId: 'Face ID',
      touchId: 'Touch ID',
      windowsHello: 'Windows Hello',
      fingerprint: 'fingeravtrykk',
      yourDevice: 'enheten din',
    },
    deviceAppleMobile: 'iPhone eller iPad (Face ID)',
    deviceAppleDesktop: 'Mac (Touch ID)',
    deviceWindows: 'Windows Hello',
    deviceAndroid: 'Android (fingeravtrykk)',
    deviceDefault: 'Denne enheten',
    errorNotAllowed:
      'Vi rakk ikke registrere passnøkkelen. Fullfør bekreftelsen i prompten. Hvis du allerede har en passnøkkel for stemne lagret i iCloud Nøkkelring eller 1Password, slett den først og prøv igjen.',
    errorUnauthorized: 'Du må være innlogget for å opprette en passnøkkel. Logg inn og prøv igjen.',
    errorRegistrationFailed: 'Registrering feilet.',
    errorGeneric: 'Noe gikk galt. Prøv igjen.',
    errorForwardWithMessage: 'Kunne ikke videresende: {message}',
    errorForward: 'Kunne ikke videresende.',
    stepLabel: 'steg 2 av 2 · sikkerhet',
    wrongOriginTitle: 'Åpne denne siden på din egen adresse.',
    wrongOriginLead:
      'For at passnøkkelen skal være bundet riktig til kontoen din, må du lage den fra',
    wrongOriginOwnAddress: "din egen stemne-adresse ({'{ditt-navn}'}.stemne.no)",
    wrongOriginTrailer: '. Bytt adresse i nettleseren og gå tilbake hit, så fortsetter vi.',
    intro:
      'Glem passord. Du logger inn på sekunder, og det finnes ingenting å glemme eller miste. Ingen kan lure deg til å gi det fra deg.',
    deviceCardMeta: 'passnøkkel for din konto',
    deviceConfirmHint: 'Vi vil be om bekreftelse fra denne enheten.',
    crossDeviceCta: 'Bruk passnøkkel fra en annen enhet',
    helpLink: 'Hva er en passnøkkel?',
    bluetoothNote: 'Bruk av passnøkkel fra telefon (QR-kode) krever at Bluetooth er på.',
    deviceConstrainedTitle: 'Denne enheten kan ikke lage en passnøkkel her.',
    deviceConstrainedBody:
      'Den har verken biometrisk innlogging (Touch ID, Face ID, Windows Hello, fingeravtrykk) eller Bluetooth, så vi får ikke startet en passnøkkel- seremoni på denne siden.',
    deviceConstrainedItemEmail:
      'Åpne {email} på en annen enhet, telefon, nettbrett eller en PC med fingeravtrykk eller Bluetooth. Lenken er gyldig i 24 timer.',
    deviceConstrainedItemEmailEmphasis: 'innloggingslenken fra e-posten',
    deviceConstrainedItemUsb:
      'Eller koble til en {usb} (for eksempel Yubikey) i denne PC-en og klikk «{cta}» under. Windows starter da seremonien med sikkerhetsnøkkelen i stedet for en kropps-passnøkkel.',
    deviceConstrainedItemUsbEmphasis: 'USB-sikkerhetsnøkkel',
    deviceConstrainedItemHelp: 'Trenger du hjelp? Send oss en e-post på {email}.',
    helpPanelP1:
      'En passnøkkel er en kryptografisk nøkkel som lever på enheten din. Den kan lagres i iCloud Nøkkelring, Google Password Manager, 1Password eller en fysisk sikkerhetsnøkkel. Den erstatter passordet. Når du logger inn, bekrefter du med Face ID, Touch ID eller PIN, og enheten beviser overfor stemne at det er deg, uten å sende noe som kan lekkes eller phishes.',
    helpPanelP2:
      'Passnøkkelen er bundet til {host}. En falsk nettside som ligner kan ikke be om den, fordi nettleseren ikke vil gi den ut til feil domene. Du trenger ikke huske noe, og det finnes ingenting å skrive feil.',
    loginFallbackLink: 'Logg inn med passnøkkel',
    bulletNoPasswordTitle: 'Ingen passord.',
    bulletNoPasswordBody: 'Det finnes intet passord å lekke eller huske.',
    bulletBoundTitle: 'Bundet til {host}.',
    bulletBoundBody: 'Passnøkkelen virker bare på vårt domene. Phishing-sider kan ikke bruke den.',
    bulletSyncedTitle: 'Synket trygt.',
    bulletSyncedBody: 'iCloud, Google og 1Password kan synke passnøkler mellom enhetene dine.',
  },
  authVerifyTokenView: {
    missingToken: 'Ugyldig lenke, mangler token.',
    invalidOrExpired: 'Lenken er ugyldig eller utløpt. Be om en ny.',
    somethingWentWrong: 'Noe gikk galt. Prøv igjen.',
    loggingIn: 'Logger inn...',
    title: 'Kunne ikke logge inn',
    backToLogin: 'Tilbake til innlogging',
  },
  // The outstanding post-service ask on the meeting detail page (#3063 part
  // D2). Its own block rather than more keys on
  // setupDashboardBookingDetailView: this is one focused component's whole
  // vocabulary, and the view's block is already the largest in this file.
  bookingPaymentRequest: {
    heading: 'Betaling',
    deposit: 'Depositum',
    remainder: 'Rest',
    full: 'Hele beløpet',
    planned: 'Sendes etter møtet',
    notSent: 'Ikke sendt',
    paidOn: 'Betalt {date}',
    chargeStatus: {
      succeeded: 'Betalt',
      pending: 'Venter på betaling',
      failed: 'Betalingen mislyktes',
      expired: 'Utløpt',
      refunded: 'Refusjon registrert',
      refundPending: 'Refusjon pågår',
      refundFailed: 'Refusjonen ble ikke fullført',
      unpaid: 'Ikke betalt',
    },
    // Which money this is. "Resten" only when there was a deposit to be the
    // rest OF — on a «betaling etterpå» service the ask is the whole price and
    // calling it a remainder would be wrong.
    headingRemainder: 'Restbeløp',
    headingAfter: 'Til betaling etter møtet',
    status: {
      open: 'Ikke betalt',
      paid: 'Betalt',
      cancelled: 'Avlyst',
      expired: 'Utløpt',
    },
    sentOn: 'Sendt {date}',
    // The limits, said plainly. An operator looking at an unpaid ask is
    // deciding whether Stemne is chasing this for them, and the answer is no.
    limits:
      'Fakturaen forfaller 14 dager etter møtet. Kunden får én påminnelse etter 7 dager og én på forfallsdagen. Stemne legger ikke til gebyrer eller renter og starter ikke inkasso automatisk. Betalingslenken virker i 90 dager.',
    collectionPaused:
      'Automatiske påminnelser er satt på pause. Fakturaen og betalingslenken er fortsatt gyldige.',
    collectionDisputed:
      'Kravet er markert som omtvistet. Stemne sender ingen påminnelser før du gjenopptar oppfølgingen.',
    resend: 'Send lenken på nytt',
    pause: 'Sett påminnelser på pause',
    resume: 'Gjenoppta oppfølgingen',
    dispute: 'Marker som omtvistet',
    cancel: 'Avslutt oppfølgingen',
    cancelConfirmTitle: 'Avslutt oppfølgingen?',
    // Names the amount AND the consequence the operator cannot see: the links
    // already in the customer's inbox stop working. "Kan ikke angres" rather
    // than a question — the design rule is blunt verbs, not "er du sikker?".
    cancelConfirmBody:
      'Kunden slutter å få påminnelser om {amount}, og betalingslenkene slutter å virke. Fakturaen blir ikke markert som betalt eller kreditert. Registrer betaling eller kreditnota i regnskapet. Dette kan ikke angres i Stemne.',
    cancelConfirmCta: 'Avslutt oppfølgingen',
  },

  bookingChoosePersonView: {
    kicker: 'hvem vil du snakke med?',
    titleFallback: 'Velg en person',
    subtitle: 'Velg en person, eller la oss sette deg opp med den som er ledig først.',
    anyoneName: 'Spiller ingen rolle',
    anyoneRole: 'Vi setter deg opp med den som er ledig først.',
  },
  bookingConfirmView: {
    onlineOrLocation: 'online eller {location}',
  },
  bookingConfirmedView: {
    portalHintConjunction: 'og',
  },
  bookingServiceLandingView: {
    pickSubtitle: 'Velg hvem du vil snakke med.',
    pooledTeamSubtitle:
      'Vi setter deg opp med en av oss. Du får vite hvem du møter så snart møtet er bekreftet.',
    pickKicker: 'velg en person',
    personCta: 'velg →',
    escapeQuestion: 'Spiller ingen rolle hvem?',
    escapeLink: 'Vis alle ledige tider på tvers',
    escapeNote: 'Vi setter deg opp med den som er ledig først.',
  },
  customerEmailConfirmView: {
    loadingSub: 'Bekrefter den nye e-postadressen din …',
    successTitle: 'E-posten din er bekreftet.',
    successSubPrefix: 'Påminnelser og bekreftelser går nå til',
    successSubSuffix: '. Du kan lukke dette vinduet.',
    expiredTitle: 'Lenken er ugyldig eller utløpt.',
    expiredSub:
      'Be operatøren sende deg en ny lenke. Lenker gjelder i sju dager fra de blir sendt.',
    errorTitle: 'Noe gikk galt.',
    genericError: 'Noe gikk galt. Prøv igjen om litt.',
  },
  // /betal/{token} — betalingssiden kunden får tilsendt etter møtet (#3063).
  //
  // Bare fire strenger, og det er med vilje: hver eneste avvisning kommer
  // ordrett fra serveren, som allerede har skrevet den for denne kunden
  // («Betalingslenken har gått ut …», «Denne betalingen er allerede gjort
  // opp …»). Å legge en tittel av vår egen over dem ville gitt siden to
  // stemmer om samme sak.
  pay: {
    redirectingTitle: 'Sender deg videre til betaling.',
    redirectingSub: 'Vi åpner betalingssiden. Det tar bare et øyeblikk.',
    // «Mottatt», ikke «registrert». Stripe sender kunden hit i det betalingen
    // er sendt — webhooken som faktisk gjør den opp kan ligge sekunder bak,
    // og på enkelte betalingsmåter lenger. Dette er samme øyeblikk som
    // manage.payment.receivedBanner beskriver ved booking-betaling, og bruker
    // med vilje samme ord. «Registrert» er reservert for en oppgjort betaling.
    paidTitle: 'Betalingen er mottatt.',
    paidSub: 'Takk. Du kan lukke dette vinduet.',
    // Brukes bare når noe faktisk feilet — nett, 5xx, eller at flagget er av.
    // En utløpt eller oppgjort betaling er ikke en feil, og havner i den
    // rolige tomme tilstanden i stedet.
    failedTitle: 'Vi fikk ikke åpnet betalingen.',
    failedBody: 'Det kan være nettet. Prøv igjen om litt.',
  },
  marketingFaqView: {
    categoryPersonvern: 'Personvern og data',
    categoryPris: 'Pris og forpliktelse',
    categoryBooking: 'Booking og kunder',
    categoryKalender: 'Kalender og videomøter',
    categoryTeam: 'Team og oppsett',
    categoryAnnet: 'Annet',
    navForsiden: 'Forsiden',
    navKomIGang: 'Kom i gang',
    kicker: 'Hjelp',
    title: 'Spørsmål og svar',
    leadIntro:
      'Her er svarene på det folk oftest lurer på før de tar Stemne i bruk. Finner du ikke det du leter etter? Skriv til',
    leadOutro: '. Vi svarer innen én virkedag.',
    tocAriaLabel: 'Innholdsfortegnelse',
    ctaKomIGangGratis: 'Kom i gang gratis',
    footerHome: 'Stemne',
    footerFaq: 'Spørsmål',
    footerPrivacy: 'Personvern',
    footerTerms: 'Vilkår',
  },
  marketingLandingView: {
    periodYearly: 'per år',
    periodMonthly: 'per måned',
    yearlyHint: 'spar opptil {pct}%',
    pricingUnavailableTitle: 'Priser er midlertidig utilgjengelige.',
    pricingUnavailableBody:
      'Vi kobler til betalingssystemet vårt nå. Last siden på nytt om litt, eller kontakt oss på {email}.',
    footerDev: 'utviklet av kodelauget.no',
  },
  marketingPractitionersView: {
    homeAriaLabel: 'Stemne, forsiden',
    navAriaLabel: 'Hovedmeny',
    pricing: 'Priser',
    login: 'Logg inn',
    heroEyebrow: 'Mer tid til kunden',
    heroTitle: 'Bookingsystem for massører og behandlere',
    heroLead:
      'La kundene bestille selv og få påminnelser før timen. Samle avtalene på ett sted, med mindre administrasjon og færre dobbeltbookinger.',
    trial: 'Gratis i 3 måneder. Ingen bindingstid.',
    priceLoading: 'Henter månedspris …',
    priceError: 'Kunne ikke hente prisen akkurat nå.',
    price: 'Deretter {price} kr per måned for Solo, uten mva.',
    priceUnavailable: 'Månedsprisen er ikke tilgjengelig akkurat nå.',
    cta: 'Prøv gratis i 3 måneder',
    dashboardAlt: 'Stemne viser kommende avtaler og kunder i oversikten',
    dashboardCaption: 'Oversikten i Stemne, vist med demodata.',
    photoAlt: 'En massør masserer skuldrene til en kunde på en behandlingsbenk i et lyst rom.',
    benefitsAriaLabel: 'En enklere timehverdag',
    benefitBookingTitle: 'Kundene finner en tid selv',
    benefitBookingBody:
      'Del bookinglenken din. Kunden velger behandling og en ledig tid, uten at du må svare mellom timene.',
    benefitCalendarTitle: 'Avtalene henger sammen',
    benefitCalendarBody:
      'Påminnelser hjelper kunden å huske timen. Koble til kalenderen din, så opptatte tider holdes utenfor bookingen.',
    benefitContinuityTitle: 'Ta opp tråden neste gang',
    benefitContinuityBody:
      'Åpne kundens historikk før neste time. Tidligere avtaler og notater gir deg et utgangspunkt for oppfølgingen.',
    continuityEyebrow: 'Kontinuitet mellom timene',
    continuityTitle: 'Husk det dere skal følge opp',
    continuityBody:
      'Private, krypterte notater ligger ved siden av booking og historikk. Du åpner dem når du forbereder neste time. Kunden ser ikke de interne notatene dine.',
    journalBoundary:
      'Har du journalplikt, bruker du Stemne ved siden av journalen din, ikke i stedet for.',
    customersAlt: 'Kundeoversikten i Stemne med tidligere og neste avtale',
    customersCaption: 'Kundeoversikten i Stemne, vist med demodata.',
    closingTitle: 'Gjør det enkelt å bestille neste time',
    closingBody: 'Legg inn behandlingene og tidene dine. Del lenken når du er klar.',
  },
  marketingAdvisorsLandingView: {
    homeAriaLabel: 'Stemne – forsiden',
    login: 'Logg inn',
    eyebrow: 'For deg som lever av gode samtaler',
    title: 'Bookingsystem for rådgivere',
    lead: 'La kunden bestille selv. Ha video, kundenotater og historikk på samme sted, så du kan bruke tiden på rådgivningen.',
    price: 'Fra {price} kr per måned, uten mva.',
    priceLoading: 'Henter gjeldende abonnementspris.',
    priceUnavailable: 'Prisen er ikke tilgjengelig akkurat nå.',
    pricingLink: 'Se priser og hva som er inkludert',
    getStarted: 'Kom i gang',
    nextConversation: 'Til neste samtale',
    privateLabel: 'Bare for deg og teamet ditt',
    productImageAlt: 'Kundekortet i Stemne med møtenotater merket Intern, som kunden ikke kan se.',
    productCaption:
      'Notatene blir hos deg. Kunden ser bare det som trengs for å bestille og møtes.',
    photoAlt: 'En rådgiver og en kunde i samtale ved et rundt bord i et lyst rom.',
    workflowEyebrow: 'Fra første booking til neste samtale',
    workflowTitle: 'En rød tråd i rådgivningen',
    workflowLead: 'For deg som jobber alene, eller sammen med andre rådgivere.',
    step1Title: 'Kunden velger samtale og tid',
    step1Body:
      'Du legger inn tjenestene og når du er ledig. Kunden velger en tjeneste og en tid. Er dere flere, kan ledige tider samles på én bookingside.',
    step2Title: 'Møt kunden med innebygd video',
    step2Body:
      'Videomøtet åpnes fra bookingen. Kunden trenger ikke opprette en konto. Videosamtaler varer i opptil 60 minutter, med betalt utvidelse til 120 minutter.',
    step3Title: 'Ta med historikken videre',
    step3Body:
      'Samle møtenotater og tidligere samtaler på kundekortet. Du og teamet ditt har oversikten. Kunden ser aldri de interne notatene eller den interne historikken.',
    footer: 'Stemne · Laget i Norge',
    aboutAriaLabel: 'Mer om Stemne',
    privacy: 'Personvern',
    terms: 'Vilkår',
    contact: 'Kontakt oss',
  },
  marketingLoginView: {
    emailPlaceholder: "din{'@'}epost.no",
  },
  // /payment-terms — annex to the Brukervilkår for the «Betaling ved
  // booking» add-on. Legal copy: the statute references and the liability
  // allocation are load-bearing, so edit the wording only with counsel.
  // PaymentTermsView.spec.ts pins the sections, the citations, and the
  // absence of em dashes and exclamation marks.
  marketingPaymentTermsView: {
    kicker: 'Vilkår',
    title: 'Vilkår for Betaling ved booking',
    lastUpdated: 'Sist oppdatert {date}',
    lead: 'Disse vilkårene gjelder når du har slått på tillegget «Betaling ved booking» og lar kundene betale med kort når de bestiller. De kommer i tillegg til Brukervilkårene. Står det noe her som ikke stemmer med Brukervilkårene, er det disse som gjelder for betalingene.',
    s1Heading: '1. Du er selgeren',
    s1Para1:
      'Kunden kjøper tjenesten av deg. Stemne er teknisk plattform, og har avtale med deg, ikke med kunden din.',
    s1Para2:
      'Betalingen går inn på din egen Stripe-konto. Pengene er aldri innom Stemnes konto, og Stemne tar ingen andel av dem.',
    s1Para3:
      'Stripe-kontoen oppretter du gjennom Stemne. Avtalen om selve kontoen inngår du direkte med Stripe (Stripe Connected Account Agreement), og Stripe kan be deg om legitimasjon og annen dokumentasjon før du får ta imot penger.',
    s2Heading: '2. Hva Stemne tar betalt',
    s2Para1:
      'Tillegget koster 199 kr per måned eks. mva., altså 248,75 kr med mva. Årlig koster det 2 029 kr eks. mva. Det faktureres sammen med abonnementet ditt.',
    s2Para2: 'Stemne tar ingen provisjon av betalingene.',
    s2Para3:
      'Sier du opp tillegget, kan ikke kundene betale ved booking lenger. Betalinger du allerede har tatt imot, og dokumentene som hører til dem, blir stående.',
    s3Heading: '3. Kortgebyret bærer du',
    s3Para1:
      'Stripe trekker kortgebyret sitt før pengene når saldoen din. Størrelsen følger av Stripes priser og varierer med korttypen.',
    s3Para2:
      'Du kan ikke legge gebyret på kunden. Å ta ekstra betalt for at noen bruker kort er forbudt etter finansavtaleloven § 2-4.',
    s3Para3: 'Prisen kunden ser når bestillingen gjøres, er hele beløpet kunden betaler.',
    s4Heading: '4. Utbetaling',
    s4Para1:
      'Du styrer utbetalingsplanen og bankkontoen i Stripe-oversikten. Stripe utbetaler etter planen du velger.',
    s4Para2:
      'Tidspunktet for den første og senere utbetalinger følger Stripes vilkår og statusen på kontoen din.',
    s4Para3:
      'Saldo, neste utbetaling og hver enkelt betaling ser du i Stripe-oversikten. Du åpner den fra Betalinger i innstillingene.',
    s5Heading: '5. Refusjon',
    s5Para1:
      'Stemne refunderer automatisk i tre tilfeller: kunden avbestiller innen fristen du har satt for tjenesten, kunden avbestiller innenfor angrefristen på 14 dager, eller du avlyser møtet selv.',
    s5Para2:
      'Refusjonen trekkes fra Stripe-saldoen din. Stripe betaler ikke tilbake kortgebyret fra den opprinnelige betalingen, så en refusjon koster deg gebyret.',
    s5Para3:
      'Har du ikke nok på saldoen, avgjør Stripe hvordan beløpet kreves inn etter avtalen mellom deg og Stripe.',
    s5Para4:
      'Refunderer du selv fra Stripe-oversikten, registrerer Stemne det og sender kreditnota til kunden. Møtet står fortsatt som bekreftet i Stemne til du avlyser det.',
    s6Heading: '6. Innsigelser fra kunden',
    s6Para1:
      'Bestrider kunden en betaling hos banken sin, trekker Stripe både beløpet og et innsigelsesgebyr fra kontoen din mens saken pågår.',
    s6Para2:
      'Du svarer på innsigelsen i Stripe-oversikten innen fristen Stripe oppgir. Stemne varsler deg på e-post, men kan ikke svare for deg.',
    s6Para3: 'Får du medhold, får du beløpet tilbake. Får du ikke medhold, blir trekket stående.',
    s7Heading: '7. Kvittering, kreditnota og mva.',
    s7Para1:
      'Stemne lager salgsdokumentet i ditt navn, med ditt organisasjonsnummer og din adresse, og sender det til kunden. Nummerserien er din alene.',
    s7Para2: 'En refusjon gir kreditnota, slik bokføringsforskriften § 5-2-7 krever.',
    s7Para3:
      'Du velger mva-behandling per tjeneste og svarer for at valget er riktig. Stemne slår opp om du står i Merverdiavgiftsregisteret og bruker svaret på dokumentene.',
    s7Para4: 'Krever tjenesten 25 % mva., må prisen være oppgitt inkludert mva.',
    s8Heading: '8. Angrerett',
    s8Para1:
      'Kunden har 14 dagers angrerett fra bestillingen. Stemne viser opplysningene loven krever, gir kunden angreskjemaet, og ber om bekreftelsen som skal til for at tjenesten kan leveres før fristen er ute.',
    s8Para2:
      'Pliktene etter angrerettloven er dine som selger. Stemne utfører dem på dine vegne, og du svarer selv hvis kunden tar kontakt om angreretten.',
    s8Para3:
      'Angrer kunden før møtet er holdt, får kunden hele beløpet tilbake. Det gjelder også når kunden er innenfor angrefristen, men utenfor avbestillingsfristen du har satt.',
    s9Heading: '9. Ansvar',
    s9Para1:
      'Stripe, ikke Stemne, har ansvaret for eventuelle underskudd på den tilknyttede kontoen. Ditt ansvar overfor Stripe følger avtalen mellom deg og Stripe.',
    s9Para2:
      'Stemne svarer ikke for at kunden betaler, og ikke for når Stripe utbetaler. Ansvarsbegrensningen i Brukervilkårene punkt 8 gjelder også for tillegget.',
    s10Heading: '10. Endringer',
    s10Para1:
      'Vi kan endre disse vilkårene. Vesentlige endringer varsler vi om minst 30 dager før de trer i kraft, på samme måte som i Brukervilkårene punkt 9.',
    contact: 'Spørsmål om betalingsvilkårene: {email}',
    footerHome: 'Tilbake til forsiden',
  },
  marketingPrivacyView: {
    navFront: 'Forsiden',
    navGetStarted: 'Kom i gang',
    kicker: 'Personvern',
    title: 'Personvernerklæring',
    lastUpdated: 'Sist oppdatert {date}',
    lead: 'Stemne er en bookingtjeneste laget i Norge for rådgivere, terapeuter og konsulenter. Vi er bygget på prinsippet om at dine data er dine. Vi samler kun det vi trenger for å levere tjenesten, og du kan slette alt med ett klikk.',
    s1Heading: '1. Hvem er behandlingsansvarlig',
    s1Controller1: 'Stemne leveres av',
    s1Controller2: '(org.nr.',
    s1Controller3: ', Skjetleinskogen 30, 7082 Kattem, Norge). Kontakt:',
    s1Processor:
      'Når en virksomhet (operatør) bruker Stemne for å booke møter med sine kunder, er operatøren behandlingsansvarlig for kundedata, og Stemne er databehandler under en databehandleravtale.',
    s2Heading: '2. Hvilke data vi behandler',
    s2OperatorsHeading: 'Operatører (de som bruker Stemne)',
    s2Op1: 'Navn, e-postadresse, telefonnummer (for innlogging og kontakt)',
    s2Op2: 'Organisasjonsnavn, organisasjonsnummer, subdomene',
    s2Op3: 'Arbeidstider og tilgjengelighet',
    s2Op4: 'Møtetypene du tilbyr, inkludert pris og varighet',
    s2Op5: 'Betalingsinformasjon (behandles av Stripe; vi lagrer aldri kortdata)',
    s2Op6:
      'Tilkoblede kalendere (Google, Outlook). Se eget avsnitt «Bruk av Google-tjenester» nedenfor for detaljer om hva vi leser og skriver',
    s2CustomersHeading: 'Sluttkunder (de som booker hos en operatør)',
    s2Cust1: 'Navn og e-postadresse oppgitt ved booking',
    s2Cust2: 'Møtetype, tidspunkt og eventuell melding fra kunden',
    s2Cust3: 'IP-adresse og brukerstatistikk (anonymisert, kun for sikkerhet)',
    s2Cust4: 'For videomøter: deltakelsestidspunkt (start/slutt), ikke møteinnhold',
    s3Heading: '3. Hvorfor vi behandler dataene',
    s3DeliveryLabel: 'Levering av tjenesten:',
    s3DeliveryBody:
      'vi trenger e-post og navn for å sende bookingbekreftelser, kalenderinvitasjoner og videomøtelenker.',
    s3LegalLabel: 'Lovkrav:',
    s3LegalBody: 'regnskapsdata oppbevares så lenge norsk bokføringslov krever (typisk 5 år).',
    s3SecurityLabel: 'Sikkerhet:',
    s3SecurityBody: 'logging av innlogginger og kritiske hendelser for å oppdage misbruk.',
    s3Basis:
      'Rettsgrunnlaget er kontraktoppfyllelse (GDPR art. 6(1)(b)) for booking- og betalingsdata, lovpålagt behandling (art. 6(1)(c)) for regnskap, og berettiget interesse (art. 6(1)(f)) for sikkerhetslogging.',
    s4Heading: '4. Hvor dataene lagres',
    s4AppLabel: 'Applikasjon og database:',
    s4AppBody: 'Hetzner, Tyskland (EU)',
    s4BackupLabel: 'Sikkerhetskopier:',
    s4BackupBody: 'kryptert lagring innenfor EU/EØS',
    s4PaymentsLabel: 'Betalinger:',
    s4PaymentsBody: 'Stripe Inc. (USA), under EU-US Data Privacy Framework',
    s4EmailLabel: 'E-post:',
    s4EmailBody: 'Brevo (Frankrike, EU)',
    s4VideoLabel: 'Videomøter:',
    s4VideoBody: 'Whereby AS, Norge',
    s4ErrorsLabel: 'Feilrapportering:',
    s4ErrorsBody: 'Sentry (Tyskland, EU)',
    s4Transfer:
      'Data forlater aldri EU/EØS uten et gyldig overføringsgrunnlag (typisk Standard Contractual Clauses eller Data Privacy Framework-sertifisering).',
    s5Heading: '5. Bruk av Google-tjenester',
    s5Intro:
      'Når du som operatør kobler Google-kalenderen din til Stemne, ber vi om tilgang via Googles offisielle OAuth-flyt. Du ser eksplisitt hvilke tilganger Stemne ber om, og du kan trekke tilbake tilgangen når som helst.',
    s5ScopesHeading: 'Hvilke tilganger Stemne ber om',
    s5ScopeEvents:
      'lese, opprette, endre og slette kalenderhendelser på de kalenderne din Google-konto har tilgang til.',
    s5ScopeOpenidAnd: 'og',
    s5ScopeOpenidBody:
      'Kun for å vise hvilken Google-konto som er tilkoblet i administrasjonsvisningen.',
    s5UsageHeading: 'Hva vi gjør med dataene',
    s5FreeBusyLabel: 'Leser opptatt/ledig',
    s5FreeBusyBody: 'fra dine valgte kalendere for å beregne ledige tidspunkter i bookingflyten.',
    s5ExistingLabel: 'Leser eksisterende hendelser',
    s5ExistingBody:
      'i din egen kalender for å vise kollisjonsvarsel i operatør-dashboardet (kun din egen oversikt. Disse vises aldri til kundene dine).',
    s5WriteLabel: 'Skriver nye Stemne-bookinger',
    s5WriteBody:
      'som kalenderhendelser i din primærkalender, med tjeneste, kundenavn, kundens beskjed, og enten videolenke eller kontoradresse. Du kan slå av denne synkroniseringen når som helst fra «Administrer kalender».',
    s5UpdateLabel: 'Oppdaterer og sletter',
    s5UpdateBody:
      'kalenderhendelser når en Stemne-booking flyttes, endrer møteform eller avbestilles.',
    s5LimitedHeading: 'Hva vi ikke gjør (Googles «Limited Use»-krav)',
    s5LimitedIntro1: 'Stemnes bruk av informasjon mottatt fra Google API-er følger Googles',
    s5LimitedPolicyLink: 'API Services User Data Policy',
    s5LimitedIntro2: ', inkludert kravene om begrenset bruk («Limited Use»):',
    s5Limited1:
      'Vi bruker kun Google-data til å levere de brukerrettede funksjonene beskrevet over.',
    s5Limited2:
      'Vi deler ikke Google-data med tredjeparter, bortsett fra som nødvendig for å levere disse funksjonene (f.eks. Infrastrukturleverandører i EU/EØS som er underlagt streng taushetsplikt).',
    s5Limited3:
      'Ingen mennesker leser Google-dataene dine. Unntak gjelder kun hvis du har gitt uttrykkelig samtykke, dataene er nødvendige for sikkerhet (f.eks. Etterforskning av misbruk), eller vi er pålagt det ved lov, og kun anonymisert/aggregert der mulig.',
    s5Limited4:
      'Vi bruker aldri Google-data til å trene KI- eller maskinlæringsmodeller, og aldri til reklame eller videresalg.',
    s5TokensHeading: 'Lagring og kryptering av tokens',
    s5TokensBody:
      'Tilgangstokenet og fornyelsestokenet vi får fra Google lagres kryptert (AES-256-GCM) i vår database i Tyskland (EU). Selve innholdet i kalenderhendelsene dine forblir hos Google. Vi laster ikke ned og lagrer ikke kalenderdata for senere bruk utenfor de operasjonene som er nødvendige for at tjenesten skal fungere.',
    s5RevokeHeading: 'Hvordan trekke tilbake tilgangen',
    s5RevokeStemneLabel: 'Fra Stemne:',
    s5RevokeStemne1: 'gå til',
    s5RevokeStemneEm: 'Administrer kalender',
    s5RevokeStemne2:
      'i operatør-dashboardet og trykk «Koble fra». Tokens slettes umiddelbart fra vår database.',
    s5RevokeGoogleLabel: 'Fra Google direkte:',
    s5RevokeGoogle1: 'gå til',
    s5RevokeGoogle2: 'og fjern «Stemne» fra listen over tilkoblede apper.',
    s5RevokeNote:
      'Eksisterende kalenderhendelser som Stemne har opprettet, blir værende i Google-kalenderen din etter frakobling. Du kan slette dem manuelt i Google hvis du ønsker det.',
    s6Heading: '6. Hvor lenge vi oppbevarer dataene',
    s6OperatorLabel: 'Operatørkonto:',
    s6OperatorBody:
      'så lenge abonnementet er aktivt, pluss 30 dager etter oppsigelse (gir tid til dataeksport).',
    s6CustomerLabel: 'Sluttkunde-data:',
    s6CustomerBody: '12 måneder etter siste møte, eller umiddelbart hvis kunden ber om sletting.',
    s6AccountingLabel: 'Regnskapsdata:',
    s6AccountingBody: '5 år (bokføringsloven).',
    s6LogsLabel: 'Sikkerhetslogger:',
    s6LogsBody: '90 dager.',
    s7Heading: '7. Dine rettigheter',
    s7Intro: 'Som registrert har du rett til å:',
    s7Right1: 'Få innsyn i hvilke data vi har om deg',
    s7Right2: 'Rette feil i dine data',
    s7Right3: 'Få dataene slettet (med unntak av det vi må oppbevare av lovkrav)',
    s7Right4: 'Få dine data utlevert i et maskinlesbart format',
    s7Right5: 'Trekke tilbake samtykke når behandlingen baserer seg på det',
    s7Right6: 'Klage til Datatilsynet hvis du mener vi behandler data feil',
    s7Requests1:
      'Sluttkunder kan slette alle sine data hos en operatør direkte fra booking-portalen. Operatører kan slette egen konto fra kontoinnstillinger. For andre forespørsler, kontakt',
    s7Requests2: 'vi svarer innen 30 dager.',
    s7PortalLink: 'Åpne kundeportalen',
    s7PortalBody:
      'for å logge inn med e-posten din. Du kan se, laste ned eller slette dataene dine hos Stemne.',
    s8Heading: '8. Cookies og sporing',
    s8Body:
      'Stemne bruker kun nødvendige cookies for å holde deg innlogget og beskytte mot CSRF. Vi bruker Sentry til feilrapportering og tilbakemeldinger; dataene brukes til feilsøking, ikke markedsføring eller produktanalyse. På markedssiden stemne.no bruker vi i tillegg en Google Ads-cookie, en Meta-pixel og en OpenAI Ads-pixel for å måle hvor godt annonsene våre fungerer, og da deler vi besøket ditt med Google, Meta og OpenAI. Dette skjer bare når du godtar det i cookie-banneret som vises ved besøk. Avslår du eller lar banneret stå ubesvart, laster vi ingen av disse annonsesporerne. Dette gjelder ikke bookingsiden til en operatør, der kundene deres aldri blir målt for annonser. Hvis du logger inn fra en videomøteklient, kan tjenesten (f.eks. Whereby) sette egne cookies. Se deres personvernerklæring.',
    s8Withdraw:
      'Du kan ombestemme deg når som helst. Velger du Avslå etter å ha godtatt, slutter annonsesporerne å sende data fra besøket ditt med en gang, og vi sletter cookiene de har satt, uten at du må laste siden på nytt. Endre valget under',
    s9Heading: '9. Sikkerhet',
    s9Body:
      'Vi krypterer alle data i transitt (TLS) og sensitive felter i hvile (AES-256-GCM). Innlogging skjer via passnøkkel (WebAuthn) eller engangslenke per e-post. Vi lagrer ikke passord. Tilgang til produksjonsdata er begrenset til et minimum av personer og logges.',
    s10Heading: '10. Endringer',
    s10Body:
      'Vi varsler om vesentlige endringer i denne erklæringen via e-post og en banner i applikasjonen minst 30 dager før de trer i kraft. Historiske versjoner er tilgjengelige på forespørsel.',
    s11Heading: '11. Kontakt',
    s11PrivacyLabel: 'Personvernspørsmål:',
    s11GeneralLabel: 'Generelle henvendelser:',
    s11AuthorityLabel: 'Datatilsynet:',
    footerStemne: 'Stemne',
    footerFaq: 'Spørsmål',
    footerPrivacy: 'Personvern',
    footerTerms: 'Vilkår',
  },
  marketingSignUpView: {
    segmentAdvisor: 'Rådgiver eller konsulent',
    segmentTrainer: 'Trener eller coach',
    yearlyHint: 'spar opptil {pct}%',
    pricePerYear: '{price}/år',
    pricePerMonth: '{price}/mnd',
    seatsUnlimited: 'Ubegrenset',
    seats: '1 bruker | {n} brukere',
    turnstileWaiting: 'vent et øyeblikk mens vi bekrefter at du ikke er en robot',
    back: '← Tilbake',
    heading: 'Sett opp bookingsiden din.',
    lede: 'Start med navn og e-post. Vi hjelper deg å lage en bookingside etter at du har bekreftet e-posten. 3 måneder gratis. Ingen kort nå.',
    segmentKicker: 'hva driver du med?',
    segmentHint: 'Hjelper oss å sette opp riktig type tjenester. Du kan endre dette senere.',
    planKicker: 'velg plan',
    planHint: '3 måneder gratis uansett valg. Ingen kort nå. Du kan endre planen når som helst.',
    nameLabel: 'Navn',
    namePlaceholder: 'Fornavn Etternavn',
    emailLabel: 'E-post',
    emailPlaceholder: "du{'@'}firma.no",
    turnstileAriaLabel: 'Bot-sjekk fra Cloudflare',
    submitCta: 'Sett opp siden min →',
    loginPrompt: 'Har du allerede en konto?',
    loginLink: 'Logg inn med passnøkkel',
    loginSuffix: '.',
    termsPrefix: 'Ved å fortsette godtar du',
    termsLink: 'vilkårene',
    termsMiddle: 'og',
    privacyLink: 'personvernerklæringen',
    termsSuffix: 'vår.',
  },
  marketingSwaggerDocsView: {
    loadError: 'Klarte ikke å laste dokumentasjonen. Last siden på nytt.',
    docsAriaLabel: 'API-dokumentasjon',
  },
  marketingTermsView: {
    navFrontpage: 'Forsiden',
    navGetStarted: 'Kom i gang',
    kicker: 'Vilkår',
    title: 'Brukervilkår',
    lastUpdated: 'Sist oppdatert {date}',
    lead: 'Disse vilkårene regulerer bruk av Stemne, en bookingtjeneste for rådgivere, terapeuter og konsulenter. Ved å opprette en konto eller booke et møte via tjenesten aksepterer du vilkårene under.',
    s1Heading: '1. Om tjenesten',
    s1Para1:
      'Stemne leveres av {company} (org.nr. 937 952 732, Skjetleinskogen 30, 7082 Kattem, Norge), heretter «vi» eller «Stemne». Tjenesten omfatter et nettbasert verktøy for å motta og administrere bookinger, sende kalenderinvitasjoner, holde videomøter (via Whereby) og kommunisere med kunder.',
    s1Para2:
      'Tjenesten leveres «som den er». Vi jobber kontinuerlig med å forbedre den og kan endre, legge til eller fjerne funksjoner uten varsel, så lenge endringene ikke vesentlig reduserer kjernefunksjonaliteten du abonnerer på.',
    s1Para3:
      'Videomøter er begrenset til 60 minutter per møte. Du kan kjøpe utvidet varighet som lar hvert videomøte vare i inntil 120 minutter. Grensen gjelder selve videorommet, ikke lengden på tjenesten du tilbyr.',
    s2Heading: '2. Brukerkonto',
    s2Para1:
      'Du må være over 18 år og ha rett til å inngå avtaler på vegne av virksomheten din for å opprette en operatørkonto. Du er ansvarlig for å holde innloggingsinformasjon trygt og for all aktivitet som skjer fra din konto.',
    s2Para2:
      'Du kan slette kontoen din når som helst fra kontoinnstillinger. Vi kan suspendere eller avslutte kontoer som bryter disse vilkårene eller bruker tjenesten på en måte som skader oss eller andre brukere.',
    s3Heading: '3. Abonnement og betaling',
    s3Para1:
      'Abonnementsprisene fremgår av prislisten på stemne.no. Du betaler månedlig eller årlig via Stripe. Prisene er oppgitt eks. mva.; mva. tillegges der det er aktuelt.',
    s3Para2:
      'Hvis betaling ikke gjennomføres, varsler vi deg og gir 14 dager til å oppdatere betalingsmåten før vi suspenderer tjenesten.',
    s4Heading: '4. Refusjon og avbestilling',
    s4Para1:
      'Stemne er et løpende abonnement. Du betaler for tilgang i den perioden du har valgt, og kan stoppe trekket når du vil. Vi refunderer ikke inneværende periode.',
    s4Para2:
      'Dette gjelder uavhengig av om du har brukt tjenesten mye eller lite i perioden. Forbrukerrettigheter etter ufravikelig lovgivning gjelder uavhengig av disse vilkårene.',
    // Section 4 is about the SUBSCRIPTION. Once the operator takes card
    // payment at booking, the refund rules for those payments are the
    // annex's, not this section's.
    s4Annex:
      'Tar du imot kortbetaling når kundene bestiller, gjelder egne vilkår for de betalingene: {link}.',
    s4AnnexLink: 'Vilkår for Betaling ved booking',
    s5Heading: '5. Ditt innhold og dine kunders data',
    s5Para1:
      'Du beholder eierskap til alt innhold du legger inn i Stemne: møtenotater, kundedata, tilgjengelighet osv. Vi har en begrenset rett til å behandle dataene for å levere tjenesten til deg.',
    s5Para2:
      'Når du behandler personopplysninger om kundene dine i Stemne, er du behandlingsansvarlig og vi er databehandler. Detaljene fremgår av databehandleravtalen som inngås automatisk når du oppretter konto.',
    s5Cta: 'Er du sluttkunde hos {name}? {link} for å se, laste ned eller slette dine egne data.',
    s5CtaLink: 'Åpne kundeportalen',
    s6Heading: '6. Akseptabel bruk',
    s6Intro: 'Du kan ikke bruke Stemne til å:',
    s6Item1: 'Sende spam eller uønsket kommunikasjon',
    s6Item2: 'Bryte norsk lov eller andre relevante regelverk',
    s6Item3: 'Manipulere bookingsystemet eller omgå sikkerhetstiltak',
    s6Item4: 'Reverse-engineere, kopiere eller selge tjenesten videre',
    s6Item5:
      'Bruke tjenesten på en måte som skader andre brukere eller den tekniske driften av Stemne',
    s7Heading: '7. Tilgjengelighet og support',
    s7Para1:
      'Vi sikter på 99,5 % oppetid for produksjonsmiljøet, men gir ingen garanti. Planlagt vedlikehold varsles minst 48 timer i forveien og gjennomføres utenom virkedager der det er mulig.',
    s7Para2:
      'Support gis på e-post til {email} innen ett virkedøgn. Akutte saker som hindrer kjernedrift (innlogging, booking) prioriteres samme dag.',
    s8Heading: '8. Ansvarsbegrensning',
    s8Para1:
      'Vi er ikke ansvarlige for indirekte tap, inkludert tapt inntekt, tapte data eller skade på omdømme, som følge av bruk eller manglende tilgang til tjenesten. Vårt samlede ansvar overfor deg er uansett begrenset til det du har betalt for tjenesten de siste 12 månedene før hendelsen.',
    s8Para2:
      'Begrensningen gjelder ikke for tap forårsaket av grov uaktsomhet, forsett eller brudd på forbrukerrettigheter.',
    s9Heading: '9. Endringer i vilkårene',
    s9Para1:
      'Vi kan endre disse vilkårene. Vesentlige endringer varsles minst 30 dager før de trer i kraft, via e-post og en banner i applikasjonen. Hvis du ikke aksepterer endringene, kan du si opp abonnementet før de trer i kraft.',
    s10Heading: '10. Lovvalg og verneting',
    s10Para1:
      'Disse vilkårene reguleres av norsk rett. Tvister søkes løst i minnelighet. Hvis det ikke lykkes, er {court} verneting.',
    s11Heading: '11. Kontakt',
    s11Terms: 'Spørsmål om vilkårene: {email}',
    s11Privacy: 'Personvern: {email}',
    footerHome: 'Stemne',
    footerFaq: 'Spørsmål',
    footerPrivacy: 'Personvern',
    footerTerms: 'Vilkår',
  },
  verifyCode: {
    eyebrow: 'bekreft e-posten',
    body: 'Skriv inn de seks sifrene fra e-posten.',
    label: 'Kode fra e-posten',
    placeholder: '000000',
    submit: 'Bekreft koden',
  },

  marketingVerifyView: {
    rateLimited: 'Vent litt og prøv igjen.',
    // Fallback headline only — the four backend codes now resolve through
    // errors.<code> in utils/apiError.ts, the documented mechanism.
    invalidLink: 'Bekreftelsen er ugyldig eller utløpt. Be om en ny kode.',
    // #3316 — lenken og koden åpner den samme registreringen. Den du bruker
    // sist møter en registrering som allerede er fullført. Ingenting har gått
    // galt, så teksten sier det.
    alreadyVerifiedMeta: 'alt er i orden',
    alreadyVerifiedBody:
      'Kontoen din er opprettet. Du kan logge inn med e-postadressen din, så sender vi deg en lenke.',
    goToLogin: 'Gå til innlogging',
    // Two bodies, because the screen has two shapes. The recovery one runs
    // when sessionStorage is empty and the operator has to type her
    // address; the other runs when we already have it and the only thing
    // on screen is a resend button. One body for both told her to type an
    // address into a field that wasn't there.
    sessionMismatchBody: 'Skriv inn navn og e-postadresse for å få en ny kode og fortsette her.',
    sessionMismatchBodyKnownEmail: 'Send en ny kode og skriv den inn her for å fortsette.',
    recoveryNameLabel: 'Navn',
    recoveryEmailLabel: 'E-postadresse',
    recoveryEmailHint: 'Skriv inn den nye koden i denne nettleseren.',
    turnstileWaiting: 'Vent et øyeblikk mens vi bekrefter at du ikke er en robot.',
    turnstileAriaLabel: 'Robotsjekk',
    resendFailed: 'Vi fikk ikke sendt en ny kode. Prøv igjen om litt.',
    codeFailed: 'Vi fikk ikke bekreftet koden. Prøv igjen om litt.',
    verifyingHeading: 'Bekrefter e-posten din...',
    errorMeta: 'noe gikk galt',
    errorBody: 'Du kan sende en ny kode, eller prøve igjen med en annen adresse.',
    resend: 'Send på nytt',
    resendCooldown: 'Send på nytt om {n}s',
    tryAnotherAddress: 'Prøv en annen adresse',
    backToSignup: 'Tilbake til registrering',
    resentHeading: 'Se etter en ny kode',
    toPrefix: 'til',
  },
  meetingInMeetingView: {
    mobilePanesLabel: 'Velg møtevisning',
    videoTab: 'Video',
    backToPrep: '← Forberedelser',
    leaveMeeting: 'Forlat møtet',
    iframeTitle: 'Stemne meeting room',
    preparingRoom: 'Åpner videorommet',
    fallbackTitle: 'Video er ikke konfigurert',
    fallbackBody:
      'Dette møtet har ingen videolenke. Kontakt operatøren hvis du forventet å møte på video, eller bruk e-postadressen fra invitasjonen for å avtale et fysisk møte.',
    chatTab: 'Chat',
    notesTab: 'Notater',
    notesHeading: 'Notater',
    notesPrivate: 'privat',
    notesDefaultTitle: 'Under møtet',
    wrapUpCta: 'Avslutt og oppsummer →',
  },
  portalManageView: {
    advisorReturning: 'Du møter {name} igjen.',
    documentsLabel: 'Dokumenter til gjennomgang',
    messagesLabel: 'Meldinger',
    seriesSlotTime: '{date} kl {time}',
    withdrawal: {
      label: 'Angrerett',
      body: 'Angrerett er noe annet enn vanlig avbestilling. Send en tydelig angremelding til {operator}. Meldingen lagres med dato og tidspunkt, og operatøren følger opp møtet og eventuell betaling.',
      open: 'Send angremelding',
      formLink: 'Åpne utskriftsvennlig angreskjema',
      emailLink: 'Send i stedet med e-post til {email}',
      // Read back from the notice's own server row, so it survives a reload —
      // the date IS the receipt, and a reassurance without one is not evidence.
      sentAt: 'Du sendte angremeldingen til {operator} {date}. Den er lagret med tidspunkt.',
      modalTitle: 'Bruke angreretten?',
      modalBody:
        'Se over meldingen før du sender. Dette varsler operatøren, men avbestiller ikke møtet automatisk.',
      messageLabel: 'Angremelding',
      submit: 'Send angremelding',
      cancel: 'Tilbake',
      subjectFallback: 'avtalen',
      operatorFallback: 'operatøren',
      emailSubject: 'Angremelding – booking {reference}',
      prefill:
        'Jeg gir med dette beskjed om at jeg bruker angreretten for «{subject}», avtalt {date}.\n\nBookingreferanse: {reference}',
    },
    // Read-only status line shown when the booking is no longer live, in
    // place of Endre/Avbestill (#2327). Customer-facing, so no "uavklart"
    // jargon on the unresolved case.
    statusReadonly: {
      cancelled: 'Dette møtet er avbestilt.',
      expired: 'Dette møtet er utløpt.',
      completed: 'Dette møtet er gjennomført.',
      noShow: 'Dette møtet ble ikke gjennomført.',
      unresolved: 'Tidspunktet for dette møtet har passert.',
      pending: 'Dette møtet venter på bekreftelse.',
    },
    // #3490 — appended to the «gjennomført» status line only, so it reads as
    // one sentence: «Dette møtet er gjennomført. Vil du avtale et nytt?»
    rebookPrompt: 'Vil du avtale et nytt?',
  },
  portalPollVoteView: {
    eyebrowInvite: 'Møteinvitasjon',
    eyebrowVote: 'Avstemning om tid',
    titleInvite: 'Du er invitert til et møte hos {name}',
    titleVote: 'Finn en tid som passer hos {name}',
    submitError: 'Kunne ikke lagre stemmen din. Prøv igjen.',
    suggestError: 'Kunne ikke foreslå tidspunktet. Prøv igjen.',
    loading: 'Henter avstemningen…',
    meetingTimeLead: 'Tidspunkt for møtet',
    committedLead: 'Tidspunktet er valgt',
    committedNote: 'Du får en egen bekreftelse på e-post med detaljene.',
    voteLead:
      'Dette er den foreslåtte tiden. Si fra om den passer, eller om en av de andre passer bedre.',
    othersSubhead: 'Disse passer også',
    deadlineNote:
      'Stem eller foreslå en ny tid innen {deadline}. Hører vi ingenting, blir den foreslåtte tiden valgt.',
    savedNote: 'Stemmen din er lagret. Takk.',
    updateVoteCta: 'Oppdater stemmen',
    saveVoteCta: 'Lagre stemmen',
    closed: 'Avstemningen er avsluttet.',
    resultLabel: 'Resultat så langt',
    suggestCta: 'Foreslå et tidspunkt',
    dateLabel: 'Dato',
    timeLabel: 'Tid',
    suggestSubmitCta: 'Foreslå tiden',
    rsvpLabel: 'Kan du delta?',
    rsvpConfirmed: 'Du har bekreftet.',
    rsvpDeclined: 'Du har takket nei.',
    rsvpConfirmCta: 'Bekreft',
    rsvpDeclineCta: 'Takk nei',
  },
  portalPortalView: {
    emailPlaceholder: "din{'@'}epost.no",
  },
  portalRescheduledView: {
    icsSummaryFallback: 'Møte',
    icsLocationOnline: 'Online',
  },
  portalRoomView: {
    defaultOperatorName: 'rådgiveren din',
    unavailableHeading: 'Rommet er ikke tilgjengelig akkurat nå.',
    unavailableBody:
      'Lenken er enten utløpt eller hører til en organisasjon som ikke har delt rom slått på ennå. Be om en ny lenke om det er en stund siden du fikk e-posten.',
    backToPortal: 'Tilbake til portalen',
    errorHeading: 'Noe gikk galt.',
    retry: 'Prøv igjen',
    kicker: 'delt rom',
    heading: 'Delt rom med {operator}',
    lead: 'Her snakker du med {operator} og finner alt hen har delt med deg. Meldinger og dokumenter samme sted, trygt bak innlogging, ikke på e-post.',
    emptyBody:
      'Ingen meldinger eller dokumenter delt ennå. Når {operator} deler noe med deg, dukker det opp her.',
    advisorTitle: 'Din rådgiver',
    privacy:
      'Dokumentene er bare synlige for deg og {operator}. Noen kan ha en utløpsdato, last dem ned hvis du vil beholde dem.',
  },
  setupDashboardAccountView: {
    tenantHostFallback: 'siden din',
    profileSaved: 'Profilen er lagret',
    profileSaveError: 'Kunne ikke lagre. Prøv igjen.',
    emailEmpty: 'E-postadressen kan ikke være tom.',
    emailSameAsCurrent: 'Den nye adressen må være forskjellig fra den nåværende.',
    emailInUse: 'Adressen er allerede i bruk av en annen konto.',
    emailInvalid: 'Ugyldig e-postadresse.',
    emailSendError: 'Kunne ikke sende bekreftelseslenken. Prøv igjen.',
    passkeyAdded: 'Passnøkkel lagt til',
    passkeyRenamed: 'Navnet er oppdatert',
    passkeyLastCannotRemove: 'Kan ikke fjerne siste passnøkkel.',
    passkeyRemoved: 'Passnøkkel fjernet',
    sessionsRevoked: 'Logget ut {n} andre økt | Logget ut {n} andre økter',
    sessionsSudoRequired: 'Bekreft med passnøkkelen din først',
    sessionsRevokeError: 'Kunne ikke logge ut andre økter',
    dateJustNow: 'nettopp',
    dateMinutesAgo: 'for {n} min siden',
    dateToday: 'i dag',
    dateYesterday: 'i går',
    breadcrumb: 'min konto',
    heading: 'Min konto',
    tabProfile: 'Profil',
    tabAvailability: 'Tilgjengelighet',
    tabMyServices: 'Mine tjenester',
    tabPasskeys: 'Passnøkler',
    tabNotifications: 'Varslinger',
    avatarChangeAria: 'Endre profilbilde',
    avatarUploadAria: 'Last opp profilbilde',
    photoSwap: 'Bytt bilde',
    photoUpload: 'Last opp bilde',
    nameLabel: 'Navn',
    titleLabel: 'Tittel',
    titleHint: 'Vises på profilsiden din.',
    bioLabel: 'Kort om deg',
    bioHint: 'Vises øverst på {host}. 1–3 setninger funker best.',
    locationLabel: 'By / sted',
    phoneLabel: 'Telefon (valgfritt)',
    loginEmailLabel: 'Innloggings-e-post',
    changeEmailCta: 'Bytt e-post',
    saveChanges: 'Lagre endringer',
    passkeysTitle: 'Passnøkler',
    addPasskeyCta: 'Legg til passnøkkel',
    passkeysDesc:
      'Hver enhet du logger inn fra får sin egen passnøkkel. Vi anbefaler <strong>minst to</strong>, én på telefonen, én på en datamaskin eller sikkerhetsnøkkel, så du har en reserve.',
    singlePasskeyWarning:
      '<strong>Du har bare én passnøkkel.</strong> Hvis enheten blir borte, kan du fortsatt logge inn via en innloggingslenke sendt til e-posten din, men det går mye raskere om du har en ekstra passnøkkel klar (telefon + datamaskin, for eksempel).',
    pillPrimary: 'primær',
    pillSynced: 'synkronisert',
    pillSyncedTitle:
      'Lagret i sky-trousseauen din. Du kan trygt fjerne den fra denne enheten, den finnes også på andre enheter du er pålogget.',
    pillLocal: 'bare på denne enheten',
    pillLocalTitle:
      'Bare lagret lokalt på denne enheten. Fjerner du den her, mister du tilgang fra alle andre enheter, bruk en magisk lenke for å logge inn på nytt.',
    metaAdded: 'lagt til {date}',
    metaLastUsed: '· sist brukt {date}',
    renameCta: 'Endre navn',
    sessionsTitle: 'Aktive økter',
    sessionsDesc:
      'Du er logget inn på <strong>{count}</strong> enheter eller nettlesere. Hvis du mistenker at noen andre har tilgang, kan du logge ut alle andre økter, den du bruker nå blir værende.',
    sessionsLogOutOthers: 'Logg ut alle andre',
    emailModalTitle: 'Bytt innloggings-e-post',
    emailSentText:
      'Vi har sendt en bekreftelseslenke til <strong>{email}</strong>. Lenken er gyldig i 24 timer. Den nåværende e-posten fungerer fram til du har bekreftet den nye.',
    emailModalLede:
      'Vi sender en bekreftelseslenke til den nye adressen. Den nåværende fungerer fram til du har bekreftet.',
    newEmailLabel: 'Ny e-post',
    sendConfirmLink: 'Send bekreftelseslenke',
  },
  setupDashboardBookingDetailView: {
    startAnywayTitle: 'Start møtet likevel?',
    crumbMeeting: 'Møte',
    crumbPrivateMeeting: 'Privat møte',
    greetingSaved: 'Hilsenen er lagret.',
    greetingSaveError: 'Kunne ikke lagre hilsenen.',
    guestAdded: 'Gjesten er lagt til og invitert.',
    guestAddError: 'Kunne ikke legge til gjesten.',
    guestRemoved: 'Gjesten er fjernet.',
    coHostRemoved: 'Medverten er fjernet.',
    attendeeRemoveError: 'Kunne ikke fjerne deltakeren.',
    roleHost: 'Vert',
    roleYou: 'deg',
    roleColleague: 'Kollega',
    badgeHost: 'vert',
    badgeCustomer: 'kunde',
    badgeGuest: 'gjest',
    badgeCoHost: 'medvert',
    waitingForNames: ' · venter på {names}',
    declinedNames: ' · {names} har takket nei',
    confirmationSummary: '{confirmed} av {total} har bekreftet{waiting}{declined}',
    lockTimeError: 'Kunne ikke låse tidspunktet.',
    timeLocked: 'Tidspunktet er låst',
    voteSaved: 'Stemmen din er lagret.',
    voteSaveError: 'Kunne ikke lagre stemmen.',
    movedToCustomerCard: 'Flyttet til kundekortet.',
    movePointError: 'Kunne ikke flytte punktet.',
    notFoundOrNoAccess: 'Møtet finnes ikke, eller du har ikke tilgang.',
    loadError: 'Kunne ikke laste møtet.',
    slotLabel: '{date} kl {time}',
    durationMin: '{mins} min',
    durationEditLabel: 'Varighet',
    durationEditAction: 'Endre varighet',
    durationRangeError: 'Varigheten må være et helt antall minutter mellom 1 og 480.',
    durationVideoError: 'Videomøter kan vare i opptil {max} minutter med abonnementet ditt.',
    modeVideo: 'Video',
    modeOffice: 'Kontoret',
    modeClinic: 'Klinikken',
    anAdvisor: 'en rådgiver',
    markedNoShow: 'Markert som ikke møtt.',
    markNoShowError: 'Kunne ikke markere som ikke møtt.',
    markedCompleted: 'Markert som gjennomført.',
    markCompletedError: 'Kunne ikke markere som gjennomført.',
    refunded: 'Beløpet er refundert. Kunden har fått kreditnota på e-post.',
    refundError: 'Kunne ikke refundere betalingen.',
    paymentRequestResent: 'Betalingslenken er sendt på nytt.',
    paymentRequestResendError: 'Kunne ikke sende betalingslenken på nytt.',
    paymentRequestCancelled: 'Betalingsoppfølgingen er avsluttet.',
    paymentRequestCancelError: 'Kunne ikke avslutte betalingsoppfølgingen.',
    paymentCollection: {
      active: 'Betalingsoppfølgingen er gjenopptatt.',
      paused: 'Automatiske påminnelser er satt på pause.',
      disputed: 'Kravet er markert som omtvistet.',
      error: 'Kunne ikke endre betalingsoppfølgingen.',
    },
    meetingBooked: 'Møtet er booket.',
    bookMeetingError: 'Kunne ikke booke møtet.',
    revealError: 'Kunne ikke vise møtet.',
    headingUnresolved: 'Møtet ble ikke registrert.',
    headingCancelled: 'Møtet er avlyst.',
    headingExpired: 'Møtet er utløpt.',
    headingPast: 'Skriv notatene.',
    headingPrep: 'Forbered møtet.',
    summaryCalloutTitle: 'Oppsummer før du sender',
    summaryCalloutBody: 'Se gjennom og rediger oppsummeringen som deltakerne skal få.',
    summaryCalloutAction: 'Se og rediger oppsummering',
    summarySentTitle: 'Oppsummeringen er sendt',
    summarySentBody: 'Sendt {when} til {to}. Du kan sende den på nytt hvis noe er endret.',
    summarySentBodyNoRecipient: 'Sendt {when}. Du kan sende den på nytt hvis noe er endret.',
    summarySentAction: 'Se og send på nytt',
    ledeUnresolved: 'Vi så ingen videosamtale i dette tidsrommet.',
    ledeCancelled: 'Det som allerede var skrevet, er bevart som historikk og kan ikke endres her.',
    unresolvedSetNewTime: 'Sett opp ny tid',
    unresolvedModalKicker: 'møte · uavklart',
    unresolvedModalBody:
      'Vi så ingen videosamtale i dette tidsrommet. Marker som gjennomført hvis dere møttes på en annen måte, eller lukk for å sette opp en ny tid.',
    completedPaymentCollectionNotice:
      'Når du markerer møtet som gjennomført, sender Stemne kunden en betalingslenke for et eventuelt restbeløp. Ubetalte krav får automatiske påminnelser etter 7 og 14 dager.',
    unresolvedModalDismiss: 'Ikke nå',
    ledePastNamed:
      'Møtet med {name} er gjennomført. Notatene er bare synlige for deg og kolleger med tilgang.',
    ledePast: 'Møtet er gjennomført. Notatene er bare synlige for deg og kolleger med tilgang.',
    ledePrep: 'Notatene dine er bare synlige for deg og kolleger med tilgang.',
    resumeMeeting: 'Fortsett møtet →',
    startMeeting: 'Start møtet →',
    kebabKicker: 'møte',
    kebabKickerCancelled: 'møte · avlyst',
    kebabJoin: 'Bli med i møtet',
    rescheduleOrCancel: 'Endre eller avlyse',
    markCompleted: 'Marker som gjennomført',
    markNoShow: 'Marker som ikke møtt',
    sectionLifecycle: 'livssyklus',
    sectionFollowUp: 'oppfølging',
    rebook: 'Book nytt møte',
    refund: 'Refunder',
    visibilityNoGrants: 'synlig for deg og kolleger med tilgang',
    visibilityYouAndOne: "synlig for deg og {'@'}{name}",
    visibilityYouAndTwo: "synlig for deg, {'@'}{first} og {'@'}{second}",
    visibilityYouAndMany: "synlig for deg, {'@'}{name} + {count} andre",
    summaryEmpty: 'tom',
    wordCount: '{count} ord',
    asksSummary: 'tom | 1 spørsmål | {n} spørsmål',
    ownerYou: 'ansvarlig · deg',
    ownerNamed: 'ansvarlig · {name}',
    changeLocation: 'Endre møtested',
    addLocation: 'Legg til møtested',
    inviteResent: 'Invitasjonen er sendt på nytt til {email}.',
    verificationResent: 'Bekreftelseslenken er sendt på nytt til {email}.',
    resendError: 'Kunne ikke sende på nytt.',
    meetingUpdated: 'Møtet er oppdatert og deltakerne er varslet.',
    saveChangesError: 'Kunne ikke lagre endringene.',
    unsavedChangesConfirm:
      'Du har endringer i møtet som ikke er lagret. Vil du forlate siden og forkaste dem?',
    meetingReassigned: 'Møtet er overført. Begge rådgivere får beskjed.',
    reassignError: 'Kunne ikke overføre møtet.',
    meetingCancelled: 'Møtet er avlyst',
    cancelError: 'Kunne ikke avlyse møtet.',
    seriesCancelled: 'Resten av serien er avlyst',
    seriesCancelError: 'Kunne ikke avlyse serien.',
    seriesRescheduled: '{n} møte i serien er flyttet | {n} møter i serien er flyttet',
    seriesRescheduleError: 'Kunne ikke flytte serien.',
    settingSaved: 'Innstillingen for dette møtet er lagret.',
    settingSaveError: 'Kunne ikke lagre innstillingen.',
    loadingMeeting: 'Henter møtet…',
    redactedTitle: 'Ikke synlig for deg.',
    redactedLede:
      'Møtet er booket på en privat tjenestetype. Kun den ansvarlige for møtet ser kundens navn, notater og lenker. Tidspunktet vises slik at du kan planlegge rundt det.',
    showAsAdmin: 'Vis som administrator',
    accessLogged: 'tilgangen loggføres',
    returningCustomer: 'Returnerende kunde · møtte sist {date} med {name}',
    moreActions: 'Flere handlinger',
    openMeeting: 'Åpne møtet →',
    openingRoom: 'Åpner møterom',
    sendMessage: 'Send melding',
    sendMessageTo: 'Send melding til {navn}',
    attendees: 'Deltakere',
    removeCoHost: 'Fjern medvert',
    removeGuest: 'Fjern gjest',
    resending: 'sender …',
    resendLink: 'Send lenke på nytt',
    inviteIntroLabel: 'Hilsen i invitasjonen (valgfritt)',
    inviteIntroPlaceholder: 'Hei, la oss samles for å vurdere ...',
    inviteIntroHint: 'Følger med i invitasjonen til nye gjester, over agendaen.',
    saveGreeting: 'Lagre hilsen',
    addGuest: 'Legg til gjest',
    emailLabel: 'E-post',
    previousParticipantLabel: 'Finn en tidligere deltaker',
    previousParticipantPlaceholder: 'Søk på navn eller e-post',
    useEmailAddress: 'Bruk e-postadressen',
    nameOptionalLabel: 'Navn (valgfritt)',
    namePlaceholder: 'Fornavn Etternavn',
    sendInvitation: 'Send invitasjon',
    meetingInProgress: 'Møtet er i gang siden {time}',
    meetingOverLabel: 'Møtet er over',
    endedAt: 'Avsluttet {time}',
    endedDuration: ' · varte {min} min',
    endedSummaryPrompt: ', vil du sende en oppsummering til {name}?',
    // Brukes i stedet for prompten når oppsummeringen allerede er sendt —
    // kortet rett under forteller når og til hvem.
    endedSentenceEnd: '.',
    participants: 'deltakerne',
    pendingLabel: 'Venter på bekreftelse',
    pendingBody: '{name} har ikke åpnet lenken ennå. Send på nytt om det er en stund siden.',
    awaitingPaymentLabel: 'Venter på betaling',
    awaitingPaymentBody:
      '{name} har ikke betalt ennå. Møtet bekreftes automatisk når betalingen er gjennomført.',
    theCustomer: 'Kunden',
    sending: 'Sender …',
    resendVerification: 'Send bekreftelseslenke på nytt',
    cancellationReasonLabel: 'Avlysningsgrunn',
    rescheduleMessageLabel: 'Beskjed sendt ved flytting',
    rescheduleApprovalLabel: 'Endring av tidspunkt',
    rescheduleApprovalInherit: 'Følg standard for tjenesten',
    rescheduleApprovalRequire: 'Krev godkjenning (kunden foreslår)',
    rescheduleApprovalAllow: 'Tillat direkte endring',
    rescheduleApprovalHint: 'Gjelder bare dette møtet. Gruppemøter går alltid via forslag.',
    remindersStatusAria: 'Påminnelsesstatus',
    remindersLabel: 'Påminnelser',
    reminderEmailChannel: '24t e-post',
    reminderSmsChannel: '24t SMS',
    reminderSent: 'sendt {time}',
    reminderWaiting: 'venter',
    asksTitle: 'Hva må vi få svar på?',
    cancelledAsksTitle: 'Planlagte spørsmål',
    notesTitle: 'Notater',
    cancelledNotesTitle: 'Bevarte notater',
    notesFromMeetingTitle: 'Notater fra møtet',
    preparationsTitle: 'Forberedelser',
    liveNotesLabel: 'Under møtet',
    prepNotesLabel: 'Forberedelser',
    cancelledPrepNotesLabel: 'Forberedelser før avlysning',
    cancelledPlanTitle: 'Planlagt for møtet',
    heldPointsTitle: 'Handlingspunkter',
    heldPointsSummary: 'tomt | 1 punkt | {n} punkter',
    heldPointsOpenSummary: '1 åpent | {n} åpne',
    accessTitle: 'Tilgang',
    documentsTitle: 'Dokumenter',
    transfersLabel: 'overføringer',
    meetingActivityLabel: 'møtehistorikk',
    customerMessageLabel: 'Melding fra kunde',
    meetingActions: 'Møtehandlinger',
    revealConfirmTitle: 'Vis privat møte?',
    revealConfirmBody:
      'Du er administrator. Når du fortsetter, registreres tilgangen i revisjonsloggen sammen med tidspunkt og din konto. Bare gjør dette når det er nødvendig.',
    revealConfirmCta: 'Vis møtet',
    noShowConfirmTitle: 'Marker som ikke møtt?',
    noShowConfirmBody:
      "Møtet flyttes til status 'ikke møtt'. Du kan ikke angre. Bruk dette når kunden ikke dukket opp og møtet ikke ble gjennomført.",
    refundConfirmTitle: 'Refunder {amount}?',
    refundConfirmBody:
      'Kunden får hele beløpet tilbake på kortet i løpet av 5 til 10 virkedager, og du sender en kreditnota med det samme. Møtet står som før — skal det ikke gjennomføres, avlys det etterpå. Du kan ikke angre.',
    lockTimeTitle: 'Lås tidspunktet',
    lockTimeBody:
      'Deltakerne får en e-post om at tidspunktet er satt, med en valgfri beskjed fra deg.',
    messageOptionalLabel: 'Beskjed (valgfritt)',
    messageToParticipantsPlaceholder: 'Kort beskjed til deltakerne',
    lockTimeCta: 'Lås tid',
    saveConfirmTitle: 'Lagre og varsle deltakerne',
    saveConfirmBody: 'Endringene lagres og deltakerne får én e-post om at møtet er oppdatert.',
    saveConfirmBodyPending:
      'Kunden har ikke bekreftet møtet ennå. Endringene lagres, og kunden får en ny invitasjon med det oppdaterte tidspunktet som de må bekrefte.',
    diffKicker: 'Dette er endret',
    messageToParticipantsLabel: 'Beskjed til deltakerne',
    saveAndSend: 'Lagre og send',
    unsavedChangesAria: 'Ulagrede endringer',
    unsavedCount: '{n} endring ikke lagret | {n} endringer ikke lagret',
    discard: 'Forkast',
  },
  setupDashboardCalendarView: {
    weekdayMon: 'Man',
    weekdayTue: 'Tir',
    weekdayWed: 'Ons',
    weekdayThu: 'Tor',
    weekdayFri: 'Fre',
    weekdaySat: 'Lør',
    weekdaySun: 'Søn',
    dowSun: 'S',
    dowMon: 'M',
    dowTue: 'T',
    dowWed: 'O',
    dowThu: 'T',
    dowFri: 'F',
    dowSat: 'L',
    meetingCreatedWithInvite: 'Møte opprettet. Kunden har fått invitasjonen.',
    slotAlreadyBooked: 'Tidspunktet er allerede booket. Velg en annen tid.',
    meetingCreateFailed: 'Kunne ikke opprette møtet.',
    meetingCreated: 'Møte opprettet.',
    endBeforeStart: 'Sluttid må være etter starttid',
    periodAdded: 'Periode lagt til',
    periodAddFailed: 'Kunne ikke legge til perioden.',
    allDayPrefix: 'heldags · {label}',
    blockedPrefix: 'Blokkert · {label}',
    meetingsThisDay: '{n} møter denne dagen',
    showAll: 'Vis alle',
    weekOverflowMore: '+{count} flere',
    rescheduleTitle: 'Flytt møtet?',
    rescheduleBody: 'Flytt {title} fra {from} til {to}? Kunden får oppdatert invitasjon på e-post.',
    moveMeeting: 'Flytt møtet',
    conflictIntro:
      'Disse møtene kolliderer med avtaler som allerede ligger i kalenderen du nettopp koblet til. Du må flytte eller avlyse dem manuelt.',
    conflictConfirm: 'Greit',
    settingsTitle: 'Kalenderinnstillinger',
    viewLabel: 'Visning',
    connectedCalendars: 'Tilkoblede kalendere',
    hourRangeLabel: 'Timer i dag- og ukevisning',
    hourRangeHint: 'Kun arbeidstid viser 08–17, utvidet med arbeidstidene dine.',
    zoomHeading: 'Zoom tidsaksen',
    zoomHint: 'Knip med to fingre på rutenettet for å strekke eller komprimere timene.',
    zoomResetCta: 'Tilpass til skjerm',
    showHolidaysLabel: 'Vis helligdager',
    showHolidaysDesc: 'Påske, pinse og andre røde dager vises i kalenderen.',
    blockedTimeHeading: 'Blokkert tid',
    blockedTimeHint: 'Marker tidsrom som utilgjengelige for booking.',
    blockTimeCta: 'Blokker tid',
  },
  setupDashboardCustomerConversationView: {
    meetingCount: '{n} møte | {n} møter',
    customerSince: 'kunde siden {date}',
    bookingCreated: 'Møtet er booket.',
    bookingFailed: 'Kunne ikke booke møtet.',
    backAria: 'Tilbake til kundekortet',
    seeProfile: 'Se profil',
    customerNotFound: 'Fant ikke kunden.',
    fencedThread: 'Denne samtalen er tildelt en annen rådgiver.',
    loadingConversation: 'Henter samtalen …',
    suggestNewTime: 'Foreslå ny tid',
    deleteMessageTitle: 'Slett meldingen?',
    deleteMessageBody: 'Den blir borte for kunden også. Dette kan ikke angres.',
    deleteMessageConfirm: 'Slett',
  },
  setupDashboardCustomerDetailV2View: {
    customerDeleted: 'Kunden er slettet',
    customerDeleteError: 'Kunne ikke slette kunden.',
    meetingBooked: 'Møtet er booket.',
    meetingBookError: 'Kunne ikke booke møtet.',
    noteNeedsMeeting:
      'Notater følger et møte. Book ett først, så kan du skrive notater fra møtesiden.',
    customerInfoLoadError: 'Kunne ikke laste kundeinfo.',
    customerInfoUpdated: 'Kundeinfo oppdatert.',
    // Email changes are verify-before-commit: the customer row keeps the old
    // address until the customer clicks the link, so the save toast must not
    // claim the address is changed (#3488).
    customerInfoUpdatedEmailPending:
      'Kundeinfo oppdatert. Vi har sendt en bekreftelseslenke til {email} — adressen byttes når kunden bekrefter.',
    customerInfoSaveError: 'Kunne ikke lagre kundeinfo.',
    meetNow: 'Møt nå',
    bookMeeting: 'Book et møte',
    writeNote: 'Skriv et notat',
    shareDocument: 'Del dokument',
    emptyDocuments: 'Ingen dokumenter delt enda.',
    shareDocumentCta: 'Del et dokument',
    emptyMeetings: 'Ingen møter enda.',
    emptyConversations: 'Ingen samtaler enda.',
    emptyFilter: 'Ingen treff for dette filteret enda.',
    loadingCustomer: 'Laster kunde...',
    notFound: 'Fant ikke kunden.',
    backToCustomerList: 'Tilbake til kundelisten',
    breadcrumbCustomers: 'Kunder',
    bellAria: '{count} nye siden sist, gå til {pill}',
    kickerCustomer: 'kunde',
    editContactInfo: 'Endre kontaktinfo',
    since: 'siden {date}',
    personalNotesChip: 'personlige notater',
    allWeHave: 'Alt vi har om {name}.',
    newestFirst: 'nyeste først',
    treatmentLocked:
      'Du ser profilen og kan booke og forberede møter. Behandlingsdata som møtenotater, dokumenter og samtaler åpnes når du har et møte med denne kunden.',
    lockedPanelTitle: 'Behandlingsdata er låst',
    lockedPanelBody:
      'Behandlingsdata åpnes når du har et møte med denne kunden. Book et møte for å få tilgang.',
    retry: 'Prøv igjen',
    searchPlaceholder: 'søk i {name}s historikk ...',
    ariaForberedelser: 'Forberedelser',
    ariaFiler: 'Filer',
    ariaNotater: 'Notater',
    ariaHistorikk: 'Historikk',
    ariaTimeline: 'Tidslinje, filter {pill}',
    ariaSidebar: 'Sidefelt',
    fabLabel: 'Handlinger for kunden',
    deleteCustomerTitle: 'Slette kunden?',
    deleteCustomerBody:
      'Slette {name}? Notater, forberedelser og historikk knyttet til kunden slettes også. Dette kan ikke angres. Har kunden møter, blir slettingen stoppet.',
    deleteCustomerConfirm: 'Slett kunde',
    personalNotesModalTitle: 'Personlige notater',
  },
  setupDashboardCustomersView: {
    sortRecent: 'sist aktivitet',
    sortNotifications: 'antall varsler',
    sortName: 'navn',
    relToday: 'i dag · {time}',
    relTomorrow: 'i morgen · {time}',
    relYesterday: 'i går',
    relLastWeek: 'forrige uke',
    exportCta: 'Eksporter',
    // Ikke "Importer flere" — knappen står der før første import også.
    importMoreCta: 'Importer',
    sortedBy: 'sortert etter',
  },
  setupDashboardDocumentsView: {
    offLead:
      'Et delt rom for dokumenter er under arbeid. Du vil få beskjed når det er klart for deg å ta i bruk.',
    manageAria: 'Administrer {name}',
    sharedWith: ' med {name}',
    sharedCount: '{count} dokumenter delt',
    sharedOne: 'Delt',
  },
  setupDashboardHelpArticleView: {
    backToHelp: 'Tilbake til hjelp',
    footPrompt: 'Fikk du ikke svaret du trengte?',
    footLink: "Skriv til support{'@'}stemne.no",
    footTail: ', vi svarer innen én virkedag.',
    notFound: 'Vi fant ikke den artikkelen.',
    backToOverview: 'Tilbake til oversikten',
    imageDialogLabel: 'Forstørret bilde',
    closeZoom: 'Lukk bildet',
  },
  setupDashboardHelpIndexView: {
    catKonto: 'Konto og innlogging',
    catTeam: 'Team og roller',
    catKalender: 'Kalender og videomøter',
    catBooking: 'Booking og kunder',
    // Betaling = penger kunden betaler DEG. Fakturering = penger du betaler
    // Stemne. Overskriftene sier hvilken vei pengene går, så de to ikke
    // leses som samme sak.
    catBetaling: 'Betaling ved booking',
    catProfil: 'Profil og branding',
    catFakturering: 'Fakturering og abonnement',
    catAnnet: 'Annet',
    kicker: 'Hjelp',
    title: 'Hvordan kan vi hjelpe?',
    lead: 'Korte, praktiske artikler om hvordan du gjør de vanligste tingene i Stemne, inviterer en kollega, kobler til kalenderen, eller endrer siden din. Finner du ikke det du leter etter? Skriv til {support}.',
    searchPlaceholder:
      'Søk i hjelpeartiklene, f.eks. «koble til kalender» eller «invitere kollega»',
    searchAria: 'Søk i hjelpeartiklene',
    noResults: 'Fant ingen treff for «{query}». Prøv et annet søkeord, eller skriv til {support}.',
    resultsCount: '{count} treff for «{query}»',
    emptyBody: 'Ingen hjelpeartikler er publisert ennå.',
  },
  setupDashboardHistoryView: {
    backOverview: 'Oversikt',
    kicker: 'full historikk · alle kunder',
    title: 'Alt som skjer hos dere.',
    newestFirst: 'nyeste først',
    searchPlaceholder: 'søk i hele historikken ...',
    searchAriaLabel: 'Søk i hele historikken',
    upcomingKicker: 'kommende',
    meetingFallback: 'Møte',
    hosAdvisor: 'hos {name}',
    emptyTitle: 'Stille så langt.',
    emptyBody: 'Når kundene booker, sender meldinger eller får dokumenter, samles alt her.',
    noHits: 'Ingen treff på «{query}» i denne perioden.',
    thisWeek: 'denne uken',
    bookingLabel: 'møte | møter',
    newCustomerLabel: 'ny kunde | nye kunder',
    documentLabel: 'dokument | dokumenter',
    team: 'team',
    teamHint: 'Trykk for å se én rådgivers hendelser',
    ghostBook: 'book et møte for en kunde',
    ghostShowOlder: 'vis eldre hendelser',
    roleOwner: 'eier',
    roleAdvisor: 'rådgiver',
    roleAdmin: 'administrator',
  },
  setupDashboardInnsiktView: {
    noConsultant: 'Uten rådgiver',
    daySun: 'sø',
    dayMon: 'ma',
    dayTue: 'ti',
    dayWed: 'on',
    dayThu: 'to',
    dayFri: 'fr',
    daySat: 'lø',
    barTitle: '{dow} {day}.: {count} møte | {dow} {day}.: {count} møter',
    kicker: 'innsikt · {period}',
    title: 'Hvordan går det med praksisen.',
    selectPeriod: 'Velg periode',
    unavailableTitle: 'Innsikt er på vei.',
    unavailableBody:
      'Denne siden rulles ut gradvis. Den dukker opp her så snart den er klar for dere.',
    loading: 'Henter tallene ...',
    emptyTitle: 'Ingen tall ennå.',
    emptyBody: 'Når kundene booker møter, samles oversikten over tid, belastning og tjenester her.',
    kpiAriaLabel: 'Nøkkeltall',
    kpiBookings: 'møter',
    kpiRevenue: 'booket verdi',
    kpiNoShow: 'ikke møtt',
    kpiNoShowSub: '{noShow} av {total} møter',
    // Shown under the counters when the operator's own no-show count for the
    // period crosses the threshold and they do not have the add-on. States
    // their number back to them, then what can be done about it. No price —
    // the panel it links to owns that.
    noShowNudge:
      '{count} møter ble ikke noe av i denne perioden. Ber du om depositum når kunden booker, blir det som regel færre.',
    noShowNudgeLink: 'Se tillegg',
    noShowNudgeOwnerOnly: 'Eieren av kontoen kan legge det til.',
    kpiCancelled: 'avbestilt',
    kpiCancelledSub: '{count} avbestillinger',
    kpiRescheduled: 'flyttet',
    kpiRescheduledSub: '{count} flyttet',
    kpiHours: 'timer booket',
    bookingsOverTime: 'møter over tid',
    bookingsOverTimeAria: 'Møter over tid',
    loadPerConsultant: 'belastning per rådgiver',
    thConsultant: 'Rådgiver',
    thBookings: 'Møter',
    thHours: 'Timer',
    serviceMix: 'tjenestemiks',
    mixCount: '{count} møte | {count} møter',
    foot: 'regnet ut fra møtene deres, oppdateres ved hvert besøk',
  },
  setupDashboardIntegrationsView: {
    tabKeys: 'API-nøkler',
    tabWebhooks: 'Webhooks',
    tabStart: 'Kom i gang',
    tabsAriaLabel: 'Integrasjonsfaner',
    eventCreatedLabel: 'Ny booking',
    eventCreatedTag: 'ny booking',
    eventRescheduledLabel: 'Booking flyttet',
    eventRescheduledTag: 'flyttet',
    eventCancelledLabel: 'Booking avbestilt',
    eventCancelledTag: 'avbestilt',
    scopeRead: 'lese',
    scopeWrite: 'skrive',
    errorKeyName: 'Gi nøkkelen et navn så du gjenkjenner den senere.',
    errorKeyScope: 'Velg minst ett tilgangsnivå.',
    errorGeneric: 'Noe gikk galt. Prøv igjen.',
    errorHookUrl: 'Skriv inn URL-en webhooks skal sendes til.',
    errorHookUrlScheme: 'URL-en må starte med https:// (eller http:// i utvikling).',
    errorHookEvents: 'Velg minst én event-type å abonnere på.',
    healthDelivering: 'leverer',
    healthFailing: 'feiler',
    healthIdle: 'ingen leveringer',
    healthDisabled: 'deaktivert',
    lastDeliveryFailed: 'feilet {time}',
    lastDeliveryOk: 'ok {time}',
    title: 'Integrasjoner',
    lede: 'Koble Stemne til CRM, regnskap eller egne systemer. Les og skriv bookinger via API-et, og få sanntidsvarsler med webhooks når noe endrer seg.',
    notEnabledTitle: 'Integrasjoner er ikke aktivert',
    notEnabledBody:
      'Det offentlige integrasjons-API-et er tilgjengelig på Vekst-planen. Ta kontakt så aktiverer vi tilgangen for organisasjonen din.',
    contactSupport: 'Kontakt support',
    apiAccessTitle: 'API-tilgang',
    apiAccessEyebrow: 'offentlig api · {version} · {oas}',
    authPrefix: 'Autentisér med en bearer-nøkkel',
    authSuffix: 'Nøkkelen identifiserer organisasjonen og peker rett på API-verten.',
    keysTitle: 'API-nøkler',
    keyCount: '{n} nøkkel | {n} nøkler',
    activeCount: '{n} aktiv',
    createKeyCta: 'Lag ny nøkkel',
    keysLede:
      'Hver nøkkel gir tilgang på vegne av hele organisasjonen. Behandle den som et passord.',
    loading: 'Laster…',
    keysErrorTitle: 'Klarte ikke å hente nøklene',
    fetchErrorBody: 'Noe gikk galt. Last siden på nytt, eller prøv igjen om et øyeblikk.',
    retry: 'Prøv igjen',
    keysEmptyTitle: 'Du har ingen nøkler ennå',
    keysEmptyBody:
      'Lag en nøkkel for å komme i gang. Nøkkelen vises bare én gang når den lages, så husk å lagre den et trygt sted (for eksempel 1Password).',
    statusActive: 'aktiv',
    statusNeverUsed: 'aldri brukt',
    createdMeta: 'opprettet {date}',
    lastUsedMeta: 'sist brukt {time}',
    revokeKeyCta: 'Trekk tilbake',
    webhooksTitle: 'Webhooks',
    endpointCount: '{n} endepunkt | {n} endepunkter',
    createHookCta: 'Lag ny webhook',
    webhooksLede:
      'Server-til-server-varsler, signert med HMAC-SHA256. Standard Webhooks-protokoll.',
    webhooksErrorTitle: 'Klarte ikke å hente webhooks',
    webhooksEmptyTitle: 'Du har ingen webhooks ennå',
    webhooksEmptyBody:
      'Lag et endepunkt for å motta hendelser i sanntid i ditt eget system. Signing secret vises bare én gang når endepunktet lages.',
    lastDeliveryMeta: 'siste levering · {status}',
    deleteHookCta: 'Slett',
    subscribeTitle: 'Du kan abonnere på',
    subscribeEyebrow: 'hendelser',
    firstRequestTitle: 'Din første forespørsel',
    firstRequestEyebrow: 'kom i gang',
    copyLower: 'kopier',
    copiedLower: 'Kopiert',
    quickstartComment: 'Hent kommende bookinger',
    docsTitle: 'Dokumentasjon',
    docsLede: 'Endepunkter, feltbeskrivelser, feilkoder og hele kontrakten for å bygge mot Stemne.',
    docsApiLink: 'API-dokumentasjon',
    footNote: 'Det offentlige integrasjons-API-et følger Vekst-tier.',
    footLink: 'Trenger du hjelp? Kontakt support',
    createKeyModalTitle: 'Lag ny API-nøkkel',
    createKeyModalKicker: 'integrasjoner',
    keyNameLabel: 'Navn på nøkkelen',
    keyNamePlaceholder: 'Min CRM-integrasjon',
    keyNameHint: 'Bruk et navn som forklarer hva nøkkelen brukes til.',
    scopeLegend: 'Tilgangsnivå',
    scopeReadLabel: 'Lese',
    scopeReadHint: 'Hente ut bookinger og andre data via API-et.',
    scopeWriteLabel: 'Skrive',
    scopeWriteHint: 'Opprette og endre data via API-et. Aktiveres når skrive-endepunkter er klare.',
    createKeySubmit: 'Lag nøkkel',
    revealKeyModalTitle: 'Lagre nøkkelen et trygt sted',
    revealModalKicker: 'vises bare denne ene gangen',
    revealKeyLede:
      'Behandle nøkkelen som et passord. Stemne lagrer den ikke, og den vises ikke igjen. Hvis du mister den, må du lage en ny.',
    revealKeyAria: 'Ny API-nøkkel',
    revealSavedAck: 'Jeg har lagret nøkkelen',
    revealDone: 'Ferdig',
    revokeConfirmTitle: 'Trekk tilbake nøkkelen?',
    revokeConfirmBody:
      'Etter at du trekker tilbake «{name}» kan den ikke brukes mer. Eksisterende integrasjoner som bruker nøkkelen vil slutte å virke.',
    createHookModalTitle: 'Lag ny webhook',
    hookUrlLabel: 'Mottaker-URL',
    hookUrlPlaceholder: 'https://din-app.no/webhooks/stemne',
    hookUrlHint: 'URL-en Stemne skal sende POST-forespørsler til. Må starte med https://.',
    hookEventsLegend: 'Eventer å abonnere på',
    createHookSubmit: 'Lag webhook',
    revealSecretModalTitle: 'Lagre signing secret et trygt sted',
    revealSecretLede:
      'Behandle denne nøkkelen som et passord. Bruk den til å verifisere HMAC-signaturen på hver forespørsel. Stemne lagrer den ikke i klartekst, og den vises ikke igjen. Hvis du mister den, må du lage et nytt endepunkt.',
    revealSecretAria: 'Nytt signing secret',
    deleteConfirmTitle: 'Slett webhook?',
    deleteConfirmBody:
      'Etter at du sletter «{url}» vil Stemne slutte å sende hendelser dit. Du må lage et nytt endepunkt for å starte igjen.',
  },
  dashboardAgendaPointsBuilder: {
    label: 'Hva må vi få svar på?',
    removeAria: 'Fjern punkt',
    inputPlaceholder: 'Skriv et spørsmål',
    addAria: 'Legg til punkt',
  },
  dashboardCandidateTimesEditor: {
    addLabel: 'legg til tid',
    prevDayAria: 'Forrige dag',
    nextDayAria: 'Neste dag',
    loading: 'henter ledige tider…',
    empty: 'Ingen flere ledige tider denne dagen.',
  },
  treatmentDemoRoomPanel: {
    kicker: 'videorom · demo',
    title: 'Videorommet vises her',
    body: 'I et ekte møte åpnes videosamtalen i dette feltet. Notatene og oppsummeringen ved siden av fungerer akkurat som vanlig.',
  },
  dashboardCustomerMessageCard: {
    label: 'Melding fra kunde',
  },
  setupDashboardMeetingLiveView: {
    novideoKicker: 'videomøte',
    novideoTitle: 'Videorommet er ikke tilgjengelig',
    novideoBody:
      'Vi klarte ikke å opprette et videorom for dette møtet. Du kan fortsatt notere under møtet og avslutte som vanlig. Last inn på nytt hvis rommet dukker opp.',
    novideoReload: 'Last inn på nytt',
    customerFallback: 'kunden',
    teamMeeting: 'Teammøte',
    teamMeetingSub: 'Teammøte · {mins} min',
    meetingFallback: 'Møte',
    headerSub: '{label} · {mins} min',
    loadError: 'Kunne ikke laste møtet',
    finishBodyJournal:
      'Du tas til oppsummeringen og kan lagre journalen. Du kan gå tilbake hvis du angrer.',
    finishBody: 'Du tas til oppsummeringen. Du kan gå tilbake hvis du angrer.',
    finishBodyVideo:
      'Videostrømmen stoppes og du tas til oppsummeringen. Du kan gå tilbake hvis du angrer.',
    finishConfirmLabel: 'Ja, avslutt',
    finishTitle: 'Avslutte møtet?',
    backAria: 'Tilbake til forberedelser',
    back: 'Forberedelser',
    inProgress: 'pågår · {copy}',
    no: 'Nei',
    qaKicker: 'spør om dette, fra forberedelsen',
    qaTitle: 'Spørsmål og svar',
    encBadge: 'lagret kryptert',
    logTitle: 'Logg raskt',
    painBefore: 'smerte før',
    painAfter: 'smerte etter',
    saved: 'Lagret ✓',
    finishAndSave: 'Avslutt og lagre →',
    finish: 'Avslutt →',
    physicalMeeting: 'fysisk møte',
    atOffice: 'På kontoret',
    seriesOf: ' av {total}',
    durationMins: '{mins} min',
  },
  setupDashboardMeetingsView: {
    stripLabelAll: 'alle',
    stripAriaLabel: 'Filtrer møter etter ansvarlig',
    stripLabelSelf: 'deg',
    stripLabelNone: 'uten eier',
    ownerSelf: 'deg',
    privateMeeting: 'Privat møte',
    meetingFallback: 'Møte',
    statusSoon: 'snart',
    statusPending: 'ubekreftet',
    statusCancelled: 'avlyst',
    statusCompleted: 'gjennomført',
    statusPast: 'tidligere',
    statusUpcoming: 'kommende',
    statusRescheduled: 'flyttet',
    notesMissing: 'notater mangler',
    footerScopeAll: 'hele selskapet',
    footerScopeNone: 'uten ansvarlig',
    footerScopeMine: 'dine',
    loadError: 'Kunne ikke laste møter.',
    createSuccess: 'Møte opprettet. Kunden har fått invitasjonen.',
    createConflict: 'Tidspunktet er allerede booket. Velg en annen tid.',
    createError: 'Kunne ikke opprette møtet.',
    assignModalTitle: 'Velg ansvarlig',
    assignModalKicker: 'møte uten ansvarlig',
    unreadAria: '{n} uleste',
    sigilAll: 'alle',
    dayHeaderCount: '{n} møte | {n} møter',
    today: 'I DAG',
    tomorrow: 'I MORGEN',
    dayHeaderToday: 'I DAG · {date}',
    dayHeaderTomorrow: 'I MORGEN · {date}',
  },
  setupDashboardNoteDetailView: {
    errorNotAvailable: 'Notatet er ikke tilgjengelig.',
    errorLoadFailed: 'Kunne ikke laste notatet.',
    grantFailedWithReason: 'Kunne ikke gi tilgang: {reason}',
    grantFailed: 'Kunne ikke gi tilgang. Prøv igjen.',
    anOperator: 'En operatør',
    anOperatorLower: 'en operatør',
    theOwner: 'eieren',
    aColleague: 'En kollega',
    backToCustomers: 'Tilbake til kunder',
    composerCaptionAuthor: 'din kommentar er synlig for alle med tilgang',
    composerCaptionRecipient: 'kommentar synlig for {name} og deg',
    headerKicker: 'notat',
    headerKickerAuthor: 'notat · ditt',
    bodyKickerPreview: 'notatet · forhåndsvisning',
    bodyKicker: 'notatet',
    deleteConfirm: 'Slette notatet? Denne handlingen kan ikke angres.',
    deleteFailed: 'Kunne ikke slette notatet.',
    deleteSuccess: 'Notatet er slettet.',
    archiveFailed: 'Kunne ikke arkivere notatet.',
    archiveSuccess: 'Notatet er arkivert.',
    linkHintNotLinked: 'ikke knyttet',
    menuEditTitle: 'Endre tittel',
    menuEditLink: 'Endre kobling',
    menuShare: 'Del med flere',
    menuNotify: 'Varsle meg ved svar',
    toggleOn: 'på',
    toggleOff: 'av',
    menuGroupExport: 'eksport',
    menuExportPdfBusy: 'Klargjør PDF ...',
    menuExportPdf: 'Eksporter som PDF',
    menuDuplicate: 'Dupliser notatet',
    menuGroupLifecycle: 'livssyklus',
    menuArchive: 'Arkiver',
    menuDelete: 'Slett notat',
    exportPdfFailed: 'Klarte ikke å lage PDF',
    kebabKickerAuthor: 'ditt notat',
    kebabKickerShared: 'delt med deg',
    untitled: 'Uten tittel',
    loadingNote: 'Henter notat …',
    breadcrumbAriaLabel: 'Brødsmuler',
    breadcrumbCustomers: 'Kunder',
    noteFallback: 'Notat',
    // #544: the note is editable right here now, so the card is a link
    // to the meeting rather than an explanation of where the editor
    // lives. The tail still points at what the meeting page adds.
    bridgeAriaLabel: 'Notatet hører til et møte',
    bridgeTitle: 'Notatet hører til et møte',
    bridgeTail: ', på møte-siden finner du også tilgangen og slett',
    bridgeCtaLong: 'Åpne på møte-siden',
    bridgeCtaShort: 'Åpne',
    bannerSharedSuffix: 'delte dette notatet med deg',
    scopeFull: 'med møte, du kan bli med',
    scopeEntry: 'kun notat, møtet er skjult for deg',
    replyToAuthor: 'Svar {name}',
    titleKickerAuthor: 'ditt notat',
    writtenBy: 'skrevet av {name}',
    updatedAt: 'oppdatert {time}',
    syncsAutomatically: 'synkes automatisk',
    moreActions: 'Flere handlinger',
    authorNoteAriaLabel: 'Beskjed fra operatør',
    authorNoteLabel: 'beskjed',
    draftAriaLabel: 'Notatet er foreløpig tomt',
    draftKicker: 'utkast',
    draftTitle: '{name} jobber på dette notatet.',
    draftBody:
      'Det er foreløpig tomt. Du har fått tilgang fordi {name} vil dele det med deg når det er klart.',
    draftToggleLabel: 'Varsle meg når det er klart',
    draftToggleHint: 'Push når {name} oppdaterer notatet.',
    editorPlaceholder: 'Skriv her …',
    commentsAriaLabel: 'Kommentarer',
    threadTitle: 'Samtale',
    replyCount: '{n} svar',
    deleteCommentFrom: 'Slett kommentaren fra {name}',
    deleteComment: 'Slett',
    replyPlaceholder: 'Skriv et svar …',
    sending: 'Sender …',
    send: 'Send',
    customerAriaLabel: 'Kunde',
    customerKicker: 'kunde',
    customerFoot: 'Notat på tvers av møtene med denne kunden.',
    customerNotLinked: 'Ikke knyttet',
    customerNotLinkedSub:
      'Dette notatet er ikke koblet til en kunde. Du kan koble det senere fra notatets meny.',
    meetingAriaLabel: 'Møtet',
    meetingKicker: 'møtet',
    meetingFallback: 'Møte',
    meetingWithCustomer: 'med {name}',
    metaWhen: 'når',
    metaDuration: 'varighet',
    durationMinutes: '{minutes} min',
    metaOwner: 'eier',
    joinMeeting: 'Bli med i møtet',
    addToCalendar: 'Legg til i kalender',
    hiddenByOwner: 'Skjult av eier',
    hiddenByOwnerSub:
      'Du har fått tilgang til notatet, men ikke selve møtet. {name} har valgt å holde kunden og tidspunktet privat.',
    metaCustomer: 'kunde',
    metaSharedBy: 'delt av',
    readOnlyCallout: 'Du kan lese, men ikke videresende eller eksportere.',
    accessAriaLabel: 'Tilgang',
    accessKicker: 'tilgang',
    accessAdd: '+ legg til',
    accessTagOwner: 'eier',
    accessYou: 'Du',
    accessTagCanComment: 'kan kommentere',
    accessTagReadOnly: 'kun lese',
    mobileReplyAriaLabel: 'Skriv et svar til {name}',
    mobileReplyText: 'Skriv et svar til {name}…',
    renameLabel: 'Tittel',
    renameHint: 'Inntil 200 tegn.',
    linkSearchLabel: 'Søk i møter',
    linkSearchPlaceholder: 'Tittel, kunde, tjeneste',
    linkUnlink: 'Koble fra',
    linkUnlinkSub: 'Notatet blir frittstående',
    linkLoading: 'Laster møter…',
    linkNoResults: 'Ingen møter passer søket.',
    unknownCustomer: 'Ukjent kunde',
    duplicateCta: 'Dupliser',
    duplicateBody:
      'Lager en kopi av notatet med tittelen "Kopi av {title}". Innholdet kopieres som det er. Kommentarer, deling og historikk blir ikke med.',
    duplicateUntitled: 'uten tittel',
    duplicateKeepLinkLabel: 'Behold koblingen til møtet',
    duplicateKeepLinkDescription: 'Skru av for å lagre kopien som et frittstående notat.',
  },
  setupDashboardOverviewView: {
    statMeetingsToday: 'møter i dag',
    statThisWeek: 'denne uken',
    statNewClients: 'nye kunder',
    copyError: 'Kunne ikke kopiere lenken. Kopier den manuelt, eller prøv igjen.',
    subjectPrivate: 'privat',
    subjectFallback: 'møte',
    loadError: 'Kunne ikke laste data.',
    modeOffice: 'kontor',
    modeTreatment: 'behandling',
    modeTrening: 'trening',
    modeVideo: 'video',
    nameFallback: 'du',
    needsAttentionLabel: 'trenger en hånd · {count}',
    seeAll: 'se alle →',
    todaysMeetingsLabel: 'dagens møter · {count}',
    week: 'uken →',
    prepareCta: 'Forbered →',
    confirmAttendanceCta: 'Bekreft oppmøte →',
    noMeetingsToday: 'Ingen møter i dag.',
    seeWeek: 'Se uken →',
    completedTodayLabel: 'gjennomført i dag · {count}',
    writeNoteCta: 'Skriv notat →',
    activityLabel: 'aktivitet, siste 7 dager',
    fullHistory: 'full historikk →',
    weekRangeLabel: 'uken · {range}',
    meetingCount: '1 møte | {n} møter',
    carouselLabel: 'Uken, møter per dag',
    moreCount: '+{count} flere',
    calendar: 'kalender →',
    newClientsLabel: 'nye kunder · {count} denne uken',
    shareYourPage: 'del siden din',
    copiedLink: 'Kopiert ✓',
    copyLink: 'Kopier lenke',
    preview: 'Forhåndsvis →',
    comeFurther: 'kom enda videre',
    makeItYours: 'Gjør siden din din.',
    openYourPage: 'Åpne siden for bestillinger.',
    nextPill: 'NESTE',
    unresolvedPill: 'UAVKLART',
  },
  setupDashboardRapporterView: {
    // Month total of what pay-at-booking already collected. Shown only to orgs
    // that take payment; the point is that this part must NOT be invoiced again.
    summaryPaid: 'Betalt gjennom Stemne for møter i valgt måned: {amount}.',
    summaryOutstanding: 'Restbeløp for møter i valgt måned: {amount}.',
    receiptsTitle: 'Kvitteringer, fakturaer og kreditnotaer',
    receiptsReconciliationLabel: 'Avstemming av innbetalinger',
    receiptsGrossSales: 'Innbetalt for dokumenter utstedt i valgt periode',
    receiptsCredited: 'Kreditert',
    receiptsStripeFee: 'Stripe-kostnad',
    receiptsNetAfterStripe: 'Netto etter kortgebyrer og kreditnotaer',
    receiptsReconciliationNote:
      'Avstemmingen omfatter kvitteringer og kreditnotaer utstedt i valgt måned, fakturaer utstedt i måneden og registrerte kortgebyrer for kvitteringene og fakturaene. Innsigelser, innsigelsesgebyrer og andre bevegelser på Stripe-saldoen er ikke med, uansett når de skjer.',
    receiptsUnavailable: 'Ikke tilgjengelig',
    receiptsOpenStripe: 'Åpne Stripe',
    receiptDownload: 'Last ned PDF',
    receiptsDownloadFailed: 'Kunne ikke laste ned dokumentet',
    receiptCreditNote: 'kreditnota for {number}',
    receiptInvoice: 'faktura',
    receiptUnpaid: 'ubetalt',
    kicker: 'fakturagrunnlag',
    title: 'Fakturagrunnlag',
    sub: 'Gjennomførte timer per kunde i valgt måned. Grunnlag for fakturering.',
    periodLabel: 'Periode',
    exportCta: 'Last ned CSV',
    unavailableTitle: 'Fakturagrunnlaget er på vei.',
    unavailableBody:
      'Denne siden rulles ut gradvis. Den dukker opp her så snart den er klar for dere.',
    tableLabel: 'Fakturagrunnlag',
    emptyTitle: 'Ingen gjennomførte timer i {month}.',
    emptyBody:
      'Når timer er gjennomført i perioden, samles de her per kunde og tjeneste, klare til fakturering.',
    colCustomer: 'Kunde',
    colService: 'Tjeneste',
    colCategory: 'Kategori',
    colCount: 'Antall',
    colDuration: 'Varighet',
    noShowMarker: 'Ikke møtt',
    kindSamtale: 'Samtale',
    kindBehandling: 'Behandling',
    kindTrening: 'Trening',
    kindOther: 'Annet',
    summaryHeld: 'Gjennomført: {count} økt, {duration} | Gjennomført: {count} økter, {duration}',
    summaryNoShow: 'I tillegg: {count} ikke møtt, {duration}',
  },
  setupDashboardServicesView: {
    reorderError: 'Kunne ikke lagre rekkefølgen. Prøv igjen.',
    segmentServices: 'Tjenester',
    segmentMatrix: 'Hvem tilbyr hva',
    sortingDone: 'Ferdig',
    sortListLabel: 'Sorter tjenestene',
    durationMins: '{n} min',
  },
  setupDashboardSettingsView: {
    kicker: 'innstillinger',
    title: 'Innstillinger',
    tabTeam: 'Team',
    tabBranding: 'Profil & booking',
    tabCompany: 'Selskap',
    tabSecurity: 'Sikkerhet',
    tabBilling: 'Abonnement',
    tabPayments: 'Betalinger',
    tabTreatment: 'Behandling',
    tabAudit: 'Aktivitetslogg',
    paymentsLockedTitle: 'Betaling ved booking er ikke aktivert',
    paymentsLockedBody:
      'Å koble til Stripe krever tillegget «Betaling ved booking». Kjøp det under Abonnement → Tillegg, så kommer denne fanen i bruk.',
    paymentsLockedBodyOwnerOnly:
      'Betaling ved booking er ikke aktivert. Eieren av kontoen kan legge det til.',
    paymentsLockedAction: 'Se tillegg',
    paymentsOwnerOnlyTitle: 'Bare eieren kan administrere betalinger',
    paymentsOwnerOnlyBody: 'Be eieren av kontoen åpne betalingsinnstillingene.',
    paymentsGateErrorTitle: 'Vi fikk ikke lastet betalingsinnstillingene dine.',
  },
  setupDashboardView: {
    unreadBadge: '{n} uleste',
    staffConsole: 'Stemne staff',
    navCollapse: 'Smal meny',
    navExpand: 'Vis meny',
    loggedInAs: 'innlogget som {email}',
    logout: 'logg ut',
  },
  setupSetupAvailabilityView: {
    saveError: 'Kunne ikke lagre tilgjengelighet. Prøv igjen.',
  },
  setupSetupCompanyView: {
    skipError: 'Kunne ikke gå videre. Prøv igjen.',
    saveError: 'Kunne ikke lagre. Prøv igjen.',
    logoLabel: 'Logo',
    logoHint: 'PNG, JPEG, WebP eller SVG. Gjennomsiktig bakgrunn anbefales. Maks 10 MB.',
  },
  setupSetupDoneView: {
    waitingMeta: 'klargjør domene',
    waitingHeading: 'Et øyeblikk,',
    waitingHeadingItalic: ' vi setter opp',
    waitingHeadingEnd: ' domenet ditt',
    waitingMessage1:
      'Vi henter sertifikatet ditt fra Cloudflare. Tar vanligvis under et minutt, akkurat tid til å sette på kaffen.',
    waitingMessage2: 'Domenet ditt skal sendes rundt på internettet. En kaffepause holder.',
    waitingMessage3: 'Vi finsliper det siste. Du er nesten på lufta.',
    waitingMessage4:
      'Cert-utstedelse pågår. Bruk minuttet til å strekke på beina, vi blir ferdige før kaffen blir kald.',
    forwardErrorWithMessage: 'Kunne ikke videresende: {message}',
    forwardError: 'Kunne ikke videresende. Prøv igjen.',
    takingLonger:
      'Dette tar lengre tid enn vanlig. Vi venter fortsatt på sertifikatet, og du kan trygt la siden stå åpen.',
    stuckBody:
      'Vi har ikke fått sertifikatet på plass ennå. Kontoen din er opprettet, så ingenting er tapt. Prøv igjen, eller ta kontakt så ordner vi det.',
    stuckRetry: 'Prøv igjen',
    stuckContact: 'Kontakt oss',
    stuckMailSubject: 'Domenet {slug} er ikke klart',
  },
  setupSetupServicesView: {
    offersTreatmentLabel: 'Tilbyr du behandling?',
    offersTreatmentHint:
      'Slå på hvis du er fysioterapeut, naprapat, fotterapeut eller lignende, da får du en egen møteflate med plan-sjekkliste under selve behandlingen. Du kan endre dette senere i innstillingene.',
    offersTrainingLabel: 'Tilbyr du trening eller coaching?',
    offersTrainingHint:
      'Slå på hvis du er personlig trener, løpecoach eller lignende, da kan du markere tjenester som trening og få en møteflate laget for økter, med øvelser og resultater. Du kan endre dette senere i innstillingene.',
    modeLegend: 'Hvordan møter du kundene dine?',
    modeVideoTitle: 'På video',
    modeVideoSub: 'jeg holder møter online',
    modeOfficeTitle: 'Fysisk',
    modeOfficeSub: 'i klinikken, kontoret eller studioet',
    modeBothTitle: 'Begge deler',
    modeBothSub: 'video og fysisk, jeg veksler',
    kindLegend: 'Type',
    kindSamtale: 'Samtale',
    kindTrening: 'Trening',
    namePlaceholderTrening: 'f.eks. Styrkeøkt',
    videoDurationHint: 'Videomøter kan vare i opptil {max} minutter med abonnementet ditt.',
    videoDurationError: 'Velg en varighet på {max} minutter eller mindre for videomøter.',
    saveError: 'Kunne ikke lagre tjenestene. Prøv igjen.',
  },
  viewsRequestDemoView: {
    turnstilePending: 'vent et øyeblikk mens vi bekrefter at du ikke er en robot',
    genericError: 'Noe gikk galt. Prøv igjen.',
    formEyebrow: 'demo',
    formTitle: 'Demoen er stengt akkurat nå',
    formBody: 'Legg igjen navn og e-post, så åpner vi demoen for deg og tar kontakt.',
    nameLabel: 'Navn',
    namePlaceholder: 'Fornavn Etternavn',
    emailLabel: 'E-post',
    emailPlaceholder: "du{'@'}firma.no",
    messageLabel: 'Melding (valgfri)',
    messagePlaceholder: 'Fortell oss gjerne litt om hva du ønsker å se',
    turnstileAriaLabel: 'Bot-sjekk fra Cloudflare',
    submitCta: 'Be om tilgang',
    sentEyebrow: 'takk',
    sentTitle: 'Forespørselen er sendt',
    sentBody: 'Takk. Vi tar kontakt og åpner demoen for deg.',
  },
  accountMarketingEmailsCard: {
    title: 'Nyheter og tilbud',
    hint: 'Gjelder e-postadressen din i alle arbeidsområder.',
    toggleLabel: 'Få nyheter og tilbud på e-post',
    toggleDescription:
      'Dette valget påvirker ikke nødvendige e-poster om kontoen din eller bookinger.',
    loading: 'Henter e-postvalget ditt …',
    saving: 'Lagrer …',
    saved: 'E-postvalget er lagret.',
    loadError: 'Vi kunne ikke hente e-postvalget ditt. Prøv igjen.',
    saveError: 'Vi kunne ikke lagre endringen. Det forrige valget vises. Prøv igjen.',
    retry: 'Prøv igjen',
  },
  accountDripEmailsCard: {
    title: 'Velkomstserien',
    hint: 'En kort serie med tips for å komme i gang med Stemne, sendt over de første ukene. Gjelder hele arbeidsområdet, ikke bare deg. Booking-relaterte e-poster går som vanlig.',
    toggleLabel: 'Få velkomstserien på e-post',
    toggleDescription:
      'Skru av når som helst. Du mister ingen bookingbekreftelser eller påminnelser.',
  },
  accountEmailNotificationsCard: {
    title: 'Varslinger',
    hint: 'Velg hvilke e-poster du vil få fra Stemne. Innstillingen gjelder bare for deg, og lagres umiddelbart.',
    bookingLabel: 'Bookingbekreftelse',
    bookingDescription: 'Når en kunde booker en time hos deg eller teamet ditt.',
    cancelLabel: 'Avbestilling',
    cancelDescription: 'Når en kunde avbestiller et planlagt møte.',
    rescheduleLabel: 'Endring av tidspunkt',
    rescheduleDescription: 'Når en kunde flytter et møte til en annen tid.',
    noshowLabel: 'No-show',
    noshowDescription: 'Når en kunde ikke møter opp til timen sin.',
    reminderLabel: 'Påminnelse',
    reminderDescription: 'Påminnelse om møter du har kommende. Sendes via egen plan.',
    paymentLabel: 'Betalingsaktivitet',
    paymentDescription:
      'Når en betalingslenke eller påminnelse sendes, eller en betaling refunderes.',
    paymentSettledLabel: 'Betaling mottatt',
    paymentSettledDescription: 'Når et depositum eller restbeløpet etter møtet er betalt.',
    messageLabel: 'Meldinger',
    messageDescription: 'Chat-meldinger fra kunder.',
    systemLabel: 'Systemvarsler',
    systemDescription: 'Viktige driftsmeldinger (kalender-synk, sikkerhet, oppdateringer).',
    mentionLabel: 'Omtaler i notater',
    mentionDescription: "Når en kollega nevner deg ({'@'}navn) i et møtenotat.",
    actionPointDueLabel: 'Frist på oppfølgingspunkt',
    actionPointDueDescription: 'Når et oppfølgingspunkt du eier har frist.',
  },
  accountMyServicesTab: {
    saveError: 'Kunne ikke lagre. Prøv igjen.',
    title: 'Mine tjenester',
    intro:
      'Velg hvilke tjenester du tilbyr. Du tilbyr alle som standard, helt til du skrur av noen her.',
    loading: 'Laster …',
    emptyBody: 'Det finnes ingen tjenester ennå.',
    guard: 'Du tilbyr ingen tjenester nå. Da blir du ikke tildelt nye møter.',
    hiddenPill: 'Skjult',
    hiddenDpa: 'Godta databehandleravtalen før du kan ta tjenesten i bruk.',
    hiddenDpaCta: 'Godta avtalen',
    hiddenPublish: 'Tjenesten er skjult. Gjør den synlig under Tjenester for å ta den i bruk.',
  },
  accountTilgjengelighetTab: {
    endBeforeStart: 'Sluttid må være etter starttid',
    periodAdded: 'Periode lagt til',
    periodSaveError: 'Kunne ikke lagre periode',
    availabilityConflictIntro:
      'Disse møtene ligger utenfor de nye åpningstidene. Lagrer du, må du manuelt flytte eller avlyse dem.',
    saveAnyway: 'Lagre likevel',
    blockerConflictIntro:
      'Disse møtene faller inn i perioden du blokkerer. Du må flytte eller avlyse dem manuelt etter at perioden er lagret.',
  },
  accountVarslingerTab: {
    title: 'Varslinger',
    quietLedeDigest:
      'Sett stille timer slik at e-poster venter til neste vindu. Varslinger i appen kommer fortsatt fram med en gang; vi holder bare tilbake utgående e-poster.',
    quietLede:
      'Sett stille timer slik at vi ikke sender e-poster i perioden. Varslinger i appen kommer fortsatt fram med en gang.',
    quietToggleLabelDigest: 'Vent med e-poster i stille timer',
    quietToggleLabel: 'Ikke send e-poster i stille timer',
    quietToggleDescriptionDigest:
      'Når påslått samler vi alle e-poster fra perioden i ett morgensammendrag.',
    quietToggleDescription:
      'Når påslått sender vi ikke e-poster i stille timer. Du ser alt i appen som vanlig.',
    saved: 'Lagret.',
    saveError: 'Kunne ikke lagre. Prøv igjen.',
    quietSaveError: 'Kunne ikke lagre stille timer.',
    formatBoth: 'Bruk formatet 22:00 og 07:00.',
    formatFrom: 'Bruk formatet 22:00.',
    formatTo: 'Bruk formatet 07:00.',
    sameTime: 'Fra og til kan ikke være like.',
    teamExpiryLabel: 'Varsle meg når kunder til teamet mitt ikke bekrefter',
    teamExpiryDescription:
      'Du får én e-post per møte en kollega var tildelt og kunden ikke bekreftet i tide. Kunden får alltid et tilbud om å booke på nytt, denne varslingen er bare en oversikt for deg.',
    fromLabel: 'Fra',
    toLabel: 'Til',
    timezoneKicker: 'Tidssone',
    timezoneHint: 'Endres under Innstillinger → Bedrift.',
    loading: 'Henter varslingsinnstillinger…',
  },
  bulkimportBulkImportWizard: {
    titleUpload: 'Importer flere kunder',
    titleMap: 'Koble kolonnene dine',
    titleReview: 'Se gjennom før import',
    kicker: 'kunder',
    importError: 'Noe gikk galt under importen.',
  },
  bulkimportDoneStep: {
    headline: '1 kunde lagt til | {n} kunder lagt til',
    detailIntro: 'De ligger nå i kundelisten din, merket «importert».',
    updated: '1 kunde ble oppdatert. | {n} kunder ble oppdatert.',
    skipped: '1 rad ble hoppet over. | {n} rader ble hoppet over.',
    errors: '1 rad fikk en feil og ble ikke lagret. | {n} rader fikk en feil og ble ikke lagret.',
    seeCustomers: 'Se kundene',
  },
  bulkimportMapStep: {
    intro:
      'Si hva hver kolonne i filen er. Vi har gjettet ut fra overskriftene, endre der det trengs. Kolonner du ikke trenger lar du stå på «Ikke importer».',
    headerToggle: 'Første rad er overskrifter',
    fieldIgnore: 'Ikke importer',
    fieldFirstName: 'Fornavn',
    fieldLastName: 'Etternavn',
    fieldEmail: 'E-post',
    fieldPhone: 'Telefon',
    fieldTags: 'Etikett',
    columnFallback: 'Kolonne {n}',
    inUseSuffix: ' (i bruk)',
    previewEmpty: 'tom',
    noticeOk: '✓ Klart. Vi bruker e-post for å unngå dubletter mot kundene du har fra før.',
    noticeBadPre: 'Koble minst',
    noticeBadOr: 'eller',
    noticeBadPost: 'for å gå videre.',
    reviewCta: 'Se gjennom {n} rader',
  },
  bulkimportReviewStep: {
    intro:
      'Slik tolket vi filen. Rett opp e-poster som mangler eller er feil, og velg hva som skjer med kunder du har fra før.',
    tallyRows: 'rader i filen',
    tallyReady: 'klare',
    tallyDuplicate: 'finnes fra før',
    tallyProblems: 'trenger en rettelse',
    dedupLabel: 'Finnes fra før ({n})',
    dedupSkip: 'Hopp over',
    dedupUpdate: 'Oppdater',
    bulkTagLabel: 'Etikett på alle',
    tagNone: 'ingen',
    colName: 'NAVN',
    colEmail: 'E-POST',
    colTags: 'ETIKETTER',
    colStatus: 'STATUS',
    includeRowAria: 'Ta med rad {row}',
    noName: '(uten navn)',
    emailPlaceholder: 'skriv e-post',
    statusReady: 'klar',
    statusDuplicate: 'finnes fra før',
    statusInvalid: 'ugyldig e-post',
    statusMissing: 'mangler e-post',
    footnote:
      'Importerte kunder får ingen automatisk e-post. Du kan invitere dem senere fra kundekortet.',
    importing: 'Importerer…',
    importCta: 'Importer 1 kunde | Importer {n} kunder',
  },
  bulkimportStepperRail: {
    ariaLabel: 'Importsteg',
    stepUpload: 'last opp',
    stepMap: 'koble kolonner',
    stepReview: 'se gjennom',
  },
  bulkimportUploadStep: {
    intro:
      'Last opp et regneark fra CRM-et ditt, en eksport, eller en liste du har samlet. Du kobler kolonnene i neste steg. Vi støtter CSV-filer i denne første versjonen, Excel kommer.',
    dropTitle: 'Slipp filen her, eller bla gjennom',
    dropMeta: '.csv · maks 5 MB · opptil 2 000 rader',
    fileMeta: '{rows} rader · {size}',
    swapFile: 'Bytt fil',
    hint: 'Vet du ikke hvordan? Lag et regneark med kolonnene fornavn, etternavn, e-post, telefon og etikett. Vi forteller deg om noe mangler.',
    mapColumnsCta: 'Koble kolonner →',
  },
  dashboardActiveSessionBanner: {
    eyebrowLate: 'over tiden',
    eyebrowActive: 'pågår nå',
    modeTreatment: 'Behandling',
    modeVideo: 'Videomøte',
    modeMeeting: 'Møte',
    titleWithName: '{label} med {name}',
    titleActive: '{label} pågår',
    finishCta: 'Avslutt',
    goToSessionCta: 'Gå til møtet',
  },
  dashboardActivityEventRow: {
    colleague: 'En kollega',
    unknown: 'Ukjent',
    docReceived: 'mottatt',
    docActive: 'aktiv',
    docExpired: 'utløpt',
    docRevoked: 'trukket',
    docMetaReceived: '{size} · mottatt',
    docMetaViewOnly: '{size} · kun visning',
    docMetaDownload: '{size} · nedlasting',
    hos: 'hos {name}',
  },
  dashboardActivityFeedSection: {
    chipAlle: 'alle',
    chipMoter: 'møter',
    chipDokumenter: 'dok',
    chipSamtaler: 'samtaler',
    chipKunder: 'kunder',
    filterAria: 'Filtrer aktivitet',
    emptyTitle: 'Stille de siste sju dagene.',
    emptyBody:
      'Ingen nye møter, ingen aktivitet å rapportere. Når noe tikker inn, dukker det opp her.',
    olderLink: 'eldre hendelser i full historikk →',
  },
  dashboardActionPointsSection: {
    label: 'oppfølgingspunkter',
    overdueBadge: '{count} forfalt',
    scopeAria: 'Vis mine eller teamets punkter',
    scopeMine: 'Mine',
    scopeTeam: 'Teamet',
    allCustomers: 'Alle kunder',
    noDue: 'ingen frist',
    overduePrefix: 'forfalt {date}',
    emptyTitle: 'Ingen åpne oppfølgingspunkter.',
    emptyTeamTitle: 'Teamet har ingen åpne oppfølgingspunkter.',
    emptyBody: 'Punkter du noterer etter et møte samles her, med frist først. Du er à jour.',
    searchPlaceholder: 'søk i punkter, kunde, rådgiver ...',
    noResults: 'Ingen punkter matcher søket.',
  },
  dashboardActivityPillFilter: {
    lensAlle: 'alle',
    lensMoter: 'møter',
    lensDokumenter: 'dokumenter',
    lensSamtaler: 'samtaler',
    lensKunder: 'nye kunder',
    listLabel: 'Filtrer historikk',
  },
  dashboardAddClientModal: {
    kicker: 'kunder',
    editTitle: 'Endre kunde',
    createTitle: 'Legg til kunde',
    intro: 'Bruk dette for kunder som har booket utenfor systemet. De får ikke automatisk e-post.',
    firstNameLabel: 'Fornavn',
    lastNameLabel: 'Etternavn',
    emailLabel: 'E-post',
    emailPlaceholder: "navn{'@'}firma.no",
    emailWarning:
      'Kunden må bekrefte den nye adressen før den tas i bruk. Vi sender en lenke til {email}. Frem til kunden har bekreftet går påminnelser, bekreftelser og innlogging fortsatt til den gamle adressen.',
    emailWarningFallback: 'den nye e-posten',
    emailPending: 'Venter på at kunden bekrefter {email}. Du kan endre adressen på nytt her.',
    phoneLabel: 'Telefon (valgfritt)',
    phonePlaceholder: '+47 …',
    addressLabel: 'Adresse (valgfritt)',
    addressPlaceholder: 'Søk etter adresse',
    addressHint: 'Brukes når du reiser til kunden',
    tagsLabel: 'Etiketter',
    otherTagHint: 'Automatisk eller eldre etikett – kan ikke fjernes her ennå',
    saveEditCta: 'Lagre endringer',
    saveCreateCta: 'Lagre kunde',
  },
  dashboardAddPasskeyModal: {
    title: 'Ny passnøkkel',
    labelPrompt: 'Hva skal vi kalle denne?',
    labelHint: 'Slik kjenner du den igjen i listen, og ved tilbakekalling.',
    deviceKicker: 'denne enheten',
    deviceFallback: 'Denne enheten',
    deviceMeta: 'Den private nøkkelen forlater aldri enheten.',
    reauthNote:
      'Dette er en ekstra passnøkkel, så vi må bekrefte at det er deg. Bruk en passnøkkel du allerede har for å fortsette.',
    confirmHint:
      'Etter du klikker bekreft ber enheten om Face ID, fingeravtrykk eller en sikkerhetsnøkkel.',
    confirmWithPasskeyCta: 'Bekreft med passnøkkel',
    confirmCta: 'Bekreft',
  },
  dashboardBlockTimeModal: {
    kicker: 'kalender',
    title: 'Blokker tid',
    intro: 'Ingen kan booke i denne perioden. Eksisterende møter berøres ikke.',
    reasonLabel: 'Grunn (valgfritt, vises ikke offentlig)',
    reasonPlaceholder: 'f.eks. Veiledning · Fridag',
    allDay: 'Hele dagen',
    dateLabel: 'Dato',
    fromLabel: 'Fra',
    toLabel: 'Til',
    fromDateLabel: 'Fra dato',
    toDateLabel: 'Til dato',
    repeatLabel: 'Gjenta',
    repeatNever: 'Aldri',
    repeatWeekly: 'Ukentlig, samme tid',
    repeatMonthly: 'Månedlig',
    blockCta: 'Blokker',
  },
  dashboardBookingAccessPanel: {
    you: 'deg',
    unknownColleague: 'ukjent kollega',
    roleCoHostReadWrite: 'Med-vert (les + skriv)',
    roleViewer: 'Lesetilgang',
    grantedToast: '{name} fikk tilgang.',
    revokedToast: '{name} har ikke lenger tilgang.',
    revokedNoteToast: '{name} har ikke lenger tilgang til notatet.',
    entryUntitled: 'Uten tittel',
    sectionAriaLabel: 'Tilgang til møtet',
    title: 'Tilgang',
    privateMeeting: 'privat møte',
    ownerLabel: 'Eier',
    participantCoHostLabel: 'Medvert',
    participantMeta: 'deltaker',
    sharedNoteLabel: 'Delt notat',
    sharedNoteTipAriaLabel: 'Hva betyr Delt notat',
    sharedNoteTip:
      'Kolleger med tilgang til ett notat ser bare det notatet, ikke kundens navn, andre notater eller hele møtet.',
    revokeTip: 'Trekk tilbake tilgangen',
    revokeAriaLabel: 'Fjern tilgang for {name}',
    coHostLabel: 'Med-vert',
    coHostMeta: 'co-host',
    viewerLabel: 'Lesetilgang',
    viewerMeta: 'leser',
    grantColleagueCta: 'Gi en kollega tilgang',
    colleagueLabel: 'Kollega',
    colleaguePlaceholder: 'Velg en kollega',
    roleLabel: 'Rolle',
    grantAccessCta: 'Gi tilgang',
    loadingAccess: 'Henter tilganger …',
    canCommentLabel: 'Kan kommentere',
    canCommentHint: 'Du blir varslet om svar.',
    noCommentsMeta: 'kan ikke kommentere',
    sharedToday: 'delt i dag',
    sharedYesterday: 'delt i går',
    sharedDaysAgo: 'delt for 1 dag siden | delt for {n} dager siden',
    sharedWeeksAgo: 'delt for 1 uke siden | delt for {n} uker siden',
    sharedMonthsAgo: 'delt for 1 måned siden | delt for {n} måneder siden',
    expiresOn: 'utløper {date}',
  },
  dashboardBookingAuditTimeline: {
    removedUser: 'Fjernet bruker',
    you: 'Du',
    unknownUser: 'Ukjent bruker',
    openedMeeting: 'åpnet møtet',
    title: 'Tilgangslogg',
    lede: 'Hver gang en administrator åpner et privat møte, blir det loggført her.',
    loading: 'Henter loggen…',
    empty: 'Ingen åpninger logget for dette møtet.',
  },
  dashboardBulkOwnerAssign: {
    noTeamToDistribute: 'Ingen i teamet å fordele til.',
    assignedCount: '1 møte tildelt | {n} møter tildelt',
    assignFailed: 'Kunne ikke tildele. Prøv igjen.',
    assignedPartial: '{ok} tildelt · {failed} feilet, last og prøv resten på nytt',
    withoutOwner: '{count} uten ansvarlig',
    headingOne: 'Tildel før det starter.',
    headingMany: 'Tildel før de starter.',
    bodySoloOne: 'Du kan ta det selv.',
    bodySoloMany: 'Du kan ta alle {count} selv.',
    bodyTeamOne: 'Du kan ta det selv, eller velge en kollega i raden.',
    bodyTeamMany: 'Ta alle selv med ett klikk, eller fordel jevnt på teamet.',
    takeSelfOne: 'Ta det selv',
    takeSelfMany: 'Ta alle {count} selv',
    distributeEvenly: 'Fordel jevnt på team',
    perPersonHint: '~{n} per',
    previewCaption: 'Forhåndsvisning av jevn fordeling',
    confirmTakeTitleOne: 'Ta dette møtet selv?',
    confirmTakeTitleMany: 'Ta alle {count} selv?',
    confirmTakeBodyOne:
      'Tildeler møtet til deg. Du kan flytte det etterpå hvis tidspunktet ikke passer.',
    confirmTakeBodyMany:
      'Tildeler {count} møter til deg. Du kan flytte enkeltmøter etterpå hvis et tidspunkt ikke passer.',
    confirmTakeCtaOne: 'Ja, gi meg det',
    confirmTakeCtaMany: 'Ja, gi meg alle {count}',
    confirmDistributeTitle: 'Fordel {count} jevnt?',
    confirmDistributeBody:
      'Fordeler {count} møter jevnt på teamet. Du kan flytte enkeltmøter etterpå.',
    confirmDistributeCta: 'Ja, fordel',
  },
  dashboardCalendarConnectionsPanel: {
    syncedToday: 'i dag {time}',
    syncedYesterday: 'i går {time}',
  },
  dashboardCalendarEventPopover: {
    sourceCalendar: '{provider} · {calendar}',
    stemneFallback: 'Stemne',
    ctaGoToSession: 'Gå til økta',
    ctaStartTreatment: 'Start behandling',
    ctaGoToMeeting: 'Gå til møte',
    seeDetails: 'Se detaljer',
    attendeeAria: '{title} og {count} flere deltakere: {names}',
    attendeesCount: '{n} deltaker | {n} deltakere',
    statusPending: 'Venter på bekreftelse',
    statusRescheduled: 'Ombooket',
    statusCompleted: 'Gjennomført',
    statusUnresolved: 'Uavklart',
    statusNoShow: 'Ikke møtt',
    statusCancelled: 'Avlyst',
    statusExpired: 'Utløpt',
    statusConfirmed: 'Bekreftet',
  },
  dashboardDashboardCustomersMobile: {
    heroKicker: 'kunder · {count} totalt',
    heroTitle: 'Kundene dine',
    heroSub:
      'Alle som har booket et møte. Bare du og rådgivere du har gitt tilgang ser denne listen.',
    filterAll: 'alle',
    filterNew: 'nye',
    filterNewSub: 'denne uken',
    filterActive: 'aktive',
    filterPaused: 'i pause',
    tagAriaLabel: 'Lifecycle-filter',
    searchPlaceholder: 'Søk navn eller e-post…',
    searchAriaLabel: 'Søk kunder',
    sectionNew: 'nye · denne uken',
    sectionActive: 'aktive',
    sectionPaused: 'i pause',
    sectionPast: 'tidligere',
    customerCount: '{n} kunde | {n} kunder',
    meetingCount: '{n} booking | {n} bookinger',
    nextRel: 'neste {rel}',
    requestedRel: 'forespurt {rel}',
    lastRel: 'sist {rel}',
    relToday: 'i dag · {time}',
    relTomorrow: 'i morgen · {time}',
    relYesterday: 'i går',
    relLastWeek: 'forrige uke',
    stagePaused: 'pause',
    stageNew: 'ny',
    stageCustomer: 'kunde',
    stageRequest: 'forespørsel',
    emptyTitle: 'Ingen kunder ennå.',
    emptyBody:
      'Kundene dine dukker opp her etter første møte, eller når du legger til noen manuelt.',
    filteredHeadNew: 'nye kunder',
    filteredHeadActive: 'aktive kunder',
    filteredHeadPaused: 'i pause',
    filteredHeadAll: 'alle kunder',
    noMatchTitle: 'Ingen kunder matcher «{query}».',
    noneInViewTitle: 'Ingen kunder i denne visningen.',
    noMatchBody: 'Prøv et annet søkeord eller fjern filteret.',
    noneInViewBody: 'Bytt filter for å se andre kunder, eller fjern det helt.',
    footerHint: 'Sortert · sist sett. Trykk på en rad for historikk og notater.',
    addCta: 'Legg til kunde',
  },
  dashboardDashboardOverviewMobile: {
    loadError: 'Kunne ikke laste oversikten.',
    youFallback: 'du',
    weekdayDate: '{weekday} · {day}. {month}',
    goodMorning: 'God morgen',
    goodLateMorning: 'God dag',
    goodAfternoon: 'God dag',
    goodEvening: 'God kveld',
    // Hilsen, ikke avskjed — se dashboard.greetingNight.
    goodNight: 'Sent oppe',
    heroTitle: '{greeting}, {name}.',
    quietDay: 'Stille dag, ingen møter satt opp.',
    todayMeetings: '1 møte i dag. | {n} møter i dag.',
    notesWaiting: '1 notat venter på deg. | {n} notater venter på deg.',
    scopeTodayLabel: 'i dag',
    scopeMeetingsSub: 'møter',
    scopeWeekLabel: 'denne uken',
    scopeNewLabel: 'nye kunder',
    scopeThisWeekSub: 'denne uken',
    minutes: '{m} min',
    inProgress: 'pågår',
    inMinutes: 'om {min} min',
    inHours: 'om {h} t',
    today: 'i dag',
    tomorrow: 'i morgen',
    filterAriaLabel: 'Oversikt-filter',
    todaysMeetingsKicker: 'dagens møter',
    meetingFallback: 'Møte',
    withPerson: 'med {name}',
    joinMeeting: 'Bli med i møtet',
    prepare: 'Forbered',
    open: 'Åpne',
    unownedTitle: 'Møter uten ansvarlig',
    unownedSub: 'Tildel før de starter',
    laterTodayKicker: 'senere i dag · i morgen',
    meetingCount: '1 møte | {n} møter',
    emptyTitle: 'Stille resten av dagen.',
    emptyBody:
      'Ingen flere møter, ingen uleste notater. Nyt pausen, vi sier ifra når noe dukker opp.',
    seeWholeWeek: 'Se hele uken i Møter',
    weekMeetings: '1 møte denne uken. | {n} møter denne uken.',
    weekQuiet: 'Ingen møter satt opp denne uken.',
    weekEmpty: 'Ingen møter denne uken.',
    newCustomers: '1 ny kunde denne uken. | {n} nye kunder denne uken.',
    newQuiet: 'Ingen nye kunder denne uken ennå.',
    newEmpty: 'Ingen nye kunder denne uken.',
    newCustomerFirstMeeting: 'Første møte {when}',
  },
  dashboardDateOverrideModal: {
    errorNoDate: 'Velg en dato.',
    errorNoWindow: 'Legg til minst ett tidsvindu.',
    errorStartBeforeEnd: 'Start må være før slutt i hvert vindu.',
    titleEdit: 'Rediger overstyring',
    titleCreate: 'Overstyr en dag',
    dateLabel: 'Dato',
    dateHint: 'For å bytte dato, slett denne og opprett en ny.',
    kindLegend: 'Hvordan',
    kindClosed: 'Stengt, ingen møter denne dagen',
    kindReplace: 'Annen tid, bruk disse tidene i stedet',
    removeWindowAria: 'Fjern vindu',
    addWindow: '+ legg til vindu',
    noteLabel: 'Notat (valgfritt)',
    notePlaceholder: 'f.eks. konferanse, ferie',
  },
  dashboardDemoCtaBanner: {
    kicker: 'demo',
    body: 'Alt her tilhører en oppdiktet praksis. Vil du se det samme med dine egne tjenester og tider, tar det noen minutter å sette opp din egen side.',
    bodyMobile: 'Eksempeldata',
    setupCta: 'Sett opp din egen side',
    setupCtaMobile: 'Opprett din side',
    dismissCta: 'Ikke nå',
  },
  dashboardDemoWelcomeModal: {
    title: 'Velkommen til demoen',
    kicker: 'demo',
    intro:
      'Dette er en levende demo. Mens du ser deg rundt, dukker det opp aktivitet som om ekte kunder er i sving.',
    bulletBooking: 'Nye kunder booker og bekrefter timer',
    bulletDocuments: 'Kunder laster opp dokumenter før møtet',
    bulletMessages: 'Meldinger og spørsmål kommer inn underveis',
    muted:
      'Alt du gjør her nullstilles hver natt, så neste omvisning starter friskt. Kalenderen kobles ikke til i demoen.',
    exploreCta: 'Utforsk demoen',
  },
  dashboardEmptyAvailabilityBanner: {
    title: 'Du har ikke satt opp egne arbeidstider',
    hint: 'Vi bruker organisasjonens standard inntil videre. Sett dine egne timer →',
  },
  dashboardCalendarConnectionBanner: {
    eyebrow: 'kalender',
    title: 'Koble til Google Kalender',
    body: 'Unngå dobbeltbookinger og få Stemne-møter inn i kalenderen din.',
    cta: 'Koble til kalender →',
    dismiss: 'Ikke nå',
  },
  dashboardImminentMeetingBanner: {
    eyebrow: 'starter snart',
    title: 'Møte',
    titleWithName: 'Møte med {name}',
    joinCta: 'Bli med i møtet',
    openCta: 'Åpne møtet',
  },
  dashboardInstantMeetingModal: {
    kicker: 'møt nå',
    titleReady: 'Møterom klart',
    titleStart: 'Start et møte nå',
    formIntro:
      'For samtaler du vil starte med en gang. Vi lager møterom og sender en invitasjon til kunden, du får lenken her med en gang.',
    customerComboLabel: 'Velg kunde eller legg til ny',
    customerComboPlaceholder: 'Søk eller skriv inn ny kunde',
    customerComboCreateLabel: 'Legg til ny kunde',
    newCustomerSectionLabel: 'ny kunde',
    nameLabel: 'Navn på kunde',
    namePlaceholder: 'Skriv navn',
    emailLabel: 'E-post',
    emailPlaceholder: "navn{'@'}firma.no",
    messageLabel: 'Beskjed til kunden (valgfritt)',
    messageHint: 'Korte ord om hva møtet handler om. Vises i e-posten.',
    loadCustomersError: 'Kunne ikke laste kunder. Prøv igjen om litt.',
    successIntro:
      'Møterommet er klart, og {email} har fått invitasjonen på e-post. Mens kaffen brygger, kan du dele lenken under hvis du vil ha kunden inn raskere.',
    linkLabel: 'Lenke til kunden',
    startCta: 'Start møte',
    joinAsHostCta: 'Bli med som vert',
    startError: 'Kunne ikke starte møtet. Prøv igjen om litt.',
    copySuccess: 'Lenke kopiert. Send den til kunden.',
    copyError: 'Kunne ikke kopiere, marker URL-en og kopier manuelt.',
  },
  dashboardLobbyBanner: {
    eyebrow: 'venter i lobbyen',
    unnamedCustomer: 'kunde uten navn',
    joinCta: 'Bli med i møtet',
    waiting: 'venter · {time}',
    overdue: 'over tiden · {time}',
  },
  dashboardMeetingAttachments: {
    label: 'Dokumenter til gjennomgang',
    uploading: 'Laster opp…',
    removeAria: 'Fjern {name}',
    dropPrimary: 'Legg ved dokumenter',
    dropMeta: 'klikk eller dra og slipp · PDF, Word, regneark, bilde · maks 25 MB',
    errUnsupportedType: 'Filtypen støttes ikke',
    errUploadFailed: 'Opplasting feilet',
  },
  dashboardMeetingDocumentsPanel: {
    hint: 'Dokumenter som er knyttet til dette møtet.',
    readOnlyHint: 'Dokumenter som er bevart fra dette avlyste møtet.',
    encryptedBadge: 'Kryptert',
    addCta: 'Legg til dokument',
    loading: 'Laster…',
    emptyBody: 'Ingen dokumenter er lagt til ennå.',
    removedOnSave: '· fjernes ved lagring',
    undo: 'Angre',
    open: 'Åpne',
    history: 'Historikk',
    revoke: 'Trekk tilbake',
    noActivity: 'Ingen aktivitet registrert ennå.',
    addedOnSave: '· legges til ved lagring',
    modalKicker: 'møte',
    pickFile: 'Velg fil',
    messageLabel: 'Melding (valgfritt)',
    messagePlaceholder: 'Kort notat til deltakerne',
    note: 'Dokumentet legges til når du lagrer møtet. Deltakerne varsles i den samlede oppdateringen.',
    submitCta: 'Legg til',
    openError: 'Kunne ikke åpne dokumentet. Prøv igjen.',
    historyError: 'Kunne ikke laste historikken',
    actorAdvisor: 'rådgiver',
    actorParticipant: 'deltaker',
    actorSystem: 'system',
    activityShared: 'Delt av {who}',
    activityNotified: 'E-post sendt',
    activityOpened: 'Åpnet av {who}',
    activityDownloaded: 'Lastet ned av {who}',
    activityRevoked: 'Trukket tilbake av {who}',
    activityExtended: 'Utløp endret av {who}',
    activityExpired: 'Utløpt automatisk',
    activityReceived: 'Mottatt fra {who}',
    activityPolicyChanged: 'Tilgangsnivå endret',
    pickFileError: 'Velg en fil',
    uploadError: 'Kunne ikke laste opp dokumentet',
  },
  dashboardMeetingNotesHistoryModal: {
    loadError: 'Kunne ikke laste historikk',
    timestamp: '{date} kl {time}',
    title: 'Historikk for «{title}»',
    untitled: 'Notat',
    loading: 'Henter historikk…',
    empty: 'Ingen tidligere versjoner.',
    version: 'Versjon {number}',
  },
  dashboardMeetingNotesPanel: {
    sectionLabel: 'Notater',
    loading: 'Henter notater…',
    empty: 'Ingen notater på dette møtet ennå.',
    conflict: 'En nyere versjon ble lagret av en annen økt. Last på nytt for å se siste versjon.',
    editorPlaceholder:
      'Skriv hva som ble diskutert, hva du forbereder, eller hva du følger opp på.',
    saveVersion: 'Lagre versjon',
    edit: 'Rediger',
    history: 'Historikk',
    delete: 'Slett',
    deleteTitle: 'Slette «{title}»?',
    deleteBody:
      'Notatet skjules fra tidslinjen, men historikk og revisjoner beholdes for revisjon.',
    deleteConfirm: 'Slett notat',
    autosaveSaving: 'Lagrer…',
    autosaveSavedAt: 'Lagret kl {time}',
    autosaveSaved: 'Lagret',
    autosaveError: 'Kunne ikke lagre',
    autosaveDirty: 'Ulagrede endringer',
    duringMeeting: 'under møtet',
    sameDayBefore: 'samme dag, før møtet',
    daysBefore: '1 dag før møtet | {n} dager før møtet',
    sameDayAfter: 'samme dag, etter møtet',
    daysAfter: '1 dag etter møtet | {n} dager etter møtet',
    timestamp: '{date} kl {time}',
    defaultTitle: 'Notat',
  },
  dashboardMiniMonthPicker: {
    prevMonth: 'Forrige måned',
    nextMonth: 'Neste måned',
  },
  dashboardMobileDetailHeader: {
    moreActions: 'Flere handlinger',
  },
  dashboardMobileNav: {
    brandAria: 'stemne, dashboard',
    unreadAria: '{count} uleste',
    more: 'Mer',
    moreListAria: 'Flere sider',
    logout: 'Logg ut',
  },
  dashboardModeIcon: {
    video: 'Videomøte',
    office: 'På kontoret',
    both: 'Video eller kontoret',
    treatment: 'Klinikken',
  },
  dashboardNewMeetingModal: {
    stepKicker: 'steg {current} av {total}',
    stepType: 'Type',
    stepParticipants: 'Deltakere',
    stepPickCustomer: 'Velg kunde',
    stepPickTime: 'Velg tid',
    stepConfirmAndSend: 'Bekreft og send',
    tabType: 'Type',
    tabParticipants: 'Deltakere',
    tabTime: 'Tid',
    tabConfirm: 'Bekreft',
    goToStepAria: 'Gå til steg {number}: {label}',
    loadCustomersError: 'Kunne ikke laste kunder. Prøv igjen om litt.',
    loadServicesError: 'Kunne ikke laste tjenester. Prøv igjen om litt.',
    loadSlotsError: 'Kunne ikke hente ledige tider.',
    newCustomerPlaceholder: 'ny kunde',
    nameAndEmailError: 'Skriv inn navn og gyldig e-post.',
    guestNotRegisteredOption: '{email} · ikke registrert',
    hostFallback: 'Vert',
    teamMemberFallback: 'Teammedlem',
    vertLabel: '{n} vert | {n} verter',
    hostPillLabel: 'Vert · {name}',
    meetingTypeTeam: 'Teammøte',
    meetingTypeGroup: 'Gruppesamtale',
    meetingTypeCustomer: 'Kundemøte',
    whoLeadOneCustomer: '1 kunde',
    whoLeadManyCustomers: '{count} kunder',
    whoSameRoom: ' Samme rom for alle.',
    whoWhatInPerson: 'bekreftelse med møtested og kalenderfil',
    whoWhatVideo: 'bekreftelse med videolenke og kalenderfil',
    whoWhatSeries:
      'én invitasjon med alle {count} tidspunktene, og bekrefter hele serien med ett klikk',
    whoWhatSeriesUntil:
      'én invitasjon med alle tidspunktene, og bekrefter hele serien med ett klikk',
    whoRest: ' får {what}.{tail}',
    whoColleagueSingle: 'Kollegaen får en intern kalenderinvitasjon.',
    whoColleaguePlural: 'Kollegene får en intern kalenderinvitasjon.',
    sendInvitation: 'Send invitasjon',
    sendInvitations: 'Send invitasjoner',
    busyConflictError: 'Noen er allerede booket: {names}',
    createMeetingError: 'Kunne ikke opprette møtet. Prøv igjen om litt.',
    summaryWhen: '{date} · {time}',
    priceNotSet: 'pris ikke satt',
    priceFree: 'gratis',
    summaryService: '{name} · {duration} min · {price}',
    recurrenceNone: 'Bare denne ene',
    recurrenceDaily: 'Daglig',
    recurrenceWeekly: 'Ukentlig',
    recurrenceBiweekly: 'Annenhver uke',
    recurrenceMonthly: 'Månedlig',
    recurrenceTimes: '{n} ganger',
    recurrenceDailyLower: 'daglig',
    recurrenceWeeklyLower: 'ukentlig',
    recurrenceBiweeklyLower: 'annenhver uke',
    recurrenceMonthlyLower: 'månedlig',
    recurrenceEndLabel: 'Avslutt',
    recurrenceEndCount: 'Etter antall ganger',
    recurrenceEndUntil: 'På en dato',
    recurrenceUntilLabel: 'Til og med',
    seriesSummary: '{count} møter, {freq} fra {date}',
    seriesSummaryUntil: '{freq} fra {date}, til og med {until}',
    seriesSummaryNoDate: 'Velg en sluttdato for å se hva som blir booket',
    typeHintTeam: 'Kun kolleger. Ingen kunde eller tjeneste.',
    typeHintGroup: 'Én tjeneste, flere kunder sammen.',
    typeHintCustomer: 'Én kunde og en tjeneste.',
    blockTime: 'Blokker tid',
    blockTimeHint: 'Marker tiden som utilgjengelig. Ingen kunde.',
    titleLabel: 'Tittel',
    titlePlaceholder: 'Gi møtet et navn',
    vertSectionLabel: 'vert',
    youFallback: 'Du',
    vertBadge: 'vert',
    vertSubtitle: 'deg · tildelt automatisk',
    customerComboLabel: 'Velg kunde eller legg til ny',
    customerComboPlaceholder: 'Søk eller skriv inn ny kunde',
    customerComboCreateLabel: 'Legg til ny kunde',
    newCustomerSectionLabel: 'ny kunde',
    nameLabel: 'Navn',
    namePlaceholder: 'Skriv navn',
    emailLabel: 'E-post',
    emailPlaceholder: "margrethe{'@'}firma.no",
    newCustomerHint: 'Kunden får invitasjonen og påminnelser på e-postadressen over.',
    billingAddressLabel: 'Fakturaadresse',
    billingAddressHint: 'Brukes som kjøperens adresse på fakturaen etter at møtet er gjennomført.',
    angrerettAttestationLabel:
      'Jeg bekrefter at kunden uttrykkelig har bedt om at tjenesten kan leveres før angrefristen er utløpt, og har fått vite at angreretten faller bort når tjenesten er fullført.',
    angrerettAttestationHint: 'Dette lagres som operatørens attestasjon, ikke som et kundeklikk.',
    customersSectionLabel: 'kunder',
    customerCount: '{count} av {max}',
    removeCustomerLabel: 'Fjern kunde',
    addCustomerComboLabel: 'Søk eller legg til ny kunde',
    addButton: 'Legg til',
    addCustomerRow: 'Legg til kunde',
    serviceLabel: 'Tjeneste',
    serviceOption: '{name} · {duration} min',
    colleaguesSectionLabel: 'kolleger',
    coHostCount: 'co-vert',
    coHostBusySubtitle: 'opptatt på valgt tid',
    coHostSubtitle: 'co-vert · får kalenderinvitasjon',
    removeColleagueLabel: 'Fjern kollega',
    guestNotRegisteredBadge: 'ikke registrert',
    guestSubtitle: 'co-vert · får e-postinvitasjon',
    removeGuestLabel: 'Fjern gjest',
    pickColleagueLabel: 'Velg kollega',
    addColleagueRow: 'Legg til kollega',
    meetingTypeLabel: 'Tjeneste',
    dateLabel: 'Dato',
    fetchingSlots: 'henter ledige tider…',
    availabilityFor: 'Ledighet for',
    meetingDuration: 'Møtets varighet',
    meetingDurationAria: 'Møtets varighet: {minutes} minutter',
    durationLabel: 'Varighet',
    durationHint:
      'Videomøter kan vare i opptil {limit} min. Fysiske møter kan vare i opptil 480 min.',
    durationWholeMinutesError: 'Skriv inn varigheten i hele minutter.',
    durationRangeError: 'Varigheten må være mellom 1 og 480 minutter.',
    durationVideoLimitError:
      'Videomøter kan vare i opptil {limit} minutter. Velg et møtested for et lengre møte.',
    pollDeadlineError: 'Fristen må være før det første foreslåtte tidspunktet.',
    busyTitle: 'Opptatt: {names}',
    busyAria: '{time}, opptatt: {names}',
    dimmedBusyHint: 'Nedtonede tider er opptatt for én eller flere deltakere.',
    noCommonSlots: 'Ingen felles ledige tider denne dagen. Velg en annen dato.',
    allowOutsideHours: 'Tillat utenfor arbeidstid',
    timeSectionLabel: 'tid',
    outsideHoursNote:
      'Disse tidene ligger utenfor dine vanlige arbeidstider. Buffer og andre møter filtreres fortsatt bort.',
    noSlots: 'Ingen ledige tider denne dagen. Velg en annen dato.',
    noFollowUpSlotsAhead:
      'Ingen ledige tider de neste 60 dagene. Velg en senere dato for å lete videre.',
    recurrenceLabel: 'Gjenta',
    recurrenceCountLabel: 'Antall ganger',
    summaryTypeLabel: 'Type',
    summaryTitleLabel: 'Tittel',
    summaryServiceLabel: 'Tjeneste',
    summaryTimeLabel: 'Tid',
    summaryRecurrenceLabel: 'Gjenta',
    summaryParticipantsLabel: 'Deltakere',
    noteLabel: 'Notat til kunden',
    noteHint: 'Sendes med i invitasjonen.',
    agendaLabel: 'Hva må vi få svar på?',
    agendaPlaceholder: 'Ett punkt per linje',
    agendaHintTeam:
      'Valgfritt. Enter legger til neste punkt. Punktene ligger klare som sjekkliste i møtet.',
    agendaHintCustomer:
      'Valgfritt. Enter legger til neste punkt. Punktene ligger klare som sjekkliste i møtet, og følger med i invitasjonen.',
    inviteMessageLabel: 'Melding til deltakerne',
    inviteMessagePlaceholder: 'Valgfri hilsen som følger med invitasjonen',
    inviteMessageHint: 'Valgfritt. Vises i invitasjonen til deltakerne.',
    locationLabel: 'Møtested',
    locationHelp: 'Søk opp en adresse eller velg et lagret sted.',
    locationDefaultHint:
      'Standard for «{name}»: {address}. Møtet bruker denne hvis du ikke velger et annet møtested.',
    locationTeamHint:
      'La det stå tomt for et videomøte med egen lenke. Velger du et sted, blir møtet et fysisk møte uten videolenke.',
    backCta: '← Tilbake',
    nextCta: 'Neste →',
  },
  dashboardNewServiceTypeModal: {
    titleStep1: 'Hva slags møte er dette?',
    titleDetails: 'Detaljer',
    titleNew: 'Ny tjeneste',
    kickerStep: 'ny tjeneste · steg {step} av 2',
    kicker: 'ny tjeneste',
    kindSamtale: 'Samtale',
    kindBehandling: 'Behandling',
    kindTrening: 'Trening',
    lede: 'Valget bestemmer hvordan møtet ser ut for deg under selve økten, og hvilke detaljer vi spør om i neste steg. Du kan ikke endre det senere uten å lage en ny tjeneste.',
    samtaleSub:
      'Du snakker, lytter, noterer. Møtet skjer på video, telefon eller fysisk på kontoret. Forbered med kontekst og spørsmål; under møtet har du notepad.',
    samtaleChip1: 'Introsamtale',
    samtaleChip2: 'Oppfølging',
    samtaleChip3: 'Strategi',
    samtaleChip4: 'Rådgivning',
    behandlingSub:
      'Kunden er hos deg, hendene dine jobber. Møteflaten er hands-free, store hak-bokser og en kort plan for det du skal gjøre.',
    behandlingChip1: 'Nakkebehandling',
    behandlingChip2: 'Fotsoneterapi',
    behandlingChip3: 'Manuell mobilisering',
    behandlingChip4: 'Akupunktur',
    treningSub:
      'Du veileder en utøver gjennom en økt. Møteflaten er laget for trening, du planlegger øvelser før økten og noterer resultater underveis. Ingen smertescore eller journal.',
    treningChip1: 'PT-time',
    treningChip2: 'Styrkeøkt',
    treningChip3: 'Løpeveiledning',
    treningChip4: 'Oppfølging',
    nameLabel: 'Navn',
    namePlaceholderBehandling: 'f.eks. Nakkebehandling',
    namePlaceholderTrening: 'f.eks. Styrkeøkt',
    namePlaceholderSamtale: 'f.eks. Introsamtale',
    descriptionLabel: 'Beskrivelse',
    descriptionPlaceholder: 'Hva slags møte er dette?',
    requiresAckLabel: 'Krev at kunden bekrefter beskrivelsen',
    requiresAckDescription:
      'Kunden må lese beskrivelsen og huke av «jeg har lest og forstått» før bookingen kan fullføres.',
    durationLabel: 'Varighet (min)',
    videoDurationHint: 'Videomøter kan vare i opptil {max} minutter med abonnementet ditt.',
    videoDurationError: 'Velg en varighet på {max} minutter eller mindre for videomøter.',
    turnaroundLabel: 'Stelletid (min)',
    turnaroundHint: 'Mellom møter.',
    bufferLabel: 'Buffer (min)',
    priceLabel: 'Pris (kr)',
    freeLabel: 'Gratis tjeneste',
    freeHint: '(skjul prisfelt på siden)',
    modeLabel: 'Hvor',
    modeVideo: 'Video',
    modeOffice: 'På kontoret',
    modeBoth: 'Begge deler',
    addressLabel: 'Adresse',
    addressHint: 'Adressen møtet skjer på. Fysiske møter bruker denne som standard.',
    trainingTypeLabel: 'Treningstype',
    typeSearchPlaceholder: 'Søk eller legg til',
    typeCreateLabel: 'Legg til',
    practitionerTypeLabel: 'Behandlertype',
    seriesLabel: 'Del av behandlingsserie',
    seriesDescription:
      'Vi viser «behandling 3 av 6» på møtekortet og gir deg recap fra forrige økt på Forbered-siden. Kun for planlegging, ikke et klippekort eller en betalingsteller.',
    seriesLengthLabel: 'Antall behandlinger i serien',
    seriesLengthPlaceholder: 'f.eks. 6',
    continueCta: 'Fortsett →',
    createCtaBehandling: 'Opprett behandling',
    createCtaTrening: 'Opprett treningstype',
    createCtaSamtale: 'Opprett tjeneste',
    addTypeError: 'Kunne ikke legge til typen.',
    createError: 'Kunne ikke opprette tjenesten.',
  },
  dashboardNoteCreateDialog: {
    title: 'Nytt notat',
    kicker: 'ny notat',
    prefillLabel: 'Notat om',
    intro:
      'Et notat er mest verdt når det handler om en kunde, gjerne på tvers av møtene dere har. Velg hvem det gjelder.',
    customerLabel: 'Kunde',
    customerPlaceholder: 'Søk på navn eller e-post',
    createCustomerLabel: 'Opprett kunde fra',
    loadingCustomersHint: 'Laster kunder …',
    creatingCustomerHint: 'Oppretter kunde …',
    escapeLabel: 'Ikke knyttet til en kunde',
    escapeHint: 'For sparring, mal, eller noe du vil koble til senere.',
    titleFieldPrefillLabel: 'Notat',
    titleFieldLabel: 'Tittel (valgfri)',
    titlePlaceholderPrefill: 'Skriv det du vil huske',
    titlePlaceholder: 'La stå tom for å bruke standardtittel',
    saveCta: 'Opprett notat',
    loadCustomersError: 'Kunne ikke laste kunder. Prøv igjen om litt.',
    createCustomerError: 'Kunne ikke opprette kunde. Prøv igjen.',
  },
  dashboardNoteShareDialog: {
    modalTitle: 'Gi en kollega tilgang.',
    modalKicker: 'del notat',
    lockedIntro:
      'Deling av notater krever Team-plan eller høyere. På Team kan du gi enkeltkolleger tilgang til et notat eller hele møtet, med eller uten kommentar-rettighet.',
    seePlansCta: 'Se planer',
    intro: 'Hva får kollegaen se? Du kan endre dette når som helst.',
    recipientLabel: 'kollega',
    removeRecipientAria: 'Fjern {name}',
    recipientPlaceholder: 'Skriv et navn…',
    scopeLegend: 'tilgangsnivå',
    scopeBookingLabel: 'Med møte',
    scopeBookingDesc:
      'Kollegaen ser alle notatene på dette møtet, samt navn, tidspunkt og møtelenke. Tilgangen gjelder kun dette møtet, ikke kundens andre møter eller historikk. Møtet dukker opp under deres Møter.',
    scopeBookingFoot: 'for samarbeid før møtet, eller når noen tar over for deg',
    scopeEntryLabel: 'Kun notat',
    scopeEntryDesc:
      'Kollegaen ser notatet, men ikke kundens navn, tidspunkt eller møtelenken. Notatet finnes kun under Notater → Delt med meg.',
    scopeEntryFoot: 'for sparring eller andre øyne uten å eksponere kunden',
    authorNoteLabel: 'Beskjed (valgfri)',
    authorNotePlaceholder:
      'Fortell hva du vil ha hjelp med, slik at mottakeren ikke åpner notatet uten kontekst.',
    charsLeftHint: '{n} tegn igjen',
    canCommentLabel: 'Kan kommentere',
    canCommentHint: 'Du blir varslet om svar.',
    shareCta: 'Del notat',
    expiryLabel: 'varighet',
    expiry7d: '7 dager',
    expiry30d: '30 dager',
    expiry90d: '90 dager',
    expiryNever: 'Til du fjerner den',
    footerNoteEntry: 'kunden ser ikke at notatet er delt',
    footerNoteBooking: 'møtetilgangen gjelder inntil du fjerner den',
    footerNoteBookingUntil: 'møtetilgangen utløper {date}',
  },
  dashboardNotesEntryForm: {
    suggestionPrep: 'Forberedelser',
    suggestionNotes: 'Notater',
    suggestionFollowUp: 'Oppfølging',
    newNote: 'Nytt notat',
    chooseTemplate: 'Eller velg en mal:',
    titleLabel: 'Tittel (valgfri)',
    titlePlaceholder: 'F.eks. Forberedelser',
    bodyLabel: 'Notat',
    bodyPlaceholder: 'Skriv hva som ble diskutert, hva du forbereder, eller hva du følger opp på.',
    saveNote: 'Lagre notat',
  },
  dashboardPollSetup: {
    allowVoting: 'Tillat stemming på tider',
    hint: 'Velg minst to tider. Den første blir forslaget ditt.',
    starHint: 'Trykk stjernen for å velge hvilken tid som er forslaget.',
    deadlineHint: 'Hører du ingenting innen fristen, velges forslaget automatisk.',
    allowAfterHours: 'Tillat utenfor arbeidstid',
    loadingSlots: 'henter ledige tider…',
    pickTimes: 'velg tider',
    busyTitle: 'Opptatt: {label}',
    busyAriaLabel: '{time}, opptatt: {label}',
    busyHint: 'Nedtonede tider er opptatt for én eller flere deltakere.',
    emptyBody: 'Ingen ledige tider denne dagen. Velg en annen dato.',
    deadlineLabel: 'Frist for å stemme (valgfritt)',
  },
  dashboardPollStatusPanel: {
    kicker: 'Avstemning · {status}',
    turnoutNone: 'Ingen deltakere ennå',
    turnoutAllVoted: 'Alle har stemt ({total})',
    turnoutCount: '1 deltaker | {total} deltakere',
    voteLead: 'Si fra hvilke tidspunkter som passer for deg.',
    voteLeadHostLocks: ' Verten låser den endelige tiden.',
    voteSaved: 'Stemmen din er lagret.',
    voteUpdateCta: 'Oppdater stemmen',
    voteSaveCta: 'Lagre stemmen',
    emptyBody: 'Ingen stemmer ennå.',
    markWinner: 'valgt',
    markLeading: 'leder',
    countWorks: '{count} passer',
    countDoesnt: '{count} passer ikke',
    lockTimeCta: 'Lås tid',
    hideWho: 'Skjul hvem',
    showWho: 'Vis hvem',
    whoLabelWorks: 'Passer',
    whoLabelDoesnt: 'Passer ikke',
    participantFallback: 'Deltaker',
    pendingSection: 'forslag til godkjenning',
    approveCta: 'Godkjenn',
    rejectCta: 'Avvis',
    pillCommitted: 'tid valgt',
    committedMoved: 'Møtet ble flyttet til {time} etter avstemningen.',
    committedLocked: 'Tidspunktet er låst. Deltakerne har fått en bekreftelse.',
    statusCommitted: 'tid valgt',
    statusCancelled: 'avbrutt',
    statusExpired: 'utløpt',
    statusOpen: 'åpen for stemming',
  },
  portalActionPoints: {
    title: 'Mine oppgaver',
    open: 'Å gjøre',
    completed: 'Fullført',
    loading: 'Henter oppgavene dine …',
    empty: 'Du har ingen oppgaver her ennå.',
    loadError: 'Kunne ikke hente oppgavene dine. Prøv igjen.',
    saveError: 'Kunne ikke lagre endringen. Prøv igjen.',
    retry: 'Prøv igjen',
    meeting: 'Møte',
    due: 'Frist {date}',
    noDeadline: 'Ingen frist',
    completedOn: 'Fullført {date}',
    complete: 'Merk som fullført',
    reopen: 'Åpne igjen',
    completeLabel: 'Merk «{text}» som fullført',
    reopenLabel: 'Åpne «{text}» igjen',
  },
  dashboardPrepNotePad: {
    defaultTitle: 'Forberedelser',
    liveEditorLabel: 'Under møtet',
    saveError: 'Notatet ble ikke lagret. Endringene dine er fortsatt her. Prøv igjen.',
    retrySave: 'Prøv igjen',
    unsavedChangesConfirm: 'Notatet har ulagrede endringer. Vil du forlate siden og forkaste dem?',
    grantErrorWithReason: 'Kunne ikke gi tilgang: {reason}',
    grantError: 'Kunne ikke gi tilgang. Prøv igjen.',
    titlePlaceholder: 'Tittel (valgfri)',
    editorPlaceholder:
      'Skriv spørsmål, kontekst og hva du vil ut av møtet. Bruk knappene over for overskrifter, lister og sitater.',
    count: '{words} ord · {chars} tegn',
    conflictStatus: '⚠ ny versjon ble lagret andre steder, last på nytt',
    readonlyStatus: 'bare for lesing',
    savingStatus: 'lagrer …',
    savedStatus: 'lagret automatisk',
    emptyStatus: 'tom',
    loading: 'Henter notater…',
  },
  dashboardPrepProTip: {
    ariaLabel: 'Tips',
    label: 'Tips!',
  },
  dashboardPriorMeetingsCard: {
    title: 'Tidligere med {name}',
    defaultMeetingTitle: 'Møte',
    withConsultant: 'med {name}',
    seeAllHistory: 'Se hele {name}s historikk',
    meetingCount: '1 tidligere møte | {n} tidligere møter',
    today: 'i dag',
    yesterday: 'i går',
    daysAgo: '1 dag siden | {n} dager siden',
    weeksAgo: '1 uke siden | {n} uker siden',
    monthsAgo: '1 mnd siden | {n} mnd siden',
    yearsAgo: '1 år siden | {n} år siden',
  },
  dashboardRescheduleOrCancelModal: {
    title: 'Endre eller avlyse',
    chooseAction: 'Velg handling',
    tabReschedule: 'Flytt møtet',
    tabMode: 'Bytt møteform',
    tabLocation: 'Endre møtested',
    tabReassign: 'Bytt rådgiver',
    tabCancel: 'Avlys',
    newDate: 'Ny dato',
    chooseTime: 'Velg tid',
    allowOffHours: 'Tillat utenfor arbeidstid',
    loadingSlots: 'Henter ledige tider …',
    noSlotsAnyHours: 'Ingen ledige tider denne dagen. Velg en annen dato.',
    noSlotsWorkHours:
      'Ingen ledige tider innenfor arbeidstid. Slå på «utenfor arbeidstid» eller velg en annen dato.',
    offHoursNote: 'Noen av disse tidene kan ligge utenfor dine vanlige arbeidstider.',
    emailHint: 'Sendes med i e-posten om endringen.',
    messageToCustomer: 'Melding til kunden',
    messageToParticipants: 'Melding til deltakerne',
    modeToday: 'I dag',
    modeSwitchesTo: 'Bytter til',
    modeOffice: 'på kontoret',
    modeVideo: 'video',
    customer: 'Kunden',
    modeNotice: '{name} får en e-post om at møteformen er endret.',
    modeNoticeVideo: 'En video-lenke opprettes automatisk og legges ved.',
    modeNoticeOffice: 'Adressen står på bookingsiden deres.',
    locationNotice:
      '{name} får e-post med det nye møtestedet og en fersk lenke. Tilkoblede kalendere oppdateres automatisk.',
    locationLabel: 'Møtested',
    messageToCustomerOptional: 'Melding til kunden (valgfritt)',
    reassignNotice:
      'Møtet overføres til en annen rådgiver. Begge rådgivere får beskjed, og kunden beholder samme tidspunkt og lenke.',
    reassignEmpty: 'Ingen andre rådgivere å overføre til.',
    chooseAdvisor: 'Velg rådgiver',
    cancelNotice: '{name} får e-post om at møtet er avlyst. Ingen avgift trekkes.',
    cancelReasonLabel: 'Grunn (valgfritt, vises i e-posten)',
    cancelReasonPlaceholder: 'Skriv noe kort og menneskelig…',
    rescheduleCta: 'Flytt og varsle',
    modeCta: 'Bytt til {mode}',
    locationCta: 'Lagre møtested',
    reassignCta: 'Overfør møtet',
    cancelCta: 'Avlys og varsle',
    kicker: 'møte · {date} {time}',
    scopeLabel: 'Velg omfang',
    scopeSingle: 'Bare dette møtet',
    scopeSeries: 'Hele serien',
    seriesRescheduleNote:
      'Alle gjenstående møter i serien flyttes like mye som dette møtet. Møter som allerede har vært, røres ikke.',
    seriesConflictIntro: 'Disse tidspunktene er ikke ledige, så ingenting ble flyttet:',
    seriesConflictPast: 'tilbake i tid',
    seriesConflictUnavailable: 'opptatt',
    seriesCancelNotice:
      '{name} får e-post om at resten av serien er avlyst. Møter som allerede har vært, røres ikke.',
    seriesRescheduleCta: 'Flytt serien og varsle',
    seriesCancelCta: 'Avlys serien og varsle',
  },
  dashboardRescheduleProposalBanner: {
    resolveError: 'Kunne ikke svare på forslaget. Prøv igjen.',
  },
  dashboardSMSCreditsBanner: {
    eyebrowEmpty: 'tom for sms',
    eyebrowLow: 'lite sms igjen',
    titleEmpty: 'Du er tom for SMS',
    titleLow: 'Snart tom for SMS, {balance} igjen',
    meta: 'Påminnelser på e-post sendes som vanlig. Kjøp flere for å fortsette med SMS.',
    cta: 'Kjøp SMS',
  },
  dashboardSeriesBadge: {
    // Visible text. "3 av 8" only when the loaded list provably holds every
    // occurrence; otherwise the numberless form, never an invented total.
    counted: '{n} av {total}',
    plain: 'serie',
    // Spoken text — the visible form is meaningless without the row around it.
    countedAria: 'Møte {n} av {total} i en gjentakende serie',
    plainAria: 'Del av en gjentakende serie',
  },
  dashboardServiceColorPicker: {
    label: 'Farge',
  },
  // Betalingsvilkår per tjeneste (#1191). Bare konfigurasjon i denne
  // versjonen — ingenting trekkes fra kunden ennå.
  stripeConnect: {
    heading: 'Betalinger',
    lede: 'Koble Stemne til Stripe så du kan ta betalt fra kundene dine. Ingenting trekkes ennå.',
    loading: 'Henter status',
    loadError: 'Kunne ikke hente betalingsstatusen.',
    connectError: 'Kunne ikke starte oppkoblingen mot Stripe.',
    refreshError: 'Kunne ikke oppdatere statusen fra Stripe.',
    dashboardError: 'Kunne ikke åpne Stripe-oversikten.',
    disconnectError: 'Kunne ikke koble Stripe fra Stemne.',
    refreshedToast: 'Statusen er oppdatert',
    returnIncomplete: 'Oppkoblingen ble ikke fullført. Du kan fortsette der du slapp.',
    disconnectedHeading: 'Stripe er frakoblet',
    disconnectedNote:
      'Stemne har stoppet nye betalinger. Den tidligere kontoen, saldoen og betalingshistorikken din finnes fortsatt i Stripe. Koble til på nytt for fremtidige betalinger.',
    disconnectedToast: 'Stripe-kontoen er frakoblet. Nye betalinger er stoppet.',
    disconnectedByOperatorToast: 'Stripe er koblet fra Stemne. Nye betalinger er stoppet.',
    chargesLabel: 'Kan ta imot betaling',
    payoutsLabel: 'Kan få utbetalinger',
    detailsLabel: 'Oppkobling fullført',
    on: 'Ja',
    off: 'Nei',
    submitted: 'Fullført',
    notSubmitted: 'Ikke fullført',
    vippsLabel: 'Vipps',
    vipps: {
      not_requested: 'Ikke aktivert',
      pending: 'Til behandling',
      active: 'Aktiv',
    },
    vippsNote: 'Krever forhåndstilgang hos Stripe.',
    neverSynced: 'Statusen er ikke hentet fra Stripe ennå.',
    payoutNote:
      'Du styrer utbetalinger, refusjoner og innsigelser i Stripe-oversikten. Stripe håndterer saldoen og eventuelle beløp som må kreves inn etter avtalen du har med Stripe.',
    // Sits under payoutNote: utbetaling, refusjon and innsigelse are the
    // three things the annex actually governs, and this is the only
    // operator surface that mentions them.
    termsLink: 'Vilkår for Betaling ved booking',
    readyNote: 'Betaling ved booking er på. Du velger betalingsmåte per tjeneste under {services}.',
    servicesLink: 'Tjenester',
    // Fallback only: shown when Stripe has card payments off and told us
    // nothing about why. Every case where Stripe DID say why gets one of the
    // four sentences below instead, because "noe" is not something an
    // operator can act on.
    pendingNote: 'Stripe mangler fortsatt noe fra deg før du kan ta betalt.',
    // One sentence per thing the operator actually does about it. The last
    // clause of each is the action, and the four actions are deliberately
    // different — providing information, waiting, and two different reasons
    // to talk to Stripe.
    disabledReason: {
      requirements_due:
        'Stripe mangler opplysninger fra deg før du kan ta betalt. Du fyller dem ut i Stripe-oversikten.',
      pending_verification:
        'Stripe går gjennom opplysningene dine. Du trenger ikke gjøre noe mens de holder på.',
      restricted:
        'Stripe har stoppet kortbetaling for kontoen din. Det er bare Stripe som kan åpne den igjen, så ta kontakt med dem.',
      unsupported:
        'Stripe støtter ikke denne virksomheten eller selskapsformen for kortbetaling. Ta kontakt med Stripe hvis du mener det er feil.',
    },
    requirementsDeadline: 'Fristen er {date}.',
    connectCta: 'Koble til Stripe',
    resumeCta: 'Fortsett hos Stripe',
    reconnectCta: 'Koble til Stripe på nytt',
    refreshCta: 'Oppdater status',
    dashboardCta: 'Åpne Stripe-oversikten',
    disconnectCta: 'Koble fra Stripe',
    disconnectTitle: 'Koble Stripe fra Stemne?',
    disconnectBody: 'Stemne slutter å bruke denne Stripe-tilkoblingen for nye betalinger.',
    disconnectWarningPayments: 'Nye betalinger via Stemne stoppes med en gang.',
    disconnectWarningAccount:
      'Stripe-kontoen, saldoen og betalingshistorikken din blir ikke slettet.',
    disconnectWarningReconnect:
      'Hvis du kobler til igjen senere, oppretter Stemne en ny tilkobling.',
    disconnectConfirm: 'Koble fra',
  },
  // Angrerett-varselet for en tjeneste med pris som Stemne ikke tar imot penger
  // for. Ordlyden er gjennomgått juridisk — «Ansvaret for tjenesten er fortsatt
  // ditt» er bærende og må ikke fjernes eller mykes opp, og ingenting her skal
  // antyde at etterlevelsen er «ordnet» hvis operatøren slår på betaling.
  // Stemne henter inn opplysningen og samtykket; ansvaret flytter seg ikke.
  serviceAngrerettNotice: {
    title: 'Du tar betalt utenfor Stemne',
    body1:
      'Når du setter en pris og fakturerer selv, er det du som skal opplyse kunden om angreretten, og du som må innhente uttrykkelig samtykke hvis møtet starter før angrefristen er ute. Stemne henter ikke inn det samtykket for deg i dag.',
    body2:
      'Tar du betalt gjennom Stemne, gjør vi begge delene: opplysningen følger med i bekreftelsen, og samtykket hentes inn i bestillingen. Ansvaret for tjenesten er fortsatt ditt.',
    enableCta: 'Slå på betaling',
    readMoreCta: 'Les om angrerett',
  },
  servicePaymentConfig: {
    heading: 'Betaling',
    // Shown in place of the terms when the org does not hold the add-on. One
    // sentence on what it does, then either a way in or who can act. No price
    // here on purpose — the panel it links to owns that number, and repeating
    // it is a second place to forget when it changes.
    teaser: 'Du kan ta betalt eller be om depositum når kunden bestiller time.',
    teaserLink: 'Se tillegg',
    teaserOwnerOnly: 'Eieren av kontoen kan legge det til.',
    // "og når", not "når de booker": «Betaling etterpå» charges nothing at
    // booking, so a hint that only asks about booking time reads as a
    // contradiction of the mode right below it.
    hint: 'Hva kunden betaler for denne tjenesten, og når. Ingenting trekkes ennå.',
    loading: 'Henter betalingsvilkår',
    loadError: 'Kunne ikke hente betalingsvilkårene.',
    saveError: 'Kunne ikke lagre betalingsvilkårene.',
    savedToast: 'Betalingsvilkårene er lagret',
    saveCta: 'Lagre betaling',
    priceLabel: 'Pris på tjenesten',
    priceValue: '{price} kr',
    priceFree: 'gratis',
    modeLabel: 'Betalingsmåte',
    modeNone: 'Ingen betaling',
    modeDeposit: 'Depositum',
    modeFull: 'Full betaling',
    modeAfter: 'Betaling etterpå',
    modeAfterHint:
      'Ingenting trekkes ved booking. Når møtet er holdt, ber vi kunden om hele prisen på e-post.',
    // No unit in the label any more — the unit is its own control beside the
    // field, and a label that says "(kr)" next to a selector set to prosent is
    // two answers to the same question.
    depositLabel: 'Depositum',
    // Two pairs, and which one shows depends on payments.post-service. The
    // "utenfor Stemne" half was true for the whole life of the deposit feature
    // and stopped being true the moment #3063 shipped — an org that collects
    // the remainder must not be told nobody does.
    depositHint: 'Hele kroner. Resten gjør dere opp utenfor Stemne.',
    depositHintPct: 'Prosent av prisen. Resten gjør dere opp utenfor Stemne.',
    depositHintCollected: 'Hele kroner. Resten kreves inn etter at møtet er holdt.',
    depositHintPctCollected: 'Prosent av prisen. Resten kreves inn etter at møtet er holdt.',
    depositUnitLabel: 'Enhet',
    depositUnitKr: 'Kroner',
    depositUnitPct: '% av prisen',
    // The percentage made concrete. Shown under the field, so it reads as a
    // consequence of what was just typed rather than as a second instruction.
    depositResolved: 'Blir {amount} kr av {price} kr.',
    vatLabel: 'Mva',
    vatUnntatt: 'Unntatt helsetjeneste',
    vatStandard: '25 % mva',
    vatHint: 'Helsetjenester er unntatt mva. Rådgivning og trening er 25 %.',
    priceIncludesVatLabel: 'Prisen inkluderer mva',
    priceIncludesVatHint: 'Slå av hvis prisen du har satt er eksklusive mva.',
    // "Når Stemne tar betalt", not "ved betaling ved booking": «Betaling
    // etterpå» charges price_kr just as unscaled as the booking-time modes do,
    // only later, so the rule covers it too. Same wording as the backend's own
    // 400 for the same reason.
    priceIncludesVatLockedHint: 'Når Stemne tar betalt, må prisen være inkludert mva.',
    errorNeedsPrice:
      'Tjenesten må ha en pris over 0 kroner før du kan kreve betaling. Sett en pris først.',
    errorDepositRequired: 'Sett et depositumsbeløp.',
    errorDepositInteger: 'Skriv beløpet i hele kroner, uten mellomrom eller desimaler.',
    errorDepositAbovePrice: 'Depositumet kan ikke være høyere enn prisen.',
    errorDepositPctInteger: 'Skriv prosenten som et helt tall, uten desimaler.',
    errorDepositPctRange: 'Depositumet må være mellom 1 og 100 prosent.',
  },
  dashboardServiceEditModal: {
    offeringSaveError: 'Kunne ikke lagre. Prøv igjen.',
    addTypeError: 'Kunne ikke legge til typen.',
    kindSamtale: 'Samtale',
    kindBehandling: 'Behandling',
    kindTrening: 'Trening',
    offeringsPartialSaveError:
      'Tjenesten ble opprettet, men noen av valgene for hvem som tilbyr den ble ikke lagret.',
    saveError: 'Kunne ikke lagre tjenesten.',
    deleteError: 'Kunne ikke slette tjenesten.',
    titleEdit: 'Rediger tjeneste',
    titleNew: 'Ny tjeneste',
    kindGroupAria: 'Type tjeneste',
    kindEdit: 'Endre kategori',
    tabsAria: 'Tjeneste-innstillinger',
    tabDetails: 'Detaljer',
    tabAvailability: 'Tilgjengelighet',
    // Singular, matching servicePaymentConfig.heading — one panel, one word.
    tabPayment: 'Betaling',
    tabNotifications: 'Varsler',
    nameLabel: 'Navn',
    namePlaceholder: 'Introsamtale',
    descriptionLabel: 'Beskrivelse',
    descriptionPlaceholder: 'Hva slags møte er dette?',
    durationLabel: 'Varighet (min)',
    videoDurationHint: 'Videomøter kan vare i opptil {max} minutter med abonnementet ditt.',
    videoDurationError: 'Velg en varighet på {max} minutter eller mindre for videomøter.',
    bufferLabel: 'Buffer (min)',
    priceLabel: 'Pris (kr)',
    freeToggleLabel: 'Gratis tjeneste (skjul prisfelt på siden)',
    actionTemplatesLabel: 'oppfølgingspunkter',
    actionTemplatesHint:
      'Hvert punkt blir en oppgave på den ansvarlige rådgiveren når noen booker denne tjenesten.',
    actionTemplateTextPlaceholder: 'Hva må gjøres etterpå',
    actionTemplateTagPlaceholder: 'merkelapp',
    actionTemplateDuePlaceholder: 'dager',
    actionTemplateRemove: 'Fjern punkt',
    actionTemplateAdd: 'Legg til punkt',
    modeLabel: 'Hvor',
    modeVideo: 'Video',
    modeOffice: 'På kontoret',
    modeBoth: 'Begge deler',
    addressLabel: 'Adresse',
    addressHint: 'Adressen møtet skjer på. Fysiske møter bruker denne som standard.',
    locationDetailsLabel: 'Beskjed til kunden om stedet',
    locationDetailsPlaceholder: 'Storgata 14, 2. etg. Ring på dørklokka.',
    locationDetailsHint: 'Detaljer kunden trenger for å finne fram, etasje, dørkode, parkering.',
    colleagueInviteLabel: 'La kunden invitere kolleger',
    colleagueInviteDesc: 'Vises som «Inviter kolleger» på møteoversikten kunden får tilsendt.',
    requiresAckLabel: 'Krev at kunden bekrefter beskrivelsen',
    requiresAckDesc:
      'Kunden må lese beskrivelsen og huke av «jeg har lest og forstått» før bookingen kan fullføres.',
    groupCapacityLabel: 'Gruppestørrelse',
    groupCapacityHint:
      'Antall plasser hvis dette er en gruppesamtale. La stå tom for et vanlig 1:1-møte.',
    activeLabel: 'Synlig for kunder',
    activeDesc:
      'Når tjenesten er synlig, kan kunder bestille den. Databehandleravtalen må være godkjent før du kan ta imot bestillinger.',
    privacyLabel: 'Privat møte',
    privacyDesc:
      'Når på, ser bare verten (og admin etter eksplisitt åpning) detaljer. Standard: av, alle kollegaer kan se.',
    turnaroundLabel: 'Stelletid (min)',
    turnaroundHint: 'Mellom møter, rommet ryddes, hender vaskes.',
    practitionerKindLabel: 'Behandlertype',
    treatmentTypeSearchPlaceholder: 'Søk eller legg til',
    treatmentTypeCreateLabel: 'Legg til',
    seriesLengthLabel: 'Antall behandlinger i en serie',
    seriesLengthPlaceholder: 'f.eks. 6',
    seriesLengthHint:
      'Planlagt lengde på et forløp, vist som «Behandling N av M» på møtekortet. Ikke et klippekort, og teller ikke betalte timer. La stå tom for å skjule totalen.',
    trainingTypeLabel: 'Treningstype',
    offeringsLabel: 'Hvem tilbyr denne',
    offeringsHint: 'Alle tilbyr denne tjenesten. Fjern dem som ikke skal.',
    availabilityDesc:
      'Bestem hvor langt frem kunder kan booke, og hva som skjer hvis de flytter eller avlyser nær møtetidspunktet.',
    maxLeadLabel: 'Hvor langt frem kan kunder booke?',
    maxLead1Week: '1 uke',
    maxLead2Weeks: '2 uker',
    maxLead1Month: '1 måned',
    maxLead3Months: '3 måneder',
    maxLead6Months: '6 måneder',
    maxLead1Year: '1 år',
    maxLeadNone: 'Ingen grense',
    maxLeadHint: 'Standard er 3 måneder. «Ingen grense» lar kunder booke så langt frem de vil.',
    leadHoursLabel: 'Varsel ved sen endring (timer før)',
    leadHoursPlaceholder: 'La stå tom for standard (24 timer)',
    leadHoursHint:
      'Du blir varslet hvis kunden endrer eller avlyser nærmere enn dette. La stå tom for standard på 24 timer. Sett 0 for å skru av.',
    lateChangeWeekendsLabel: 'Tell med helger',
    lateChangeWeekendsDesc:
      'Av: helger teller ikke med, så «24 timer» betyr én arbeidsdag. På: mål ren klokketid inkludert helger.',
    lateWarningLabel: 'Tekst kunden ser ved sen endring',
    lateWarningPlaceholder: 'Avlysning under 24 timer faktureres som vanlig time.',
    lateWarningHint: 'Vises når kunden flytter eller avlyser innenfor varslingstiden over.',
    rescheduleApprovalLabel: 'Endring av tidspunkt',
    rescheduleInherit: 'Følg standardinnstillingen',
    rescheduleRequire: 'Krev godkjenning (kunden foreslår)',
    rescheduleAllow: 'Tillat direkte endring',
    rescheduleApprovalHint:
      'Når godkjenning kreves, flytter ikke kunden møtet selv, de sender et forslag du godkjenner. Gruppemøter går alltid via forslag.',
    notifyConfirmationLabel: 'Send bekreftelse til kunde',
    notifyConfirmationDesc:
      'Sender en bekreftelse på e-post med møtelenke når kunden booker. Anbefales på, så kunden har lenken til møtet.',
    notifyReminderEmailLabel: 'Send påminnelse 24 timer før',
    notifyReminderEmailDesc: 'Sender automatisk en e-post med møtelenke 24 timer før møtet.',
    notifyReminderSmsLabel: 'Send SMS-påminnelse 24 timer før',
    notifyReminderSmsDesc:
      'Sender SMS 24 timer før møtet når kunden har lagt inn telefonnummer. Krever SMS-tillegget og at du har SMS igjen.',
    deleteCta: 'Slett',
    createCta: 'Opprett',
    deleteConfirmTitle: 'Slett tjenesten?',
    deleteConfirmBody:
      'Eksisterende møter beholdes. Tjenesten blir borte fra bookingsiden umiddelbart.',
    deleteConfirmCta: 'Slett tjenesten',
    conflictIntro:
      'Disse møtene ligger så tett at de ikke lenger får plass med de nye innstillingene. Du må flytte eller avlyse dem manuelt etter at du har lagret.',
    conflictConfirmCta: 'Lagre likevel',
  },
  dashboardServiceOfferingsMatrix: {
    title: 'Hvem tilbyr hva',
    intro: 'Kryss av hvem som kan tildeles hver tjeneste. Alle tilbyr alt som standard.',
    loading: 'Laster …',
    emptyServices: 'Det finnes ingen tjenester ennå.',
    soloOperator:
      'Du er den eneste rådgiveren, så du tilbyr alle tjenester. Når teamet vokser, styrer du fordelingen her.',
    advisorHeader: 'Rådgiver',
    cellAriaLabel: '{operator} tilbyr {service}',
    zeroCoverageWarning: 'ingen tilbyr denne tjenesten. Møter blir stående uten rådgiver.',
    saveError: 'Kunne ikke lagre. Prøv igjen.',
  },
  dashboardStatusPill: {
    confirmed: 'bekreftet',
    pending: 'venter',
    cancelled: 'avlyst',
    rescheduled: 'flyttet',
    expired: 'utløpt',
    completed: 'gjennomført',
    noShow: 'ikke møtt',
    unresolved: 'uavklart',
  },
  dashboardSubscriptionStatusCard: {
    trialPeriod: 'Prøveperiode',
    lastDay: 'Siste dag',
    oneDayLeft: '1 dag igjen',
    daysLeft: '{n} dager igjen',
    trialOver: 'Prøveperioden er over',
    paymentDue: 'Betaling forfalt',
    paused: 'Pauset',
    ended: 'Avsluttet',
    inTrial: 'i prøveperioden',
    trialUntil: 'til {date}',
    noPaymentMethod: 'ingen betalingsmåte',
    updatePaymentMethod: 'oppdater betalingsmåte',
    choosePlan: 'velg plan',
  },
  dashboardTrialBanner: {
    trialingNoDays: 'Velg en plan før prøveperioden tar slutt.',
    trialingLastDay: 'Siste dag av prøveperioden.',
    trialingDaysLeft: '1 dag igjen av prøveperioden. | {n} dager igjen av prøveperioden.',
    trialExpired: 'Prøveperioden er over. Velg en plan for å gjenoppta booking.',
    pastDue: 'Betalingen ble avvist. Oppdater betalingsmåte for å unngå avbrudd.',
    paused: 'Abonnementet er pauset. Bookingsiden er skjult for kunder.',
    canceled: 'Abonnementet er avsluttet.',
    ctaChoosePlan: 'Velg plan',
    ctaUpdatePayment: 'Oppdater betalingsmåte',
    ctaResume: 'Gjenoppta',
  },
  dashboardWelcomeModal: {
    modalTitle: 'Velkommen til Stemne',
    kicker: 'Velkommen til Stemne',
    greeting: 'Hyggelig å ha deg her, {name}.',
    greetingNoName: 'Hyggelig å ha deg her.',
    lead: 'Siden din er klar. Herfra holder du oversikt over møter, kunder og notater, alt på ett sted. Det er stille akkurat nå; det fyller seg etter hvert som folk booker.',
    dpaLead:
      'Før kunder kan bestille, må virksomheten godta databehandleravtalen. Du kan fortsatt utforske dashboardet.',
    inviteTitle: 'Inviter teammedlemmer',
    inviteDesc: 'Få rådgiverne dine om bord, så kan dere dele møter og notater.',
    helpPrefix: 'Står du fast? Innom',
    helpLink: 'hjelpesidene',
    helpMiddle: ', eller skriv til oss på',
    helpSuffix: ', vi svarer som folk.',
    footerNote: 'Du får korte oppstartse-poster. Du kan skru dem av under Varslinger.',
    acceptDpaCta: 'Godta avtalen og åpne siden',
    viewDpaCta: 'Se avtalen',
    shareCta: 'Del siden din',
  },
  billingAddonCard: {
    pillActive: 'Aktiv',
    pillIncluded: 'Inkludert',
    pillTrial: 'Prøveperiode',
    pillRequiresPayment: 'Betaling kreves',
    pillAvailable: 'Tilgjengelig',
    pillRequiresVekst: 'Krever Vekst',
    pillUnavailable: 'Ikke tilgjengelig',
    etaSoon: 'snart',
    pillComing: 'Kommer {eta}',
    // Three price forms, picked from the Stripe Price's tax_behavior.
    // The suffix-less priceLabel is the one for "unspecified": Stripe
    // never recorded the convention, so the card claims nothing.
    priceLabel: '{sign}{price} kr / mnd',
    priceLabelInclVat: '{sign}{price} kr / mnd inkl. mva',
    priceLabelExclVat: '{sign}{price} kr / mnd eks. mva',
    tierVekst: 'Vekst',
    tierTeam: 'Team',
    tierPlan: 'planen',
    activateAria: 'Aktiver {name}',
    deactivateAria: 'Deaktiver {name}',
    // Only rendered for add-ons that carry a termsPath — today that is
    // «Betaling ved booking» alone (useAddons.ADDON_CATALOG).
    termsLink: 'Les vilkårene',
    updating: 'Oppdaterer …',
    tryInTrial: 'Prøv i prøveperioden',
    paymentRequired: 'Kjøp krever betaling først',
    includedIn: 'Inngår i {tier}',
    switchToVekst: 'Bytt til Vekst for å aktivere',
    pilotOnly: 'Åpnes for pilotkunder først',
    notifyMe: 'Varsle meg',
    willNotify: 'Vi gir beskjed',
    cancelTitle: 'Deaktivere {name}?',
    cancelBody: 'Tillegget deaktiveres med en gang. Ubrukt tid godskrives på neste faktura.',
    cancelConfirm: 'Deaktiver tillegg',
    cancelKeep: 'Behold tillegg',
  },
  billingBillingAddonsPanel: {
    kicker: 'tillegg',
    title: 'Utvid abonnementet uten å bytte plan',
    sub: 'Legg til funksjoner på toppen av planen din. Endringer belastes pro-rata fra i dag.',
    noActiveAddons: 'Ingen aktive tillegg.',
    planSub: 'Planen din: {plan}.',
    planLineWithPrice: '{name}, {price} kr / mnd',
    activeAddonsCount: '{count} aktive tillegg.',
    totalPerMonth: '+{total} kr / mnd',
  },
  billingBillingCancelModal: {
    title: 'Avslutte abonnementet?',
    ledeBefore: 'Du beholder full tilgang ut perioden, frem til',
    ledeAfter: '. Etter det fryses kontoen i 30 dager før data slettes.',
    reasonLegend: 'Hvorfor? (valgfritt, men hjelper oss)',
    reasonTooExpensiveName: 'For dyrt',
    reasonTooExpensiveDesc: 'Prisen passer ikke akkurat nå.',
    reasonNotUsingEnoughName: 'Bruker det ikke nok',
    reasonNotUsingEnoughDesc: 'Får ikke verdien jeg håpet på.',
    reasonMissingFeaturesName: 'Mangler funksjoner',
    reasonMissingFeaturesDesc: 'Trenger noe Stemne ikke har.',
    reasonSwitchingToolsName: 'Bytter til et annet verktøy',
    reasonSwitchingToolsDesc: 'Fant noe som passer bedre.',
    reasonOtherName: 'Annet',
    reasonOtherDesc: 'Forteller deg gjerne hva, i tekstboksen.',
    noteLabel: 'Detaljer',
    notePlaceholder: 'Hva burde vi vite? Vi leser hver tilbakemelding.',
    deflectHeading: 'Bare borte en stund?',
    deflectBody:
      'Pause kan være en bedre løsning, du beholder oppsettet, kalenderen pauses, og du kan starte igjen når som helst.',
    pauseInsteadCta: 'Pause i stedet →',
    confirmCta: 'Avslutt {date}',
    cancelSuccess: 'Abonnementet avsluttes {date}',
    cancelError: 'Kunne ikke avslutte abonnement.',
  },
  billingBillingCycleNote: {
    invoiceSentTo: 'faktura sendes til',
    cycleKicker: 'faktureringssyklus',
    monthly: 'Månedlig',
    yearly: 'Årlig',
    prorationNote: 'Stripe regner ut pro-rata og viser deg beløpet før du bekrefter.',
    vatKicker: 'moms',
    vatNote: 'Trekkes fra på fakturaen ved gyldig orgnr.',
    switchToYearly: 'Bytt til årlig',
    switchToMonthly: 'Bytt til månedlig',
  },
  billingBillingHeroCard: {
    hintPortal:
      'Åpner Stripes kundeportal i ny fane. Bytt plan, oppdater kort, eller hent fakturaer.',
    hintTrial: 'Velg en plan i tabellen under. Du kan bytte når som helst.',
    metaFirstCharge: 'første belastning',
    metaAccessExpires: 'tilgang utløper',
    metaNextAttempt: 'neste forsøk',
    metaPaused: 'pauset',
    metaEnded: 'avsluttet',
    metaNextCharge: 'neste belastning',
    subUpdatePaymentMethod: 'oppdater betalingsmåte',
    subNoChargesOngoing: 'ingen belastninger pågående',
    subDataDeleted30Days: 'data slettes etter 30 dager',
    subDataDeletedSoon: 'data slettes om kort tid',
    priceAuto: '{price} for planen alene · auto',
    currentPlan: 'nåværende plan',
    users: 'brukere',
    paymentMethod: 'betalingsmåte',
    change: 'endre',
    noPaymentMethod: 'Ingen betalingsmåte lagt til',
  },
  billingContext: {
    planPriceOnly: '{price} for planen alene',
    priceMonthly: '{price} kr / mnd eks. mva',
    priceYearly: '{price} kr / år eks. mva',
    pillTrial: 'Prøveperiode',
    pillLockedInTrial: 'Aktivert',
    pillActive: 'Aktiv',
    pillPaymentPending: 'Behandler',
    pillPaymentFailed: 'Betaling feilet',
    pillPastDueFinal: 'Siste varsel',
    pillPaused: 'Pauset',
    pillCanceledGrace: 'Avsluttes',
    pillCanceledGraceDate: 'Avsluttes {date}',
    pillCanceledEnded: 'Avsluttet',
    pillTrialEnded: 'Prøveperiode utløpt',
    trialDaysLeftNone: 'mindre enn én dag igjen',
    trialDaysLeft: '{n} dag igjen | {n} dager igjen',
    subtitleTrialWithDate: 'Velg en plan før {date}, eller fortsett — vi minner deg på det.',
    subtitleTrialNoDate: 'Velg en plan når du er klar.',
    subtitleLockedInTrial: '{price} · gratis frem til {date}',
    subtitleActive: '{price} · neste belastning {date}',
    subtitlePaymentPending: '{price} · belastning er sendt',
    subtitleAccessUntil: '{price} · tilgang frem til {date}',
    subtitlePaymentFailedNoDate: '{price} · oppdater betalingsmåte for å unngå avbrudd',
    subtitleAccessEnds: '{price} · tilgangen avsluttes {date}',
    subtitleAccessEndsSoon: '{price} · tilgangen avsluttes snart',
    subtitlePaused: '{price} · pauset',
    subtitleCanceledEnded: 'Velkommen tilbake. Velg en plan for å aktivere kontoen igjen.',
    subtitleTrialEndedNoPayment: 'Legg til betalingsmåte for å fortsette der du slapp.',
    ctaChoosePlan: 'Velg plan',
    ctaManagePayment: 'Administrer betaling',
    ctaCheckStatus: 'Sjekk status',
    ctaUpdatePayment: 'Oppdater betalingsmåte',
    ctaResume: 'Gjenoppta abonnement',
    ctaReopen: 'Gjenåpne abonnement',
    ctaExportData: 'Eksporter data',
    bannerPaymentPendingTitle: 'Vi venter på bekreftelse fra banken.',
    bannerPaymentPendingBody:
      'Vanligvis tar dette under et minutt. Bankoverføringer kan ta opp til 3 virkedager. Du trenger ikke gjøre noe.',
    bannerPaymentFailedTitle: 'Betalingen ble avvist.',
    bannerPaymentFailedBody:
      'Vi prøver igjen automatisk de neste dagene. Oppdater betalingsmåte for å unngå avbrudd i tjenesten.',
    bannerPastDueTitle: 'Vi har prøvd å trekke beløpet flere ganger.',
    bannerPastDueBodyGate:
      'Tilgangen avsluttes hvis betalingen ikke går gjennom. Etter det får kundene dine «booking ikke tilgjengelig» når de besøker siden.',
    bannerPastDueBodyNoGate: 'Tilgangen avsluttes hvis betalingen ikke går gjennom.',
    bannerPausedTitle: 'Abonnementet er pauset.',
    bannerPausedBodyGate:
      'Bookingsiden din er skjult for kunder. Eksisterende møter står; ingen nye kan bestille før du gjenopptar.',
    bannerPausedBodyNoGate: 'Eksisterende møter står. Du blir ikke fakturert før du gjenopptar.',
    bannerCanceledGraceTitle: 'Tilgangen din varer ut perioden.',
    bannerCanceledGraceAutoDeleteDate:
      'Etter {date} blir kontoen frosset i 30 dager før den slettes. Du kan gjenåpne abonnementet når som helst i mellomtiden.',
    bannerCanceledGraceAutoDeleteNoDate:
      'Etter perioden er ute blir kontoen frosset i 30 dager før den slettes. Du kan gjenåpne abonnementet når som helst i mellomtiden.',
    bannerCanceledGraceKeepDate:
      'Etter {date} fryses kontoen, og dataene dine beholdes trygt. Du kan gjenåpne abonnementet når som helst.',
    bannerCanceledGraceKeepNoDate:
      'Etter perioden er ute fryses kontoen, og dataene dine beholdes trygt. Du kan gjenåpne abonnementet når som helst.',
    bannerCanceledEndedAutoDeleteTitle: 'Data slettes om kort tid.',
    bannerCanceledEndedAutoDeleteBody:
      'Vi holder kunde-, møte- og fakturadata i 30 dager etter avslutning. Eksporter alt som CSV før det.',
    bannerCanceledEndedKeepTitle: 'Dataene dine er trygt lagret.',
    bannerCanceledEndedKeepBody:
      'Vi tar vare på kunde-, møte- og fakturadata til du gjenåpner kontoen eller ber oss slette dem. Du kan når som helst eksportere alt som CSV.',
    bannerTrialEndedTitleDate: 'Prøveperioden tok slutt {date}.',
    bannerTrialEndedTitle: 'Prøveperioden er over.',
    bannerTrialEndedBodyGate:
      'Bookingsiden din er skjult for kunder, men alle dataene står som de var. Aktiver en plan for å gjenoppta normal drift.',
    bannerTrialEndedBodyNoGate:
      'Alle dataene dine står som de var. Aktiver en plan for å gjenoppta normal drift.',
  },
  billingBillingInvoiceHistory: {
    kicker: 'fakturaer',
    title: 'Faktureringshistorikk',
    searchPlaceholder: 'Søk fakturanr, beløp, måned',
    searchAriaLabel: 'Søk i fakturaer',
    colDate: 'dato',
    colNumber: 'nummer',
    colAmount: 'beløp',
    colStatus: 'status',
    amount: '{amount} kr',
    retry: 'Prøv igjen ↗',
    downloadPdf: 'Last ned PDF ↓',
    statusPaid: 'Betalt',
    statusOpen: 'Åpen',
    statusDraft: 'Utkast',
    statusVoid: 'Annullert',
    statusUncollectible: 'Mislykket',
  },
  billingBillingInvoicesPanel: {
    summaryAria: 'Faktureringsdetaljer',
    kickerPaymentMethod: 'betalingsmåte',
    noneAdded: 'Ingen lagt til',
    change: 'Endre →',
    addCard: 'Legg til kort →',
    kickerBillingEmail: 'faktura sendes til',
    kickerBillingCycle: 'faktureringssyklus',
    kickerVat: 'mva',
    vatValue: '25 %, Norge',
    vatSub: 'Trekkes fra på fakturaen ved gyldig orgnr.',
    pauseSubscription: 'Pause abonnement',
    cancelSubscription: 'Avslutt abonnement',
    cycleYearly: 'Årlig',
    cycleMonthly: 'Månedlig',
    switchToMonthly: 'Bytt til månedlig →',
    switchToYearly: 'Bytt til årlig →',
  },
  billingBillingPauseModal: {
    ledeGated:
      'Bookingsiden din skjules for kunder; eksisterende møter står. Du blir ikke fakturert mens du er pauset, og oppsettet ditt er klart når du gjenopptar.',
    lede: 'Eksisterende møter står. Du blir ikke fakturert mens du er pauset, og oppsettet ditt er klart når du gjenopptar.',
    reasonLessToDoName: 'Mindre å gjøre nå',
    reasonLessToDoDesc: 'Stille periode, kommer tilbake.',
    reasonVacationName: 'Ferie / sabbatical',
    reasonVacationDesc: 'Borte i noen uker.',
    reasonRevisitingName: 'Vurderer endringer',
    reasonRevisitingDesc: 'Tenker på plan eller oppsett.',
    reasonOtherName: 'Annet',
    reasonOtherDesc: 'Skriv gjerne litt mer.',
    duration1Month: '1 måned',
    duration3Months: '3 måneder',
    durationIndefinite: 'Til jeg gjenopptar',
    pausedToast: 'Abonnementet er pauset.',
    pauseError: 'Kunne ikke pause abonnement.',
    title: 'Pause abonnementet?',
    reasonLegend: 'Hvorfor? (valgfritt, men hjelper oss)',
    noteLabel: 'Detaljer',
    notePlaceholder: 'Hva burde vi vite?',
    durationLabel: 'Hvor lenge?',
    pauseCta: 'Pause abonnementet',
  },
  billingBillingPaymentChip: {
    card: 'Kort',
    balance: 'Saldo',
    otherMethod: 'Annen betalingsmåte',
  },
  billingBillingPlanPanel: {
    soloFeature1: '1 bruker',
    soloFeature2: 'Krypterte møtenotater',
    soloFeature3: 'Kalenderkoblinger (Google, Apple, Outlook)',
    soloFeature4: 'Norsk fakturering med MVA',
    teamFeature1: 'Inntil 5 brukere',
    teamFeature2: 'Del krypterte notater med kolleger',
    teamFeature3: 'Rådgiver-rolle på inviterte brukere',
    teamFeature4: 'Egen avsenderadresse (e-post)',
    vekstFeature1: 'Inntil 15 brukere',
    vekstFeature2: 'Revisjonslogg',
    vekstFeature3: 'API-tilgang (kjøp som tillegg)',
    vekstFeature4: 'Prioritert support',
    cycleMonthly: 'Månedlig',
    cycleYearly: 'Årlig − 17%',
    availablePlansKicker: 'tilgjengelige planer',
    availablePlansTitle: 'Velg størrelsen som passer',
    billingCycleAria: 'Faktureringsperiode',
    allPlansLabel: 'På alle planer:',
    allPlansBody: 'Krypterte møtenotater og kalenderkoblinger (AES-256).',
  },
  billingBillingPlanTable: {
    availablePlansKicker: 'tilgjengelige planer',
    title: 'Velg størrelsen som passer',
    yearlyHint: 'spar opptil {pct}%',
    colPlan: 'plan',
    colPrice: 'pris',
    colUsers: 'brukere',
    contactUs: 'Kontakt oss',
    priceYearly: '{amount} kr / år',
    priceMonthly: '{amount} kr / mnd',
    trialFree: '3 måneder gratis',
    included: 'inkludert',
    yearlyInvoiceSoon: 'Årlig faktura kommer snart',
    subYearlySaving: 'tilsvarer {monthly} kr / mnd · spar {pct}% mot månedlig',
    subYearlyNoVat: 'tilsvarer {monthly} kr / mnd · eks. mva',
    subMonthly: 'eks. mva · faktureres månedlig',
    perYearShort: 'år',
    perMonthShort: 'mnd',
    deltaUp: '+{amount} kr / {suffix}',
    deltaDown: '−{amount} kr / {suffix}',
    upgradeTo: 'Oppgrader til {plan}',
    switchTo: 'Bytt til {plan}',
    seatsUnlimited: 'Ubegrenset',
    seatsOne: '1 bruker',
    seatsMany: 'Inntil {n} brukere',
    currentBadge: 'nåværende',
    unavailableNow: 'Ikke tilgjengelig nå',
    onAllPlansKicker: 'på alle planer',
    featureEncryptedNotes: 'Krypterte møtenotater og kalenderkoblinger (AES-256)',
    plansSoloTeamVekst: 'Solo · Team · Vekst',
    featuresPerPlanKicker: 'funksjoner per plan',
    featureShareNotes: 'Del krypterte notater med kolleger',
    featureInviteColleagues: 'Inviter kolleger til selskapet',
    featureCustomerPicks: 'Kunden velger person eller bare tid',
    featureAdvisorRole: 'Rådgiver-rolle på inviterte brukere',
    featureCustomSender: 'Egen avsenderadresse (e-post)',
    featureAuditLog: 'Revisjonslogg',
    featureApiAccess: 'API-tilgang',
    plansTeamVekst: 'Team · Vekst',
    plansVekst: 'Vekst',
    foot: 'Bytte trer i kraft umiddelbart. Ved oppgradering belaster vi en pro-rata-andel av forskjellen i dag; ved nedgradering trekkes overskuddet fra neste regning.',
    pauseSubscription: 'Pause abonnement',
    cancelSubscription: 'Avslutt abonnement',
  },
  billingDowngradeReassignModal: {
    title: 'Hvem tar over kundene?',
    kicker: 'nedgradering · steg 2 av 2',
    lede: 'Hver av disse mister tilgang ved periodeslutt. Velg hvem som overtar de kommende møtene deres. Notater beholder forfatteren, ingenting skrives om.',
    rowLabel: 'Hvem tar over kundene til {name}?',
    confirmCta: 'Planlegg nedgradering',
    autoDistribute: 'Fordel automatisk',
  },
  billingDowngradeSelectionModal: {
    title: 'Hvem mister tilgang?',
    kicker: 'nedgradering · steg 1 av 2',
    lede: '{plan} gir plass til {cap} brukere. Dere er {count}. Velg {surplus} som mister tilgang ved periodeslutt. Du bestemmer hvem som tar over kundene deres i neste steg.',
    toggleLabel: 'Velg {name}',
    countRemaining: 'Velg {n} til',
    countOver: 'Fjern {n}',
    countReady: 'Klar',
  },
  billingPlanCard: {
    contactUs: 'Kontakt oss',
    priceYearly: '{amount} kr / år',
    priceMonthly: '{amount} kr / mnd',
    trialFree: '3 måneder gratis',
    included: 'inkludert',
    yearlyInvoiceSoon: 'Årlig faktura kommer snart',
    exVatYearly: 'eks. mva · faktureres årlig',
    exVatMonthly: 'eks. mva · faktureres månedlig',
    seatsUnlimited: 'Ubegrenset brukere',
    seats: '1 bruker | Inntil {n} brukere',
    upgradeTo: 'Oppgrader til {name}',
    switchTo: 'Bytt til {name}',
    unitYear: 'år',
    unitMonth: 'mnd',
    deltaUp: '+{amount} kr / {unit}',
    deltaDown: '−{amount} kr / {unit}',
    recommended: 'Anbefalt',
    currentPlan: 'Nåværende plan',
  },
  brandingBrandingProfilePanel: {
    previewFallbackName: 'din side',
    logoNotRegistered: 'Logoen ble lastet opp, men ble ikke registrert. Prøv igjen.',
    logoUpdated: 'Logoen er oppdatert',
    settingsSaved: 'Innstillingene er lagret',
    saveFailed: 'Kunne ikke lagre. Prøv igjen.',
    logoLabel: 'logo',
    logoHint: 'PNG, JPEG, WebP eller SVG. Raster minst 128×128 piksler, maks 10 MB.',
    displayNameLabel: 'Visningsnavn',
    displayNameHint: 'Vises sammen med logoen i toppen av bookingsiden.',
    modeLegend: 'Hvordan velger kunden hvem de booker med?',
    modePooledName: 'Vi setter dem opp',
    modePooledDescription: 'Kunden velger tjeneste og tid. Vi tildeler personen automatisk.',
    modeChooseName: 'La kunden velge person eller bare tid',
    modeChooseDescription:
      "Etter at kunden har valgt tjeneste viser vi en skjerm der de kan velge en konkret person, eller 'spiller ingen rolle' for neste ledige.",
    modePickFirstName: 'La kunden velge person først',
    modePickFirstDescription:
      'Kunden velger først hvem de vil snakke med, deretter tjeneste og tid.',
    previewKicker: 'forhåndsvisning',
    poweredBy: 'drevet av stemne',
    previewHeading: 'Book et møte med {name}.',
    previewSubPickFirst: 'Velg hvem du vil snakke med.',
    previewSubChoose: 'Velg en tjeneste. Så velger du person eller bare tid.',
    previewSubPooled: 'Vi setter deg opp med en av oss.',
    previewSubSolo: 'Velg en tjeneste og finn en ledig tid.',
    saveCta: 'Lagre endringer',
  },
  brandingMeetingPanel: {
    loading: 'Laster møtebakgrunnene …',
    lede: 'Velg bakgrunner for nye videomøter. De vises bare i møterommet, ikke på bookingsiden. Eksisterende videorom endres ikke.',
    roomLabel: 'bakgrunn i møterommet',
    roomHint: 'PNG, minst 1400 piksler bred, maks 600 kB. Ligger bak videobildet.',
    knockLabel: 'bakgrunn på venteskjermen',
    knockHint:
      'PNG, minst 1400 piksler bred, maks 600 kB. Vises mens kunden venter på å slippes inn.',
    clearCta: 'Fjern bildet',
    roomClearCta: 'Fjern bakgrunnen i møterommet',
    knockClearCta: 'Fjern bakgrunnen på venteskjermen',
    roomSaved: 'Bakgrunnen brukes i nye møterom',
    knockSaved: 'Bakgrunnen brukes på venteskjermen i nye møterom',
    cleared: 'Bildet er fjernet for nye møterom',
    clearFailed: 'Kunne ikke fjerne bildet. Prøv igjen.',
    notRegistered: 'Bildet ble lastet opp, men ble ikke registrert. Prøv igjen.',
    loadFailed: 'Kunne ikke laste møtebakgrunnene.',
    fallbackNote: 'Uten eget bilde bruker møtet standardbakgrunnen fra videoleverandøren.',
  },
  brandingBrandingQrPanel: {
    title: 'QR-kode for siden din',
    desc: 'Last ned et A4-ark med QR-koden til bookingsiden din. Heng opp i\n        resepsjonen, lim på visittkort, eller del ut på arrangement.',
    previewAlt: 'QR-kode',
    sheetKicker: 'slik blir arket',
    layoutLegend: 'Antall per A4-ark',
    layoutSingleName: '1 stor',
    layoutSingleDesc: 'Én stor QR-kode midt på arket, for plakat eller oppslag.',
    layoutGrid4Name: '4 stk',
    layoutGrid4Desc: '2 × 2, gode visittkortstørrelser.',
    layoutGrid8Name: '8 stk',
    layoutGrid8Desc: '2 × 4, middels store, fyll ut og klipp opp.',
    layoutGrid12Name: '12 stk',
    layoutGrid12Desc: '3 × 4, for handouts og kort distribusjon.',
    downloadCta: 'Last ned PDF',
  },
  companyAvailabilityPanel: {
    hoursLabel: '{h} timer',
    daysLabel: '{d} dager',
    savedToast: 'Tilgjengeligheten er lagret',
    saveErrorToast: 'Kunne ikke lagre. Prøv igjen.',
    timezoneLabel: 'tidssone',
    timezoneHint: 'Kunder i andre tidssoner ser tidene konvertert automatisk.',
    noticeCardLabel: 'varsel og horisont',
    noticeLabel: 'Minste varsel før et møte',
    noticeHint: 'kunder kan ikke booke nærmere enn dette',
    horizonLabel: 'Hvor langt frem kan de booke?',
    rescheduleCardLabel: 'endring av tidspunkt',
    rescheduleToggleLabel: 'Krev godkjenning for endring av tidspunkt',
    rescheduleHint:
      'Når denne er på, flytter ikke kunden møtet selv. I stedet sender de et forslag du godkjenner eller avslår. Står den av, flytter kunden et 1:1-møte direkte. Gruppemøter går alltid via forslag.',
    continuityCardLabel: 'deling av behandlingshistorikk',
    continuityToggleLabel: 'Del behandlingshistorikk mellom behandlere',
    continuityHint:
      'Står den av, ser hver behandler bare sine egne tidligere økter med kunden: forrige notat, åpne oppfølgingspunkter og smerteregistrering. Slå den på hvis dere har felles journal og alle behandlere skal se hverandres historikk. Gjelder bare behandling. Trening og samtale deles alltid i teamet.',
  },
  companyBookingNotifyPanel: {
    saveSuccess: 'Varslingen er lagret',
    saveError: 'Kunne ikke lagre. Prøv igjen.',
    cardLabel: 'varsling ved nytt møte',
    toggleLabel: 'Varsle hele teamet ved nye møter',
    toggleHint:
      'Når denne er på, får hele teamet e-post og varsel om hvert nye møte. Står den av, varsles bare rådgiveren som får møtet. Et møte uten tildelt rådgiver varsler alltid hele teamet, så noen kan ta det.',
  },
  companyCompanyProfilePanel: {
    orgnrLabel: 'Organisasjonsnummer',
    orgnrHint: '9 sifre. Vi sender kvittering og fakturaer hit.',
    nameLabel: 'Foretaksnavn',
    nameHintFilled: 'Hentet fra Brønnøysundregisteret.',
    nameHintEmpty: 'Skriv inn organisasjonsnummer over så fyller vi inn navnet automatisk.',
    addressLabel: 'Forretningsadresse',
    addressHintFilled: 'Hentet fra Brønnøysundregisteret.',
    addressHintEmpty: 'Fylles inn fra Brønnøysundregisteret når organisasjonsnummer er gyldig.',
    naceLabel: 'Bransje (NACE)',
    subdomainLabel: 'Adressen din på stemne',
    subdomainHint: 'Endring av adresse er ikke støttet ennå, kontakt support.',
    invoiceEmailLabel: 'Faktura-e-post',
    invoiceEmailPlaceholder: "faktura{'@'}firma.no",
    invoiceEmailHint: 'Endrer ikke innloggings-e-post.',
    contactEmailLabel: 'Kontakt-e-post for kunder',
    contactEmailPlaceholder: "post{'@'}firma.no",
    contactEmailHint:
      'Denne vises til kundene dine, blant annet på angreskjemaet. Bruk en adresse du leser selv, ikke faktura-adressen.',
    publicToggleLabel: 'Offentlig profil',
    publicHintBefore: 'Når denne er på, kan hvem som helst booke deg på',
    publicHintAfter:
      '. Slå av hvis du kun vil ta imot kunder via private bookinglenker (f.eks. KAM-er, rekrutterere). Token-baserte lenker fortsetter å virke.',
    treatmentToggleLabel: 'Tilbyr du behandling?',
    treatmentHint:
      'Slå på hvis du er fysioterapeut, naprapat, fotterapeut eller lignende. Da kan du markere tjenester som behandling og få en tilpasset møteflate med plan-sjekkliste under selve økten. Lar du den stå av, er Stemne en samtalebookingsiden.',
    trainingToggleLabel: 'Tilbyr du trening eller coaching?',
    trainingHint:
      'Slå på hvis du er personlig trener, løpecoach eller lignende. Da kan du markere tjenester som trening og få en møteflate laget for økter, med øvelser og resultater. Eksisterende tjenester påvirkes ikke når du slår den av.',
    saveCta: 'Lagre endringer',
    dataCardLabel: 'databehandling',
    dataCardBody:
      'stemne lagrer kunde- og møtedata i EU (Frankfurt). Du kan laste ned alt under Eksporter data eller be om sletting når som helst.',
    saveSuccess: 'Innstillingene er lagret',
    saveError: 'Kunne ikke lagre. Prøv igjen.',
  },
  settingsAboutSectionEditor: {
    cropHint: 'Dra for å flytte, knip eller bruk hjulet for å zoome.',
    cropTitleImage: 'Beskjær bildet',
    cropEyebrowImage: 'bilde',
    cropTitlePortrait: 'Beskjær portrettet',
    cropEyebrowPortrait: 'portrett',
    cropEyebrowGallery: 'galleribilde',
    uploadNotRegistered: 'Opplastingen ble ikke registrert. Prøv igjen.',
    uploadFailed: 'Kunne ikke laste opp bildet. Prøv igjen.',
    readImageFailed: 'Kunne ikke lese bildet. Prøv en annen fil.',
    galleryFull: 'Galleriet rommer maks tre bilder.',
    galleryFullAddedFirst: 'Galleriet rommer maks tre bilder. La til de første.',
    cropFailed: 'Kunne ikke beskjære dette bildet. Last det opp på nytt.',
    saved: 'Om oss-seksjonen er lagret',
    saveFailed: 'Kunne ikke lagre. Prøv igjen.',
    title: 'Om oss på bookingsiden',
    lede: 'Fortell kundene hvem de møter. Fyll inn det som passer dere: kort tekst, et portrett, eller bilder fra hvor dere møtes. Vi velger layout etter det du har lagt inn.',
    preview: 'Forhåndsvis',
    kickerText: 'tekst',
    textTitle: 'Det kundene leser',
    textDesc: 'En overskrift og litt brødtekst er nok til å publisere. Resten er valgfritt.',
    headingLabel: 'Overskrift',
    headingHint: 'For eksempel «Litt om hvordan vi jobber».',
    ledeLabel: 'Inngang (valgfri)',
    ledeHint: 'Vises stort øverst når dere ikke har bilder.',
    bodyLabel: 'Brødtekst',
    bodyHint: 'Skill avsnitt med en blank linje.',
    kickerQuote: 'sitat',
    quoteTitle: 'En setning som sitter',
    quoteDesc: 'En valgfri ramme rundt noe som sier hvem dere er.',
    quoteLabel: 'Sitat (valgfri)',
    quoteByLabel: 'Sitatets opphav',
    quoteByHint: 'For eksempel «Hans-Kristian, asd as».',
    kickerDetails: 'detaljer',
    detailsTitle: 'En liten metalinje',
    credentialsLabel: 'Bunntekst (valgfri)',
    credentialsHint: 'Korte fakta, skilt med ·.',
    kickerImages: 'bilder',
    imagesTitle: 'Portrett eller galleri',
    imagesDesc:
      'Last opp ett portrett hvis du driver alene. Legger du til galleribilder, viser vi dem i stedet, og siden bytter til en bredere layout.',
    portraitLabel: 'portrett',
    portraitOpt: 'for solo',
    portraitHint:
      'PNG, JPEG eller WebP. Minst 512×512 piksler, maks 10 MB. Vi viser det stort ved siden av teksten.',
    portraitAlt: 'Portrett',
    crop: 'Beskjær',
    replace: 'Bytt',
    dropPortrait: 'Slipp et portrett',
    galleryLabel: 'galleri',
    galleryOpt: 'inntil tre',
    galleryHint:
      'Bilder fra kontoret eller en samtale. Galleriet erstatter portrettet på publikumssiden.',
    captionPlaceholder: 'Bildetekst',
    dropImage: 'Slipp et bilde',
    allSaved: 'Alt er lagret',
    saveCta: 'Lagre om-oss',
    closePreview: 'Lukk forhåndsvisning',
    previewEmpty: 'Fyll inn innhold for å se hvordan «Om oss» ser ut for kundene.',
  },
  settingsAuditLogTab: {
    kicker: 'aktivitetslogg',
    title: 'Hvem gjorde hva, og når',
    body: 'En kronologisk oversikt over innlogginger og endringer på arbeidsplassen. Aktiviteten lagres i minst 12 måneder.',
    columnTime: 'Tidspunkt',
    columnCategory: 'Kategori',
    columnActor: 'Utført av',
    columnEvent: 'Hendelse',
    tableAriaLabel: 'Aktivitet på arbeidsplassen',
    searchLabel: 'Søk i lastede hendelser',
    searchPlaceholder: 'navn, hendelse eller kategori …',
    shownCount: 'Viser {shown} av {loaded} lastede hendelser',
    clearFilters: 'Nullstill filtre',
    filterScope: 'Sortering og filtre gjelder bare hendelsene som er lastet inn i tabellen.',
    categoryLogin: 'Innlogging',
    categorySecurity: 'Sikkerhet',
    categoryTeam: 'Team',
    categoryMeeting: 'Møter',
    categoryWorkspace: 'Arbeidsplass',
    categoryOther: 'Annet',
    agFilterPlaceholder: 'Filtrer …',
    agEquals: 'Er lik',
    agNotEqual: 'Er ikke lik',
    agContains: 'Inneholder',
    agNotContains: 'Inneholder ikke',
    agStartsWith: 'Begynner med',
    agEndsWith: 'Slutter med',
    agBlank: 'Er tom',
    agNotBlank: 'Er ikke tom',
    agBefore: 'Før',
    agAfter: 'Etter',
    agAnd: 'OG',
    agOr: 'ELLER',
    agApply: 'Bruk',
    agReset: 'Nullstill',
    agClear: 'Tøm',
    agCancel: 'Avbryt',
    agNoRows: 'Ingen lastede hendelser samsvarer med filtrene.',
    loadError: 'Kunne ikke laste aktivitetsloggen.',
    actionPasskeyRegister: 'registrerte en passnøkkel',
    actionPasskeyRegisterMagicLinkGrace: 'bekreftet passnøkkelregistreringen via innloggingslenke',
    actionPasskeyLogin: 'logget inn med passnøkkel',
    actionPasskeyDelete: 'fjernet en passnøkkel',
    actionPasskeyResetTarget: 'nullstilte passnøklene til {target}',
    actionPasskeyReset: 'nullstilte en passnøkkel',
    actionSessionsRevokedAll: 'logget ut alle sesjonene',
    actionAdminRoleChangedTarget: 'endret rollen til {target} til {role}',
    actionAdminRoleChanged: 'endret en rolle til {role}',
    newRoleFallback: 'ny rolle',
    actionAdminSuspendedTarget: 'suspenderte {target}',
    actionAdminSuspended: 'suspenderte en bruker',
    actionAdminReactivatedTarget: 'reaktiverte {target}',
    actionAdminReactivated: 'reaktiverte en bruker',
    actionAdminRemovedTarget: 'fjernet {target}',
    actionAdminRemoved: 'fjernet en bruker',
    actionAdminInvitedWithRole: 'inviterte {email} som {role}',
    actionAdminInvited: 'inviterte {email}',
    actionAdminInvitedGeneric: 'sendte en invitasjon',
    actionAdminInvitationRoleChangedWithRole: 'endret rollen på en invitasjon til {role}',
    actionAdminInvitationRoleChanged: 'endret rollen på en invitasjon',
    actionAdminInvitationDeleted: 'trakk tilbake en invitasjon',
    actionBookingCreatedForCustomer: 'opprettet møte for {email}',
    actionBookingCreatedForCustomerGeneric: 'opprettet et møte for en kunde',
    actionBookingModeOffice: 'endret møteform til kontor',
    actionBookingModeVideo: 'endret møteform til video',
    actionBookingModeChanged: 'endret møteform',
    actionBookingsClaimed: 'tok {count} møte | tok {count} møter',
    actionBookingsClaimedGeneric: 'tok møter',
    actionBookingsDistributed: 'fordelte {count} møte på teamet | fordelte {count} møter på teamet',
    actionBookingsDistributedGeneric: 'fordelte møter på teamet',
    actionBrandUpdatedFields: 'endret selskap ({fields})',
    actionBrandUpdated: 'endret selskap',
    fieldCity: 'sted',
    unknownOperator: 'Ukjent operatør',
    emptyBody: 'Ingen aktivitet enda. Når noen logger inn eller endrer noe, dukker det opp her.',
    loadMore: 'Last flere',
    loadingList: 'Henter aktivitetsloggen …',
  },
  settingsBillingTab: {
    refreshStateError: 'Kunne ikke hente status. Prøv igjen.',
    subscriptionResumed: 'Abonnementet er gjenopptatt',
    resumeError: 'Kunne ikke gjenoppta abonnementet. Prøv igjen.',
    subscriptionReopened: 'Abonnementet er gjenåpnet',
    reopenError: 'Kunne ikke gjenåpne abonnementet. Prøv igjen.',
    subtabPlan: 'Plan',
    subtabTillegg: 'Tillegg',
    subtabFakturering: 'Fakturering',
    loadError: 'Kunne ikke laste abonnement.',
    subscriptionActivated: 'Abonnementet er aktivert',
    confirmingPurchase:
      'Vi bekrefter kjøpet ditt. Last siden på nytt om denne meldingen blir hengende.',
    purchaseCancelled: 'Du avbrøt kjøpet. Ingen endringer er gjort.',
    smsPurchaseSuccess: 'Takk. SMS-ene legges til kontoen din straks.',
    checkoutError: 'Kunne ikke starte kjøp.',
    cycleYear: 'år',
    cycleMonth: 'mnd',
    pricePerCycle: '{price} kr / {cycle}',
    seatsUnlimited: '{used} · Ubegrenset',
    seatsUsed: '{used} av {purchased}',
    seatsTrial: '{used} bruker | {used} brukere',
    invoicesEmptyTitle: 'Ingen fakturaer ennå',
    invoicesEmptyTrialTitle: 'Ingen fakturaer ennå.',
    invoicesEmptyTrialSub: 'Første kommer {date} når prøveperioden går over til betalt plan.',
    invoicesEmptyLockedTitle: 'Første faktura er klar.',
    invoicesEmptyLockedSub:
      'Sendes {date} når prøveperioden går over. Stripe regner ut pro-rata og viser deg beløpet før du bekrefter.',
    invoicesEmptySub: 'Når første betaling er gjennomført dukker fakturaen opp her med PDF-lenke.',
    title: 'Abonnement',
    lede: 'Hvilken plan du er på, tilleggene du har lagt til, og fakturering.',
    nextBillKicker: 'neste regning',
    nextBillExplanation: 'Inkluderer planen, aktive tillegg, eventuelle justeringer og mva.',
    subtabsAriaLabel: 'Underfaner for abonnement',
    downgradePendingKicker: 'planlagt endring',
    downgradePendingTitle: 'Nedgradering til {plan} er planlagt',
    downgradePendingBody: 'Endringen trer i kraft {date}. Frem til da har alle tilgang som før.',
    downgradeCancelCta: 'Avbryt nedgradering',
    downgradeCancelTitle: 'Avbryt nedgraderingen',
    downgradeCancelBody:
      'Dere blir på planen dere har nå, og ingen mister tilgang. Du kan planlegge nedgradering til {plan} på nytt senere.',
    downgradeCancelConfirm: 'Avbryt nedgraderingen',
    downgradeCancelDismiss: 'Lukk',
    downgradeStaged: 'Nedgraderingen er planlagt og trer i kraft {date}.',
    downgradeCancelled: 'Nedgraderingen er avbrutt.',
    downgradeAlreadyPending:
      'Dere har allerede en planlagt nedgradering. Avbryt den før du planlegger en ny.',
    downgradeMembersError: 'Kunne ikke hente brukerlisten. Prøv igjen.',
  },
  settingsBrandingTab: {
    subtabProfil: 'Profil',
    subtabQr: 'QR-kode',
    subtabOmOss: 'Om oss',
    subtabMoterom: 'Møterom',
    title: 'Profil & booking',
    lede: 'Slik ser kundene siden din: logo, navn på arbeidsplassen, hvordan møter bestilles, og hva du forteller om dere.',
    subtabsAriaLabel: 'Underfaner for profil og booking',
  },
  settingsCompanyTab: {
    tabSelskap: 'Selskap',
    tabTilgjengelighet: 'Tilgjengelighet',
    tabVarsling: 'Bookingvarsler',
    tabMotesteder: 'Møtesteder',
    introTitle: 'Selskap',
    introLede: 'Selskapsinformasjon, tilgjengelighet, varsling og møtesteder.',
    subtabsAriaLabel: 'Underfaner for selskap',
  },
  settingsEditMemberModal: {
    saveError: 'Kunne ikke lagre. Prøv igjen.',
    fallbackTitle: 'Medlem',
    readonlySelf: 'Profilbildet, tittelen og presentasjonen din endrer du i Min konto.',
    readonlyOther:
      '{name} håndterer sin egen profil fra Min konto. Endringer her krever at de logger seg på selv.',
    titleLabel: 'Tittel',
    titleHint: 'Vises på den offentlige bookingsiden, f.eks. «Parterapeut».',
    titlePlaceholder: 'Ingen tittel satt',
    bioLabel: 'Kort presentasjon',
    bioHint: 'To til fire setninger om hva du tilbyr.',
    bioPlaceholder: 'Ingen presentasjon satt',
    resetPasskeysTitle: 'Tilbakestill passnøkler',
    resetPasskeysBody:
      'Fjerner alle passnøkler for {name}. De må sette opp nye ved neste innlogging.',
    resetPasskeysCta: 'Tilbakestill',
    roleLabel: 'Rolle',
    changeRoleCta: 'Endre rolle',
    servicesLabel: 'Tjenester',
    servicesHint: 'Velg hvilke tjenester {name} kan tildeles.',
    servicesLoading: 'Laster …',
    servicesEmpty: 'Det finnes ingen tjenester ennå.',
    reopenTitle: 'Gjenåpne tilgang',
    suspendTitle: 'Suspender tilgang',
    reopenBody: '{name} får tilgang til arbeidsplassen igjen, med samme rolle som før.',
    suspendBody:
      '{name} mister tilgang umiddelbart, men kontoen, møtene og notatene beholdes. Du kan gjenåpne når som helst.',
    reopenCta: 'Gjenåpne',
    suspendCta: 'Suspender',
    removeTitle: 'Fjern fra arbeidsplassen',
    removeBody:
      '{name} mister tilgang umiddelbart. Du blir bedt om en begrunnelse som havner i revisjonsloggen.',
    removeCta: 'Fjern bruker',
    editProfileCta: 'Rediger profil i Min konto',
  },
  settingsInviteUserModal: {
    title: 'Inviter brukere',
    emailLabel: 'E-post',
    emailHint: 'Adskill med komma eller linjeskift. Inntil 50 om gangen.',
    emailPlaceholder: "anna{'@'}firma.no, jonas{'@'}firma.no\nmari.berg{'@'}firma.no",
    roleForAll: 'Rolle for alle',
    roleGroupAria: 'Rolle',
    roleAdvisor: 'Rådgiver',
    roleAdmin: 'Administrator',
    roleOwner: 'Eier',
    roleHintOwner:
      'Eiere har full tilgang inkludert fakturering og branding. Velg dette kun for medeiere.',
    roleHintAdmin:
      'Administratorer kan håndtere møter, kunder, tjenester og team, men ikke fakturering.',
    roleHintAdvisor: 'Rådgivere ser kun egne møter og notater. Standardvalget for nye kolleger.',
    foundCount: '1 e-post funnet | {n} e-poster funnet',
    conflictSelf: ', du kan ikke invitere deg selv.',
    conflictTaken: ', er allerede invitert eller medlem.',
    sendCount: 'Send {n} invitasjon | Send {n} invitasjoner',
    sendCta: 'Send invitasjon',
  },
  settingsMeetingLocationsCard: {
    title: 'Møtesteder',
    lede: 'Adresser du møter kunder på. Brukes når du setter opp en tjeneste eller et møte.',
    loading: 'Laster møtesteder.',
    emptyBody: 'Du har ingen lagrede møtesteder ennå.',
    removeAriaLabel: 'Fjern møtested',
    nameLabel: 'Navn',
    namePlaceholder: 'Klinikken',
    addressLabel: 'Adresse',
    addCta: 'Legg til møtested',
    confirmRemoveTitle: 'Fjern møtested?',
    confirmRemoveBody:
      'Vil du fjerne {name} fra de lagrede møtestedene dine? Møter som allerede er booket her, beholder adressen sin.',
    nameTakenError: 'Det finnes allerede et sted med dette navnet',
    saveError: 'Kunne ikke lagre møtestedet. Prøv igjen.',
    removeError: 'Kunne ikke fjerne møtestedet. Prøv igjen.',
  },
  settingsReasonConfirmModal: {
    reasonLabel: 'Begrunnelse (synlig i revisjonsloggen)',
    reasonPlaceholder: 'Hvorfor gjør du dette? Skriv noen ord til loggen.',
    tooLong: 'Begrunnelsen er for lang.',
    charCount: '{count} / {max} tegn',
  },
  settingsSecurityTab: {
    introTitle: 'Sikkerhet',
    introBefore:
      'stemne bruker passnøkler (WebAuthn / FIDO2) som eneste innloggingsmetode. Det finnes ingen passord å lekke, og phishing-sider kan ikke bruke nøklene fordi de er bundet til',
    coverageLabel: 'passnøkkel-dekning',
    coverageSubPrefix: 'brukere med minst én passnøkkel · totalt',
    activeKeys: 'aktiv nøkkel | aktive nøkler',
    loadingOverview: 'Henter oversikt…',
    allReadyBefore: 'Alle brukere er klare. Be hver enkelt om å legge til',
    allReadyEmphasis: 'minst',
    allReadyAfter:
      'én reserve under Min konto, det forhindrer å bli låst ute hvis en enhet blir borte.',
    missingPasskey: '{count} bruker mangler passnøkkel: | {count} brukere mangler passnøkkel:',
    completeSetupHint:
      'De fullfører oppsettet ved å klikke på invitasjonslenken og registrere en nøkkel.',
    sessionLengthLabel: 'Sesjonslengde',
    daysValue: '{count} dager',
    sessionLengthBody:
      'Brukere blir bedt om å bekrefte med passnøkkel etter {count} dager uten aktivitet, eller når de logger inn fra en ny enhet.',
    allowedDomainsLabel: 'Godkjente domener',
    allDomains: 'alle',
    allowedDomainsBody: 'Nye brukere må ha e-post på et godkjent domene.',
    noDomainRestrictionBody:
      'Det er ingen domenebegrensning. Sett dette under selskapsinnstillinger for å begrense hvem som kan inviteres.',
    loginLogsLabel: 'Innloggingslogger',
    last90Days: 'Sist 90 dager',
    loginLogsBody: 'Last ned en CSV med alle vellykkede og avbrutte forsøk.',
    logoutAllTitle: 'Logg ut alle umiddelbart',
    logoutAllBody:
      'Avslutter alle aktive sesjoner. Brukere må logge inn på nytt med passnøkkel. Bruk hvis du tror noen har fått uautorisert tilgang.',
    logoutAllCta: 'Logg ut alle',
    confirmTitle: 'Logg ut alle?',
    confirmBody:
      'Avslutter alle aktive sesjoner. Brukere må logge inn på nytt med passnøkkel. Dette logger også ut deg.',
    sessionsEnded: '{count} sesjoner avsluttet',
    logoutAllError: 'Kunne ikke logge ut alle.',
  },
  settingsSettingsSaveBar: {
    unsavedChanges: 'Ulagrede endringer',
    discard: 'Forkast',
  },
  settingsTreatmentTab: {
    title: 'Tiltak-chips',
    sub: 'Disse vises som hurtigknapper under behandlingen, for å logge hva du gjorde uten å skrive. Du kan endre, slette eller legge til når du vil.',
    dpaHeading: 'Godkjenn databehandleravtalen',
    dpaBody:
      'Tiltak-chips er sensitive helsedata (hva som gjøres med pasienten). For å ta dem i bruk må du godkjenne databehandleravtalen mellom organisasjonen din og Stemne. Da låses tiltak-chips og smerteskala opp.',
    dpaReadLink: 'Les hele databehandleravtalen',
    dpaAccepted: 'Databehandleravtalen er akseptert.',
    dpaDownloadPdf: 'Last ned som PDF',
    dpaUnlockCta: 'Godta og lås opp',
    addonRequiredHeading: 'Krever tillegget «Behandlingsjournal»',
    addonRequiredBody:
      'Databehandleravtalen er godtatt. Den kliniske journalen krever i tillegg abonnementstillegget «Behandlingsjournal», som foreløpig ikke er tilgjengelig for kjøp.',
    lockedHeading: 'Krever databehandleravtale.',
    lockedBody:
      'Tiltak-chips er sensitive helsedata (hva som gjøres med pasienten). De blir tilgjengelige når Stemne har signert databehandleravtalen med organisasjonen din. Inntil da kan du notere prosedyrer som vanlig tekst i «Plan for i dag» på selve behandlingen.',
    removeAria: 'Slett {label}',
    empty: 'Ingen tiltak enda. Legg til de du bruker oftest.',
    newLabel: 'Nytt tiltak',
    newPlaceholder: 'bløtdel, traksjon, tape …',
    addCta: 'Legg til',
    acceptModalTitle: 'Godta databehandleravtalen',
    acceptModalBody:
      'Ved å godta bekrefter du databehandleravtalen mellom organisasjonen din og Stemne. Les hele avtalen først. Etter aksept låses tiltak-chips og smerteskala opp.',
    acceptModalConfirm: 'Jeg godtar',
    acceptError: 'Kunne ikke lagre aksept. Prøv igjen.',
    dpaPartyLabel: 'Behandlingsansvarlig',
    dpaPartyNameOrgnr: '{name}, org.nr. {orgnr}',
    ownerOnly:
      'Bare eieren i virksomheten kan godta databehandleravtalen. Be eieren logge inn for å godta.',
    removeConfirm: 'Slett dette tiltaket? Historiske journaler beholder etiketten.',
  },
  settingsUsersTab: {
    title: 'Team',
    memberCount: '{n} medlem | {n} medlemmer',
    withPasskey: '{n} med passnøkkel',
    missingPasskey: '{n} mangler',
    pendingCount: '{n} venter på svar',
    inviteCta: '+ Inviter bruker',
    searchPlaceholder: 'Søk i teamet',
    colMember: 'medlem',
    colRole: 'rolle',
    colStatus: 'status',
    editAria: 'Endre {name}',
    copyEmailAria: 'Kopier e-postadresse {email}',
    statusSuspended: 'suspendert',
    statusActive: 'aktiv',
    statusMissing: 'mangler',
    awaitingReply: 'Venter på svar',
    statusInvited: 'invitert',
    resendTitle: 'Send invitasjon på nytt til {email}',
    resending: 'sender...',
    resend: 'send på nytt',
    deleteInviteTitle: 'Slett invitasjon til {email}',
    deleteInviteShort: 'slett',
    footnote: 'Brukere setter opp egne passnøkler under Min konto → Passnøkler.',
    emailCopied: 'Kopiert {email}',
    emailCopyFailed: 'Kunne ikke kopiere, er du på https?',
    seatsAvailable: '{n} ledig plass | {n} ledige plasser',
    seatPrompt: 'Du har {seats} på {plan}. Inviter kolleger fra teamet ditt.',
    inviteSentPartial: '{ok} sendt · {failed} feilet',
    invitesSent: '{n} invitasjon sendt | {n} invitasjoner sendt',
    seatCount: '{used} av {max}',
    seatsFullOwnerCount: 'Plassene er fulle ({count}). Oppgrader for å invitere flere.',
    seatsFullOwner: 'Plassene er fulle. Oppgrader for å invitere flere.',
    seatsFullAdminCount: 'Plassene er fulle ({count}). Spør eieren om å oppgradere.',
    seatsFullAdmin: 'Plassene er fulle. Spør eieren om å oppgradere.',
    inviteSendError: 'Kunne ikke sende invitasjonene. Prøv igjen.',
    roleChanged: 'Rollen til {name} er endret til {role}',
    roleChangeError: 'Kunne ikke endre rollen.',
    suspended: '{name} er suspendert',
    suspendError: 'Kunne ikke suspendere brukeren.',
    reactivated: '{name} har tilgang igjen',
    reactivateError: 'Kunne ikke gjenåpne tilgangen.',
    removed: '{name} er fjernet',
    removeError: 'Kunne ikke fjerne brukeren.',
    inviteResent: 'Invitasjon sendt på nytt til {email}',
    inviteResendError: 'Kunne ikke sende invitasjon på nytt.',
    inviteDeleted: 'Invitasjon for {email} slettet',
    inviteDeleteError: 'Kunne ikke slette invitasjonen.',
    passkeysReset: 'Passnøkler fjernet for {name}',
    passkeysResetError: 'Kunne ikke fjerne passnøkler.',
    roleModalTitle: 'Endre rolle?',
    roleModalBody: 'Endre rollen til {name} fra {from} til {to}?',
    roleModalConfirm: 'Endre rolle',
    removeModalTitle: 'Fjern bruker?',
    removeModalBody: 'Fjerne {name} fra arbeidsplassen? De mister tilgang umiddelbart.',
    removeModalConfirm: 'Fjern bruker',
    suspendModalTitle: 'Suspender tilgang?',
    suspendModalBody:
      'Suspendere {name}? De mister tilgang umiddelbart, men kontoen beholdes og kan gjenåpnes.',
    suspendModalConfirm: 'Suspender',
    reactivateModalTitle: 'Gjenåpne tilgang?',
    reactivateModalBody: 'Gi {name} tilgang til arbeidsplassen igjen, med samme rolle som før?',
    reactivateModalConfirm: 'Gjenåpne',
    deleteInviteModalTitle: 'Slett invitasjon?',
    deleteInviteModalBody:
      'Slette invitasjonen til {email}? Lenken i e-posten slutter å virke umiddelbart.',
    deleteInviteModalConfirm: 'Slett invitasjon',
    resetPasskeysModalTitle: 'Fjern passnøkler?',
    resetPasskeysModalBody:
      'Fjerne alle passnøkler for {name}? De må sette opp nye ved neste innlogging.',
    resetPasskeysModalConfirm: 'Fjern passnøkler',
    fabLabel: 'Inviter bruker',
  },
  closeActionPointPrompt: {
    title: 'Lukk oppfølgingspunkt?',
    lead: 'Du sendte {document} til {customer}. Vil du markere et oppfølgingspunkt som fullført, med dokumentet som bevis?',
    closeOne: 'Lukk med dokument',
    dismiss: 'Nei, senere',
    overduePrefix: 'forfalt {date}',
    closed: 'Oppfølgingspunktet er lukket.',
    closeError: 'Kunne ikke lukke oppfølgingspunktet. Prøv igjen.',
  },
  keepOwedPrompt: {
    title: 'Behold oppfølgingspunkter?',
    lead: 'Møtet med {customer} ble avlyst. Punktene under avsluttes automatisk. Vil du beholde noen som en løs oppfølging?',
    keepOne: 'Behold',
    dismiss: 'La dem utgå',
    overduePrefix: 'forfalt {date}',
    kept: 'Oppfølgingspunktet beholdes.',
    keepError: 'Kunne ikke beholde oppfølgingspunktet. Prøv igjen.',
  },
  reassignPointsField: {
    label: 'Overfør oppfølgingspunkter',
    unassigned: 'La dem stå uten eier',
    hint: 'Åpne oppfølgingspunkter flyttes til personen du velger. La stå tom for å frigjøre dem — da får de aktive kollegene beskjed.',
  },
  externalDone: {
    title: 'Marker oppgaven som fullført?',
    lead: '{org} har bedt deg bekrefte at en oppgave er gjort. Trykk på knappen når den er i orden.',
    cta: 'Marker som fullført',
    doneTitle: 'Takk',
    doneLead: 'Oppgaven er registrert som fullført. {org} får beskjed.',
    errorTitle: 'Lenken virker ikke',
    errorLead:
      'Denne lenken er ikke lenger gyldig. Ta kontakt med {org} hvis du fortsatt trenger å bekrefte oppgaven.',
  },
  customerDetailActivityFeed: {
    loading: 'Laster historikk ...',
    emptyBody: 'Ingen aktivitet ennå. Alt som skjer med kundens data vises her.',
    chipAll: 'alle',
    chipFiles: 'filer',
    chipNotes: 'notater',
    chipMeetings: 'møter',
    showOpens: 'Vis åpninger',
    noChanges: 'Ingen endringer ennå. Skru på «vis åpninger» for å se hvem som har sett på noe.',
    atTime: 'kl {time}',
    today: 'I dag',
    yesterday: 'I går',
    actionFileUploaded: 'lastet opp filen',
    actionFileShared: 'delte filen',
    actionFileRevoked: 'trakk tilbake filen',
    actionFileDeleted: 'slettet filen',
    actionFileOpened: 'åpnet filen',
    actionFileDownloaded: 'lastet ned filen',
    actionNoteCreated: 'skrev notatet',
    actionNoteEdited: 'endret notatet',
    actionNoteDeleted: 'slettet notatet',
    actionNoteViewed: 'åpnet notatet',
    actionMeetingOpened: 'åpnet møtet',
    actionMeetingSessionStopped: 'avsluttet møtet uten å markere det som gjennomført',
    actionMeetingSummarySent: 'sendte oppsummering',
    actionCustomerUpdated: 'endret kontaktinfo',
    actionActionPointCreated: 'opprettet oppfølgingspunkt',
    actionActionPointCompleted: 'fullførte oppfølgingspunkt',
    actionActionPointCancelled: 'avbrøt oppfølgingspunkt',
    actionActionPointReassigned: 'flyttet oppfølgingspunkt',
    proofManual: 'manuelt',
    proofClickToken: 'via påminnelse',
    proofFile: 'dokument sendt',
    actorCustomer: 'Kunden',
    actorSystem: 'Systemet',
    actorTeamMember: 'Et teammedlem',
  },
  customerDetailCustomerSearchModal: {
    title: 'Søk i {name}s historikk',
    searchPlaceholder: 'søk i {name}s historikk ...',
    categoryFacetAria: 'Filtrer dokumenter på kategori',
    facetAll: 'Alle',
    escKey: 'esc',
    hitSummary: '{count} treff hos {name}',
    searching: 'søker ...',
    noHits: 'ingen treff hos {name}',
    resultsLabel: 'Søkeresultater',
    notesInternal: 'aldri synlig for kunden',
    footerKeys: '↑↓ bla · ↵ åpne · esc lukk',
    footerInternal: 'notat-treff er synlige for teamet, ikke for kunden',
    noteFallbackTitle: 'Notat',
    openMeetingCta: 'Åpne møtet',
    openDocumentCta: 'Åpne dokumentet',
    openConversationCta: 'Åpne samtalen',
    sharedByYou: 'delt av deg',
    fromCustomer: 'fra {name}',
    fromYou: 'du',
    groupMeetings: 'møter',
    groupNotes: 'notater',
    groupDocuments: 'dokumenter',
    groupMessages: 'meldinger',
  },
  globalSearch: {
    title: 'Søk',
    triggerLabel: 'Søk',
    searchPlaceholder: 'Søk i møter, kunder, notater, tjenester, team og tagger …',
    searchPlaceholderMobile: 'Søk i alt …',
    placeholderPrefix: 'Søk etter',
    placeholderExamples: [
      'møte om oppfølging',
      'notater om skulder',
      'kunder med kostholdsplan',
      'kunde Ingrid Hansen',
      'dokument om trening',
      'notat om kosthold',
    ],
    escKey: 'esc',
    cancel: 'Avbryt',
    searching: 'søker …',
    errorGeneric: 'kunne ikke søke akkurat nå',
    resultsLabel: 'Søkeresultater',
    hitSummary: '{count} treff',
    noResultsFor: 'Ingen treff for «{query}». Prøv et navn, en tjeneste eller en tagg.',
    didYouMean: 'Mente du …?',
    noResultShortcuts: 'snarveier',
    seeAllCustomers: 'Se alle kunder',
    seeAllMeetings: 'Se alle møter',
    fallbackOpen: 'åpne',
    emptyHeading: 'Hva leter du etter?',
    recentLabel: 'nylig søkt',
    contextLabel: 'på denne siden',
    internalBadge: 'aldri synlig for kunden',
    footerKeys: '↑↓ bla · ↵ åpne · esc lukk',
    footerKeysMobile: '↵ åpne · trykk for detaljer',
    typeMoteLabel: 'møter',
    typeMoteKicker: 'møte',
    typeOppfolgingLabel: 'oppfølging',
    typeOppfolgingKicker: 'oppfølgingspunkt',
    typeKundeLabel: 'kunder',
    typeKundeKicker: 'kunde',
    typeNotatLabel: 'notater',
    typeNotatKicker: 'internt notat',
    typeMeldingLabel: 'meldinger',
    typeMeldingKicker: 'melding',
    messageFromYou: 'deg',
    typeAgendaLabel: 'agenda',
    typeAgendaKicker: 'agendapunkt',
    typeTjenesteLabel: 'tjenester',
    typeTjenesteKicker: 'tjeneste',
    typeRadgiverLabel: 'team',
    typeRadgiverKicker: 'rådgiver',
    typeTaggLabel: 'tagger',
    typeTaggKicker: 'tagg',
    typeDokumentLabel: 'dokumenter',
    typeDokumentKicker: 'dokument',
    actionOpenMeeting: 'åpne møtet',
    actionWriteNote: 'skriv notat',
    actionOpenPoint: 'åpne punktet',
    actionMarkDone: 'marker som gjort',
    actionOpenCustomer: 'åpne kunden',
    actionNewMeeting: 'nytt møte',
    actionOpenNote: 'åpne notatet',
    actionOpenMessage: 'åpne samtalen',
    actionOpenAgenda: 'åpne møtet',
    actionOpenService: 'åpne tjenesten',
    actionOpenProfile: 'åpne profilen',
    actionShowTagged: 'vis alt med taggen',
    actionOpenDocument: 'åpne dokumentet',
    cardMeetingsToday: 'møter i dag',
    cardNewCustomers: 'nye kunder',
    cardOverdue: 'forfalte punkter',
    cardUpcomingMeetings: 'kommende møter',
    cardPendingReply: 'venter på svar',
    cardWeekMeetings: 'møter denne uken',
    cardActiveServices: 'aktive tjenester',
    cardHiddenServices: 'skjulte tjenester',
    cardTotalCustomers: 'kunder totalt',
    previewEmptyTitle: 'Velg et treff',
    previewEmptyBody: 'Forhåndsvisningen viser detaljer uten at du forlater søket.',
    previewInternal: 'internt notat · aldri synlig for kunden',
    metaWhen: 'når',
    metaService: 'tjeneste',
    metaStatus: 'status',
    metaDue: 'frist',
    metaCustomer: 'kunde',
    metaRole: 'rolle',
    metaUsage: 'brukt',
  },
  customerDetailCustomerSearchPanel: {
    searching: 'Søker...',
    noResults: 'Ingen treff for «{query}».',
    resultsLabel: 'Søkeresultater',
    untitledNote: 'Notat',
    groupMeetings: 'Møter',
    groupNotes: 'Notater',
    groupDocuments: 'Dokumenter',
    groupMessages: 'Meldinger',
  },
  customerDetailDocumentDetailModal: {
    errLoadActivity: 'Kunne ikke laste aktivitet.',
    encryptedBadge: 'Kryptert',
    statusActive: 'aktiv',
    statusExpired: 'utløpt',
    statusRevoked: 'tilbakekalt',
    statusReceived: 'mottatt',
    directionOut: 'delt med',
    directionIn: 'mottatt fra',
    fileTypeSpreadsheet: 'Regneark',
    fileTypeDocument: 'Dokument',
    fileTypePresentation: 'Presentasjon',
    fileTypeImage: 'Bilde',
    policyView: 'Kun visning',
    policyDownload: 'Nedlasting',
    activityShared: 'Delt',
    activityNotified: 'Varslet på e-post',
    activityOpened: 'Åpnet',
    activityDownloaded: 'Lastet ned',
    activityRevoked: 'Tilgang trukket',
    activityExtended: 'Utløp forlenget',
    activityExpired: 'Utløpt',
    activityReceived: 'Mottatt fra kunde',
    activityPolicyChanged: 'Tilgang endret',
    actorCustomer: 'kunden',
    actorSystem: 'systemet',
    actorYou: 'du',
    activitySharedInvite: 'Delt i invitasjon',
    errOpenDocument: 'Kunne ikke åpne dokumentet.',
    confirmRevoke: 'Trekke tilbake delingen? Kunden mister tilgangen umiddelbart.',
    errRevoke: 'Kunne ikke trekke tilbake delingen.',
    fallbackTitle: 'Dokument',
    glyphFallback: 'DOC',
    rowExpiry: 'utløp',
    rowAccess: 'tilgang',
    activityHeading: 'aktivitet',
    activityLoading: 'Laster aktivitet…',
    activityEmpty: 'Ingen aktivitet registrert ennå.',
    revokeCta: 'Trekk tilbake',
    downloadCta: 'Last ned kopi',
  },
  customerDetailFilerTab: {
    subAlle: 'Alle',
    subIntern: 'Intern',
    subDelt: 'Delt',
    subFraKunde: 'Fra kunde',
    stripInternal:
      'Interne filer er synlige for teamet, aldri for {name}. Trykk «Del» når noe skal ut.',
    stripShared: 'Disse filene er delt med {name} i det delte rommet.',
    stripReceived: 'Filer {name} har sendt deg.',
    stripAll: 'Alt du har om {name}, interne notater, delte filer og det kunden har sendt.',
    filterAria: 'Filtrer filer',
    uploadCta: 'Last opp',
    emptyBody:
      'Ingen filer her ennå. Last opp et dokument, bilde eller video, det holdes internt til du deler det.',
    emptyCta: 'Last opp fil',
  },
  customerDetailMeetingModeChip: {
    video: 'Video',
    office: 'Oppmøte',
    treatment: 'Behandling',
    phone: 'Telefon',
    trening: 'Trening',
  },
  customerDetailNotaterTab: {
    guard:
      'Datert logg over hva som skjedde. Hold den adskilt fra forberedelsene, som er det du skal gjøre. Notater er intern, synlig for teamet, ikke for {name}.',
    eyebrow: 'nytt notat · {name}',
    composerPlaceholder: 'Hva skjedde? Hva vil du huske til neste gang?',
    composerCaption:
      'Skriv som om {name} kan be om innsyn, hold deg til det som er relevant for oppdraget.',
    saveCta: 'Lagre notat',
    emptyBody:
      'Ingen notater ennå. Skriv ned det du vil huske om {name}, eller skriv et møtenotat fra et møte.',
    internalChip: 'intern',
    prepPhase: 'forberedelser',
    livePhase: 'under møtet',
    sharedWith: 'delt med {name} som oppsummering',
    visibleToTeam: 'Synlig for teamet',
    visibleToColleagues: 'Synlig for deg og kolleger med tilgang',
    editOnMeeting: 'Rediger på møtet',
    changeSummary: 'Endre oppsummering',
    shareAsSummary: 'Del som oppsummering',
    noteLabel: 'notat',
    deleteNoteAria: 'Slett notat',
    deleteTitle: 'Slette notatet?',
    deleteBody: 'Notatet blir slettet permanent.',
    deleteConfirm: 'Slett',
    summaryShared: 'Oppsummering delt.',
    summaryShareFailed: 'Kunne ikke dele oppsummeringen.',
    unshareFailed: 'Kunne ikke slutte å dele.',
    noteSaved: 'Notatet er lagret.',
    noteSaveFailed: 'Kunne ikke lagre notatet.',
    noteDeleteFailed: 'Kunne ikke slette notatet.',
  },
  customerDetailNoteShareSummaryModal: {
    kicker: 'notat',
    titleEdit: 'Endre oppsummering',
    titlePublish: 'Del oppsummering med kunden',
    hint: 'Skriv en kort oppsummering kunden kan lese i sin egen visning. Du kan endre eller fjerne den senere.',
    label: 'Oppsummering',
    counter: '{count} / {max} tegn',
    notifyLabel: 'Varsle kunden på e-post',
    notifyDescription: 'Kunden får en lenke til portalen. Sendes bare ved første deling.',
    unshareCta: 'Slutt å dele',
    updateCta: 'Oppdater',
    publishCta: 'Del',
  },
  customerDetailPillFilter: {
    lensAlle: 'alle',
    lensMoter: 'booking | bookinger',
    lensForberedelser: 'forberedelse | forberedelser',
    lensFiler: 'fil | filer',
    lensNotater: 'notat | notater',
    lensDokumenter: 'dokument | dokumenter',
    lensSamtaler: 'samtale | samtaler',
    lensHistorikk: 'historikk',
    pillAriaBase: '{label}, {count}',
    pillAriaUnread: '{base}, {n} nye',
    listLabel: 'Filtrer tidslinje',
  },
  customerDetailTimelineContextAction: {
    moterTitle: 'Book et nytt møte med {name}',
    moterHint: 'klikk for å åpne kalender og velge tid',
    dokumenterTitle: 'Del et dokument med {name}',
    dokumenterHint: 'dra inn en fil her, eller klikk for å velge',
  },
  customerDetailTimelineList: {
    timelineAriaLabel: 'Tidslinje',
  },
  customerDetailTimelineMessageComposer: {
    sendFailed: 'Kunne ikke sende meldingen.',
    removeAttachment: 'Fjern vedlegg',
    placeholderWithFile: 'legg ved en melding (valgfritt) …',
    placeholder: 'skriv en melding …',
    attachAria: 'Legg ved dokument eller bilde',
    sending: 'Sender …',
    send: 'Send',
  },
  itemsDocumentItem: {
    statusActive: 'Aktiv',
    statusExpired: 'Utløpt',
    statusRevoked: 'Tilbakekalt',
    statusReceived: 'Mottatt',
    directionOut: 'Delt med kunden',
    directionIn: 'Lastet opp av kunden',
    sizeKb: '{n} kB',
    sizeMb: '{n} MB',
    policyView: 'Kun visning',
    policyDownload: 'Nedlasting',
    kind: 'Dokument',
    opened: 'Åpnet {n}×',
  },
  itemsMeetingChatLog: {
    eyebrow: 'logg · prat under møtet',
    note: 'ikke delt på nytt',
    customerFallback: 'Kunde',
    operator: 'du',
    sharedDocument: 'Delt dokument',
    retainedBadge: 'beholdt',
    pinnedBadge: 'festet',
  },
  itemsMeetingItem: {
    kommende: 'kommende',
    notat: 'notat',
    emptyNote: '(tomt notat)',
    editSummaryCta: 'endre oppsummering',
    shareSummaryCta: 'del oppsummering',
    forberedelser: 'forberedelser',
    loading: 'laster…',
    noQuestions: 'ingen spørsmål',
    motechat: 'møtechat',
    messageCount: '{n} melding | {n} meldinger',
    retainedLinkCount: '{n} lenke beholdt | {n} lenker beholdt',
    hide: 'skjul',
    showLog: 'vis logg',
    motechatCaption: 'møtechat teller ikke som «samtaler», den hører til møtet',
    summaryAriaLabel: 'Oppsummering delt med kunden',
    summaryEyebrow: 'oppsummering',
    sharedWith: 'delt med {name}',
    customerFallback: 'kunden',
    forberedelserLoadError: 'Kunne ikke laste forberedelser',
    motechatLoadError: 'Kunne ikke laste møtechatten',
  },
  itemsMessageItem: {
    senderYou: 'Du',
    senderAdvisor: 'Rådgiveren',
    senderCustomer: 'Kunden',
    senderMessage: 'Melding',
    refLabel: 'om:',
    sharedFile: 'Delte en fil',
  },
  prepPrepCanvas: {
    sectionAria: 'Forberedelser',
    title: 'Om {name}',
    sub: 'fast forberedelse · følger kunden',
    chip: 'overlever hvert møte',
    lede: 'Den faste lesningen av {name} øverst. Under: åpne tråder du følger opp på tvers av møter. Punkter du flytter opp fra et møte havner her.',
    notePlaceholder: 'Hva er viktig å huske om {name}?',
    threadsLabel: 'å følge opp',
    threadsLede: 'Åpne tråder du sporer på tvers av møter, hak av når de er løst.',
    markUndone: 'Marker som ikke løst',
    markDone: 'Marker som løst',
    movedFromMeeting: 'Flyttet opp fra et møte',
    inCard: 'i kundekortet',
    addPlaceholder: 'Legg til noe å følge opp …',
    addCta: 'Legg til',
    attachLabel: 'vedlegg',
    upload: 'Last opp',
    attachEmpty:
      'Ingen filer ennå. Last opp bilder, video eller dokumenter. De holdes interne til du deler.',
    errSaveNote: 'Kunne ikke lagre forberedelsene.',
    errAddPoint: 'Kunne ikke legge til punktet.',
    errTogglePoint: 'Kunne ikke oppdatere punktet.',
    errRemovePoint: 'Kunne ikke fjerne punktet.',
  },
  treatmentActionChips: {
    label: 'tiltak gjort',
    empty: 'Ingen tiltak-chips er satt opp enda. Legg dem til i innstillinger.',
  },
  treatmentHealthDataWarning: {
    trainingAriaLabel: 'Synlighet',
    trainingLead: 'Internt, ikke synlig for kunden.',
    trainingBody:
      'Notér det du trenger for å følge opp økten, som repetisjoner, vekt og observasjoner. Kunden ser det aldri.',
    clinicalAriaLabel: 'Personvern',
    clinicalLead: 'Ikke skriv helseopplysninger eller diagnoser.',
    clinicalBody:
      'Plan-punktene er for prosedyrer, «masser venstre fot», «strekk hamstring», ikke pasientvurderinger.',
    clinicalCta: 'Godta databehandleravtalen for å registrere helseopplysninger',
    unlockedLead: 'Helseopplysninger tillatt',
  },
  treatmentLastSessionCard: {
    painDelta: 'smerte {before} → {after}',
    kicker: 'sist gang · {date}',
    kickerWithDelta: 'sist gang · {date} · {delta}',
    showCue: 'vis',
    notesShow: 'vis notater',
    notesHide: 'skjul notater',
    notesLoading: 'laster notater …',
    notesError: 'kunne ikke laste notater',
    notesEmpty: 'Ingen notater fra forrige møte',
    notesPanelAria: 'Notater fra forrige møte',
    openPrevMeeting: 'åpne forrige møte',
  },
  treatmentMeetingWrapModal: {
    slotShort: '{date} kl {time}',
    closeConfirmTitle: 'Lukke oppsummeringen?',
    closeDirtyBody:
      'Du har endringer som ikke er lagret. Lagre dem før du lukker, eller forkast dem.',
    closeSavingBody: 'Oppsummeringen lagres nå. Vent til lagringen er ferdig før du lukker.',
    closeFailedBody: 'Siste lagring mislyktes. Prøv å lagre på nytt, eller forkast endringene.',
    closeSavedBody: 'Oppsummeringen er lagret. Du kan lukke den nå.',
    closeConfirmAction: 'Lukk oppsummeringen',
    closeSaveAction: 'Lagre og lukk',
    closeDiscardAction: 'Forkast endringer og lukk',
    closeConfirmCancel: 'Fortsett redigering',
    alreadySentNotice: 'Oppsummeringen ble sendt {when} til {to}.',
    alreadySentNoticeNoRecipient: 'Oppsummeringen ble sendt {when}.',
    ctaResendToCustomer: 'Send på nytt til {name} →',
    ctaResendToParticipants: 'Send på nytt til 1 deltaker → | Send på nytt til {n} deltakere →',
    resendConfirmTitle: 'Sende oppsummeringen på nytt?',
    resendConfirmBody:
      'Den ble sendt {when}. Mottakerne får en ny e-post med oppsummeringen slik den står nå.',
    resendConfirmBodyNoDate:
      'Den er allerede sendt. Mottakerne får en ny e-post med oppsummeringen slik den står nå.',
    resendConfirmAction: 'Send på nytt',
    resendConfirmCancel: 'Avbryt',
    closeSaveError: 'Kunne ikke lagre oppsummeringen. Prøv igjen før du lukker.',
    saveFailed: 'Kunne ikke lagre',
    autoIntroTraining: 'Takk for økta. Kort oppsummering:',
    autoExercisesHeading: 'Øvelser i dag:',
    kindCohost: 'medvert',
    kindInvitee: 'deltaker',
    kindCustomer: 'kunde',
    meetingIndexOfTotal: 'møte {index} av {total}',
    meetingIndex: 'møte {index}',
    qaMetaLabel: '{answered} av {total} besvart · lagret kryptert',
    summaryTitleDefault: 'Oppsummering · {service}',
    autoGreetingTeam: 'Hei,',
    autoGreeting: 'Hei {name},',
    autoIntro: 'Takk for samtalen. Kort oppsummering:',
    autoClosing: 'Si fra hvis noe er uklart.',
    autoSignoff: 'Mvh',
    ctaArchive: 'Arkiver',
    ctaPickTime: 'Velg en tid →',
    ctaSendConfirm: 'Send + inviter til {slot} →',
    ctaSendToParticipants: 'Send til 1 deltaker → | Send til {n} deltakere →',
    ctaSendToCustomer: 'Send til {name} →',
    errSave: 'Kunne ikke lagre oppsummeringen. Prøv igjen.',
    errSend: 'Kunne ikke sende oppsummeringen.',
    errNoEmail: 'Mangler e-postadresse på kunden.',
    errPickServiceTime: 'Velg tjeneste og tidspunkt.',
    errBook: 'Kunne ikke booke ny tid.',
    errFollowup: 'Kunne ikke sende oppsummeringen og invitasjonen. Prøv igjen.',
    editSummary: 'Til oppsummeringen',
    errFollowupRecovery:
      'Vi kunne ikke sjekke om oppsummeringen og invitasjonen ble sendt. Prøv igjen for å hente status.',
    moreActions: 'Flere handlinger',
    downloadPdf: 'Last ned PDF',
    errExportPdf: 'Kunne ikke lage PDF.',
    serviceOptionLabel: '{name} · {mins} min',
    modeOffice: 'møte på kontor',
    modePhone: 'telefon',
    modeVideo: 'video',
    modeTreatment: 'klinikken',
    modeTraining: 'trening',
    modalTitle: 'Hva tar du videre fra dette?',
    modalKicker: 'etter møtet',
    qaKicker: 'spør om dette, fra forberedelsen',
    qaTitle: 'Spørsmål og svar',
    qaEmpty:
      'Ingen spørsmål ble forberedt. Bruk forberedelsesnotatene fra møtet for å huske hva dere snakket om.',
    summaryKicker: 'til kunden, kan redigeres fritt',
    summaryTitle: 'Oppsummering',
    saving: 'lagrer …',
    savedEncrypted: 'lagret · kryptert',
    autoFilled: 'auto-fylt fra svar',
    summaryTitlePlaceholder: 'Oppsummering, {service}',
    summaryTitleAria: 'Tittel på oppsummering',
    editorPlaceholder: 'Skriv en oppsummering …',
    hintTeam: 'Deltakerne ser dette hvis du sender.',
    hintCustomer: '{name} ser dette hvis du sender.',
    includeNotesLabel: 'Ta med notatene fra møtet',
    includeNotesDescription: 'Legger ved notatene når du sender. Av som standard.',
    includeNotesFormatLegend: 'Format',
    includeNotesTextLabel: 'I e-posten',
    includeNotesTextDescription: 'Vises nederst som ren tekst.',
    includeNotesPdfLabel: 'PDF-fil',
    includeNotesPdfDescription: 'Legges ved som møtenotater.pdf.',
    nextKicker: 'hva skjer nå',
    nextTitle: 'Velg én',
    optionSendDesc: 'E-post til kunden med oppsummering.',
    optionSendTitle: 'Send oppsummering',
    optionRescheduleDesc:
      'Send oppsummeringen og en egen invitasjon til et nytt møte. Kunden må bekrefte invitasjonen.',
    optionRescheduleTitle: 'Send + ny tid',
    optionArchiveDesc: 'Lagre alt internt, ingen e-post. Du kan sende senere.',
    optionArchiveTitle: 'Bare arkiver',
    reschedKicker: 'velg tjeneste og tid',
    reschedTitle: 'Velg et nytt møtetidspunkt',
    reschedServiceLabel: 'Tjeneste',
    reschedServicePlaceholder: 'Velg en tjeneste …',
    reschedDateLabel: 'Dato',
    slotsLabel: 'Ledige tider',
    slotsLoading: 'Laster …',
    slotsEmpty: 'Ingen ledige tider denne dagen.',
    slotsUnavailableAhead:
      'Ingen ledige tider de neste 60 dagene. Velg en senere dato for å lete videre.',
    errLoadAvailability: 'Kunne ikke hente ledige tider. Prøv igjen.',
    recipientsKicker: 'hvem skal få oppsummeringen',
    recipientsTitle: 'Mottakere',
    recipientsEmpty:
      'Ingen deltakere å sende til. Legg til medverter eller inviterte på møtet først.',
    recipientDescription: '{email} · {kind}',
    archiveNote:
      'Alt lagres på møtet uten å sende noe. Du finner det igjen under «Tidligere» og kan sende e-posten senere, uten å miste svarene.',
    archiveNoteStrong: '{name} får ingen påminnelse om at det er et notat.',
    sentKickerReschedule: 'oppsummering og invitasjon sendt',
    sentKickerArchive: 'arkivert',
    sentKickerSend: 'sendt',
    sentTitleReschedule: 'To ting på vei.',
    sentTitleArchive: 'Lagret på møtet.',
    sentTitleTeam: 'Sendt til deltakerne.',
    sentTitleCustomer: 'Sendt til {name}.',
    sentRowMailTeamPrefix: 'Oppsummering sendt til',
    participantWord: 'deltaker | deltakere',
    sentRowMailPrefix: 'Oppsummering sendt til',
    sentRowBookedPrefix: 'Invitasjon sendt, venter på kundens bekreftelse ·',
    sentRowArchived: 'Oppsummering og svar lagret kryptert på møtet.',
    sentCopyReschedule:
      '{name} får oppsummeringen og en egen e-post for å bekrefte den nye tiden. Møtet venter på kundens bekreftelse.',
    sentCopyArchive: 'Du kan sende e-posten senere fra møteoversikten uten å miste svarene.',
    sentCopyTeam:
      'Deltakerne har fått en e-post med oppsummeringen. Svarene dine ligger kryptert på møtet.',
    sentCopyCustomer:
      '{name} har fått en e-post med oppsummeringen. Svarene dine ligger kryptert på møtet.',
    backToMeeting: 'Til møtet',
    // Avslutt uten oppsummering (#1894). Sentence case, blunt verb, no
    // question mark — the confirm step already asked.
    finishWithoutSummary: 'Marker som gjennomført uten oppsummering',
    stopWithoutCompleting: 'Avslutt uten å markere som gjennomført',
  },
  tagChipInput: {
    add: 'tag',
    remove: 'Fjern tag',
    suggestions: 'Forslag',
  },
  externalOwnerState: {
    notSent: 'Ikke sendt',
    sent: 'Påminnelse sendt',
    overdue: 'Forfalt',
    done: 'Fullført',
    markDone: 'Marker fullført',
  },
  treatmentPlanChecklist: {
    askKicker: 'spør om dette',
    askTitle: 'Hva må vi få svar på?',
    askAddLabel: 'legg til spørsmål',
    askEmpty: 'Ingen spørsmål enda. Skriv ned det du vil ha svar på.',
    askEmptyLive: 'Ingen spørsmål enda.',
    askPlaceholder: 'Skriv et spørsmål',
    planKicker: 'behandle dette',
    planTitle: 'Plan for i dag.',
    planAddLabel: 'legg til',
    planEmpty: 'Ingen plan-punkter enda. Legg til det du må huske.',
    planEmptyLive: 'Ingen plan-punkter enda.',
    planPlaceholder: 'Skriv et plan-punkt',
    ownerMe: 'meg',
    ownerClient: 'kunde',
    ownerColleague: 'kollega',
    ownerExternal: 'ekstern',
    ownerLabel: 'ansvarlig',
    externalPrefix: 'e-post',
    externalPlaceholder: "navn{'@'}eksempel.no",
    externalFor: 'E-post til ekstern ansvarlig for «{text}»',
    duePrefix: 'frist',
    dueTimePrefix: 'kl',
    dueFor: 'Frist for «{text}»',
    cancelPoint: 'Avbryt punktet',
    cancelPointFor: 'Avbryt «{text}»',
    reopen: 'Åpne igjen',
    reopenFor: 'Åpne «{text}» igjen',
    cancelled: 'avbrutt',
    answered: 'besvart',
    done: 'gjort',
    markUndone: 'Marker som ikke gjort',
    markDone: 'Marker som gjort',
    editItem: 'Endre «{text}»',
    removeTag: 'Fjern tag',
    addTag: 'Legg til tag',
    tag: 'tag',
    tagPlaceholder: 'tag',
    targetPrefix: 'for',
    targetAll: 'alle',
    targetFor: 'Hvem gjelder «{text}»',
    targetForNew: 'Hvem gjelder spørsmålet',
    assigneeFor: 'Hvem følger opp «{text}»',
    assigneeForNew: 'Hvem følger opp punktet',
    assigneePrefix: 'hvem',
    resultPrefix: 'resultat',
    resultFor: 'Resultat for «{text}»',
    resultPlaceholder: 'Hva ble resultatet',
    moveUp: 'Flytt opp',
    moveDown: 'Flytt ned',
    inCardTitle: 'Ligger i kundekortet',
    inCard: 'i kundekortet',
    promoteTitle: 'Flytt til kundekortet (overlever møtet)',
    promote: 'Flytt til kundekortet',
    delete: 'Slett',
  },
  meetingActionPointsSummary: {
    sectionAria: 'Handlingspunkter fra møtet',
    planLabel: 'Punkter',
    askLabel: 'Spørsmål og svar',
    unanswered: 'ikke besvart',
    ownerClient: 'kunde',
    ownerExternal: 'ekstern',
  },
  treatmentPriorSessionHistory: {
    resultsLabel: 'Resultater fra sist',
    sectionAria: 'Forrige gang',
    kicker: 'forrige gang',
    noteLabel: 'Notat fra sist',
    openItemsLabel: 'Åpne oppfølgingspunkter fra sist',
    canvasLabel: 'Fra kundekortet',
    assigneeClient: 'kunde',
    assigneeMe: 'meg',
  },
  treatmentQACard: {
    editQuestionAria: 'Endre spørsmålet «{text}»',
    answerPlaceholder: 'Skriv svaret her …',
    saving: 'lagrer …',
    savedEncrypted: 'lagret · kryptert',
    answerBlocked: 'Du kan bare svare på dine egne punkter',
  },
  treatmentTrainingExerciseLog: {
    kicker: 'treningslogg',
    title: 'Logg øvelser',
    priorHead: 'Sist · {date}',
    removeAria: 'Fjern {name}',
    emptyBody: 'Ingen øvelser logget enda.',
    nameLabel: 'øvelse',
    namePlaceholder: 'F.eks. knebøy',
    setsLabel: 'sett',
    repsLabel: 'reps',
    weightLabel: 'vekt (kg)',
    addCta: 'Legg til',
    loadLabel: '{sets} × {reps}',
    loadLabelWeight: '{sets} × {reps} · {weight} kg',
  },
  treatmentTreatmentMetaCard: {
    statusConfirmed: 'Bekreftet',
    statusRescheduled: 'Flyttet',
    statusPending: 'Avventer',
    statusCancelled: 'Avlyst',
    statusCompleted: 'Gjennomført',
    statusNoShow: 'Ikke møtt',
    slotDayTime: '{day} kl {time}',
    seriesNounDefault: 'Behandling',
    seriesOfTotal: '{noun} {index} av {total}',
    seriesIndex: '{noun} {index}',
    subLine: '{service} · {mins} min · {slot}',
    moreActions: 'Flere handlinger',
  },
  treatmentTreatmentPrep: {
    customerMessageLabelTraining: 'Fra kunden, mål og bakgrunn',
    empty: 'tom',
    planCount: '1 punkt | {n} punkter',
    asksCount: '1 spørsmål | {n} spørsmål',
    wordCount: '1 ord | {n} ord',
    notesVisibility: 'deg og kolleger med tilgang',
    writeNotesTitle: 'Skriv notatene.',
    cancelledTitleTraining: 'Økten er avlyst.',
    cancelledTitleTherapy: 'Behandlingen er avlyst.',
    cancelledLede: 'Det som allerede var skrevet, er bevart som historikk og kan ikke endres her.',
    cancelledPlanTitle: 'Planlagt for timen',
    cancelledNotesTitle: 'Bevarte notater',
    asksTitle: 'Hva må vi få svar på?',
    planTitleTraining: 'Dagens plan',
    planTitleTherapy: 'Plan for i dag',
    notesPastTraining: 'Notater fra økten',
    notesPastTherapy: 'Notater fra behandlingen',
    notes: 'Notater',
    notePlaceholder: 'F.eks. «husk å spørre om parkering» eller «snakk om katten, Mille».',
  },
  treatmentWherebyEmbed: {
    prestartTitle: 'Klar for videomøtet?',
    prestartBody: 'Når du starter, åpnes videorommet før du går inn i møtet.',
    prestartAction: 'Start møtet',
    kicker: 'videorom',
    popoutAriaLabel: 'Åpne videorommet i et nytt vindu',
    popoutLabel: 'Åpne i nytt vindu',
    frameTitle: 'Whereby videorom',
    poppedTitle: 'Møtet er åpnet i et eget vindu',
    poppedBody: 'Rommet her koblet fra, så du er med bare én gang.',
    poppedBack: 'Hent møtet tilbake hit',
    poppedFallback: 'Åpne direkte i Whereby',
  },
  treatmentStemneVideoRoom: {
    roomAccessClosed: 'Den inkluderte møtetiden er over. Du kan ikke bli med i rommet igjen.',
    roomLabel: 'Stemne videorom',
    eyebrow: 'Stemne videomøte',
    readyTitle: 'Klar for videomøtet',
    readyBody: 'Sjekk at kamera og mikrofon virker før du blir med.',
    checkDevices: 'Sjekk kamera og mikrofon',
    checkingDevices: 'Sjekker kamera og mikrofon',
    previewTitle: 'Ser og høres alt riktig ut?',
    previewBody: 'Velg utstyret du vil bruke. Du kan slå av kamera eller mikrofon før du går inn.',
    previewYou: 'Forhåndsvisning',
    previewControls: 'Kontroller for forhåndsvisning',
    noCamera: 'Ingen kamera funnet',
    noMicrophone: 'Ingen mikrofon funnet',
    noSpeaker: 'Ingen høyttaler funnet',
    cameraNumber: 'Kamera {number}',
    microphoneNumber: 'Mikrofon {number}',
    speakerNumber: 'Høyttaler {number}',
    deviceChangeError: 'Kunne ikke bytte enhet. Kontroller at den fortsatt er koblet til.',
    speakerChangeError: 'Kunne ikke bytte høyttaler. Kontroller at den fortsatt er koblet til.',
    join: 'Bli med',
    joinWithoutCamera: 'Bli med uten kamera',
    joining: 'Gjør videorommet klart',
    permissionError:
      'Stemne fikk ikke tilgang til kamera eller mikrofon. Sjekk nettleserinnstillingene og prøv igjen.',
    noDevicesError: 'Stemne fant ikke kameraet eller mikrofonen. Koble til utstyret og prøv igjen.',
    joinError: 'Videorommet kunne ikke åpnes. Prøv igjen.',
    providerFallback: 'Åpne reservevideorommet',
    tryAgain: 'Prøv igjen',
    cancelJoin: 'Avbryt',
    leftTitle: 'Du har forlatt videorommet',
    leftBody: 'Møtet i Stemne er fortsatt åpent.',
    rejoin: 'Bli med igjen',
    participantCount: '{count} i rommet',
    you: 'Deg',
    waitingForOthers: 'Venter på andre',
    roomLocked: 'Rommet er låst.',
    askToJoin: 'Be om å bli med',
    waitingForHost: 'Venter på verten',
    reconnecting: 'Kobler til videorommet på nytt',
    kicked: 'Verten fjernet deg fra videorommet.',
    knockRejected: 'Verten avslo forespørselen.',
    waitingRoom: 'Venter på å bli med',
    guest: 'Gjest',
    admit: 'Slipp inn',
    reject: 'Avvis',
    yourScreen: 'Skjermen din',
    sharedScreen: 'Delt skjerm',
    controls: 'Kontroller for videomøtet',
    devices: 'Enheter',
    deviceChoices: 'Valg av kamera, mikrofon og høyttaler',
    camera: 'Kamera',
    cameraOn: 'Slå på kamera',
    cameraOff: 'Slå av kamera',
    microphone: 'Mikrofon',
    microphoneOn: 'Slå på mikrofon',
    microphoneOff: 'Demp mikrofon',
    speaker: 'Høyttaler',
    share: 'Del skjerm',
    stopSharing: 'Stopp deling',
    leave: 'Forlat',
  },
  widgetsDeltRomCard: {
    title: 'Delt rom',
    activeShares: 'aktive delinger',
    receivedFromCustomer: 'mottatt fra kunde',
    lastMessage: 'siste melding',
    senderYou: 'Du',
  },
  widgetsForberedelserCard: {
    title: 'Forberedelser',
    kicker: 'forberedelser',
    openCta: 'åpne',
    followsSub: 'følger {name} · overlever hvert møte',
    empty: 'Ingen forberedelser ennå.',
    points: 'punkter',
    internalFiles: 'interne filer',
  },
  widgetsKontaktCard: {
    title: 'Kontakt',
    company: 'firma',
    email: 'e-post',
    emailPending: 'venter på bekreftelse: {email}',
    since: 'siden',
    deleteCta: 'Slett kunde',
  },
  widgetsOutstandingPaymentsCard: {
    title: 'Betalinger',
    loading: 'Henter betalinger …',
    paid: 'Betalt',
    outstanding: 'Utestående',
    documents: 'Kvitteringer, fakturaer og kreditnotaer',
    requests: 'Utestående betalingskrav',
    sale: 'Kvittering',
    credit_note_reversal: 'Reversering av kreditnota',
    invoice: 'Faktura',
    credit_note: 'Kreditnota',
    corrects: 'Korrigerer {number}',
    remaining: '{amount} utestående',
    download: 'Last ned',
    downloadLabel: 'Last ned dokument {number}',
    empty: 'Ingen betalinger ennå.',
    summary:
      '{count} utestående betaling · {amount} totalt | {count} utestående betalinger · {amount} totalt',
    openMeeting: 'Åpne møtet',
  },
  widgetsCustomerActionPointsCard: {
    title: 'Oppfølgingspunkter',
    openSummary: '{count} åpent oppfølgingspunkt | {count} åpne oppfølgingspunkter',
    overdueSummary: '{count} forfalt',
    empty: 'Ingen åpne oppfølgingspunkter.',
    owner: 'Ansvarlig: {name}',
    ownerCustomer: 'kunden',
    ownerExternal: 'ekstern ansvarlig',
    ownerUnassigned: 'ikke tildelt',
    noDue: 'ingen frist',
    due: 'frist {date}',
    overdueDue: 'forfalt {date}',
    history: 'Se fullført og avbrutt historikk',
  },
  widgetsNotesPreviewCard: {
    title: 'Interne notater',
    addToggle: 'legg til',
    hint: 'Synlig for teamet. Kunden kan be om innsyn',
    composePlaceholder: 'Skriv en kort observasjon om kunden.',
    saving: 'Lagrer …',
    editAria: 'Endre notat fra {date}',
    deleteAria: 'Slett notat fra {date}',
    emptyNote: '(tomt notat)',
    empty: 'Ingen interne notater enda.',
    noteLabel: '(notat)',
    errSaveEdit: 'Kunne ikke lagre endringen.',
    errSaveNote: 'Kunne ikke lagre notatet.',
    errDeleteNote: 'Kunne ikke slette notatet.',
  },
  editorLinkPrompt: {
    dialogLabel: 'Sett inn lenke',
    urlLabel: 'URL (https:// eller mailto:)',
    insertCta: 'Sett inn',
  },
  editorSuggestionMenu: {
    ariaLabel: 'Forslag',
  },
  sharedAttendeeStack: {
    ariaMore: '{name} og {count} flere deltakere: {list}',
    attendeeCount: '{count} deltakere',
  },
  sharedAvatarStack: {
    you: 'Du',
  },
  sharedCandidateTimeChip: {
    primaryMarker: 'foreslått',
    promoteLabel: 'Gjør til foreslått tid',
    pendingMarker: 'venter på godkjenning',
    removeLabel: 'Fjern tidspunkt',
  },
  sharedCookieConsentBanner: {
    ariaLabel: 'Samtykke til cookies',
    body: 'Vi bruker cookies for å måle hvordan annonsene våre fungerer. Da deler vi besøket ditt med Google, Meta og OpenAI. Godtar du dette?',
    accept: 'Godta',
    decline: 'Avslå',
    currentGranted: 'Du har valgt å godta.',
    currentDenied: 'Du har valgt å avslå.',
  },
  sharedCookieSettingsLink: {
    label: 'Cookie-innstillinger',
    labelLower: 'cookie-innstillinger',
  },
  sharedParticipantRow: {
    rsvpConfirmed: 'bekreftet',
    rsvpPending: 'venter på svar',
    rsvpDeclined: 'takket nei',
  },
  sharedPollTally: {
    voterCount: '{n} deltaker | {n} deltakere',
    allVoted: 'alle har stemt',
    empty: 'Ingen stemmer ennå.',
    badgeWinner: 'valgt',
    badgeLeading: 'leder',
    worksCount: '{count} passer',
    doesntCount: '{count} passer ikke',
  },
  sharedTypewriterRole: {
    roleAdvisors: 'rådgivere',
    roleTherapists: 'terapeuter',
    roleConsultants: 'konsulenter',
    roleStrategists: 'strateger',
    roleCoaches: 'coacher',
    roleMentors: 'mentorer',
    roleGuides: 'veiledere',
    rolePsychologists: 'psykologer',
  },
  sharedVoteRow: {
    suggestedBadge: 'Foreslått',
    voteOn: 'Stem på {time}',
    works: 'Passer',
    doesntWork: 'Passer ikke',
  },
  uiAddressAutocomplete: {
    placeholder: 'Søk etter adresse',
  },
  uiAddressBookPicker: {
    searchPlaceholder: 'Søk etter sted',
    addAddress: 'Legg til ny adresse',
    clearAria: 'Fjern møtested',
    nameLabel: 'Navn på stedet',
    namePlaceholder: 'Klinikken',
    addressLabel: 'Adresse',
    addressPlaceholder: 'Søk etter adresse',
    duplicateNameErr: 'Det finnes allerede et sted med dette navnet',
    saveErr: 'Kunne ikke lagre stedet. Prøv igjen om litt.',
  },
  uiConflictWarningDialog: {
    title: '{n} møte påvirkes | {n} møter påvirkes',
  },
  uiStemneBirthdateInput: {
    hint: 'For eksempel 3 5 1962',
    dayLabel: 'Dag',
    monthLabel: 'Måned',
    yearLabel: 'År',
    errorPrefix: 'Feil:',
    errors: {
      digitsOnly: 'Bruk bare tall i fødselsdatoen',
      missingDay: 'Fødselsdatoen må inneholde dag',
      missingMonth: 'Fødselsdatoen må inneholde måned',
      missingYear: 'Fødselsdatoen må inneholde år',
      dayRange: 'Dag må være et tall mellom 1 og 31',
      monthRange: 'Måned må være et tall mellom 1 og 12',
      yearDigits: 'Årstallet må ha fire siffer, for eksempel 1962',
      impossible: 'Fødselsdatoen må være en gyldig dato. {month} {year} har {days} dager.',
      future: 'Fødselsdatoen må være i fortiden',
      tooOld: 'Sjekk årstallet. Fødselsdatoen kan ikke være før {year}.',
      saveRejected: 'Fødselsdatoen ble avvist. Sjekk at datoen stemmer.',
    },
  },
  uiStemneDatePicker: {
    placeholder: 'Velg dato',
    dialogLabel: 'Velg dato',
    dialogLabelFor: 'Velg dato for {label}',
    prevMonth: 'Forrige måned',
    prevYear: 'Forrige år',
    prevPeriod: 'Forrige periode',
    nextMonth: 'Neste måned',
    nextYear: 'Neste år',
    nextPeriod: 'Neste periode',
    chooseMonthYear: 'Velg måned og år',
    chooseYear: 'Velg år',
    weekdayMon: 'ma',
    weekdayTue: 'ti',
    weekdayWed: 'on',
    weekdayThu: 'to',
    weekdayFri: 'fr',
    weekdaySat: 'lø',
    weekdaySun: 'sø',
  },
  uiStemneEditor: {
    editorAriaLabel: 'Notatfelt',
    toolbarLabel: 'Tekstformatering',
    boldTitle: 'Fet',
    boldGlyph: 'F',
    italicTitle: 'Kursiv',
    italicGlyph: 'K',
    heading2Title: 'Overskrift 2',
    heading3Title: 'Overskrift 3',
    bulletListTitle: 'Punktliste',
    orderedListTitle: 'Nummerert liste',
    inlineCodeTitle: 'Inline kode',
    codeBlockTitle: 'Kodeblokk',
    addImageTitle: 'Legg til bilde',
    imageAnnotationPrefix: 'Bilde: ',
    imageUploading: 'Laster opp bilde...',
    imagePasteFailed: 'Kunne ikke lime inn bildet. Prøv igjen.',
  },
  uiStemneImageCropModal: {
    title: 'Beskjær bildet',
    eyebrow: 'profilbilde',
    hint: 'Dra for å flytte, knip eller bruk hjulet for å zoome. Bildet blir lagret kvadratisk.',
    saveCta: 'Lagre bildet',
  },
  uiStemneImageDropzone: {
    browse: 'eller bla gjennom',
  },
  uiStemneImageUpload: {
    imageAlt: 'Bilde',
    noImage: 'Ingen bilde',
    replaceCta: 'Bytt bilde',
    uploadCta: 'Last opp bilde',
    finalizeFailed: 'Bildet ble lastet opp, men kunne ikke lagres. Prøv igjen.',
  },
  uiStemneModal: {
    discardTitle: 'Ulagrede endringer',
    discardBody: 'Du har ulagrede endringer. Sikker på at du vil lukke?',
    discardConfirm: 'Forkast endringer',
    discardCancel: 'Fortsett redigering',
  },
  uiStemnePasskeySudoModal: {
    title: 'Bekreft med passnøkkelen din',
    body: 'For å endre passnøkler må du bekrefte at det er deg. Bruk passnøkkelen din nå for å fortsette.',
  },
  uiStemneSearchAndTag: {
    searchPlaceholder: 'Søk',
    tagAriaLabel: 'Filter',
  },
  uiStemneSearchCombobox: {
    placeholder: 'Søk',
    createLabel: 'Legg til ny',
    searchFailed: 'Søket feilet',
    noResults: 'Ingen treff',
  },
  uiStemneSearchInput: {
    placeholder: 'Søk',
    clearAria: 'Tøm {label}',
  },
  uiStemneSegmentedControl: {
    defaultAriaLabel: 'Velg en av flere',
  },
  uiStemneSelect: {
    placeholder: 'Velg…',
    countSelected: '{n} valgt',
    searchPlaceholder: 'Søk…',
    noResults: 'Ingen treff',
    close: 'Lukk',
  },
  uiStemneTabs: {
    defaultAriaLabel: 'Faner',
    badgeAria: '{n} uleste',
  },
  uiStemneToastContainer: {
    regionLabel: 'Varsler',
    closeLabel: 'Lukk varsel',
  },
  uiTrustStrip: {
    lead: 'Passordfri, phishing-sikker innlogging.',
    body: 'stemne bruker passnøkler (WebAuthn / FIDO2). Ingen passord blir sendt eller lagret. Du logger inn med Face ID, Touch ID, Windows Hello eller en sikkerhetsnøkkel.',
  },
  billingBillingCycleToggle: {
    ariaLabel: 'Faktureringsperiode',
    monthly: 'Månedlig',
    yearly: 'Årlig',
    yearlyWithHint: 'Årlig, {hint}',
  },
  billingPlanUpgradedModal: {
    title: 'Velkommen til {plan}',
    kicker: 'abonnementet er oppgradert',
    featuresTitle: 'Det dere får nå',
    inviteTitle: 'Inviter teamet',
    inviteLead:
      'Dere har {seatCap} plasser totalt. Legg til opptil {inviteCapacity} kolleger nå, eller hopp over og gjør det fra Innstillinger.',
    emailPlaceholder: "kollega{'@'}firma.no",
    emailAriaLabel: 'E-postadresse {n}',
    removeRowAriaLabel: 'Fjern rad {n}',
    addRow: 'Legg til rad',
    roleLabel: 'Rolle',
    roleAdvisor: 'Rådgiver',
    roleAdmin: 'Administrator',
    skip: 'Hopp over',
    sendCta: 'Send invitasjon',
    toastPartial: '{ok} sendt · {failed} feilet',
    toastSent: '1 invitasjon sendt | {n} invitasjoner sendt',
    errorGeneric: 'Kunne ikke sende invitasjonene. Prøv igjen.',
  },
  bookingBookingMonthCalendar: {
    weekdayMon: 'ma',
    weekdayTue: 'ti',
    weekdayWed: 'on',
    weekdayThu: 'to',
    weekdayFri: 'fr',
    weekdaySat: 'lø',
    weekdaySun: 'sø',
  },
  bookingOmOssBand: {
    kicker: 'om oss',
  },
  documentsDocumentInlineReader: {
    closePreview: 'Lukk forhåndsvisning',
    zoomOut: 'Zoom ut',
    zoomIn: 'Zoom inn',
    downloadCopy: 'Last ned kopi',
    detailsAndActivity: 'Detaljer og aktivitet',
    fetchingDocument: 'Henter dokumentet …',
    renderingPdf: 'Tegner PDF …',
    previewUnsupported: 'Forhåndsvisning støttes ikke for denne filtypen.',
    openError: 'Kunne ikke åpne dokumentet.',
    pdfError: 'Kunne ikke vise PDF.',
    fileGlyphFallback: 'FIL',
  },
  documentsFileCard: {
    share: 'Del',
    manage: 'Styr',
    open: 'Åpne',
    openAria: 'Åpne {name}',
    privateChip: 'bare meg',
    meetingChip: 'møte',
    encryptedBadge: 'Kryptert',
    moreOptionsAria: 'Flere valg for {name}',
    deleteFile: 'Slett fil',
  },
  documentsFileLightbox: {
    visibilityInternal: 'synlig for teamet · ikke {name}',
    visibilitySharedWith: 'delt med {name}',
    visibilityReceivedFrom: 'mottatt fra {name}',
    download: 'Last ned',
    shareWith: 'Del med {name}',
  },
  documentsFileShelfModals: {
    deleteTitle: 'Slette filen?',
    deleteBody: '«{name}» blir slettet permanent. Dette kan ikke angres.',
    deleteConfirm: 'Slett',
  },
  documentsInternalUploadModal: {
    titleOne: 'Last opp en fil.',
    titleMany: 'Last opp filer.',
    kicker: 'last opp · intern',
    bannerTeam: 'Holdes internt, synlig for teamet, aldri for {name} før du deler.',
    bannerPrivate: 'Holdes internt, bare du ser den, aldri for {name} før du deler.',
    dropTitle: 'Velg filer',
    dropHint: 'PDF, Word, regneark, bilde eller video · maks 50 MB',
    carouselLabel: 'Valgte bilder',
    removeFile: 'Fjern {name}',
    previewFile: 'Forhåndsvis {name}',
    captionLabel: 'Bildetekst (valgfritt)',
    captionPlaceholder: 'Kort tekst til bildet',
    addMore: 'Legg til flere',
    whoSeesLabel: 'Hvem ser den',
    whoSeesAria: 'Hvem ser filen',
    wholeTeam: 'Hele teamet',
    onlyMe: 'Bare meg',
    pinLabel: 'Knytt til møte (valgfritt)',
    pinOnCustomer: 'På kunden',
    tagsLabel: 'Tagger (valgfritt)',
    tagsSearchPlaceholder: 'Søk eller skriv en ny tagg og trykk enter',
    tagsAria: 'Tagger',
    noteLabel: 'Intern notis (valgfritt)',
    notePlaceholder: 'Hvorfor lagrer du denne?',
    encryptLabel: 'Krypter filen',
    encryptDesc: 'Innholdet lagres kryptert i skylagringen.',
    dpaAckTitle: 'Last opp uten kryptering',
    dpaAckBody:
      'Databehandleravtalen må godtas på nytt før filer kan krypteres. Vil du laste opp filen ukryptert likevel?',
    dpaAckConfirm: 'Last opp ukryptert',
    uploadCta: 'Last opp',
    closePreview: 'Lukk forhåndsvisning',
    uploadSuccess: 'Lastet opp internt.',
    uploadError: 'Kunne ikke laste opp filene.',
    errEncryptionRequired: 'Denne filen må krypteres. Skru på kryptering og prøv igjen.',
  },
  documentsManageShareDrawer: {
    actorOp: 'rådgiver',
    actorCust: 'mottaker',
    actorSystem: 'system',
    activityShared: 'Delt av {actor}',
    activityNotified: 'E-post sendt',
    activityOpened: 'Åpnet av {actor}',
    activityDownloaded: 'Lastet ned av {actor}',
    activityRevoked: 'Trukket tilbake av {actor}',
    activityExtended: 'Utløp endret av {actor}',
    activityExpired: 'Utløpt automatisk',
    activityReceived: 'Mottatt fra {actor}',
    policyChangedView: 'Endret til kun visning',
    policyChangedDownload: 'Endret til nedlasting tillatt',
    policyChangedGeneric: 'Tilgangsnivå endret',
    errorNotFound: 'Fant ikke delingen. Last inn arkivet på nytt.',
    errorConflict: 'Handlingen er ikke mulig nå, delingen er ikke aktiv lenger.',
    errorGeneric: 'Noe gikk galt. Prøv igjen.',
  },
  documentsPromoteShareModal: {
    title: 'Del med kunden.',
    kicker: 'del internt vedlegg',
    banner: 'Denne filen er intern nå. Velg innstillinger, så blir den delt med {name}.',
    shareWith: 'Del med {name}',
    sharedWith: 'Delt med {name}.',
    shareError: 'Kunne ikke dele filen.',
  },
  documentsShareDocumentModal: {
    title: 'Del dokument',
    kicker: 'ny deling',
    filesLabel: 'Filer',
    removeFileAria: 'Fjern {name}',
    dropzoneAddMore: 'Legg til flere filer',
    dropzonePick: 'Klikk for å velge filer eller dra og slipp',
    dropzoneMeta: 'PDF, Word, regneark, presentasjon eller bilde. Maks 25 MB per fil.',
    customerLabel: 'Til kunde',
    customerLoading: 'Laster kunder…',
    customerPlaceholder: 'Søk eller legg til ny kunde',
    customerCreateLabel: 'Legg til ny kunde',
    newCustomerKicker: 'ny kunde',
    newCustomerNameLabel: 'Navn',
    newCustomerNamePlaceholder: 'Skriv navn',
    newCustomerEmailLabel: 'E-post',
    newCustomerEmailPlaceholder: "navn{'@'}firma.no",
    policyLabel: 'Tilgang',
    policyHint: '«Kun visning» hindrer nedlasting og utskrift.',
    policyDownload: 'Visning og nedlasting',
    policyView: 'Kun visning',
    expiryLabel: 'Utløp',
    expiryHint: '«Ingen utløp» beholder tilgang til du trekker den tilbake.',
    expiry7d: 'Om 7 dager',
    expiry30d: 'Om 30 dager',
    expiry90d: 'Om 90 dager',
    expiryNever: 'Ingen utløp',
    requireLoginLabel: 'Krev innlogging',
    requireLoginDesc: 'Kunden må åpne en magisk lenke før dokumentet vises.',
    notifyEmailLabel: 'Varsle på e-post',
    notifyEmailDesc: 'Kunden får et varsel og en lenke til rommet.',
    messageLabel: 'Melding (valgfritt)',
    messagePlaceholder: 'Skriv en kort kontekst, havner i rommet over dokumentet.',
    encryptLabel: 'Krypter filen',
    encryptDesc: 'Innholdet lagres kryptert i skylagringen.',
    uploading: 'Laster opp',
    sharing: 'Deler…',
    submitCta: 'Del dokument',
    errUnsupportedType:
      'Filtypen støttes ikke. Velg PDF, Word, regneark, presentasjon eller bilde.',
    errEmptyFile: 'Filen er tom eller skadet.',
    errTooLarge: 'Filen er for stor. Maks 25 MB.',
    errLoadCustomers: 'Kunne ikke laste kundelisten.',
    errInvalidEmail: 'Ugyldig e-postadresse.',
    errCustomerNotFound: 'Fant ikke kunden. Last inn på nytt.',
    errReauth: 'Du må logge inn på nytt.',
    errEncryptionRequired: 'Denne filen må krypteres. Skru på kryptering og prøv igjen.',
    errUploadExpired: 'Opplastingen er utløpt. Prøv å dele på nytt.',
    errDuplicate: 'Denne filen er allerede registrert.',
    dpaAckTitle: 'Del uten kryptering',
    dpaAckBody:
      'Databehandleravtalen må godtas på nytt før filer kan krypteres. Vil du dele filen ukryptert likevel?',
    dpaAckConfirm: 'Del ukryptert',
    errShareFailed: 'Noe gikk galt med delingen.',
  },
  documentsShareSettingsFields: {
    accessKicker: 'tilgang',
    downloadTitle: 'Visning og nedlasting',
    downloadDesc: 'Kunden kan åpne dokumentet og laste det ned.',
    viewTitle: 'Kun visning',
    viewDesc: 'Kunden kan lese i nettleseren, men ikke laste ned.',
    expiryKicker: 'deling utløper',
    expiry7d: '7 dager',
    expiry30d: '30 dager',
    expiry90d: '90 dager',
    expiryNever: 'Ingen utløp',
    requireLoginLabel: 'Krev innlogging',
    requireLoginDesc: 'Kunden må være innlogget via magisk lenke for å åpne.',
    notifyEmailLabel: 'Varsle på e-post',
    notifyEmailDesc: 'Kunden får en e-post med lenke til det delte rommet.',
    messageKicker: 'melding til kunden (valgfritt)',
    messagePlaceholder: 'Skriv noen ord …',
  },
  documentsShareStatusPill: {
    internal: 'intern',
    received: 'mottatt',
    expired: 'utløpt',
    revoked: 'trukket tilbake',
    shared: 'delt',
  },
  meetingMeetingLiveWorkspace: {
    actionsKicker: 'avtalt under møtet',
    actionsTitle: 'Handlingspunkter',
    notesKicker: 'mens møtet pågår',
    notesTitle: 'Under møtet',
    encBadge: 'lagret kryptert',
    notesPlaceholder:
      'Skriv ned det som blir sagt, det dere blir enige om, og det du vil huske til neste gang.',
  },
  meetingTopBar: {
    back: 'møter',
    remaining: '{n} min igjen',
    untilClose: 'stenger om {n} min',
    encrypted: 'lagret kryptert',
    finish: 'Avslutt →',
    participants: '{n} i rommet',
  },
  meetingDeadline: {
    includedRemaining: '{n} min igjen av inkludert møtetid.',
    overtime: 'Den inkluderte møtetiden er over. Videorommet avsluttes om {n} min.',
    expiredKicker: 'videorom',
    expiredTitle: 'Videomøtet er avsluttet',
    expiredOperator: 'Videorommet er avsluttet. Du kan fortsatt oppsummere møtet.',
    expiredParticipant: 'Den avtalte møtetiden er over. Du kan nå lukke vinduet.',
  },
  meetingRail: {
    tabsAria: 'Møteverktøy',
    noteTitle: 'Under møtet',
    notePlaceholder:
      'Skriv ned det som blir sagt, det dere blir enige om, og det du vil huske til neste gang.',
    pointsTitle: 'Handlingspunkter',
    asksTitle: 'Spør om dette',
    encBadge: 'lagret kryptert',
    participantsTitle: 'Deltakere',
    participantsEmpty: 'Ingen deltakere i rommet ennå.',
    unnamedParticipant: 'Deltaker uten navn',
    participantRoleHost: 'vert',
    participantRoleCustomer: 'kunde',
    participantRoleParticipant: 'deltaker',
  },
  meetingLogPanel: {
    quickTitle: 'Logg raskt',
    painBefore: 'Smerte før',
    painAfter: 'Smerte etter',
  },
  meetingMiniCard: {
    restore: 'Tilbake til møtet',
    restoreAria: 'Tilbake til møtet med {name}',
    finish: 'Avslutt møtet',
  },
  meetingOverlay: {
    teamMeeting: 'Internt møte',
    durationMins: '{mins} min',
    seriesIndex: 'møte {n}',
    remaining: '{n} min igjen',
    videoRunning: 'video pågår',
    videoPreview: 'før møtet',
    showVideo: 'vis',
    hideVideo: 'Skjul video',
    resizePanels: 'Endre størrelse på møtevisning og sidemeny',
    mode: {
      video: 'video',
      office: 'oppmøte',
      treatment: 'behandling',
      trening: 'trening',
    },
    tab: {
      notat: 'notat',
      punkter: 'punkter',
      chat: 'chat',
      logg: 'logg',
      folk: 'folk',
    },
  },
  meetingMeetingChatPanel: {
    statusConnected: 'tilkoblet',
    statusConnecting: 'kobler til …',
    empty: 'Ingen meldinger ennå. Skriv noe for å starte.',
    pinned: 'festet',
    pin: 'fest',
    liftToNote: 'løft til notat',
    liftToTask: 'løft til oppgave',
    seen: 'Sett',
    foot: 'festes til dette møtet · lenker og dokumenter beholdes',
    sharerYou: 'Du',
    sharerAdvisor: 'Rådgiveren',
    sharedFiles: '{sharer} delte {count} filer',
    sharedDocument: 'Delt dokument',
  },
  messagingConversationBubble: {
    tombstone: 'Meldingen ble slettet av rådgiveren.',
    editAria: 'Rediger meldingen',
    actionsAria: 'Meldingshandlinger',
    edit: 'Rediger',
    delete: 'Slett',
    editedLabel: '(redigert)',
    seenLabel: 'sett',
  },
  messagingConversationComposer: {
    placeholderNamed: 'skriv en melding til {name} …',
    placeholder: 'skriv en melding …',
    deliveryHint: '{name} får meldingen på e-post, og kan svare deg der.',
    removeAttachment: 'Fjern vedlegg',
    attachLabel: 'Legg ved dokument eller bilde',
    enterHint: '↵ for å sende',
    sendLabel: 'Send melding',
    send: 'Send',
  },
  messagingConversationThread: {
    eventBooked: 'Møte booket',
    eventRescheduled: 'Møtet ble flyttet',
    eventCancelled: 'Møtet ble avbestilt',
    eventNoShow: 'Kunden møtte ikke',
    document: 'Dokument',
    sharedADocument: 'Delte et dokument',
    batchDocumentsShared: '{n} dokumenter delt',
    statusRevoked: 'Tilbakekalt',
    statusExpired: 'Utløpt',
    emptyBody: 'Ingen meldinger enda. Skriv den første nedenfor.',
    conversationAriaLabel: 'Samtale',
    openToSeeFiles: 'Åpne for å se filene',
    seenReceipt: 'sett',
  },
  // Notification titles/details the backend used to ship pre-rendered in
  // Norwegian. The wire now carries a key + params (title_key / detail_key),
  // so the bell follows the operator's language toggle. Kept as its own
  // top-level object rather than folded into notificationsNotificationRow —
  // the same catalog is addressed by the backend's dot-path verbatim and may
  // be consumed by other surfaces. Legacy rows carry no key and keep
  // rendering their stored plain string.
  notifications: {
    title: {
      newTimeProposed: 'Nytt tidspunkt foreslått',
      pollVoteCast: 'Ny stemme i avstemningen',
      bookingConfirmed: 'Bekreftet booking',
      meetingStartingSoon: 'Møtet starter snart',
      modeChanged: 'Møteform endret',
      locationChanged: 'Møtested endret',
      bookingMoved: 'Flyttet booking',
      newBooking: 'Ny booking',
      bookingCancelled: 'Avlyst booking',
      bookingNoShow: 'Kunden møtte ikke',
      lateCancellationBillable: 'Sen avbestilling, kunden bør faktureres',
      lateRescheduleBillable: 'Sen flytting, kunden bør faktureres',
      meetingUpdated: 'Møtet er oppdatert',
      proposalAccepted: 'Tidspunktforslaget ditt ble godtatt',
      proposalDeclined: 'Tidspunktforslaget ditt ble avslått',
      reassignedToYou: 'Du fikk møtet med {name}',
      reassignedToYouByActor: '{actorName} ga deg møtet med {name}',
      reassignedFromYou: 'Møtet med {name} ble overført til {newAdminName}',
      reassignedFromYouByActor: '{actorName} overførte møtet med {name} til {newAdminName}',
      newMessageFrom: 'Ny melding fra {who}',
      newDocumentFrom: 'Nytt dokument fra {who}',
      newDocumentFromCustomer: 'Nytt dokument fra en kunde',
      paymentDisputed: 'Betalingskrav fra kunden',
      refundFailed: 'Tilbakebetalingen gikk ikke gjennom',
      refundedExternally: 'Refusjon registrert fra Stripe',
      paymentLinkSent: 'Betalingslenke sendt',
      paymentRefunded: 'Betaling refundert',
      paymentReminderSent: 'Betalingspåminnelse sendt',
      paymentSettled: 'Betaling mottatt',
      paymentAttemptFailed: 'Betalingsforsøk feilet',
      paymentFailed: 'Betalingen feilet',
      paymentExpired: 'Betalingen utløp',
      actionPointDue: 'Frist på oppfølgingspunkt',
      mentioned: 'Du ble nevnt i et notat',
      noteComment: 'Ny kommentar i et notat',
      subscriptionUpdated: 'Abonnementet er oppdatert',
      subscriptionCanceled: 'Abonnementet er avsluttet',
      subscriptionCanceledScheduled: 'Oppsigelsen er registrert',
    },
    detail: {
      // The row formats the RFC3339 `iso` param through formatDate() in the
      // active locale before handing it here as `time`.
      slotTime: '{time}',
      subscriptionUpdated: 'Planen eller tilleggene dine er endret.',
      subscriptionCanceled: 'Du kan ikke gjøre endringer før du velger en plan igjen.',
      subscriptionCanceledScheduled: 'Du har tilgang ut perioden du har betalt for.',
    },
  },
  notificationsBuySMSModal: {
    title: 'Kjøp SMS-pakke',
    kicker: 'SMS-saldo',
    balancePrefix: 'Du har',
    balanceSuffix: 'SMS igjen.',
    balanceLoading: 'Henter saldo.',
    packName: '{count} SMS',
    packNote:
      'SMS-ene brukes til påminnelser før møter. De utløper ikke. Når saldoen er tom hopper vi over SMS, men e-postpåminnelsen sendes som vanlig.',
    buyMoreCta: 'Kjøp {count} SMS til',
    buyCta: 'Kjøp {count} SMS',
  },
  notificationsNotificationBell: {
    ariaLabel: 'Varslinger',
    ariaLabelUnread: 'Varslinger, {count} uleste',
    title: 'Varslinger',
  },
  notificationsNotificationGroupRow: {
    andMore: '· og {n} til | · og {n} flere',
    unreadCount: '{n} ny | {n} nye',
  },
  notificationsNotificationPanel: {
    dialogLabel: 'Varslinger',
    tabAll: 'Alle',
    tabUnread: 'Uleste',
    groupByCustomer: 'Grupper per kunde',
    markAllRead: 'Marker alle lest',
    emptyTitle: 'Du er ajour',
    emptyBody: 'Ingen nye varslinger. Vi sier fra når noe skjer.',
    byCustomer: 'etter kunde',
    settings: 'Innstillinger',
    allSeen: 'alt er sett',
    unreadMeta: '{n} uleste',
    dayToday: 'i dag',
    dayYesterday: 'i går',
  },
  notificationsNotificationRow: {
    markReadTitle: 'Marker som lest',
    markReadAria: 'Marker {title} som lest',
    archiveTitle: 'Arkiver',
    archiveAria: 'Arkiver {title}',
    // Per-notification event-type tag (the KIND label). Locale-aware so it
    // doesn't sit as Norwegian next to English panel chrome (#2445).
    kind: {
      booking: 'booking',
      cancel: 'avlysning',
      reschedule: 'flytting',
      reminder: 'påminnelse',
      payment: 'betaling',
      payment_settled: 'betaling mottatt',
      message: 'melding',
      noshow: 'no-show',
      system: 'system',
      late_change: 'sen endring',
      mention: 'omtale',
      document: 'dokument',
      note_comment: 'kommentar',
      sms_low: 'sms',
      poll: 'avstemning',
      action_point_due: 'frist',
    },
  },
  notificationsSMSBalanceCard: {
    title: 'SMS-saldo',
    hint: 'SMS-påminnelser sendes før møter til kunder som har oppgitt mobilnummer. Du kjøper SMS i pakker, og de utløper ikke.',
    unit: 'SMS igjen',
    meterLabel: '{remaining} av {total} kjøpte SMS igjen',
    bannerEmpty:
      'Du er tom for SMS. Påminnelser på e-post sendes som vanlig, men SMS hopper vi over til du fyller på.',
    bannerLow: 'Det begynner å bli lite igjen. Fyll på før saldoen er tom.',
    buyMore: 'Kjøp flere SMS',
    buyPackage: 'Kjøp SMS-pakke',
    historyTitle: 'Forbruk',
    reasonTopup: 'Kjøpt',
    reasonSend: 'Sendt',
    reasonRefund: 'Refundert',
    reasonSegment: 'Ekstra segment',
    reasonAdjustment: 'Justert',
  },
  portalBookingCard: {
    summaryRegion: 'Oppsummering fra rådgiveren',
    expandSummary: 'Vis hele oppsummeringen',
    collapseSummary: 'Vis mindre',
  },
  portalBookingDocumentsPanel: {
    openDocument: 'Åpne {name}',
    chipViewOnly: 'kun visning',
    chipDownloadable: 'nedlastbar',
  },
  portalBookingMessagesPanel: {
    advisorFallback: 'rådgiveren',
    title: 'Chat',
    hint: 'om dette møtet',
    loading: 'Laster meldinger …',
    emptyBody: 'Skriv en melding til {advisor}. Den havner i innboksen deres.',
    privacy: 'festes til dette møtet · {advisor} får beskjed',
  },
  portalMeetingCard: {
    lifecycle: {
      upcoming: 'kommende møte',
      pending: 'venter på bekreftelse',
      paymentPending: 'venter på betaling',
      completed: 'gjennomført møte',
      cancelled: 'avbestilt møte',
      expired: 'utløpt møte',
      noShow: 'ikke gjennomført',
      unresolved: 'tidspunktet har passert',
    },
    messageAriaLabel: 'Melding fra rådgiveren',
    agendaAriaLabel: 'Agenda',
    summaryAriaLabel: 'Oppsummering fra rådgiveren',
    paymentAriaLabel: 'Betaling',
    outstandingAriaLabel: 'Å betale',
  },
  portalPortalConversation: {
    advisorFallback: 'Rådgiveren',
    backAria: 'Tilbake til rommet',
    roleLabel: 'rådgiver',
    conversationAria: 'Samtale',
    emptyBody: 'Ingen samtaler ennå. Skriv den første nedenfor.',
    lockedBody: 'Du må ha et møte med rådgiveren for å starte en samtale.',
    bookCta: 'Book en time',
    privacyNote: 'bare du og {name} ser dette rommet',
  },
  portalPortalDocumentsPanel: {
    advisorFallback: 'rådgiveren',
    sendCta: 'Send et dokument',
    privacyNote:
      'Dokumentene er bare synlige for deg og {advisor}. Last dem ned hvis du vil beholde dem.',
    uploading: 'Laster opp…',
    successNote: '{name} sendt til {advisor}.',
    sendAnother: 'Send et til',
  },
  portalPortalHome: {
    advisorFallbackCap: 'Rådgiveren',
    advisorFallback: 'rådgiveren',
    summaryBannerTitleSubject: '{who} delte en oppsummering fra {subject}',
    summaryBannerTitle: '{who} delte en oppsummering',
    emptyMeetings: 'Ingen møter å vise.',
    emptyDocuments: 'Ingen dokumenter å vise.',
    emptyConversations: 'Ingen samtaler ennå. Skriv den første nedenfor.',
    emptyAll: 'Det er stille her ennå. Når dere har et møte eller deler noe, dukker det opp her.',
    statMeetings: 'møte holdt | møter holdt',
    statSummaries: 'oppsummering | oppsummeringer',
    statDocuments: 'dokument | dokumenter',
    loggedInAs: 'innlogget som {email}',
    heroEyebrow: 'delt rom',
    heroTitleWithAdvisor: 'Deg og {name}.',
    heroTitle: 'Ditt rom.',
    heroLeadWithAdvisor:
      'Hele forløpet med {advisor}{tenant}, samlet ett sted: møtene dere har hatt, oppsummeringene, dokumentene og meldingene, trygt bak innlogging.',
    heroLead: 'Møtene dine, dokumentene og meldingene, samlet ett sted og trygt bak innlogging.',
    summaryAriaLabel: 'Ny oppsummering',
    markRead: 'Merk som lest',
    streamEyebrow: 'tidslinje',
    streamOrder: 'eldste først',
    timelineAriaLabel: 'Tidslinje',
    composerLocked: 'Du må ha et møte med rådgiveren for å starte en samtale.',
    bookTime: 'Book en time',
    privacyNote: 'bare du og {name} ser dette rommet',
    forlopEyebrow: 'forløpet',
    inContactSince: 'i kontakt siden {date}',
    sendDocumentAriaLabel: 'Send et dokument',
  },
  portalPortalNextMeetingCard: {
    modeVideo: 'online',
    modeOffice: 'på kontoret',
    modeTreatment: 'behandling',
    modeTrening: 'trening',
    clock: 'kl {time}',
    meetingFallback: 'Møte',
    withAdvisor: 'med {name}',
    today: 'i dag',
    tomorrow: 'i morgen',
    inDays: 'om {days} dager',
    durationMins: '{mins} min',
    linkOpensBefore: 'lenken åpner 15 min før',
    eyebrow: 'neste møte',
    placeLabel: 'Møtested',
    joinMeeting: 'Bli med i møtet',
    addToCalendar: 'Legg til i kalender',
    requestNewTime: 'Be om ny tid',
    cancelMeeting: 'Avbestill',
    emptyTitle: 'Ingen kommende møter.',
    emptyBody: 'Når dere avtaler en ny samtale, dukker den opp her.',
  },
  portalReschedule: {
    backToPortal: 'Tilbake til møtene mine',
  },
  portalPortalPillFilter: {
    alle: 'alle',
    moter: 'møter',
    dokumenter: 'dokumenter',
    samtaler: 'samtaler',
    listLabel: 'Filtrer',
  },
  portalPortalTimelineView: {
    advisorFallbackLower: 'rådgiveren',
    advisorFallback: 'Rådgiveren',
    emptyMeetings: 'Ingen møter å vise.',
    emptyDocuments: 'Ingen dokumenter å vise.',
    emptyConversations: 'Ingen samtaler ennå. Send en melding under for å starte.',
    emptyAppointments: 'Du har ingen møter ennå.',
    composerTitle: 'Send en melding',
    composerLocked: 'Du må ha et møte med rådgiveren for å starte en samtale.',
    bookTime: 'Book en time',
    composerPrivacy: 'bare du og {name} ser dette rommet',
    uploadTitle: 'Send et dokument tilbake',
    dropPrimary: 'Klikk for å velge en fil eller dra og slipp',
    dropMeta: 'PDF, Word, regneark, presentasjon eller bilde. Maks 25 MB.',
    uploading: 'Laster opp…',
    uploadSuccess: '{name} sendt til rådgiveren.',
    uploadAnother: 'Send et til',
  },
  composablesCalendar: {
    blokkert: 'Blokkert',
  },
  composablesNorwegianHolidays: {
    nyttarsdag: 'Nyttårsdag',
    offentligHoytidsdag: 'Offentlig høytidsdag',
    grunnlovsdag: 'Grunnlovsdag',
    forsteJuledag: 'Første juledag',
    andreJuledag: 'Andre juledag',
    palmesondag: 'Palmesøndag',
    skjaertorsdag: 'Skjærtorsdag',
    langfredag: 'Langfredag',
    forstePaskedag: 'Første påskedag',
    andrePaskedag: 'Andre påskedag',
    kristiHimmelfartsdag: 'Kristi himmelfartsdag',
    forstePinsedag: 'Første pinsedag',
    andrePinsedag: 'Andre pinsedag',
  },
  composablesNotificationMappers: {
    today: 'i dag',
    yesterday: 'i går',
    system: 'System',
  },
  composablesUseActiveSessions: {
    minutes: '{m}m',
    hoursMinutes: '{h}t {m}m',
    daysCount: '{n} dag | {n} dager',
  },
  composablesUseAddPasskey: {
    registrationAborted:
      'Registrering avbrutt. Hvis du allerede har en passnøkkel for stemne i iCloud Nøkkelring eller 1Password, slett den først og prøv igjen.',
    addFailed: 'Kunne ikke legge til passnøkkel.',
  },
  composablesUseAddons: {
    apiIntegrationsTitle: 'API-integrasjoner',
    apiIntegrationsDescription:
      'Koble Stemne til CRM, regnskap eller egne systemer. Full tilgang til bookinger, kunder og fakturadata via et REST-API.',
    apiIntegrationsTagRestApi: 'REST-API',
    apiIntegrationsTagWebhooks: 'Webhooks',
    apiIntegrationsTagApiKeys: 'API-nøkler',
    apiIntegrationsTagCalls: '10 000 kall / mnd',
    loadFailed: 'Kunne ikke laste tillegg.',
    purchaseFailed: 'Kunne ikke aktivere tillegget.',
    cancelFailed: 'Kunne ikke avslutte tillegget.',
    waitlistFailed: 'Kunne ikke melde deg på ventelisten.',
    errorNoSubscription: 'Ingen aktivt abonnement. Velg en plan først.',
    errorRequiresHigherPlan: 'Tillegget krever en høyere plan. Oppgrader først.',
    errorUnavailable: 'Tillegget er ikke tilgjengelig akkurat nå. Prøv igjen senere.',
    errorAlreadyActive: 'Tillegget er allerede aktivt.',
    errorNotFound: 'Tillegget finnes ikke.',
    errorGeneric: 'Noe gikk galt. Prøv igjen.',
  },
  composablesUseAsyncData: {
    defaultError: 'Noe gikk galt. Prøv igjen.',
    defaultForbidden: 'Du har ikke tilgang til denne siden.',
  },
  composablesUseAuthRouting: {
    b5Primary: 'Opprett ny passnøkkel her',
    b5LoginSecondary: 'Logg inn med passnøkkelen din i stedet',
    loginPrimary: 'Logg inn med passnøkkel',
    b1AddDeviceSecondary: 'Legg til denne enheten i stedet',
    crossDeviceQr: 'Bruk passnøkkelen fra telefonen din i stedet (logg inn)',
    sendMagicLink: 'Send meg en innloggingslenke',
    signupTouchId: 'Opprett med Touch ID',
    signupFaceId: 'Opprett med Face ID',
    signupWindowsHello: 'Opprett med Windows Hello',
    signupSecurityKey: 'Opprett med sikkerhetsnøkkel',
    securityKeyHelp: 'Hva er en sikkerhetsnøkkel?',
    signupFingerprint: 'Opprett med fingeravtrykk',
    signupPasskey: 'Opprett passnøkkel',
    b2TouchIdMac: 'Legg til Touch ID på denne Mac-en',
    b2FaceId: 'Legg til Face ID på denne enheten',
    b3WindowsHello: 'Legg til Windows Hello her',
    b3SecurityKey: 'Legg til sikkerhetsnøkkel her',
    b4Fingerprint: 'Legg til fingeravtrykk på denne enheten',
    b5AddPasskey: 'Legg til passnøkkel her',
    b6AddPasskey: 'Legg til passnøkkel på denne enheten',
  },
  composablesUseBackNav: {
    overview: 'Tilbake til oversikt',
    overviewCrumb: 'Oversikt',
    meetings: 'Tilbake til møter',
    meetingsCrumb: 'Møter',
    notater: 'Tilbake til notater',
    notaterCrumb: 'Notater',
    customers: 'Tilbake til kunder',
    customersCrumb: 'Kunder',
    customerDetail: 'Tilbake til kunden',
    customerDetailCrumb: 'Kunden',
    meetingDetail: 'Tilbake til møtet',
    meetingDetailCrumb: 'Møtet',
    services: 'Tilbake til tjenester',
    servicesCrumb: 'Tjenester',
    availability: 'Tilbake til tilgjengelighet',
    availabilityCrumb: 'Tilgjengelighet',
    calendar: 'Tilbake til kalender',
    calendarCrumb: 'Kalender',
    settings: 'Tilbake til innstillinger',
    settingsCrumb: 'Innstillinger',
    account: 'Tilbake til kontoen',
    accountCrumb: 'Min konto',
    help: 'Tilbake til hjelp',
    helpCrumb: 'Hjelp',
  },
  // Behandlingsgrunnlag-fence-låsepanelet, nøklet på bookingens tjenestekind
  // (behandling / trening / nøytral fallback). Brukes kun via useBasisLockCopy
  // — den delte katalogen for møtesiden, TreatmentPrep og wrap-modalen, så
  // teksten ikke kan drifte mellom flatene.
  composablesUseBasisLockCopy: {
    titleTreatment: 'Behandlingsdata er låst',
    titleTraining: 'Treningsdata er låst',
    titleNeutral: 'Møtedata er låst',
    bodyBasisTreatment:
      'Planer, notater og oppsummeringer blir tilgjengelige når du har et behandlingsgrunnlag med kunden.',
    bodyBasisTraining:
      'Planer, notater og oppsummeringer blir tilgjengelige når du selv har økter med denne utøveren.',
    bodyBasisNeutral:
      'Planer, notater og oppsummeringer blir tilgjengelige når du selv har møter med denne kunden.',
    bodyAssignedTreatment:
      'Møtet er tildelt {name}. Behandlingsdata er bare synlig for behandlere som selv har timer med kunden.',
    bodyAssignedTraining:
      'Økten er tildelt {name}. Treningsdata er bare synlig for trenere som selv har økter med utøveren.',
    bodyAssignedNeutral:
      'Møtet er tildelt {name}. Notater og forberedelser er bare synlige for kolleger som selv har møter med kunden.',
    bodySharedNote:
      'Notater fra møtet er delt med deg. Øvrige møtedata er bare synlige for kolleger som selv har møter med kunden.',
    wrapBodyTreatment:
      'Oppsummeringen blir tilgjengelig når du har et behandlingsgrunnlag med kunden.',
    wrapBodyTraining: 'Oppsummeringen blir tilgjengelig når du selv har økter med denne utøveren.',
    wrapBodyNeutral: 'Oppsummeringen blir tilgjengelig når du selv har møter med denne kunden.',
  },
  composablesUseBillingPlanChange: {
    nowOnPlan: 'Du er nå på {plan}',
    planSolo: 'Solo',
    planTeam: 'Team',
    planVekst: 'Vekst',
    planTrial: 'Prøveperiode',
    planComp: 'Avtalt fritak',
    soloFeatureBookingPage: 'Egen bookingside',
    soloFeatureSharedWithCustomers: 'Delt med kunder',
    soloFeatureEmailReminders: 'E-post-påminnelser',
    teamFeatureSeats: '5 brukere på samme arbeidsrom',
    teamFeatureAssignMeetings: 'Tildel møter til kolleger',
    teamFeatureNotes: "Notater med {'@'}-omtaler og delte tråder",
    teamFeatureSharedAvailability: 'Felles tilgjengelighet og kalender',
    vekstFeatureSeats: '15 brukere på samme arbeidsrom',
    vekstFeatureRoles: 'Rolle-styring: administrator og rådgiver',
    vekstFeatureJournal: 'Behandlingsjournal med PainScale',
    vekstFeaturePrioritySupport: 'Prioritert support',
  },
  composablesUseBooking: {
    fetchNotFound: 'Møtet ble ikke funnet. Lenken kan ha utløpt.',
    fetchFailed: 'Kunne ikke hente møtet. Prøv igjen.',
    confirmFailed: 'Kunne ikke bekrefte møtet. Prøv igjen.',
    rescheduleSlotTaken: 'Denne tiden er ikke lenger tilgjengelig. Velg en annen tid.',
    rescheduleNotDirect:
      'Dette møtet kan ikke endres direkte. Ta kontakt med rådgiveren for å endre tidspunkt.',
    rescheduleFailed: 'Kunne ikke endre tidspunkt. Prøv igjen.',
    cancelFailed: 'Kunne ikke avbestille møtet. Prøv igjen.',
    proposeAlreadyOpen: 'Du har allerede et åpent forslag for dette møtet.',
    proposeNotChangeable: 'Møtet kan ikke endres nå.',
    proposeFailed: 'Kunne ikke sende forslaget. Prøv igjen.',
    cancelSeriesFailed: 'Kunne ikke avbestille serien. Prøv igjen.',
    cancelSeriesNothingLeft: 'Serien har ingen kommende møter igjen. Ingenting ble avbestilt.',
  },
  composablesUsePortalManage: {
    rescheduleSlotTaken: 'Denne tiden er ikke lenger tilgjengelig. Velg en annen tid.',
    rescheduleNotDirect:
      'Dette møtet kan ikke endres her. Ta kontakt med rådgiveren for å endre tidspunkt.',
    reschedulePastSlot: 'Tidspunktet er ugyldig eller har passert. Velg en annen tid.',
    rescheduleFailed: 'Kunne ikke endre tidspunkt. Prøv igjen.',
    cancelAlreadyGone: 'Møtet er allerede avbestilt.',
    cancelFailed: 'Kunne ikke avbestille møtet. Prøv igjen.',
  },
  composablesUseBookingFlow: {
    invalidData: 'Ugyldig data. Sjekk skjemaet og prøv igjen.',
    nameMaxLength: 'Navnet kan være maks {max} tegn.',
    emailMaxLength: 'E-postadressen kan være maks {max} tegn.',
    emailInvalid: 'E-postadressen er ugyldig.',
    nameRequired: 'Skriv inn navnet ditt.',
    emailRequired: 'Skriv inn e-postadressen din.',
    slotRequired: 'Velg et tidspunkt.',
    billingAddressRequired: 'Oppgi fakturaadressen.',
    subjectMaxLength: 'Emnet kan være maks {max} tegn.',
    messageMaxLength: 'Meldingen kan være maks {max} tegn.',
    addressMaxLength: 'Adressen kan være maks {max} tegn.',
    postCodeMaxLength: 'Postnummeret kan være maks {max} tegn.',
    postPlaceMaxLength: 'Poststedet kan være maks {max} tegn.',
    slotUnavailable: 'Denne tiden er ikke lenger tilgjengelig. Velg en annen tid.',
    genericError: 'Noe gikk galt. Prøv igjen senere.',
    networkError: 'Kunne ikke opprette møtet. Sjekk internettforbindelsen.',
  },
  composablesUseBookingMessages: {
    linkExpired: 'Lenken er utløpt. Be om en ny.',
    loadFailed: 'Vi kunne ikke laste meldingene. Prøv igjen.',
    sendFailedTooLong: 'Meldingen kunne ikke sendes. Prøv en kortere tekst.',
    sendFailed: 'Vi kunne ikke sende meldingen. Prøv igjen om et øyeblikk.',
    sendEmpty: 'Du kan ikke sende en tom melding.',
  },
  composablesUseBrand: {
    roleAdmin: 'Administrator',
    roleAdvisor: 'Rådgiver',
  },
  composablesUseBulkImport: {
    fileTooLarge: 'Filen er for stor, maks 5 MB.',
    fileEmpty: 'Filen ser tom ut. Sjekk at den har overskrifter og minst én rad.',
    fileNoRows: 'Filen har overskrifter men ingen rader.',
    fileTooManyRows: 'Filen har for mange rader ({count}). Maks {max}.',
  },
  composablesUseCalendarDrag: {
    pastSlot: 'Kan ikke flytte møte til en tid som har passert.',
    moved: 'Flyttet til {label}',
    moveFailed: 'Kunne ikke flytte møtet.',
  },
  composablesUseCalendarSlotInteractions: {
    reasonBooked: 'Booket',
    meeting: 'møte',
    busy: 'opptatt',
    reasonBlocked: 'Blokkert',
    reasonBuffer: 'Buffer rundt et møte',
    reasonAllDay: 'Heldags',
    reasonPast: 'Kan ikke opprette møter i fortiden',
    reasonOutsideHours: 'Utenfor arbeidstid',
    reasonUnavailable: 'Ikke tilgjengelig',
    statusPending: 'Venter',
    statusCompleted: 'Gjennomført',
    statusUnresolved: 'Uavklart',
    statusNoShow: 'Ikke møtt',
  },
  composablesUseCalendarViewState: {
    viewModeDay: 'Dag',
    viewModeWeek: 'Uke',
    viewModeMonth: 'Måned',
    weekHeading: 'Uke {n} · {range}',
  },
  composablesUseConversation: {
    loadError: 'Vi kunne ikke laste samtalen. Prøv igjen.',
    sendError: 'Kunne ikke sende meldingen.',
    editError: 'Kunne ikke endre meldingen.',
    deleteError: 'Kunne ikke slette meldingen.',
  },
  composablesUseCurrentAdmin: {
    roleOwner: 'Eier',
    roleAdmin: 'Administrator',
    roleAdvisor: 'Rådgiver',
    loadProfileError: 'Kunne ikke laste profilen',
  },
  composablesUseAnalytics: {
    periodWeek: 'Siste 7 dager',
    periodMonth: 'Siste 30 dager',
    periodQuarter: 'Siste kvartal',
    deltaSame: 'som forrige periode',
    deltaChange: '{sign}{n} fra forrige periode',
  },
  composablesUseCustomerAccess: {
    rateLimited: 'For mange forsøk. Vent litt og prøv igjen.',
    sendLinkFailed: 'Vi kunne ikke sende lenken. Prøv igjen om et øyeblikk.',
    genericError: 'Noe gikk galt. Prøv igjen.',
  },
  composablesUseCustomerDocuments: {
    linkExpired: 'Lenken er utløpt.',
    loadFailed: 'Kunne ikke laste dokumenter.',
  },
  composablesUseCustomerTimelineV2: {
    weekdaySunday: 'Søndag',
    weekdayMonday: 'Mandag',
    weekdayTuesday: 'Tirsdag',
    weekdayWednesday: 'Onsdag',
    weekdayThursday: 'Torsdag',
    weekdayFriday: 'Fredag',
    weekdaySaturday: 'Lørdag',
    monthJanuary: 'januar',
    monthFebruary: 'februar',
    monthMarch: 'mars',
    monthApril: 'april',
    monthMay: 'mai',
    monthJune: 'juni',
    monthJuly: 'juli',
    monthAugust: 'august',
    monthSeptember: 'september',
    monthOctober: 'oktober',
    monthNovember: 'november',
    monthDecember: 'desember',
    todayLabel: 'I dag · {weekday} {day}. {month}',
    customerSince: 'Kunde siden {date}',
    loadCustomerError: 'Kunne ikke laste kunden.',
    ghostBookMeeting: 'book et møte',
    ghostShareDocument: 'del et dokument',
    shareSummaryError: 'Kunne ikke dele oppsummering.',
    unshareSummaryError: 'Kunne ikke avslutte deling.',
    searchNotConfigured: 'Søk er ikke konfigurert for denne installasjonen.',
    searchError: 'Kunne ikke søke.',
  },
  composablesUseCustomerUpload: {
    unsupportedType: 'Filtypen støttes ikke. Velg PDF, Word, regneark, presentasjon eller bilde.',
    emptyFile: 'Filen er tom eller skadet.',
    tooLarge: 'Filen er for stor. Maks 25 MB.',
    linkExpired: 'Lenken er utløpt. Be om en ny tilgang.',
    accountNotFound: 'Vi fant ikke kontoen din. Be om en ny tilgang.',
    unsupportedTypeShort: 'Filtypen støttes ikke.',
    uploadUnavailable: 'Opplasting er midlertidig utilgjengelig. Prøv igjen.',
    uploadFailed: 'Noe gikk galt med opplastingen.',
  },
  composablesUseInviteeMeeting: {
    meetingNotFound: 'Møtet ble ikke funnet. Lenken kan ha utløpt.',
    loadFailed: 'Kunne ikke hente møtet. Prøv igjen.',
    confirmFailed: 'Kunne ikke bekrefte deltakelsen. Prøv igjen.',
    declineFailed: 'Kunne ikke lagre svaret. Prøv igjen.',
    proposalPending: 'Du har allerede et åpent forslag for dette møtet.',
    meetingNotChangeable: 'Møtet kan ikke endres nå.',
    proposalFailed: 'Kunne ikke sende forslaget. Prøv igjen.',
  },
  composablesUseMeetingChat: {
    loadFailed: 'Kunne ikke laste meldingene.',
    sendFailed: 'Meldingen ble ikke sendt.',
    pinFailed: 'Kunne ikke oppdatere festingen.',
    liftFailed: 'Kunne ikke løfte meldingen.',
  },
  composablesUseMeetingEditSession: {
    modeVideo: 'Videomøte',
    modeOffice: 'På kontoret',
    modeTreatment: 'Behandling',
    modeTrening: 'Trening',
    weekdaySunday: 'søndag',
    weekdayMonday: 'mandag',
    weekdayTuesday: 'tirsdag',
    weekdayWednesday: 'onsdag',
    weekdayThursday: 'torsdag',
    weekdayFriday: 'fredag',
    weekdaySaturday: 'lørdag',
    monthJanuary: 'januar',
    monthFebruary: 'februar',
    monthMarch: 'mars',
    monthApril: 'april',
    monthMay: 'mai',
    monthJune: 'juni',
    monthJuly: 'juli',
    monthAugust: 'august',
    monthSeptember: 'september',
    monthOctober: 'oktober',
    monthNovember: 'november',
    monthDecember: 'desember',
    slotFallback: '{date} kl {time}',
    slotFull: '{weekday} {day}. {month} kl {time}',
    joinLast: '{head} og {last}',
    titleTime: 'Nytt tidspunkt',
    titleDuration: 'Endret varighet',
    durationMinutes: '{mins} min',
    titleMode: 'Endret møteform',
    titleLocation: 'Endret møtested',
    titleAgenda: 'Endret agenda',
    titleDocuments: 'Endret dokumenter',
    titleGreeting: 'Endret hilsen',
    defaultAddress: 'Standard adresse',
    multiSummary: 'Vi har oppdatert møtet: {list}.',
    addedAgenda: 'la til {n} punkt | la til {n} punkter',
    removedAgenda: 'fjernet {n} punkt | fjernet {n} punkter',
    addedDocuments: 'la til {n} dokument | la til {n} dokumenter',
    removedDocuments: 'fjernet {n} dokument | fjernet {n} dokumenter',
    sentenceTime: 'Vi har flyttet møtet til {summary}.',
    sentenceDuration: 'Varigheten er endret til {summary}.',
    sentenceMode: 'Møteformen er endret til {mode}.',
    sentenceLocation: 'Møtestedet er endret til {summary}.',
    sentenceLocationDefault: 'Møtestedet er oppdatert.',
    sentenceAgenda: 'Vi har oppdatert agendaen for møtet.',
    sentenceDocuments: 'Vi har oppdatert dokumentene for møtet.',
    sentenceGreeting: 'Vi har oppdatert hilsenen i invitasjonen.',
    sentenceDefault: 'Vi har oppdatert møtet.',
    phraseTime: 'nytt tidspunkt',
    phraseDuration: 'ny varighet',
    phraseMode: 'ny møteform',
    phraseLocation: 'nytt møtested',
    phraseAgenda: 'oppdatert agenda',
    phraseDocuments: 'oppdaterte dokumenter',
    phraseGreeting: 'endret hilsen',
    phraseDefault: 'endringer',
  },
  composablesUseMeetingNotes: {
    loadFailed: 'Kunne ikke laste notater',
    saveStandaloneFailed: 'Kunne ikke lagre frittstående notat',
    saveFailed: 'Kunne ikke lagre notat',
    saveDraftFailed: 'Kunne ikke lagre kladd',
    conflict: 'En nyere versjon ble lagret av en annen økt. Last på nytt og prøv igjen.',
    saveRevisionFailed: 'Kunne ikke lagre versjon',
    deleteFailed: 'Kunne ikke slette notat',
  },
  composablesUseNoteComments: {
    loadFailed: 'Kunne ikke laste kommentarer.',
    commentAccessDenied: 'Du har lese-tilgang, men ikke kommentar-tilgang på dette notatet.',
    postFailed: 'Kunne ikke sende kommentar.',
    deleteFailed: 'Kunne ikke slette kommentar.',
  },
  composablesUseNoteDuplicate: {
    duplicateError: 'Kunne ikke duplisere notatet. Prøv igjen.',
  },
  composablesUseNoteLink: {
    loadError: 'Kunne ikke laste møtene. Prøv igjen.',
    saveError: 'Kunne ikke endre koblingen. Prøv igjen.',
  },
  composablesUseNoteRename: {
    renameFailed: 'Kunne ikke endre tittelen. Prøv igjen.',
  },
  composablesUseNotesTips: {
    live1Body:
      'Lim inn et skjermbilde rett i notatet, eller bruk kameraikonet. Bildet blir liggende i notatet og følger med i PDF-en du kan laste ned etterpå.',
    live1Link: 'Slik skriver du møtenotater',
    live2Body:
      'Fet skrift, mellomtitler og punktlister overlever helt inn i PDF-en. Bruk dem på det du vil finne igjen om et halvt år.',
    live2Link: 'Formatering i notater',
    live3Body:
      'Skriv krøllalfa og navnet til en kollega for å gi hen tilgang til notatet uten å forlate møtet.',
    live3Link: 'Dele notater med kolleger',
    live4Body:
      'Under «punkter» kan du legge inn hvem som gjør hva, og når. Det havner på oppsummeringen kunden får.',
    live4Link: 'Aksjonspunkter etter møtet',
    live5Body:
      'Dette notatet er internt. Det kunden ser, er oppsummeringen du skriver når du avslutter møtet.',
    live5Link: 'Hva kunden ser',
    tip1Body:
      'Lim inn lenker, tidligere e-poster, eller utklipp fra forrige møte. Notatene følger med inn i møtet og finnes i arkivet etterpå.',
    tip1Link: 'Slik bruker du forberedelses-notater',
    tip2Body:
      'Bruk korte spørsmål-lister, det du vil huske å spørre om, heller enn fullskrevet manus. Du kommer raskere i flyt under møtet.',
    tip2Link: 'Hva som passer i forberedelser',
    tip3Body:
      'Forberedelser og møtenotater er to ulike spor. Hold "ting jeg planla å spørre om" adskilt fra "ting kunden faktisk sa".',
    tip3Link: 'Hvorfor adskilt fra møtenotater',
    tip4Body:
      'Skriv "Husk å spørre om barnet er friskt igjen", det personlige som gjør oppfølginger ekte. Notatene er kun for deg og kolleger med tilgang.',
    tip4Link: 'Hva passer i forberedelser',
    tip5Body:
      "Du kan {'@'}-omtale en kollega i et notat, de får varsel og lese-tilgang, selv om de ikke vanligvis ser møtene dine.",
    tip5Link: "Slik {'@'}-omtaler du en kollega",
    tip6Body:
      'Skriv `/` midt i et notat for en rask formatering-meny, overskrifter, lister, kode, fet.',
    tip6Link: 'Format-snarveiene',
    tip7Body:
      'Som administrator kan du se andres møter, men private tjenester redigeres bare av eieren. Tilgangsåpning loggføres.',
    tip7Link: 'Hva administrator kan og ikke kan se',
    tip8Body:
      'Trenger kunden å se konteksten? Det er bevisst friksjon, notatene er interne. Bruk meldingstråden hvis du vil dele noe.',
    tip8Link: 'Sende melding til kunden',
    tip9Body:
      'Notatene synkroniseres mens du skriver. Du kan lukke fanen midt i en setning og fortsette i en annen, siste tegn er på plass.',
    tip9Link: 'Hvor møtenotatene lagres',
    tip10Body:
      'Tjenesten kan settes som privat. Da ser ikke andre rådgivere navn, e-post, eller notater, bare at tidspunktet er opptatt.',
    tip10Link: 'Slik fungerer privat-flagget',
  },
  composablesUseOrgActivity: {
    weekdaySunday: 'søndag',
    weekdayMonday: 'mandag',
    weekdayTuesday: 'tirsdag',
    weekdayWednesday: 'onsdag',
    weekdayThursday: 'torsdag',
    weekdayFriday: 'fredag',
    weekdaySaturday: 'lørdag',
    monthJanuary: 'januar',
    monthFebruary: 'februar',
    monthMarch: 'mars',
    monthApril: 'april',
    monthMay: 'mai',
    monthJune: 'juni',
    monthJuly: 'juli',
    monthAugust: 'august',
    monthSeptember: 'september',
    monthOctober: 'oktober',
    monthNovember: 'november',
    monthDecember: 'desember',
    dayToday: 'I dag · {base}',
    dayYesterday: 'I går · {base}',
    verbBooked: 'booket {title}',
    verbCancelled: 'avbestilte {title}',
    verbRescheduled: 'flyttet {title}',
    verbCompleted: 'fullførte {title}',
    verbNoShow: 'møtte ikke til {title}',
    verbMessage: 'sendte en melding',
    verbDocumentIn: 'sendte et dokument',
    verbDocumentShared: 'delte et dokument i {title}',
    verbDocumentGot: 'fikk et dokument',
    verbCustomer: 'ble kunde',
    verbNoteShared: 'delte et notat med deg',
    verbBookingShared: 'delte {title} med deg',
    meetingFallback: 'møte',
    aMeetingFallback: 'et møte',
    metaCancelled: '{meta} · avbestilt',
    metaNoShow: '{meta} · ikke møtt',
    metaMessageExcerpt: '«{excerpt}»',
    policyView: 'kun visning',
    policyDownload: 'nedlasting',
    metaDocumentReceived: '{name} · mottatt',
    customerViaBookingLink: 'via bookinglenken deres',
    customerAddedManually: 'lagt til manuelt',
    modeOffice: 'oppmøte',
    modeTreatment: 'behandling',
    modeVideo: 'video',
    loadError: 'Kunne ikke laste aktivitet.',
  },
  composablesUsePasskeyLogin: {
    hintNoPasskeyForDevice:
      'Vi finner ingen passnøkkel for denne e-posten på denne enheten. Send deg selv en innloggingslenke, den fungerer også fra et nytt nettleser-vindu.',
    hintDeviceDeclined:
      'Enheten fant ingen passnøkkel for denne kontoen. Send deg en innloggingslenke i stedet.',
    hintFinishRejected:
      'Innlogging feilet. Send deg en innloggingslenke, eller prøv passnøkkel igjen.',
    hintUnknown:
      'Vi fant ingen passnøkkel for denne enheten. Send deg en innloggingslenke for å logge inn.',
    hintStaleRpId:
      'Du må enrolle en ny passnøkkel på denne kontoen. Vi sender deg en innloggingslenke i stedet.',
    errorGeneric: 'Vi får ikke kontakt med innloggingen akkurat nå. Prøv igjen om et øyeblikk.',
  },
  composablesUsePasskeySudoReauth: {
    accountNotFound: 'Vi fant ikke kontoen din. Logg inn på nytt.',
    noPasskey: 'Ingen passnøkkel registrert på denne enheten. Logg inn på nytt for å fortsette.',
    staleRpId:
      'Passnøkkelen din må fornyes. Logg inn på nytt med innloggingslenke og enrolle en ny passnøkkel.',
    cancelled: 'Du avbrøt. Prøv igjen for å fortsette.',
    authFailed: 'Autentisering feilet. Prøv igjen.',
    genericError: 'Noe gikk galt. Prøv igjen.',
  },
  composablesUsePlanFeatures: {
    loadError: 'Klarte ikke å laste plan-funksjoner.',
  },
  composablesUsePortalMessages: {
    linkExpired: 'Lenken er utløpt. Be om en ny.',
    loadFailed: 'Vi kunne ikke laste samtalene. Prøv igjen.',
    needBooking: 'Du må ha et møte med rådgiveren for å starte en samtale.',
    sendTooLong: 'Meldingen kunne ikke sendes. Prøv en kortere tekst.',
    sendFailed: 'Vi kunne ikke sende meldingen. Prøv igjen om et øyeblikk.',
  },
  composablesUsePriorBookings: {
    loadFailed: 'Kunne ikke laste tidligere møter.',
  },
  composablesUsePrivacy: {
    rateLimited: 'For mange forespørsler. Prøv igjen om litt.',
    generic: 'Noe gikk galt. Prøv igjen.',
    exportFailed: 'Kunne ikke hente dataene dine.',
    deleteFailed: 'Sletting feilet.',
  },
  // Customer-facing role noun, resolved from the service kind (#2014). Three
  // forms per segment because Norwegian needs label / indefinite / definite and
  // no callable rule derives one from another.
  composablesUseRoleNoun: {
    advisorLabel: 'Rådgiver',
    advisorIndefinite: 'rådgiver',
    advisorDefinite: 'rådgiveren',
    therapistLabel: 'Behandler',
    therapistIndefinite: 'behandler',
    therapistDefinite: 'behandleren',
    trainerLabel: 'Trener',
    trainerIndefinite: 'trener',
    trainerDefinite: 'treneren',
  },
  composablesUseRoom: {
    loadFailed: 'Kunne ikke laste rommet.',
  },
  composablesUseSMSCredits: {
    loadBalanceError: 'Kunne ikke hente SMS-saldo',
    startPurchaseError: 'Kunne ikke starte kjøpet',
  },
  composablesUseActionPoints: {
    loadError: 'Kunne ikke laste oppfølgingspunkter.',
  },
  composablesUseCustomerActionPoints: {
    loadError: 'Kunne ikke laste kundens oppfølgingspunkter.',
  },
  composablesUseServicesList: {
    loadError: 'Kunne ikke laste tjenester.',
    created: 'Tjenesten er opprettet.',
    saved: 'Endringene er lagret.',
    removed: 'Tjenesten er slettet.',
  },
  composablesUseSlots: {
    fetchSlotsError: 'Kunne ikke hente ledige tider. Prøv igjen.',
  },
  composablesUseSlotsRange: {
    fetchFailed: 'Kunne ikke hente tilgjengelighet.',
  },
  composablesUseStripePortal: {
    openPortalError: 'Kunne ikke åpne kundeportal.',
  },
  composablesUseSudoAction: {
    somethingWrong: 'Noe gikk galt.',
    cancelled: 'Du avbrøt, prøv igjen om du vil.',
    authFailed: 'Autentisering feilet.',
    registrationFailed: 'Registrering feilet.',
  },
  composablesUseTeamMeetings: {
    busyDefault: 'Noen deltakere er allerede booket',
  },
  composablesUseTenant: {
    loadError: 'Kunne ikke laste innstillinger. Prøv å laste siden på nytt.',
  },
  composablesUseTimePoll: {
    pollNotFound: 'Avstemningen ble ikke funnet. Lenken kan ha utløpt.',
    loadFailed: 'Kunne ikke hente avstemningen. Prøv igjen.',
  },
  composablesUseTreatment: {
    loadFailed: 'Kunne ikke laste behandlingsdata',
    startFailed: 'Kunne ikke starte behandlingen',
    finishFailed: 'Kunne ikke avslutte',
    addFailed: 'Kunne ikke legge til',
    updateFailed: 'Kunne ikke oppdatere',
    deleteFailed: 'Kunne ikke slette',
    saveAnswerFailed: 'Kunne ikke lagre svar',
    saveExerciseFailed: 'Kunne ikke lagre øvelsen',
    deleteExerciseFailed: 'Kunne ikke slette øvelsen',
    saveJournalFailed: 'Kunne ikke lagre journal',
    loadChipsFailed: 'Kunne ikke laste tiltak-chips',
    addChipFailed: 'Kunne ikke legge til chip',
    updateChipFailed: 'Kunne ikke oppdatere chip',
    deleteChipFailed: 'Kunne ikke slette chip',
  },
  composablesUseTreatmentFraming: {
    trainingPrepTitle: 'Forbered økten.',
    trainingPrepLede:
      'Notatene er bare synlige for deg og kolleger med tilgang. Se hva som virket sist, og skriv ned det du må følge opp i dag.',
    trainingCtaStart: 'Start økten →',
    trainingCtaResume: 'Fortsett økten →',
    trainingServiceFallback: 'Treningsøkt',
    trainingSeriesNoun: 'Økt',
    trainingPersonNoun: 'utøver',
    trainingPlanKicker: 'gjør dette',
    trainingPlanTitle: 'Dagens plan.',
    trainingPinnedLabel: 'Øktshandlinger',
    trainingFinishTitle: 'Avslutte økten?',
    trainingClientFollowupTitle: 'Ditt opplegg til neste økt',
    trainingClientVisibilityHint: 'Synlig for utøveren',
    therapyPrepTitle: 'Forbered behandlingen.',
    therapyPrepLede:
      'Notatene er bare synlige for deg og kolleger med tilgang. Sjekk hva som virket sist, og skriv ned det du må følge opp i dag.',
    therapyCtaStart: 'Start behandlingen →',
    therapyCtaResume: 'Fortsett behandlingen →',
    therapyServiceFallback: 'Behandling',
    therapySeriesNoun: 'Behandling',
    therapyPersonNoun: 'pasient',
    therapyPlanKicker: 'behandle dette',
    therapyPlanTitle: 'Plan for i dag.',
    therapyPinnedLabel: 'Behandlingshandlinger',
    therapyFinishTitle: 'Avslutte behandlingen?',
    therapyClientFollowupTitle: 'Ditt opplegg til neste gang',
    therapyClientVisibilityHint: 'Synlig for kunden',
  },
  composablesUseTurnstile: {
    verifyFailedWithCode:
      'Kunne ikke fullføre robotsjekken (kode {code}). Last siden på nytt, eller prøv en annen nettleser.',
    verifyFailed:
      'Kunne ikke fullføre robotsjekken. Last siden på nytt, eller prøv en annen nettleser.',
    loadFailed:
      'Robotsjekken kunne ikke lastes. Last siden på nytt, eller prøv en annen nettleser.',
    unsupported: 'Nettleseren støtter ikke robotsjekken. Prøv en annen nettleser.',
  },
  composablesUseUpcomingMeeting: {
    startsNow: 'starter nå',
    underOneMin: 'om under 1 min',
    inMins: 'om {mins} min',
  },
  composablesUseUpload: {
    aborted: 'Opplastingen ble avbrutt',
    networkError: 'Nettverksfeil. Sjekk tilkoblingen og prøv igjen.',
    unavailable: 'Bildeopplasting er midlertidig utilgjengelig',
    mustReLogin: 'Du må logge inn på nytt',
    genericError: 'Noe gikk galt med opplastingen',
    fileTooLarge: 'Filen er for stor. Maks 10 MB.',
    videoTooLarge: 'Videoen er for stor. Maks 300 MB.',
    contentTypeNotAllowed: 'Filtypen støttes ikke. Prøv et annet format.',
    rejected: 'Opplastingen ble avvist. Prøv igjen.',
    fileEmptyOrCorrupt: 'Filen er tom eller skadet. Prøv en annen fil.',
  },
  composablesUseWebhookEndpoints: {
    unknownError: 'Ukjent feil',
  },
  utilsCustomerCsv: {
    colName: 'Navn',
    colEmail: 'E-post',
    colMeetingCount: 'Antall møter',
    colLastMeeting: 'Siste møte',
    colNextMeeting: 'Neste møte',
    colValue: 'Pris totalt',
    colTags: 'Etiketter',
    filename: 'kunder.csv',
  },
  utilsHelpActions: {
    titleInviteAdvisor: 'Åpne Innstillinger → Team og start invitasjon av en rådgiver',
    titleInviteAdmin: 'Åpne Innstillinger → Team og start invitasjon av en administrator',
    titleInviteOwner: 'Åpne Innstillinger → Team og start invitasjon av en eier',
    titleManageTeam: 'Åpne Innstillinger → Team',
    titleEditBrand: 'Åpne Innstillinger → Profil & booking',
    titleEditCompany: 'Åpne Innstillinger → Selskap',
    titleEditPersonalProfile: 'Åpne Min konto',
    titleConnectCalendar: 'Åpne Kalender og koble til Google eller Outlook',
    titleManageCalendar: 'Administrer tilkoblet kalender',
    titleViewAvailability: 'Åpne Tilgjengelighet',
    titleMagicLinkLogin: 'Be om en magisk innloggingslenke',
    titleAddPasskey: 'Legg til en ny passnøkkel på kontoen din',
    titleChangeEmail: 'Endre e-postadressen på kontoen din',
    titleViewNotifications: 'Åpne Min konto, fanen Varslinger',
    titleViewAuditLog: 'Åpne Innstillinger → Aktivitetslogg',
    titleManageBilling: 'Åpne Innstillinger → Fakturering',
    titleViewInvoices: 'Se tidligere fakturaer',
    titleConnectFiken: 'Koble Stemne til Fiken',
    titleManagePayments: 'Åpne Betalinger i innstillingene',
    titleViewMeetings: 'Åpne Møter',
    titleNewMeeting: 'Lag et nytt møte på vegne av en kunde',
    titleInstantMeeting: 'Start et «Møt nå»-rom',
    titleViewCustomers: 'Åpne Kunder',
    titleExportCustomers: 'Eksportér kundeliste som CSV',
    titleImportCustomers: 'Importer flere kunder fra CSV',
    titleViewServices: 'Åpne Tjenester',
    titleAddService: 'Legg til en ny tjeneste',
    titleAddTimeOff: 'Legg til en fri-periode',
    titleAddDayOverride: 'Legg til engangs-endring for én dag',
  },
  utilsInvoiceBasisCsv: {
    colCustomer: 'Kunde',
    colEmail: 'E-post',
    colService: 'Tjeneste',
    colCategory: 'Kategori',
    colStatus: 'Status',
    colCount: 'Antall',
    colMinutes: 'Minutter',
    statusHeld: 'Gjennomført',
    statusNoShow: 'Ikke møtt',
    filenamePrefix: 'fakturagrunnlag',
  },
  utilsMessageTemplates: {
    greetingNamed: 'Hei {name},',
    greeting: 'Hei,',
    proposal: 'jeg må dessverre flytte møtet vårt. Funker {day} {time} for deg?',
    instruction:
      'Vennligst bekreft om det nye tidspunktet passer, eller bruk kalendervelgeren til å foreslå et annet.',
    daySunday: 'søndag',
    dayMonday: 'mandag',
    dayTuesday: 'tirsdag',
    dayWednesday: 'onsdag',
    dayThursday: 'torsdag',
    dayFriday: 'fredag',
    daySaturday: 'lørdag',
  },
  utilsPasskeyLabel: {
    icloudKeychain: 'iCloud-nøkkelring',
    googlePasswordManager: 'Google Passordbehandler',
    synced: 'Synket passnøkkel',
    deviceBound: 'Enhet-låst passnøkkel',
  },
  utilsRefundPolicy: {
    short:
      'Du kan avbestille når som helst fra dashbordet og videre trekk stopper umiddelbart. Inneværende periode refunderes ikke, heller ikke for uforbrukte dager.',
    bulletPeriod: 'Abonnementet løper periode-til-periode, månedlig eller årlig.',
    bulletCancel:
      'Du kan avbestille når som helst fra dashbordet. Videre trekk stopper umiddelbart.',
    bulletNoRefund:
      'Inneværende periode refunderes ikke, uavhengig av når i perioden du avbestiller.',
    bulletNoProration:
      'Uforbrukte dager refunderes ikke ved avbestilling, oppgradering eller nedgradering.',
    bulletSupport: "Har du spørsmål om en konkret faktura, skriv til support{'@'}stemne.no.",
  },
  // Group departures (stories/09-group-departures.md).
  departures: {
    service: {
      toggleLabel: 'Fast avgang',
      toggleDesc: 'Kundene booker plasser på avganger du setter opp, i stedet for ledige tider.',
      capacityLabel: 'Plasser per avgang',
      capacityHint: 'Standard for nye avganger. Du kan endre det per avgang.',
      capacityError: 'Skriv et tall fra {min} til {max}.',
      help: 'En fast avgang skjer alltid fysisk. Oppmøtestedet er adressen under.',
    },
    admin: {
      kicker: 'avganger',
      title: 'Avganger',
      sub: 'Faste avganger med plasser. Åpne en avgang for å se gjestelisten.',
      listLabel: 'Kommende avganger',
      loadError: 'Vi fikk ikke lastet avgangene.',
      rosterError: 'Vi fikk ikke lastet gjestelisten.',
      rosterLoading: 'Laster gjestelisten',
      unavailableTitle: 'Avganger er ikke tilgjengelig',
      unavailableBody: 'Faste avganger er ikke slått på for dere ennå.',
      emptyTitle: 'Ingen kommende avganger',
      emptyBody: 'Sett opp den første avgangen, så kan kundene booke plasser.',
      createCta: 'Ny avgang',
      createTitle: 'Ny avgang',
      createDesc: 'Dato og klokkeslett gjelder i {zone}.',
      createError: 'Vi fikk ikke opprettet avgangen.',
      createMissing: 'Velg tjeneste, dato, klokkeslett og guide.',
      createInPast: 'Avgangen må starte fram i tid.',
      created: 'Avgangen er lagt til',
      noServices:
        'Ingen tjenester er satt opp som fast avgang. Slå på «Fast avgang» på en tjeneste først.',
      serviceLabel: 'tjeneste',
      servicePlaceholder: 'Velg tjeneste',
      dateLabel: 'dato',
      timeLabel: 'klokkeslett',
      guideLabel: 'guide',
      guidePlaceholder: 'Velg guide',
      capacityLabel: 'plasser',
      seatsOf: '{held} av {capacity} plasser',
      bookingCount: '{count} booking | {count} bookinger',
      total: 'Totalt',
      backToList: 'Alle avganger',
      cancelledBadge: 'Avlyst',
      cancelledWithReason: 'Avlyst: {reason}',
      cancelledHeading: 'Avbestilt',
      rosterEmptyTitle: 'Ingen gjester ennå',
      rosterEmptyBody: 'Bookinger på avgangen dukker opp her.',
      cancelCta: 'Avlys avgang',
      cancelTitle: 'Avlys avgang',
      cancelBody:
        '1 gjest får beskjed på e-post med begrunnelsen og en lenke for å booke en annen avgang. | Alle {count} gjestene får beskjed på e-post med begrunnelsen og en lenke for å booke en annen avgang.',
      cancelBodyEmpty: 'Ingen gjester har booket denne avgangen ennå.',
      cancelKeep: 'Behold avgangen',
      cancelledGuestsHeading: 'Gjester som var booket',
      guestSeatsHint: 'Gjesten og følget, opptil {n}.',
      reasonLabel: 'Begrunnelse',
      reasonHint: 'Står i e-posten til gjestene, for eksempel «Stengt vei på grunn av uvær».',
      cancelError: 'Vi fikk ikke avlyst avgangen.',
      cancelled: 'Avgangen er avlyst',
      addGuestCta: 'Legg til gjest',
      addGuestTitle: 'Legg til gjest',
      addGuestError: 'Vi fikk ikke lagt til gjesten.',
      guestAdded: 'Gjesten er lagt til',
      guestName: 'Navn',
      guestEmail: 'E-post',
      guestPhone: 'Telefon (valgfritt)',
    },
    public: {
      zoneLabel: 'Tidene vises i lokal tid for {zone} ({abbrev}).',
      loading: 'Laster avganger',
      loadError: 'Vi fikk ikke lastet avgangene.',
      emptyTitle: 'Ingen ledige avganger',
      emptyBody: 'Det er ingen kommende avganger for denne tjenesten akkurat nå.',
      seatsLeft: '{count} plass igjen | {count} plasser igjen',
      full: 'Fullt',
      tooFewSeats: 'For få plasser',
      seatsLabel: 'Antall plasser',
      seatsHint: 'Deg og de som skal være med, opptil {max}.',
      seatsCount: '{count} plass | {count} plasser',
      departureLabel: 'avgang',
      meetingPoint: 'Oppmøtested',
      when: '{date} kl {time} ({zone})',
      rebookInvalid:
        'Lenken for å booke på nytt er utløpt eller allerede brukt. Du kan fortsatt velge en avgang og booke vanlig.',
      gone: 'Vi finner ikke denne avgangen lenger. Velg en annen avgang.',
      // Varianter av bookingflyten for tjenester med fast avgang (stories/09).
      pickHeading: 'Velg avgang',
      pickSub: 'Avgangen varer {duration}.',
      durationHours: '{h} t',
      durationHoursMins: '{h} t {m} min',
      perPerson: '{price} per person',
      perPersonShort: 'per person',
      meetingPointLine: 'Oppmøtested: {place}',
      meetingPointPending: 'Oppmøtested oppgis i bekreftelsen',
      guide: 'guide',
      guideLabel: 'Guide',
      phoneHint: 'Brukes kun til en SMS-påminnelse 24 timer før avreise, dersom det er slått på.',
      noteLabel: 'Noe vi bør vite?',
      notePlaceholder: 'For eksempel allergier eller behov for tilrettelegging.',
      confirmSubmit: 'Bekreft booking',
      terms:
        'Du kan avbestille bookingen. Tidspunktet kan ikke endres, men du kan bestille en ny avgang.',
      confirmedMeta: 'booking bekreftet',
      confirmedSub:
        'En bekreftelse er sendt til {email}. Du kan administrere bookingen herfra når som helst.',
      confirmedManage: 'Administrer booking',
      rebookArrival: 'Turen din ble avlyst. Velg en ny avgang, vi har fylt inn opplysningene dine.',
    },
    manage: {
      noReschedule:
        'Dette er en fast avgang, så tidspunktet kan ikke endres. Vil du reise en annen dag, avbestill og book en ny avgang.',
      eyebrow: 'din avgang',
      heading: 'Avgang med {name}',
    },
  },
}
